var Ht = Object.defineProperty;
var jt = (e, t, n) => t in e ? Ht(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var C = (e, t, n) => jt(e, typeof t != "symbol" ? t + "" : t, n);
import { C as CollidableType, D as DEXFTypeNames, a as DEXFTypeCodes, K as KVADRAT_DEXF_APP_NAME, b as KVADRAT_VERSION, i as isWallCollidable, M as MenuState, c as COLLIDABLE_MATERIALCATEGORY_MAP, d as CustomComponent, e as CustomComponentIds, f as deserializerRegistry, r as round, g as KVADRAT_WALL_WIDTH_MIN, h as KVADRAT_WALL_WIDTH_MAX, j as getDoorComponent, k as it, l as getKvadratId, E as ErrorCodes, m as getOpeningDirectionComponent, P as Pn, n as getWallLength, W as Wn, o as MINIMUM_DOOR_WIDTH, p as MINIMUM_DOOR_HEIGHT, q as MINIMUM_WINDOW_WIDTH, s as MINIMUM_WINDOW_HEIGHT, t as hasWindowComponent, u as hasDoorComponent, L as Lt, R as Rn, v as u, w as MenuOptionType, x as bt, Y as Yt, y as getParametricObjectProperties, z as EditorMode, A as isErrorCode, B as isCollidableWithMaterialSupport, F as ht, G as getDecoratedRoom, H as generateId, I as getWallFeatureIds, O as On, J as te, N as hasInvalidWallFeatures, Q as replaceItemInArrayById, S as replaceItemInArray, T as getNextFreeWindowSpace, U as getNextFreeDoorSpace, _, $, V as getWallIds, X as addNodeBasedOnWallIndexes, Z as U, a0 as repositionWallFeaturesAfterWallResize, a1 as hasInvalidWallFeaturesInRoom, a2 as hasIntersectingWallsInRoom, a3 as areWallFeaturesColliding, a4 as decreaseIndicesForWall, a5 as decreaseIfNumHigher, a6 as isInvalidRoom, a7 as Direction, a8 as P, a9 as V, aa as me, ab as hasPerpedicularAngleBasedOnDirection, ac as extrudeWallWhenZeroAngle, ad as pe, ae as findFirstTruthyValue, af as isInvalidSchema, ag as byId, ah as MERGE_OFFSET, ai as KVADRAT_CEILING_HEIGHT_MAX, aj as KVADRAT_CEILING_HEIGHT_MIN, ak as ge, al as asVec2, am as MEASUREMENT_OFFSET, an as st, ao as We, ap as y, aq as isWallFeatureCollidable, ar as isCornerCollidable, as as KVADRATMEASUREMENT_ID, at as tn, au as RoomRelationsUtil, av as getRoomSurfaceRelationsComponent, aw as getEdgeCornerPoints, ax as closestOnEdge, ay as hasRoomComponent, az as createEntity, aA as requireKvadratIds, aB as createOrUpdateWallEntity, aC as requireKvadratId, aD as getEdgeRelationComponent, aE as getCornerPosition, aF as isTruthy, aG as CornerComponent, aH as getCornerComponent, aI as hasWallComponent, aJ as WallComponent, aK as hasCeilingComponent, aL as CeilingComponent, aM as hasFloorComponent, aN as FloorComponent, aO as RoomSurfaceComponent, aP as EdgeComponent, aQ as requireEdgeRelationComponent, aR as findEntityByKvadratId, aS as KvadratIdComponent, aT as KvadratComponent, aU as getDescendantWithRoom, aV as getDescendantsWithKvadrat, aW as KvadratSystemBase, aX as isDoorOrWindow, aY as ExcludeWallFeatureFromBlueprintComponent, aZ as removeExcludeWallFeatureFromBlueprintComponent, a_ as hasRoomSurfaceComponent, a$ as getSurfaceFrontFacingSize, b0 as getParametricObjectComponent, b1 as hasOpeningArcComponent, b2 as createOrUpdateFunctionalZonesLocalComponent, b3 as getFunctionalZones, b4 as KvadratSystemBase2, b5 as getDescendantsWithRoomSurface, b6 as hasParametricObjectComponent, b7 as getDescendantsWithShouldBeInteractable, b8 as getShouldBeInteractableComponent, b9 as findRoomEntityUpAndDownInHierarchy, ba as getDescendantsWithMaterial, bb as getMaterialComponent, bc as getDescendantsWithMaterialPreview, bd as getMaterialPreviewComponent, be as MaterialStorageComponent, bf as KvadratSystemBase5, bg as RoomSurfaceComponentSystem, bh as EdgeComponentSystem, bi as CornerComponentSystem, bj as getDescendantsWithParametricObject, bk as removeParametricObjectComponent, bl as getOpeningArcComponent, bm as removeOpeningArcComponent, bn as getStaleConnections, bo as getKvadratIdComponent, bp as hasEdgeComponent, bq as getSelectedWallEntityBasedOnEdge, br as project, bs as getFloorCeilingCornersFromEdge, bt as Be, bu as absElementWise, bv as getCornerRelationSurfaces, bw as getRoomPartNormal, bx as getEdgesOfWallEntity, by as removeRoomUnderConstructionForRoomHierarchy, bz as KvadratSystemBase3, bA as hasKvadratComponent, bB as getKvadratEntities, bC as addStandardRoomComponents, bD as RoomGenerator, bE as getNextSiblingWall, bF as getPreviousSiblingWall, bG as areWallsPerpendicular, bH as findRoomEntity, bI as getCoreEntities, bJ as getBlueprintFromCoreState, bK as getCameraEntityPosition, bL as createOrUpdateParametricObjectEntity, bM as getWallFeatureCandidate, bN as isCollisionValidationResult, bO as getDescendantsWithWall, bP as DoorComponent, bQ as OpeningDirectionComponent, bR as byFloorEdge, bS as byCeilingEdge, bT as getFloorCorners, bU as addRoomUnderConstructionForRoomHierarchy, bV as vec3ToVector, bW as detachEntity, bX as MaterialComponent, bY as snapEntityToClosestCandidate, bZ as updatePositionsForCornerEntities, b_ as isLessThanThreshold, b$ as getCeilingCorner, c0 as getCornerRelationComponent, c1 as byWalls, c2 as byCeilings, c3 as byFloors, c4 as getLeftAndRightWallForFloorCorner, c5 as getOuterFloorCeilingEdges, c6 as createOrUpdateEdgeEntity, c7 as addRoomUnderConstruction, c8 as replaceReferencesInCornerComponent, c9 as removeReferencesFromSurfaceComponent, ca as removeMaterialPreviewComponent, cb as vectorToVec3, cc as isRequiredConnectorsValidationResult, cd as getDescendantsWithWindow, ce as getDescendantsWithDoor, cf as MaterialPreviewComponent, cg as DEFAULT_SCALE, ch as ONBOARDING_SESSION_KEY, ci as MAX_SCALE, cj as MIN_SCALE, ck as getPointOnLine, cl as positionToSceenCoordinates, cm as getGroundClearance, cn as ERROR_CODE_TRANSLATION_KEYS, co as fe, cp as zn, cq as xt, cr as getBounds2D, cs as parseHexColor, ct as ICOLOR_DEFAULT, cu as ICOLOR_HOVER, cv as Fn, cw as WALL_TOP_LINE_HEIGHT, cx as WALL_TOP_LINE_DRAG_SIZE, cy as K, cz as ICOLOR_DRAGGING, cA as B, cB as cuboidFromBlueprint, cC as CAMERA_TRANSITION_DURATION_SECONDS, cD as getDirection, cE as tt, cF as transformPoint, cG as getMagnitude, cH as HighlightType, cI as isCeilingCollidable, cJ as sendNotification, cK as isFloorCollidable, cL as getClosestEntityCornerPosition, cM as ClosestEntitySide, cN as getCenter, cO as getAngle, cP as getNearestSnapPositionForWallFeatureOnWall, cQ as KVADRAT_UI_SELECTOR, cR as getWallsInConnectedOrder, cS as Pe, cT as $e, cU as createOrFindEntity, cV as wallsWithNonPerpendicularAngles, cW as getSquareMeters, cX as generateCuboidBlueprint, cY as migrate, cZ as blueprintAsPartialIcf, c_ as _e } from "./blueprintMigration-DWnU48_4.js";
import { d3 as Qn, d4 as eo, e7 as to, eg as no, eB as oo, d5 as ro, d6 as io, eE as so, fb as ao, d7 as lo, d8 as co, eG as uo, eL as po, eQ as mo, eV as go, eY as fo, f0 as ho, f6 as Co, d9 as Eo, er as _o, da as Io, db as vo, dc as To, dd as Oo, de as yo, df as So, dg as Mo, dh as Ro, di as bo, dj as wo, dk as Ao, dl as Do, c$ as xo, dm as Lo, d0 as No, e0 as Wo, e9 as Po, e4 as Fo, e2 as ko, e5 as Vo, ea as Uo, ee as Bo, ei as Ho, en as jo, ez as Ko, eO as zo, eT as Go, ed as $o, em as Zo, el as Yo, es as Xo, ex as qo, eF as Jo, d2 as Qo, eH as er, eJ as tr, eR as nr, eZ as or, f1 as rr, d1 as ir, f4 as sr, dn as ar, f7 as lr, e3 as dr, e8 as cr, eh as ur, ek as pr, eq as mr, eu as gr, ew as fr, ey as hr, eC as Cr, eN as Er, eS as _r, eW as Ir, e_ as vr, f2 as Tr, dp as Or, dq as yr, dr as Sr, f9 as Mr, ds as Rr, fa as br, dt as wr, du as Ar, dv as Dr, dw as xr, dx as Lr, dy as Nr, dz as Wr, dA as Pr, dB as Fr, dC as kr, dD as Vr, dE as Ur, dF as Br, dG as Hr, dH as jr, dI as Kr, dJ as zr, dK as Gr, dL as $r, dM as Zr, dN as Yr, dO as Xr, e1 as qr, e6 as Jr, eb as Qr, ec as ei, ef as ti, ej as ni, eo as oi, ep as ri, et as ii, ev as si, eA as ai, eD as li, eI as di, eK as ci, eP as ui, eU as pi, eX as mi, e$ as gi, f3 as fi, f5 as hi, f8 as Ci, eM as Ei, dP as _i, dQ as Ii, dR as vi, dS as Ti, dT as Oi, dU as yi, dV as Si, dW as Mi, dX as Ri, dY as bi, dZ as wi, d_ as Ai, d$ as Di } from "./blueprintMigration-DWnU48_4.js";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import React, { useMemo, useCallback, createContext, useContext, useState, useRef, useEffect, useId, memo, forwardRef } from "react";
import { setContext, getContext, onMount, afterUpdate, onDestroy } from "svelte";
import { SkapaTheme, ThemeBreakpointObserver, FontLoader } from "@inter-ikea-kompis/themes";
import { HierarchyUtils, Vector, ComponentIds, SelectedComponent, VectorConstants, TransformUtils, DisplayNameComponent, ConnectorsComponent, DisabledConnectorsComponent, MathUtils, ComponentUtils, ColliderUtils, ModelTransform, ViewerObjectComponent, PolyhedronUtils, Transform, FunctionalZone, FunctionalZonesLocalComponent, RenderedComponent, DraggableComponent, SelectableComponent, Cuboid, ColliderShapeComponent, RelativeConnectorRepositioner, RoomPartComponent, RoomPartType, SnapUtils, ModelInfoComponent, LocalTransformComponent, ValidationResultType, ProductUtils, ValidationResultFail, ValidationResultWarning, ConnectionUtils, DynamicProductCatalog, PlacementService, SnapActionCandidateSortAndSelectStrategies, RecommendedInitialPositionFromFloorComponent, CollisionUtils, UnserializableEntityComponent } from "@inter-ikea-core/core";
import { groupBy, last, isEqual, xor, isNumber, uniqBy, merge, keyBy, debounce, once, throttle, camelCase, clamp as clamp$1, isString } from "lodash-es";
import Toggle from "@ingka/toggle";
import styled, { css, ThemeProvider } from "styled-components";
import Text$2 from "@ingka/text";
import { KeyboardManager, InputModeEnum } from "@inter-ikea-kompis/keyboard-manager";
import FormField from "@ingka/form-field";
import InputField from "@ingka/input-field";
import { writable, get, derived, readable } from "svelte/store";
import { IpexMomentEnum } from "@insights/insights-data-provider";
import { CookieConsentService, TranslationsService, SettingsService } from "@inter-ikea-kompis/services";
import { IPEXViewerObject, CameraUpdateSystem } from "@inter-ikea-core/ipex-betrakta-core-adapter";
import { SystemBase2, SystemBase, SystemBase4, ZoneVsColliderRule, ZoneVsZoneRule } from "@inter-ikea-core/core-toolbox";
import { clamp, Vector3, CardinalDirection, IVector3, smoother_step } from "@inter-ikea-betrakta/viewer";
import Button$3 from "@ingka/button";
import Tooltip from "@ingka/tooltip";
import Skeleton from "@ingka/skeleton";
import SsrIcon from "@ingka/ssr-icon";
import plusIcon from "@ingka/ssr-icon/paths/plus";
import Select, { Option } from "@ingka/select";
import CrossIcon from "@ingka/ssr-icon/paths/cross";
import cubeIcon from "@ingka/ssr-icon/paths/cube-3d";
import squareIcon from "@ingka/ssr-icon/paths/square";
import fillBucketIcon from "@ingka/ssr-icon/paths/fill-bucket";
import openings from "@ingka/ssr-icon/paths/openings";
import roomLayout from "@ingka/ssr-icon/paths/room-layout";
import { announce } from "@react-aria/live-announcer";
import ArrowLeftIcon from "@ingka/ssr-icon/paths/arrow-left";
import ListView, { ListViewItem } from "@ingka/list-view";
import { OrthographicPlannerCamera } from "@inter-ikea-betrakta/viewer/dist/modules/cameras/OrthographicPlannerCamera.js";
import { OrbitPlannerCamera } from "@inter-ikea-betrakta/viewer/dist/modules/cameras/OrbitPlannerCamera.js";
import { LineMeasureWidget } from "@inter-ikea-betrakta/viewer/dist/modules/MeasurementWidget.js";
import { SvelteComponent, init, safe_not_equal, append_styles, element, text, space as space$1, attr, insert, append, set_data, noop, detach, null_to_empty, assign, exclude_internal_props, binding_callbacks, toggle_class, listen, stop_propagation, action_destroyer, group_outros, transition_out, check_outros, transition_in, is_function, run_all, component_subscribe, bubble, create_component, mount_component, destroy_component, ensure_array_like, empty, update_keyed_each, outro_and_destroy_block, create_slot, update_slot_base, get_all_dirty_from_scope, get_slot_changes } from "svelte/internal";
import "svelte/internal/disclose-version";
import ellipsesHorizontalIcon from "@ingka/ssr-icon/paths/ellipses-horizontal";
import { createRoot } from "react-dom/client";
import trashCanIcon from "@ingka/ssr-icon/paths/trash-can";
import wallDividerIcon from "@ingka/ssr-icon/paths/wall-divider";
import pencilIcon from "@ingka/ssr-icon/paths/pencil";
import "@inter-ikea-kompis/component-text";
import Draggable$1 from "draggable";
import { createPortal } from "react-dom";
import ArrowRightIcon from "@ingka/ssr-icon/paths/arrow-right";
import CheckmarkIcon from "@ingka/ssr-icon/paths/checkmark";
import polylabel from "polylabel";
const useApplyMaterial = (e) => {
  const { userInteractionStore: t } = useStores(), n = useKvadratApi(), o = useMemo(
    () => ({
      [CollidableType.WALL]: n.applyMaterialToWall.bind(n),
      [CollidableType.FLOOR]: n.applyMaterialToFloor.bind(n),
      [CollidableType.CEILING]: n.applyMaterialToCeiling.bind(n)
    }),
    [n]
  ), r = useMemo(
    () => ({
      [CollidableType.WALL]: n.applyMaterialToAllWalls.bind(n),
      [CollidableType.FLOOR]: n.applyMaterialToAllFloors.bind(n),
      [CollidableType.CEILING]: n.applyMaterialToAllCeilings.bind(n)
    }),
    [n]
  );
  return useCallback(
    (i, s = {}) => {
      var m, p;
      const { all: a = !1, commit: l = !1 } = s, { selectedCollidableId: d, selectedCollidable: c } = t.get();
      !a && d && (c == null ? void 0 : c.type) === e ? (m = o[e]) == null || m.call(o, d, i, l) : (p = r[e]) == null || p.call(r, i, l);
    },
    [t, e, o, r]
  );
}, API_KEY = Object.freeze({});
function getApi() {
  return getContext(API_KEY);
}
function setApi(e) {
  setContext(API_KEY, e);
}
const EditedEntityContext = createContext({
  isEditing: !1,
  entity: null,
  closeEditing: () => {
  }
}), HeaderLevelContext = createContext(1), KvadratContext = createContext(void 0), MenuContext = createContext(null), StoresContext = createContext(void 0), STORE_KEY = Object.freeze({});
function getStores() {
  return getContext(STORE_KEY);
}
function setStores(e) {
  setContext(STORE_KEY, e);
}
function useStores() {
  const e = useContext(StoresContext);
  if (!e)
    throw new Error("Stores context is not available. Has Kvadrat been initialized?");
  return e;
}
SkapaTheme.breakpoint.medium.width - 1, `${SkapaTheme.breakpoint.medium.width}`;
const useBreakpoints = () => {
  const [e, t] = useState(!1), n = useRef(), o = useCallback(() => {
    var i;
    if (!n.current)
      return;
    const r = (i = n.current.getBreakpoint()) == null ? void 0 : i.width;
    Number.isInteger(r) && t(r < SkapaTheme.breakpoint.medium.width);
  }, []);
  return useEffect(() => {
    const r = new ThemeBreakpointObserver(o);
    return n.current = r, n.current.observe(SkapaTheme), o(), () => {
      var i;
      (i = n.current) == null || i.disconnect();
    };
  }, [o]), {
    isMobile: e
  };
};
function useKvadratApi() {
  const e = useContext(KvadratContext);
  if (!e)
    throw new Error("Kvadrat is not available");
  return e;
}
function useCore() {
  return useKvadratApi().core;
}
const getCoveringMaterialId = (e, t) => {
  const n = t === CollidableType.WALL ? e.walls : t === CollidableType.FLOOR ? e.floors : t === CollidableType.CEILING ? e.ceilings : [];
  return n.length === 0 ? void 0 : n.every(
    (r) => r.materialId === n[0].materialId
  ) ? n[0].materialId : void 0;
}, useCoveringMaterialId = (e) => {
  const { blueprintStore: t } = useStores(), n = t.get().rooms[0];
  return getCoveringMaterialId(n, e);
};
function useComponentListener(e, t, n) {
  const o = useCore();
  useEffect(() => {
    const r = (a, l) => {
      fulfillsMandatoryComponents() && t("add", a, l);
    }, i = (a, l, d) => {
      fulfillsMandatoryComponents() && t("update", a, d);
    }, s = (a, l) => {
      fulfillsMandatoryComponents() && t("remove", a, l);
    };
    return o.services.entityManager.subscribeAdd(e, r), o.services.entityManager.subscribeUpdate(e, i), o.services.entityManager.subscribeRemove(e, s), () => {
      o.services.entityManager.unsubscribeRemove(e, s), o.services.entityManager.unsubscribeUpdate(e, i), o.services.entityManager.unsubscribeAdd(e, r);
    };
  }, [e, t, n, o.services.entityManager]);
}
function fulfillsMandatoryComponents(e, t) {
  return !0;
}
class KvadratReferenceError extends Error {
  constructor(t) {
    super("Invalid reference"), this.errorCode = t, this.name = "KvadratReferenceError";
  }
}
class MaterialError extends Error {
  constructor(t, n) {
    super(n), this.status = t;
  }
}
var RoomConfigurationErrorMessage = /* @__PURE__ */ ((e) => (e.LOAD_ERROR = "Load configuration failed. The VPC code doesn't exist or does not point to a Kvadrat room configuration.", e.SAVE_ERROR = "Save configuration failed", e))(RoomConfigurationErrorMessage || {});
class RoomConfigurationError extends Error {
  constructor(t, n) {
    super(n), this.status = t;
  }
}
const getItemsPath$1 = "webplanner/v1/query/items/retailunit/";
async function getMaterials(e, t, n, o, r, i) {
  const s = `${e}${getItemsPath$1}${r}/locale/${o}?filter.appId=${n}&filter.valid=true&filter.tags=${DEXFTypeNames.MATERIALCATEGORY},${DEXFTypeNames.MATERIAL}&fields=*`, a = await fetch(s, {
    headers: {
      "dexf-api-key": t
    }
  });
  if (!a.ok)
    throw new MaterialError(a.status, a.statusText);
  const { data: l } = await a.json(), {
    [`CI-${DEXFTypeCodes.MATERIALCATEGORY}`]: d,
    [`CI-${DEXFTypeCodes.MATERIAL}`]: c
  } = groupBy(l, "content.typeCode");
  return !d || !c ? null : d.sort((m, p) => {
    var g, f;
    return (((g = m.content.appConfig.attributes) == null ? void 0 : g.sortorder) || 0) - (((f = p.content.appConfig.attributes) == null ? void 0 : f.sortorder) || 0);
  }).map((m) => {
    var p;
    return {
      name: m.content.name,
      tags: m.content.appConfig.tags,
      type: (p = m.content.appConfig.attributes) == null ? void 0 : p.categorytype,
      materials: c.filter(
        (g) => {
          var f;
          return g.content.appConfig.tags.includes(((f = m.content.appConfig.attributes) == null ? void 0 : f.targettag) || "");
        }
      ).sort(
        (g, f) => {
          var h, E;
          return (((h = g.content.appConfig.attributes) == null ? void 0 : h.sortorder) || 0) - (((E = f.content.appConfig.attributes) == null ? void 0 : E.sortorder) || 0);
        }
      ).map(({ itemId: g, content: f }) => {
        var h, E, I, R, A;
        return {
          id: g,
          name: f.name,
          // DEXF translates this through Översätta
          previewUrl: ((h = f.image) == null ? void 0 : h[0].url) || "",
          url: ((I = (E = f.asset) == null ? void 0 : E[0]) == null ? void 0 : I.url) || "",
          colorCode: (R = f.appConfig.attributes) != null && R.colorcode ? `#${(A = f.appConfig.attributes) == null ? void 0 : A.colorcode}` : void 0,
          description: f.name,
          tags: f.appConfig.tags
        };
      }).filter((g) => !(i != null && i.length) || i.some((f) => {
        var h;
        return (h = g.tags) == null ? void 0 : h.includes(f);
      }))
    };
  }).filter((m) => m.materials.length);
}
const FIVE_MINUTES = 3e5;
function useQuery(e, t, ...n) {
  const { fetchOnMount: o = !1, shouldCache: r = !1, cacheTime: i = FIVE_MINUTES, onSuccess: s, onError: a } = t, [l, d] = useState(null), [c, m] = useState(null), [p, g] = useState(!0), [f, h] = useState(0), E = () => {
    r && f > Date.now() || (h(Date.now() + i), g(!0), e(...n).then((I) => {
      d(I), s == null || s(I);
    }).catch((I) => {
      m(I), a == null || a(I);
    }).finally(() => {
      g(!1);
    }));
  };
  return useEffect(() => {
    o && E();
  }, [e]), { retry: E, data: l, error: c, isLoading: p };
}
const useMaterials = () => {
  const { configurationStore: e, i18nStore: t } = useStores(), { dexfBaseUrl: n, dexfApiKey: o, dexfSegment: r, materialTags: i } = e.get(), { locale: s, countryCode: a } = t.get(), { data: l, error: d, isLoading: c } = useQuery(
    getMaterials,
    { fetchOnMount: !0, shouldCache: !0 },
    n,
    o,
    `${KVADRAT_DEXF_APP_NAME}.${r}`,
    s,
    a,
    i
  );
  return { data: l, error: d, isLoading: c };
}, appendCustomMaterials = (e, t) => [
  ...e,
  ...Object.keys(t).reduce((n, o) => (/^custom-/.test(o) && n.push(t[o]), n), [])
], addCustomMaterialsToCategory = (e, t, n) => e.map((o) => o.type !== n ? o : {
  ...o,
  materials: appendCustomMaterials(o.materials, t)
});
var CookieConsentLevels = /* @__PURE__ */ ((e) => (e[e.TECHNICAL = 1] = "TECHNICAL", e[e.ANALYTICAL = 2] = "ANALYTICAL", e[e.PREFERENCE = 3] = "PREFERENCE", e[e.MARKETING = 4] = "MARKETING", e))(CookieConsentLevels || {}), InsightsEventType = /* @__PURE__ */ ((e) => (e[e.SAVE = 2] = "SAVE", e[e.ZOOM_BUTTON_IN = 3] = "ZOOM_BUTTON_IN", e[e.ZOOM_BUTTON_OUT = 4] = "ZOOM_BUTTON_OUT", e[e.SCROLL_ZOOM_IN = 5] = "SCROLL_ZOOM_IN", e[e.SCROLL_ZOOM_OUT = 6] = "SCROLL_ZOOM_OUT", e[e.MIRROR = 7] = "MIRROR", e[e.ROTATE = 8] = "ROTATE", e[e.EDITOR_MODE = 9] = "EDITOR_MODE", e[e.SET_BLUEPRINT = 10] = "SET_BLUEPRINT", e[e.RESIZE_WALL = 11] = "RESIZE_WALL", e[e.ERROR_RESIZE_WALL = 12] = "ERROR_RESIZE_WALL", e[e.SET_CEILING_HEIGHT = 13] = "SET_CEILING_HEIGHT", e[e.DELETE_CORNER = 14] = "DELETE_CORNER", e[e.ERROR_DELETE_CORNER = 15] = "ERROR_DELETE_CORNER", e[e.ERROR_ROOM_CHANGE = 16] = "ERROR_ROOM_CHANGE", e[e.MOVE_CORNER = 17] = "MOVE_CORNER", e[e.SELECT_CORNER = 18] = "SELECT_CORNER", e[e.MERGE_CORNER = 19] = "MERGE_CORNER", e[e.MOVE_WALL = 20] = "MOVE_WALL", e[e.SELECT_WALL = 21] = "SELECT_WALL", e[e.SPLIT_WALL = 22] = "SPLIT_WALL", e[e.SCENE_MENU = 24] = "SCENE_MENU", e[e.OPEN_KVADRAT = 25] = "OPEN_KVADRAT", e[e.CLOSE_KVADRAT = 26] = "CLOSE_KVADRAT", e[e.INITIALIZE_KVADRAT = 27] = "INITIALIZE_KVADRAT", e[e.ADD_WALL_FEATURE = 28] = "ADD_WALL_FEATURE", e[e.SELECT_WALL_FEATURE = 29] = "SELECT_WALL_FEATURE", e[e.UPDATE_WALL_FEATURE = 30] = "UPDATE_WALL_FEATURE", e[e.UPDATE_WALL_FEATURE_POSITION = 31] = "UPDATE_WALL_FEATURE_POSITION", e[e.DELETE_WALL_FEATURE = 32] = "DELETE_WALL_FEATURE", e[e.MOVE_WALL_FEATURE = 33] = "MOVE_WALL_FEATURE", e[e.ROOM_OUTSIDE_SCREEN = 34] = "ROOM_OUTSIDE_SCREEN", e[e.PAN_CAMERA = 35] = "PAN_CAMERA", e[e.MINIMIZED_MEASUREMENT_CLICKED = 36] = "MINIMIZED_MEASUREMENT_CLICKED", e[e.EXTRUDE = 37] = "EXTRUDE", e[e.DRAGGING_CONTEXT_MENU = 38] = "DRAGGING_CONTEXT_MENU", e[e.ONBOARDING_OPENED = 39] = "ONBOARDING_OPENED", e[e.ONBOARDING_CLOSED = 40] = "ONBOARDING_CLOSED", e[e.SCROLL_ZOOM_OUT_3D = 41] = "SCROLL_ZOOM_OUT_3D", e[e.SCROLL_ZOOM_IN_3D = 42] = "SCROLL_ZOOM_IN_3D", e[e.MEASUREMENT_INPUT = 43] = "MEASUREMENT_INPUT", e[e.UPDATE_WALL_MATERIAL = 44] = "UPDATE_WALL_MATERIAL", e[e.UPDATE_ALL_WALL_MATERIALS = 45] = "UPDATE_ALL_WALL_MATERIALS", e[e.UPDATE_FLOOR_MATERIAL = 46] = "UPDATE_FLOOR_MATERIAL", e[e.UPDATE_ALL_FLOOR_MATERIALS = 47] = "UPDATE_ALL_FLOOR_MATERIALS", e[e.UPDATE_CEILING_MATERIAL = 48] = "UPDATE_CEILING_MATERIAL", e[e.UPDATE_ALL_CEILING_MATERIALS = 49] = "UPDATE_ALL_CEILING_MATERIALS", e[e.SELECT_CEILING = 50] = "SELECT_CEILING", e[e.SELECT_FLOOR = 51] = "SELECT_FLOOR", e[e.TOGGLE_MATERIAL_CATEGORY = 52] = "TOGGLE_MATERIAL_CATEGORY", e[e.APPLY_RECENTLY_USED_MATERIAL = 53] = "APPLY_RECENTLY_USED_MATERIAL", e[e.MATERIAL_POPUP_OPENED = 54] = "MATERIAL_POPUP_OPENED", e[e.MATERIAL_POPUP_CLOSED = 55] = "MATERIAL_POPUP_CLOSED", e[e.COMPOUND_UPDATE = 56] = "COMPOUND_UPDATE", e[e.SHOW_USER_FEEDBACK = 57] = "SHOW_USER_FEEDBACK", e[e.UPDATE_DOOR_OPENING_DIRECTION = 58] = "UPDATE_DOOR_OPENING_DIRECTION", e[e.UPDATE_DOOR_HANDLE_LOCATION = 59] = "UPDATE_DOOR_HANDLE_LOCATION", e))(InsightsEventType || {}), InsightsInteractionType = /* @__PURE__ */ ((e) => (e.DROPPED = "DROPPED", e.CLICKED = "CLICKED", e.CONTEXT_MENU = "CONTEXT_MENU", e.KEYBOARD_SHORTCUT = "KEYBOARD_SHORTCUT", e.KEY_DOWN = "KEY_DOWN", e.BLUR = "BLUR", e.PAN = "PAN", e.ZOOM_BUTTON_IN = "ZOOM_BUTTON_IN", e.ZOOM_BUTTON_OUT = "ZOOM_BUTTON_OUT", e.ZOOM_SCROLL_IN = "ZOOM_SCROLL_IN", e.ZOOM_SCROLL_OUT = "ZOOM_SCROLL_OUT", e))(InsightsInteractionType || {}), InsightsInteractionOrigin = /* @__PURE__ */ ((e) => (e.SIDE_MENU = "SIDE_MENU", e.CONTEXT_MENU = "CONTEXT_MENU", e.CANVAS = "CANVAS", e))(InsightsInteractionOrigin || {});
let moduleClient, cookieConsentService, usingProxy = !1;
const decoratedPayloads = [];
function getPayloadDecoration() {
  return last(decoratedPayloads);
}
function decorateInsightEventWith(e, t) {
  decoratedPayloads.push(e), t(), decoratedPayloads.pop();
}
function connectAnalytics(e, t, n, o, r) {
  usingProxy = o;
  const i = o ? r : "";
  cookieConsentService = new CookieConsentService({
    localizationPrefixApplication: "KVADRAT",
    localizationEndpoints: [
      `${i}/addon-app/localizations/common--kvadrat/latest/{country}/{language}/`,
      "/addon-app/localizations/common--kvadrat/latest/{country}/{language}/"
    ],
    locale: n
  }), moduleClient = new Promise((s, a) => {
    hasConsent().then((l) => {
      l || a();
      try {
        const d = t.moduleClient({
          moduleId: "kvadrat",
          moduleVersion: KVADRAT_VERSION,
          dev: e === "qa"
        });
        s(d);
      } catch (d) {
        a(d);
      }
    });
  });
}
function sendEvent(e, t, n = IpexMomentEnum.makeItMe) {
  const o = getPayloadDecoration();
  moduleClient == null || moduleClient.then((r) => {
    try {
      r.sendEvent({
        event: InsightsEventType[e],
        ipexMoment: n,
        payload: {
          ...o,
          ...t
        }
      });
    } catch (i) {
      console.warn(i);
    }
  }).catch((r) => {
    console.warn(r);
  });
}
function hasConsent() {
  return usingProxy ? Promise.resolve(!0) : cookieConsentService.hasCookieConsent(CookieConsentLevels.ANALYTICAL);
}
JSON.stringify(SkapaTheme);
const MATERIAL_LAYOUTS = {
  compact: {
    width: "35px",
    outlineOffset: "3px"
  },
  default: {
    width: "5rem",
    outlineOffset: "6px"
  }
}, Circle = styled.button.attrs(
  ({ $layout: e, $backgroundImage: t, $backgroundColor: n, $borderColor: o, $interactive: r = !0, $checked: i }) => ({
    $backgroundColor: n || "none",
    $backgroundImage: t ? `url("${t}")` : "none",
    $layout: e,
    $borderColor: o,
    $interactive: r,
    $checked: i
  })
)`
  border-radius: ${SkapaTheme.border.radius.radius64}%;
  width: 100%;
  aspect-ratio: 1 / 1;
  background-color: ${(e) => e.$backgroundColor};
  background-image: ${(e) => e.$backgroundImage};
  background-size: contain;
  outline-offset: ${(e) => MATERIAL_LAYOUTS[e.$layout].outlineOffset};
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${(e) => `0.7px solid ${e.$borderColor || SkapaTheme.color.neutral.grey500}`};
  box-sizing: border-box;
  cursor: ${(e) => e.$interactive ? "pointer" : "default"};
  outline: ${(e) => e.$checked ? "1px solid #000000" : "unsets"};

  &:hover {
    outline: ${(e) => e.$interactive ? `1px solid ${SkapaTheme.color.neutral.grey500}` : "none"};
  }

  &:focus {
    outline: ${(e) => e.$interactive ? `${SkapaTheme.focusOutline.width}px solid ${SkapaTheme.focusOutline.color}` : "none"};
  }
`, Wrapper$8 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 400px;
`, ButtonWrapper$1 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: space-around;
  align-items: center;
`, CircleWrapper$1 = styled.div`
  position: absolute;
  top: 30px;
  right: calc(17px + 0.5rem);
  width: 34px;
  height: 34px;
`, Title = styled.span`
  color: ${({ theme: e }) => e.color.text.dark};
  font-size: ${({ theme: e }) => e.font.size[75]};
  font-weight: 700;
`, isHexColor = (e) => e === void 0 ? !1 : /^(?:[0-9A-Fa-f]{3}){1,2}$/i.test(e);
function CustomMaterialForm({ onAccept: e, onReject: t, defaultValue: n = "", scrollIntoView: o = !0 }) {
  const { translate: r } = useI18n(), [i, s] = useState(n), [a, l] = useState(!0), [d, c] = useState(!1), m = useRef(null), p = (g) => {
    l(isHexColor(g.target.value)), s(g.target.value), c(!0);
  };
  return useEffect(() => {
    var g;
    o && ((g = m == null ? void 0 : m.current) == null || g.scrollIntoView(!0));
  }, []), /* @__PURE__ */ jsxs(Wrapper$8, { ref: m, children: [
    /* @__PURE__ */ jsx(Title, { children: r("materialCustomTitle") }),
    /* @__PURE__ */ jsxs(
      FormField,
      {
        valid: a,
        shouldValidate: d,
        validation: {
          msg: r("materialCustomErrorMessage")
        },
        style: { margin: 0, position: "relative" },
        children: [
          /* @__PURE__ */ jsx(
            InputField,
            {
              id: "some-input",
              type: "text",
              label: r("materialCustomLabel"),
              value: i,
              onChange: p
            }
          ),
          /* @__PURE__ */ jsx(CircleWrapper$1, { hidden: !isHexColor(i), children: /* @__PURE__ */ jsx(Circle, { $interactive: !1, $layout: "compact", $backgroundColor: `#${i}` }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(ButtonWrapper$1, { children: [
      /* @__PURE__ */ jsx(Button$3, { size: "small", fluid: !0, onClick: t, type: "secondary", children: r("cancel") }),
      /* @__PURE__ */ jsx(
        Button$3,
        {
          size: "small",
          fluid: !0,
          disabled: !isHexColor(i),
          onClick: () => {
            i && e("#" + i);
          },
          type: "primary",
          children: r("done")
        }
      )
    ] })
  ] });
}
const ArrowBelowLineIcon = ({ rotation: e = 0 }) => {
  const t = (e + 90 + 180) % 360 - 180;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      version: "1.1",
      id: "Layer_2_copy",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0",
      y: "0",
      viewBox: "0 0 25 15",
      xmlSpace: "preserve",
      style: { transform: `rotate(${t}deg)` },
      children: [
        /* @__PURE__ */ jsx("style", { children: ".st0{fill:currentColor}" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            className: "st0",
            d: "M17.4 14.1c-3.6 0-6.6-3-6.6-6.6 0-3.6 3-6.6 6.6-6.6 3.6 0 6.6 3 6.6 6.6 0 3.6-3 6.6-6.6 6.6zm0-11.2c-2.5 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.6 2.5 0 4.6-2.1 4.6-4.6 0-2.5-2.1-4.6-4.6-4.6z"
          }
        ),
        /* @__PURE__ */ jsx("circle", { className: "st0", cx: "17.5", cy: "7.5", r: "2.5" }),
        /* @__PURE__ */ jsx("path", { className: "st0", d: "M7.3 13.7.5 7.5l6.8-6.2 1.4 1.4-5.2 4.8 5.2 4.8z" }),
        /* @__PURE__ */ jsx("path", { className: "st0", d: "M2 6.5h9.8v2H2z" })
      ]
    }
  );
}, ArrowDisabledIcon = () => /* @__PURE__ */ jsxs("svg", { width: "11", height: "11", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("circle", { cx: "5.5", cy: "5.5", r: "5", fill: "transparent", stroke: "currentColor" }),
  /* @__PURE__ */ jsx("circle", { cx: "5.5", cy: "5.5", r: "2.75", fill: "currentColor" })
] }), CheckMarkOutlineIcon = () => /* @__PURE__ */ jsx("svg", { width: "16", height: "13", viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M12.916 1.64889L12.56 1.288L12.2041 1.64886L6.5639 7.36614L3.79585 4.56176L3.43987 4.2011L3.08402 4.56189L1.64402 6.02189L1.29771 6.37301L1.64403 6.72412L6.20803 11.3511L6.56403 11.712L6.92 11.3511L14.356 3.81109L14.7023 3.45998L14.356 3.10889L12.916 1.64889Z",
    fill: "black",
    stroke: "white"
  }
) }), DragIcon = () => /* @__PURE__ */ jsxs("svg", { width: "14", height: "26", viewBox: "0 0 14 26", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("path", { d: "M2 19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18C1.55228 18 2 18.4477 2 19Z" }),
  /* @__PURE__ */ jsx("path", { d: "M2 25C2 25.5523 1.55228 26 1 26C0.447715 26 0 25.5523 0 25C0 24.4477 0.447715 24 1 24C1.55228 24 2 24.4477 2 25Z" }),
  /* @__PURE__ */ jsx("path", { d: "M2 7C2 7.55228 1.55228 8 1 8C0.447715 8 0 7.55228 0 7C0 6.44772 0.447715 6 1 6C1.55228 6 2 6.44772 2 7Z" }),
  /* @__PURE__ */ jsx("path", { d: "M2 13C2 13.5523 1.55228 14 1 14C0.447715 14 0 13.5523 0 13C0 12.4477 0.447715 12 1 12C1.55228 12 2 12.4477 2 13Z" }),
  /* @__PURE__ */ jsx("path", { d: "M2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1Z" }),
  /* @__PURE__ */ jsx("path", { d: "M8 19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19C6 18.4477 6.44772 18 7 18C7.55228 18 8 18.4477 8 19Z" }),
  /* @__PURE__ */ jsx("path", { d: "M8 25C8 25.5523 7.55228 26 7 26C6.44772 26 6 25.5523 6 25C6 24.4477 6.44772 24 7 24C7.55228 24 8 24.4477 8 25Z" }),
  /* @__PURE__ */ jsx("path", { d: "M8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7Z" }),
  /* @__PURE__ */ jsx("path", { d: "M8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13Z" }),
  /* @__PURE__ */ jsx("path", { d: "M8 1C8 1.55228 7.55228 2 7 2C6.44772 2 6 1.55228 6 1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1Z" }),
  /* @__PURE__ */ jsx("path", { d: "M14 19C14 19.5523 13.5523 20 13 20C12.4477 20 12 19.5523 12 19C12 18.4477 12.4477 18 13 18C13.5523 18 14 18.4477 14 19Z" }),
  /* @__PURE__ */ jsx("path", { d: "M14 25C14 25.5523 13.5523 26 13 26C12.4477 26 12 25.5523 12 25C12 24.4477 12.4477 24 13 24C13.5523 24 14 24.4477 14 25Z" }),
  /* @__PURE__ */ jsx("path", { d: "M14 7C14 7.55228 13.5523 8 13 8C12.4477 8 12 7.55228 12 7C12 6.44772 12.4477 6 13 6C13.5523 6 14 6.44772 14 7Z" }),
  /* @__PURE__ */ jsx("path", { d: "M14 13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13C12 12.4477 12.4477 12 13 12C13.5523 12 14 12.4477 14 13Z" }),
  /* @__PURE__ */ jsx("path", { d: "M14 1C14 1.55228 13.5523 2 13 2C12.4477 2 12 1.55228 12 1C12 0.447715 12.4477 0 13 0C13.5523 0 14 0.447715 14 1Z" })
] });
function isTouchDevice() {
  return window.matchMedia("(hover: none)").matches;
}
const WithTooltip = ({
  children: e,
  disabled: t,
  text: n,
  hideTooltipTextFromAccessibility: o = !1,
  wrapperStyle: r,
  ...i
}) => isTouchDevice() || t || !n ? /* @__PURE__ */ jsx(Fragment, { children: e }) : /* @__PURE__ */ jsx(
  "div",
  {
    ref: (s) => {
      if (s === null)
        return;
      const a = s.querySelector(".tooltip__body");
      a !== null && a.setAttribute("aria-hidden", o.toString());
    },
    style: r,
    children: /* @__PURE__ */ jsx(Tooltip, { interactiveCustomTrigger: !0, tooltipText: n, ...i, children: e })
  }
), TextWrapper$1 = ({ children: e, className: t, ...n }) => /* @__PURE__ */ jsx(Text$2, { tagName: "span", bodySize: "s", className: t, ...n, children: e }), CircleWrapper = styled.div`
  width: ${(e) => MATERIAL_LAYOUTS[e.layout].width};
`, Text$1 = styled(TextWrapper$1)`
  margin-top: 9px;
  color: ${SkapaTheme.color.text.default};
  cursor: pointer;
`, Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, Material = ({
  material: e,
  showName: t = !1,
  checked: n = !1,
  onHover: o,
  onFocus: r,
  onApply: i,
  onBlur: s,
  layout: a = "default",
  toggleButton: l = !1,
  testId: d,
  ...c
}) => {
  const m = () => {
    i == null || i(e);
  }, p = () => {
    s == null || s(e);
  }, g = () => {
    r == null || r(e);
  }, f = () => {
    o == null || o(e);
  }, h = () => {
    p();
  };
  return /* @__PURE__ */ jsx(WithTooltip, { position: "top", text: e == null ? void 0 : e.name, hideTooltipTextFromAccessibility: !0, children: /* @__PURE__ */ jsx(
    Label,
    {
      onMouseEnter: f,
      onMouseLeave: h,
      onBlur: p,
      onFocus: g,
      onClick: m,
      ...c,
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(CircleWrapper, { layout: a, children: /* @__PURE__ */ jsx(
          Circle,
          {
            $layout: a,
            $backgroundColor: e == null ? void 0 : e.colorCode,
            $backgroundImage: e == null ? void 0 : e.previewUrl,
            $borderColor: e == null ? void 0 : e.borderColor,
            $checked: n,
            "data-testid": d,
            "aria-label": e == null ? void 0 : e.name,
            "aria-pressed": l ? n : void 0,
            className: "focus-visible",
            children: n && /* @__PURE__ */ jsx(CheckMarkOutlineIcon, {})
          }
        ) }),
        (e == null ? void 0 : e.name) && t && /* @__PURE__ */ jsx(Text$1, { "aria-hidden": "true", children: e.name })
      ] })
    }
  ) });
}, Wrapper$7 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, SkeletonCircle = styled(Skeleton)(
  ({ layout: e }) => css`
    border-radius: 50%;
    height: ${MATERIAL_LAYOUTS[e].width};
    width: ${MATERIAL_LAYOUTS[e].width};
  `
), SkeletonText = styled(Skeleton)`
  height: 1rem;
  margin-top: 9px;
`, MaterialSkeleton = ({ layout: e, showName: t }) => /* @__PURE__ */ jsxs(Wrapper$7, { children: [
  /* @__PURE__ */ jsx(SkeletonCircle, { inlineBlock: !0, layout: e, width: MATERIAL_LAYOUTS[e].width }),
  t && /* @__PURE__ */ jsx(SkeletonText, { inlineBlock: !0 })
] }), PlusWrapper = styled.button(
  ({ $layout: e }) => css`
    border-radius: ${SkapaTheme.border.radius.radius64}%;
    width: ${MATERIAL_LAYOUTS[e].width};
    height: ${MATERIAL_LAYOUTS[e].width};
    outline-offset: ${MATERIAL_LAYOUTS[e].outlineOffset};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;

    &:hover {
      outline: 1px solid ${SkapaTheme.color.neutral.grey300};
    }

    &:focus {
      box-sizing: border-box;
      border-radius: ${SkapaTheme.border.radius.radius64}%;
      outline: ${SkapaTheme.focusOutline.width}px solid ${SkapaTheme.focusOutline.color};
    }
  `
), AddMaterial = ({ layout: e, onClick: t }) => {
  const { translate: n } = useI18n();
  return /* @__PURE__ */ jsx(WithTooltip, { position: "top", text: n("materialCustomTitle"), children: /* @__PURE__ */ jsx(PlusWrapper, { tabIndex: 0, $layout: e, onClick: t, "aria-label": n("materialCustomTitle"), children: /* @__PURE__ */ jsx(SsrIcon, { paths: plusIcon }) }) });
};
function useHeaderLevelContext() {
  return useContext(HeaderLevelContext);
}
const Section = ({ children: e }) => {
  const t = useHeaderLevelContext(), n = Math.min(t + 1, 6);
  return /* @__PURE__ */ jsx(HeaderLevelContext.Provider, { value: n, children: e });
}, getSize = (e) => ({
  1: "l",
  2: "m",
  3: "s",
  4: "xs",
  5: "xs",
  6: "xs"
})[e], H = ({ children: e, className: t, testId: n, ...o }) => {
  const r = useHeaderLevelContext(), i = `h${r}`;
  return /* @__PURE__ */ jsx(Text$2, { ...o, tagName: i, className: t, "data-testid": n, headingSize: getSize(r), children: e });
}, StyledSelect = styled(Select)(
  () => css`
    display: flex;
    padding: 10px 10px 0 10px;
  `
), TitleWrapper = styled.div(
  ({ $defaultLayout: e }) => !e && css`
      padding: 20px 20px 0 20px;
    `
), CategorySelector = ({
  defaultLayout: e,
  materialCategories: t,
  selectedCategoryIndex: n,
  className: o,
  setCategory: r
}) => {
  const [i, s] = useState(
    t.find((d, c) => c === n || "No materials")
  ), { userInteractionStore: a } = useStores(), { materialPopupFocusOnRender: l } = a.get();
  return t.length > 1 ? /* @__PURE__ */ jsx(
    StyledSelect,
    {
      id: "kvadrat-material-category-toggle",
      onChange: (d) => {
        r(t.indexOf(d.target.value)), s(d.target.value);
      },
      className: o,
      value: i,
      "data-testid": "kvadrat-material-category-toggle",
      hintText: "",
      autoFocus: l,
      children: t.map((d) => /* @__PURE__ */ jsx(
        Option,
        {
          value: d,
          name: d,
          style: { fontWeight: 700 },
          "data-testid": `kvadrat-material-category-item-${d}`
        },
        d
      ))
    }
  ) : /* @__PURE__ */ jsx(TitleWrapper, { $defaultLayout: e, children: /* @__PURE__ */ jsx(Section, { children: /* @__PURE__ */ jsx(H, { children: t.length ? t[0] : "No materials found for this surface" }) }) });
}, Wrapper$6 = styled.div(
  ({ $isDragging: e }) => css`
    position: relative;
    display: flex;
    background-color: ${SkapaTheme.color.background.default};
    height: 60px;
    align-items: center;
    justify-content: end;
    border-bottom: ${SkapaTheme.border.thickness.thin}px solid ${SkapaTheme.color.border.light};
    padding: 0 ${SkapaTheme.spacing.space75}px;
    pointer-events: ${e ? "none" : "auto"};
    z-index: 300;
  `,
  ({ $defaultLayout: e }) => e && css`
      height: auto;
      padding: 0;
      border-bottom: none;
    `
), Button$2 = styled.button(
  () => css`
    display: flex;
    align-items: center;
    border: none;
    background-color: unset;
    padding: 12px;
    cursor: pointer;
    margin: 2px;
    height: 56px;
    border-radius: 4%;

    &:focus {
      box-sizing: border-box;
      border-radius: ${SkapaTheme.border.radius.radius4}%;
      outline: ${SkapaTheme.focusOutline.width}px solid ${SkapaTheme.focusOutline.color};
    }
  `
), Header$1 = ({ defaultLayout: e, onClose: t, isDragging: n }) => {
  const { userInteractionStore: o } = useStores(), r = useRef(null), { materialPopupFocusOnRender: i } = o.get();
  return useEffect(() => {
    r.current && i && r.current.focus();
  }, [r, i]), /* @__PURE__ */ jsx(Wrapper$6, { $defaultLayout: e, $isDragging: n, className: "materialSelectorPopup", children: !e && /* @__PURE__ */ jsx(Button$2, { onClick: t, children: /* @__PURE__ */ jsx(SsrIcon, { paths: CrossIcon }) }) });
}, isDefaultLayout = (e) => e === "default", RecentlyUsedWrapper = styled.div(
  () => css`
    padding: ${SkapaTheme.spacing.space125}px 0;
    border-bottom: ${SkapaTheme.border.thickness.thin}px solid ${SkapaTheme.color.border.light};
  `,
  ({ $defaultLayout: e }) => e && css`
      padding: ${SkapaTheme.spacing.space100}px 0;
      border-top: ${SkapaTheme.border.thickness.thin}px solid ${SkapaTheme.color.border.light};
      margin-top: ${SkapaTheme.spacing.space200}px;
    `
), RecentMaterialWrapper = styled.div`
  display: flex;
  padding-top: ${SkapaTheme.spacing.space25}px;
  gap: ${SkapaTheme.spacing.space75}px;
`, RecentlyUsed = ({
  layout: e,
  recentMaterials: t,
  allWallsSelected: n,
  onApplyMaterial: o,
  onBlurMaterial: r,
  onFocusMaterial: i,
  onHoverMaterial: s
}) => {
  const { translate: a } = useI18n(), l = useId(), d = isDefaultLayout(e), c = useCallback(
    (m) => {
      o(m, n), sendEvent(InsightsEventType.APPLY_RECENTLY_USED_MATERIAL, {
        materialName: m.name,
        materialDescription: m.description,
        allWallsSelected: n
      });
    },
    [o, n]
  );
  return /* @__PURE__ */ jsxs(RecentlyUsedWrapper, { $defaultLayout: d, "data-testid": "kvadrat-material-recently-used-section", children: [
    /* @__PURE__ */ jsx(Text$2, { tagName: "span", bodySize: "s", children: /* @__PURE__ */ jsx("span", { id: l, children: a("materialSelectorRecentlyUsedTitle") }) }),
    /* @__PURE__ */ jsx(RecentMaterialWrapper, { "aria-labelledby": l, role: "list", children: t.map((m) => /* @__PURE__ */ jsx(
      Material,
      {
        material: m,
        layout: "compact",
        onApply: c,
        onBlur: (p) => r(p, n),
        onFocus: (p) => i(p, n),
        onHover: (p) => s(p, n),
        role: "listitem",
        testId: `kvadrat-material-recently-used-${m.name.replace(/\s/g, "")}`
      },
      m.id
    )) })
  ] });
}, Wrapper$5 = styled.div(
  () => css`
    z-index: 201;
    width: 220px;
    background-color: ${SkapaTheme.color.background.default};
    position: relative;
    overflow-y: hidden;
    box-shadow: 0px ${SkapaTheme.spacing.space25}px ${SkapaTheme.spacing.space25}px rgba(0, 0, 0, 0.25);
  `,
  ({ $defaultLayout: e }) => e && css`
      width: 100%;
      box-shadow: none;
    `
), Content = styled.div(
  () => css`
    position: relative;
    height: 250px;
    overflow: hidden auto;
    padding: 10px;
  `,
  ({ $defaultLayout: e }) => e && css`
      height: auto;
      min-height: 250px;
    `
), ToggleWrapper = styled.div`
  padding: 10px 10px 0 10px;
`, MaterialWrapper = styled.div(
  ({ $isDragging: e }) => css`
    display: grid;
    grid-template-columns: repeat(4, 35px);
    padding: ${SkapaTheme.spacing.space125}px 10px 10px 10px;
    gap: 6px 12px;
    justify-content: space-between;
    pointer-events: ${e ? "none" : "auto"};
  `,
  ({ $defaultLayout: e }) => e && css`
      grid-template-columns: repeat(auto-fill, 80px);
      text-align: center;
      gap: ${SkapaTheme.spacing.space150}px;
      padding: ${SkapaTheme.spacing.space200}px 0;
    `
), useSelectionToggle = (e) => {
  const { collidableType: t, selectedMaterial: n } = e, [o, r] = useState(0), i = o === 1, { blueprintStore: s } = useStores();
  let a = !0;
  if (t === CollidableType.WALL) {
    const {
      rooms: [l]
    } = s.get(), { walls: d } = l;
    a = d.reduce((c, m) => m.materialId === n ? c : !1, !0);
  }
  return [{ selectedIndex: o, allWallsSelected: i, allWallsSameMaterial: a }, r];
}, CATEGORY_SELECTOR_CLASS = "kvadratCategorySelector", AddNewMaterialWrapper = styled.div`
  padding: 20px 14px;
`, SkeletonMaterials = memo(({ layout: e }) => /* @__PURE__ */ jsx(Fragment, { children: [...Array(20).keys()].map((t) => /* @__PURE__ */ jsx(MaterialSkeleton, { layout: e, showName: isDefaultLayout(e) }, `loading-material-${t}`)) })), MaterialSelector = forwardRef(
  ({
    materialCategories: e,
    recentMaterials: t,
    selectedMaterial: n,
    isLoading: o,
    layout: r = "default",
    onApplyMaterial: i,
    onBlurMaterial: s,
    onFocusMaterial: a,
    onHoverMaterial: l,
    onClose: d,
    className: c,
    isDragging: m,
    collidableType: p,
    style: g,
    testId: f
  }, h) => {
    const [E, I] = useState(!1), { translate: R } = useI18n(), { userInteractionStore: A } = useStores(), { selectedCollidable: F } = A.get(), z = [
      {
        text: R("materialSelectorSelectedSurface")
      },
      {
        text: R("materialSelectorAllWalls")
      }
    ], [ne, k] = useState(0), [{ selectedIndex: q, allWallsSelected: X, allWallsSameMaterial: ae }, ve] = useSelectionToggle({
      collidableType: p,
      selectedMaterial: n
    }), [De, Le] = useState(!1), ue = useId(), le = e[ne], we = isDefaultLayout(r), ee = useCallback(
      (de) => {
        de.target instanceof HTMLElement && !de.target.closest(`.${CATEGORY_SELECTOR_CLASS}`) && De && Le(!1);
      },
      [De, Le]
    );
    useEffect(() => (document.addEventListener("click", ee), () => {
      document.removeEventListener("click", ee);
    }), [ee]);
    const W = (de) => {
      Le((ye) => !ye), sendEvent(InsightsEventType.TOGGLE_MATERIAL_CATEGORY, {
        category: e[de].name,
        categoryTags: e[de].tags
      }), k(de);
    }, Z = () => {
      d == null || d();
    }, he = (de, ye) => {
      ve(ye);
    }, Ce = t && t.length > 0;
    return /* @__PURE__ */ jsxs(Wrapper$5, { ref: h, className: c, $defaultLayout: we, style: g, "data-testid": f, children: [
      !o && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Header$1, { defaultLayout: we, onClose: Z, isDragging: !!m }),
        /* @__PURE__ */ jsx(
          CategorySelector,
          {
            defaultLayout: we,
            materialCategories: e.map((de) => de.name),
            selectedCategoryIndex: ne,
            setCategory: W,
            className: CATEGORY_SELECTOR_CLASS
          }
        ),
        !we && isWallCollidable(F) && /* @__PURE__ */ jsx(ToggleWrapper, { className: "materialSelectorPopup", children: /* @__PURE__ */ jsx(Toggle, { onClick: he, activeIndex: q, buttons: z, fluid: !0 }) })
      ] }),
      /* @__PURE__ */ jsxs(Content, { $defaultLayout: we, children: [
        /* @__PURE__ */ jsxs(Fragment, { children: [
          !o && Ce && /* @__PURE__ */ jsx(
            RecentlyUsed,
            {
              layout: r,
              recentMaterials: t,
              allWallsSelected: X,
              onApplyMaterial: i,
              onBlurMaterial: s,
              onFocusMaterial: a,
              onHoverMaterial: l
            }
          ),
          /* @__PURE__ */ jsxs(
            MaterialWrapper,
            {
              $defaultLayout: we,
              $isDragging: !!m,
              className: "materialSelectorPopup",
              "aria-busy": o,
              "aria-labelledby": ue,
              role: "list",
              children: [
                o && /* @__PURE__ */ jsx(SkeletonMaterials, { layout: r }),
                !o && le && le.materials.map((de) => /* @__PURE__ */ jsx(
                  Material,
                  {
                    material: de,
                    checked: ae && X && de.id === n || !X && de.id === n,
                    layout: r,
                    showName: isDefaultLayout(r),
                    onApply: (ye) => i(ye, X),
                    onBlur: (ye) => s(ye, X),
                    onFocus: (ye) => a(ye, X),
                    onHover: (ye) => l(ye, X),
                    testId: `kvadrat-material-${de.name.replace(/\s/g, "")}`,
                    role: "listitem",
                    toggleButton: !0
                  },
                  de.id
                )),
                !o && (le == null ? void 0 : le.type) === "color" && /* @__PURE__ */ jsx(AddMaterial, { onClick: () => I(!0), layout: r })
              ]
            }
          )
        ] }),
        E && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("hr", {}),
          /* @__PURE__ */ jsx(AddNewMaterialWrapper, { children: /* @__PURE__ */ jsx(
            CustomMaterialForm,
            {
              onAccept: (de) => {
                I(!1), i({
                  name: de,
                  id: "custom-" + de,
                  url: "",
                  previewUrl: "",
                  colorCode: de
                });
              },
              onReject: () => I(!1)
            }
          ) })
        ] })
      ] })
    ] });
  }
), Coverings = ({ collidableType: e }) => {
  const { blueprintStore: t, userInteractionStore: n, i18nStore: o } = useStores(), { translate: r } = o, { onNotification: i } = useKvadratApi(), s = useApplyMaterial(e), a = useSelectedMaterial(), l = useCoveringMaterialId(e), [d, c] = useRecentMaterials(e), m = useSelectedCollidable(), p = useMenuContext();
  useEffect(() => {
    const { materialPopupOpen: q } = n.get();
    return n.setAllowMaterialPopup(!1), () => {
      n.setIsMaterialPopupOpen(q), n.setIsContextMenuOpen(!1), n.setAllowMaterialPopup(!0);
    };
  }, []), useEffect(() => {
    if (m && m.type !== e)
      switch (m.type) {
        case CollidableType.CEILING:
          p.goTo(MenuState.CEILING_COVERINGS, !0);
          break;
        case CollidableType.WALL:
          p.goTo(MenuState.WALL_COVERINGS, !0);
          break;
        case CollidableType.FLOOR:
          p.goTo(MenuState.FLOOR_COVERINGS, !0);
          break;
      }
  }, [m]);
  const { data: g, error: f, isLoading: h } = useMaterials();
  if (f)
    return i.emit({
      type: "error",
      title: r("errorGenericTitle"),
      message: r("errorGenericMessage")
    }), null;
  const E = addCustomMaterialsToCategory(g ?? [], t.get().materials, "color"), I = COLLIDABLE_MATERIALCATEGORY_MAP[e] || "", R = E.filter((q) => q.tags.includes(I)), A = (q) => (X, ae) => {
    s(X, { commit: q, all: ae }), q && c(X);
  }, F = A(), z = A(!0), ne = () => {
    t.resetPreviewMaterials();
  }, k = (a == null ? void 0 : a.id) ?? l;
  return /* @__PURE__ */ jsx(
    MaterialSelector,
    {
      isLoading: h,
      materialCategories: R,
      onApplyMaterial: z,
      onBlurMaterial: ne,
      onFocusMaterial: F,
      onHoverMaterial: F,
      selectedMaterial: k,
      recentMaterials: d,
      testId: `kvadrat-${e.toLowerCase()}-material-selector`
    }
  );
}, CeilingCoverings = () => /* @__PURE__ */ jsx(Coverings, { collidableType: CollidableType.CEILING }), FloorCoverings = () => /* @__PURE__ */ jsx(Coverings, { collidableType: CollidableType.FLOOR }), WallCoverings = () => /* @__PURE__ */ jsx(Coverings, { collidableType: CollidableType.WALL });
class BlueprintComponent extends CustomComponent {
  constructor(n) {
    super();
    C(this, "typeId", CustomComponentIds.BLUEPRINT_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !1);
    this.blueprint = n;
  }
  eq(n) {
    return isEqual(this.blueprint, n.blueprint);
  }
}
function getBlueprintComponent(e) {
  return e.getComponent(CustomComponentIds.BLUEPRINT_COMPONENT_ID) ?? null;
}
function hasBlueprintComponent(e) {
  return e.hasComponent(CustomComponentIds.BLUEPRINT_COMPONENT_ID);
}
function getDescendantsWithBlueprint(e) {
  return HierarchyUtils.getDescendantsWithComponent(e, CustomComponentIds.BLUEPRINT_COMPONENT_ID);
}
function isCustomComponentSerializationKey(e) {
  return /^kv-(\w|-)+\w$/.test(e);
}
class CustomComponentDeserializer {
  constructor() {
    C(this, "thisClassIsGuaranteedToNotModifyOrQueryCoreState", !0);
  }
  canHandle(t) {
    return isCustomComponentSerializationKey(t) && deserializerRegistry.has(t);
  }
  deserialize(t, n) {
    if (!isCustomComponentSerializationKey(t))
      throw new Error(`Cannot deserialize for non-Kvadrat key: ${t}`);
    return deserializerRegistry.get(t)(n.toString());
  }
}
class CustomMeshComponent extends CustomComponent {
  constructor(n, o = new Vector(0, 0, 0), r = new Vector(0, 0, 0)) {
    super();
    C(this, "typeId", CustomComponentIds.CUSTOM_MESH_COMPONENT);
    C(this, "doStoreInSnapshot", !1);
    this.meshId = n, this.offsetPosition = o, this.offsetRotation = r;
  }
  eq(n) {
    return isEqual(n, this);
  }
}
function getCustomMeshComponent(e) {
  return e.getComponent(CustomComponentIds.CUSTOM_MESH_COMPONENT) ?? null;
}
function hasCustomMeshComponent(e) {
  return e.hasComponent(CustomComponentIds.CUSTOM_MESH_COMPONENT);
}
function getDescendantsWithCustomMesh(e) {
  return HierarchyUtils.getDescendantsWithComponent(e, CustomComponentIds.CUSTOM_MESH_COMPONENT);
}
function removeCustomMeshComponent(e) {
  e.removeComponent(CustomComponentIds.CUSTOM_MESH_COMPONENT);
}
class DisabledRoomConnectorsConfigComponent {
  constructor(t) {
    C(this, "typeId", ComponentIds.DISABLED_ROOM_CONNECTORS_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !0);
    C(this, "serializable", !1);
    this.connectorKeys = t;
  }
  eq(t) {
    return xor(this.connectorKeys, t.connectorKeys).length === 0;
  }
  addEnabledConnector(t) {
    return this.connectorKeys.includes(t) ? this : new DisabledRoomConnectorsConfigComponent([...this.connectorKeys, t]);
  }
  removeEnabledConnector(t) {
    return this.connectorKeys.includes(t) ? new DisabledRoomConnectorsConfigComponent(this.connectorKeys.filter((n) => n !== t)) : this;
  }
}
class EditingComponent extends CustomComponent {
  constructor() {
    super(...arguments);
    C(this, "doStoreInSnapshot", !0);
    C(this, "typeId", CustomComponentIds.EDITING_COMPONENT_ID);
  }
  eq() {
    return !1;
  }
}
function hasEditingComponent(e) {
  return e.hasComponent(CustomComponentIds.EDITING_COMPONENT_ID);
}
function getEditingComponent(e) {
  return e.getComponent(CustomComponentIds.EDITING_COMPONENT_ID) ?? null;
}
function getDescendantWithEditing(e) {
  return HierarchyUtils.getDescendantWithComponent(e, CustomComponentIds.EDITING_COMPONENT_ID) ?? null;
}
function removeEditingComponent(e) {
  e.removeComponent(CustomComponentIds.EDITING_COMPONENT_ID);
}
class EditorModeComponent extends CustomComponent {
  constructor(n, o, r) {
    super();
    C(this, "typeId", CustomComponentIds.EDITOR_MODE_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !0);
    this.mode = n, this.view = o, this.frameSelected = r;
  }
  eq(n) {
    return this.mode === n.mode && this.view === n.view && !this.frameSelected;
  }
}
function hasEditorModeComponent(e) {
  return e.hasComponent(CustomComponentIds.EDITOR_MODE_COMPONENT_ID);
}
function getEditorModeComponent(e) {
  return (e && e.getComponent(CustomComponentIds.EDITOR_MODE_COMPONENT_ID)) ?? null;
}
function removeEditorModeComponent(e) {
  e.removeComponent(CustomComponentIds.EDITOR_MODE_COMPONENT_ID);
}
class GridComponent extends CustomComponent {
  constructor(n, o) {
    super();
    C(this, "typeId", CustomComponentIds.GRID_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !0);
    this.size = n, this.divisions = o;
  }
  eq(n) {
    return this.size === n.size && this.divisions === n.divisions;
  }
}
function getGridComponent(e) {
  return (e && e.getComponent(CustomComponentIds.GRID_COMPONENT_ID)) ?? null;
}
function removeGridComponent(e) {
  e.removeComponent(CustomComponentIds.GRID_COMPONENT_ID);
}
class KvadratActiveComponent extends CustomComponent {
  constructor() {
    super(...arguments);
    C(this, "typeId", CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !0);
  }
  eq() {
    return !0;
  }
}
function hasKvadratActiveComponent(e) {
  return e.hasComponent(CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID);
}
function removeKvadratActiveComponent(e) {
  e.removeComponent(CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID);
}
class UIResizeWidgetComponent extends CustomComponent {
  constructor() {
    super(...arguments);
    C(this, "typeId", CustomComponentIds.UI_WIDGET_COMPONENT);
    C(this, "doStoreInSnapshot", !0);
  }
  eq() {
    return !0;
  }
}
function getUIWidgetComponent(e) {
  return e.getComponent(CustomComponentIds.UI_WIDGET_COMPONENT) ?? null;
}
function hasUIWidgetComponent(e) {
  return e.hasComponent(CustomComponentIds.UI_WIDGET_COMPONENT);
}
function getDescendantsWithUIWidgets(e) {
  return HierarchyUtils.getDescendantsWithComponent(e, CustomComponentIds.UI_WIDGET_COMPONENT);
}
function removeUIWidgetComponent(e) {
  e.removeComponent(CustomComponentIds.UI_WIDGET_COMPONENT);
}
class UpdateHostConnectionsComponent extends CustomComponent {
  constructor() {
    super(...arguments);
    C(this, "typeId", CustomComponentIds.UPDATE_HOST_CONNECTIONS_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !1);
  }
  eq() {
    return !0;
  }
}
function removeUpdateHostConnectionsComponent(e) {
  e.removeComponent(CustomComponentIds.UPDATE_HOST_CONNECTIONS_COMPONENT_ID);
}
class ViewerUpdateObserverComponent extends CustomComponent {
  constructor(n) {
    super();
    C(this, "doStoreInSnapshot", !1);
    C(this, "typeId", CustomComponentIds.VIEWER_UPDATE_OBSERVER_COMPONENT_ID);
    this.observer = n;
  }
  eq(n) {
    return Object.is(this.observer, n.observer);
  }
}
function removeViewerUpdateObserverComponent(e) {
  e.removeComponent(CustomComponentIds.VIEWER_UPDATE_OBSERVER_COMPONENT_ID);
}
class VisualGridPlaneComponent extends CustomComponent {
  constructor(n) {
    super();
    C(this, "typeId", CustomComponentIds.VISUAL_GRID_PLANE_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !1);
    this.object = n;
  }
  eq(n) {
    return this.object === n.object;
  }
}
function removeVisualGridPlaneComponent(e) {
  e.removeComponent(CustomComponentIds.VISUAL_GRID_PLANE_COMPONENT_ID);
}
class WallThicknessComponent extends CustomComponent {
  constructor() {
    super(...arguments);
    C(this, "typeId", CustomComponentIds.WALL_THICKNESS_COMPONENT_ID);
    C(this, "doStoreInSnapshot", !0);
  }
  eq() {
    return !0;
  }
}
function hasWallThicknessComponent(e) {
  return e.hasComponent(CustomComponentIds.WALL_THICKNESS_COMPONENT_ID);
}
function getChildrenWithThickness(e) {
  return HierarchyUtils.children(e).filter((t) => hasWallThicknessComponent(t));
}
function getDescendantsWithThickness(e) {
  return HierarchyUtils.getDescendantsWithComponent(e, CustomComponentIds.WALL_THICKNESS_COMPONENT_ID);
}
function removeWallThicknessComponent(e) {
  e.removeComponent(CustomComponentIds.WALL_THICKNESS_COMPONENT_ID);
}
const useSubscribableStore = (e) => {
  const [t, n] = useState(e.get());
  return useEffect(() => {
    const o = e.subscribe((r) => {
      n(r);
    });
    return () => {
      o();
    };
  }, [e, n]), t;
};
function useMeasurementSystem() {
  const { configurationStore: e } = useStores(), { measurementSystem: t } = useSubscribableStore(
    e
  );
  return {
    useMetric: t === "metric"
  };
}
const INCH_TO_CM = 2.54, CM_TO_METER = 0.01, FEET_TO_INCH = 12, MM_TO_INCH = 0.0393700787;
function getLowestFraction(e) {
  if (e === 0)
    return "";
  let t = 1e-15, n, o, r, i, s, a, l, d;
  for (d = e, l = Math.floor(d), o = 1, s = 0, n = l, i = 1; d - l > t * i * i; )
    d = 1 / (d - l), l = Math.floor(d), r = o, o = n, a = s, s = i, n = r + l * o, i = a + l * s;
  return n + "/" + i;
}
function roundFraction(e) {
  return Math.round(e * 8) / 8;
}
function inToFtIn(e) {
  const t = Math.round(e * 1e3) / 1e3, n = Math.floor(t / FEET_TO_INCH), o = t - FEET_TO_INCH * n, r = o % 1;
  return {
    feet: n,
    inches: o - r,
    fractions: getLowestFraction(roundFraction(r))
  };
}
function inToM(e) {
  return e * INCH_TO_CM * CM_TO_METER;
}
function mmToM(e) {
  return e / 1e3;
}
function mmToCm(e) {
  return e * 0.1;
}
function mToCm(e) {
  return e * 100;
}
function cmToMm(e) {
  return e * 10;
}
function cmToM(e) {
  return e / 100;
}
function mmToInch(e) {
  return e * MM_TO_INCH;
}
function cmToInch(e) {
  return e * MM_TO_INCH * 10;
}
function mToInch(e) {
  return e * MM_TO_INCH * 1e3;
}
function inchToCm(e) {
  return e * 2.54;
}
function inchToMm(e) {
  return e * 25.4;
}
function mToMm(e) {
  return e * 1e3;
}
function inchToM(e) {
  return 0.0254 * e;
}
function feetToM(e) {
  return 0.3048 * e;
}
function getClosestValue(e, t) {
  return t ? e : inchToMm(Math.ceil(mmToInch(e)));
}
function toDisplayCm(e, t = "sv-SE", n = 1) {
  const o = new Intl.NumberFormat(t);
  return e !== null && !isNaN(e) ? o.format(n >= 0 ? round(e, n) : e) : "";
}
function toDisplayFtIn(e) {
  if (!isNaN(e) && e >= 0) {
    const { feet: t, inches: n, fractions: o } = inToFtIn(e), r = [];
    return t && r.push(`${t}'`), n && (o ? r.push(n) : r.push(`${n}"`)), o && r.push(`${o}"`), r.filter(Boolean).join(" ") || '0"';
  }
  return "";
}
const fractionsReg = new RegExp(/^([1-9][0-9]*\/[1-9][0-9]*)["″”]?$/g), inchReg = new RegExp(/^(0|[1-9][0-9]*)["″”]?$/g), footReg = new RegExp(/^(\d{1,})[´'′]$/g), feetInchReg = new RegExp(/^([1-9][0-9]*)["″”'′´]?\s*([1-9][0-9]*)["″”'′´]?$/g), feetInchFractionReg = new RegExp(
  /^([0-9][0-9]*)["″”'′´]?\s*([0-9][0-9]*)["″”'′´]?\s*([0-9][0-9]*\/[0-9][0-9]*)["″”]?$/g
), numberFractionReg = new RegExp(/^([1-9][0-9]*)(["″”'′´]?)\s*([1-9][0-9]*\/[1-9][0-9]*)["″”]?$/), anyLastSignReg = new RegExp(/[-!$%^&*()_¤+#|~={}[\]:";<>?,./"″”´'′]$/), feetSignReg = new RegExp(/['′´]/), FEET_TO_INCHES = 12;
function parseFractions(input) {
  fractionsReg.lastIndex = 0;
  const result = fractionsReg.exec(input.trim());
  if (result)
    return eval(result[1]);
}
function parseInches(e) {
  inchReg.lastIndex = 0;
  const t = inchReg.exec(e.trim());
  if (t)
    return Number.parseInt(t[1]);
}
function parseFeet(e) {
  footReg.lastIndex = 0;
  const t = footReg.exec(e.trim());
  if (t)
    return Number.parseInt(t[1]) * FEET_TO_INCHES;
}
function parseFeetAndInches(e) {
  feetInchReg.lastIndex = 0;
  const t = feetInchReg.exec(e.trim());
  if (t)
    return Number.parseInt(t[1]) * FEET_TO_INCHES + Number.parseInt(t[2]);
}
function parseFeetInchesAndFractions(input) {
  feetInchFractionReg.lastIndex = 0, anyLastSignReg.lastIndex = 0;
  const result = feetInchFractionReg.exec(input.trim());
  if (result)
    return Number.parseInt(result[1]) * FEET_TO_INCHES + Number.parseInt(result[2]) + eval(result[3].replace(anyLastSignReg, ""));
}
function parseNumberAndFractions(input) {
  numberFractionReg.lastIndex = 0;
  const result = numberFractionReg.exec(input.trim());
  if (result) {
    const [, value, sign, fraction] = result, factor = feetSignReg.test(sign) ? FEET_TO_INCHES : 1;
    return parseInt(value) * factor + eval(fraction);
  }
}
const parseImperialOrder = [
  parseFractions,
  parseInches,
  parseFeet,
  parseNumberAndFractions,
  parseFeetAndInches,
  parseFeetInchesAndFractions
];
function parseImperial(e) {
  for (const t of parseImperialOrder) {
    const n = t(e);
    if (!isNaN(n))
      return n;
  }
}
function parseMetric(e) {
  return Number(e.replace(",", ".").replace(/\s/g, ""));
}
function validateWidthSize(e) {
  return e >= KVADRAT_WALL_WIDTH_MIN && e <= KVADRAT_WALL_WIDTH_MAX;
}
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cmToInch,
  cmToM,
  cmToMm,
  feetToM,
  getClosestValue,
  inToFtIn,
  inToM,
  inchToCm,
  inchToM,
  inchToMm,
  mToCm,
  mToInch,
  mToMm,
  mmToCm,
  mmToInch,
  mmToM,
  parseFeet,
  parseFeetAndInches,
  parseFeetInchesAndFractions,
  parseFractions,
  parseImperial,
  parseInches,
  parseMetric,
  parseNumberAndFractions,
  roundFraction,
  toDisplayCm,
  toDisplayFtIn,
  validateWidthSize
}, Symbol.toStringTag, { value: "Module" })), SubTitle = styled.div(({ theme: e }) => ({
  fontSize: e.font.size[100],
  marginBottom: e.space[50],
  marginTop: e.space[25]
})), Row = styled.div(({ theme: e }) => ({
  marginBottom: e.space[100]
})), JustifiedDiv = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: ${(e) => e.$isMobile ? "space-between" : e.$align || "space-around"};
  width: ${(e) => e.$isMobile && "100%"};
`, Input = ({
  autoFocus: e,
  className: t,
  disabled: n,
  formClassName: o,
  id: r,
  label: i,
  prefixLabel: s,
  suffixLabel: a,
  value: l,
  testId: d,
  valid: c,
  validationMessage: m,
  shouldValidate: p,
  onApply: g,
  onBlur: f,
  onChange: h,
  inputMode: E
}) => {
  const { kioskMode: I } = useFeatureFlagStore();
  return /* @__PURE__ */ jsx(
    FormField,
    {
      valid: c,
      validation: { msg: m },
      shouldValidate: p,
      className: o,
      children: /* @__PURE__ */ jsx(
        InputField,
        {
          id: r,
          type: "text",
          "aria-live": "polite",
          className: t,
          autoFocus: e,
          disabled: n,
          label: i,
          onInput: (ne) => {
            h == null || h(ne.target.value);
          },
          onFocus: (ne) => {
            I && new KeyboardManager().setFocus(ne.target);
          },
          onBlur: (ne) => {
            f == null || f(ne.target.value), g == null || g(ne.target.value), I && new KeyboardManager().removeFocus();
          },
          prefixLabel: s,
          suffixLabel: a,
          defaultValue: l,
          "data-testid": d,
          onKeyPress: (ne) => {
            g && ne.key === "Enter" && g(ne.target.value);
          },
          inputMode: E
        }
      )
    }
  );
}, InlineSubTitle = styled(SubTitle)(
  ({ theme: e }) => css`
    display: flex;
    align-items: center;
    column-gap: ${e.space[75]};
  `
);
function updateDoorHandlePosition(e, t, n) {
  const o = getKvadratId(t);
  return o ? e.setDoorHandleSide(o, n) : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
}
function EditDoorHandleSide({ entity: e }) {
  const { translate: t } = useI18n(), n = useKvadratApi(), o = getDoorComponent(e), r = [
    {
      text: t("doorHandleSideLeft"),
      value: it.LEFT
    },
    {
      text: t("doorHandleSideRight"),
      value: it.RIGHT
    }
  ], [i, s] = useState(
    r.findIndex((l) => l.value === (o == null ? void 0 : o.handleLocation))
  );
  function a(l, d) {
    i !== d && (s(d), decorateInsightEventWith(
      {
        interactionZone: InsightsInteractionOrigin.SIDE_MENU,
        interactionType: l.detail > 0 ? InsightsInteractionType.CLICKED : InsightsInteractionType.KEY_DOWN
      },
      () => updateDoorHandlePosition(n, e, r[d].value)
    ));
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(InlineSubTitle, { children: /* @__PURE__ */ jsx(Section, { children: /* @__PURE__ */ jsx(H, { children: t("doorHandleSide") }) }) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Toggle, { buttons: r, activeIndex: i, onClick: a }) })
  ] });
}
function updateOpeningDirection(e, t, n) {
  const o = getKvadratId(t);
  return o ? e.setOpeningDirection(o, n) : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
}
function EditOpeningSide({ entity: e }) {
  const { translate: t } = useI18n(), n = useKvadratApi(), o = getOpeningDirectionComponent(e), r = [
    {
      text: t("doorOpeningDirectionOutwards"),
      value: Pn.OUTWARDS
    },
    {
      text: t("doorOpeningDirectionInwards"),
      value: Pn.INWARDS
    }
  ], [i, s] = useState(
    r.findIndex((l) => l.value === (o == null ? void 0 : o.openingDirection))
  );
  function a(l, d) {
    i !== d && (s(d), decorateInsightEventWith(
      {
        interactionZone: InsightsInteractionOrigin.SIDE_MENU,
        interactionType: l.detail > 0 ? InsightsInteractionType.CLICKED : InsightsInteractionType.KEY_DOWN
      },
      () => updateOpeningDirection(n, e, r[d].value)
    ));
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SubTitle, { children: /* @__PURE__ */ jsx(Section, { children: /* @__PURE__ */ jsx(H, { children: t("doorOpeningDirection") }) }) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Toggle, { buttons: r, activeIndex: i, onClick: a }) })
  ] });
}
const StyledParagraph$1 = styled(Text$2)`
  margin-bottom: ${({ theme: e }) => e.space[100]};
`;
function EditDoor({ entity: e }) {
  var c;
  const t = useKvadratApi(), { translate: n } = useI18n(), { useMetric: o } = useMeasurementSystem(), r = HierarchyUtils.parent(e), i = useWallFeatureWidth(
    e,
    r ? getWallLength(r) : KVADRAT_WALL_WIDTH_MAX,
    getClosestValue(MINIMUM_DOOR_WIDTH, o)
  ), s = useWallFeatureHeight(
    e,
    t.getCeilingHeight(),
    getClosestValue(MINIMUM_DOOR_HEIGHT, o)
  ), a = ((c = getDoorComponent(e)) == null ? void 0 : c.doorType) !== Wn.OPENING, l = o ? n("unitCm") : "", d = o ? InputModeEnum.decimal : InputModeEnum.measurement;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(SubTitle, { children: /* @__PURE__ */ jsx(Section, { children: /* @__PURE__ */ jsx(H, { children: n("sizeLabel") }) }) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
      Input,
      {
        id: "kvadrat-door-width-input",
        type: "number",
        label: n("width"),
        suffixLabel: l,
        inputMode: d,
        value: i.formattedValue,
        onChange: i.setValue,
        onApply: i.applyValue,
        validationMessage: i.error,
        valid: !i.error,
        shouldValidate: !!i.error
      },
      `Use metric: ${o.toString()}`
    ) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
      Input,
      {
        id: "kvadrat-door-height-input",
        type: "number",
        label: n("height"),
        suffixLabel: l,
        inputMode: d,
        value: s.formattedValue,
        onChange: s.setValue,
        onApply: s.applyValue,
        validationMessage: s.error,
        valid: !s.error,
        shouldValidate: !!s.error
      },
      `Use metric: ${o.toString()}`
    ) }),
    a && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Section, { children: [
      /* @__PURE__ */ jsx(SubTitle, { children: /* @__PURE__ */ jsx(H, { children: n("wallFeaturePositionLabel") }) }),
      /* @__PURE__ */ jsx(StyledParagraph$1, { tagName: "p", children: n("doorHandleSideTooltip") }),
      /* @__PURE__ */ jsx(EditOpeningSide, { entity: e }),
      /* @__PURE__ */ jsx(EditDoorHandleSide, { entity: e })
    ] }) })
  ] });
}
function EditWindow({ entity: e }) {
  const t = useKvadratApi(), { translate: n } = useI18n(), { useMetric: o } = useMeasurementSystem(), r = HierarchyUtils.parent(e), i = useWallFeatureWidth(
    e,
    r ? getWallLength(r) : KVADRAT_WALL_WIDTH_MAX,
    getClosestValue(MINIMUM_WINDOW_WIDTH, o)
  ), { height: s, groundClearance: a } = useWallFeatureHeightAndClearance(
    e,
    t.getCeilingHeight(),
    getClosestValue(MINIMUM_WINDOW_HEIGHT, o)
  ), l = o ? n("unitCm") : "", d = o ? InputModeEnum.decimal : InputModeEnum.measurement;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(SubTitle, { children: /* @__PURE__ */ jsx(Section, { children: /* @__PURE__ */ jsxs(H, { children: [
      n("sizeLabel"),
      ":"
    ] }) }) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
      Input,
      {
        id: "kvadrat-window-width-input",
        type: "number",
        label: n("width"),
        suffixLabel: l,
        inputMode: d,
        value: i.formattedValue,
        onChange: i.setValue,
        onApply: i.applyValue,
        validationMessage: i.error,
        valid: !i.error,
        shouldValidate: !!i.error
      },
      `Use metric: ${o.toString()}`
    ) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
      Input,
      {
        id: "kvadrat-window-height-input",
        type: "number",
        label: n("height"),
        suffixLabel: l,
        inputMode: d,
        value: s.formattedValue,
        onChange: s.setValue,
        onApply: s.applyValue,
        validationMessage: s.error,
        valid: !s.error,
        shouldValidate: !!s.error
      },
      `Use metric: ${o.toString()}`
    ) }),
    /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(
      Input,
      {
        id: "kvadrat-window-ground-clearance-input",
        type: "number",
        label: n("groundClearance"),
        suffixLabel: l,
        inputMode: d,
        value: a.formattedValue,
        onChange: a.setValue,
        onApply: a.applyValue,
        validationMessage: a.error,
        valid: !a.error,
        shouldValidate: !!a.error
      },
      `Use metric: ${o.toString()}`
    ) })
  ] });
}
const EditFeature = () => {
  const { entity: e } = useContext(EditedEntityContext), { key: t } = useHistoryUpdates([
    // ignore everything except UNDO and REDO
    "TAKE_SNAPSHOT",
    "DISCARD_SNAPSHOT",
    "CLEAR"
  ]);
  return e ? /* @__PURE__ */ jsxs(React.Fragment, { children: [
    hasWindowComponent(e) && /* @__PURE__ */ jsx(EditWindow, { entity: e }),
    hasDoorComponent(e) && /* @__PURE__ */ jsx(EditDoor, { entity: e })
  ] }, t) : null;
}, doorIcon = `
<svg viewBox="0 0 32 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 0H0V64H32V0Z" stroke="#111111" stroke-width="5" fill="white" />
  <path d="M26 30V34H28V30H26Z" fill="#111111" />
</svg>
`, doorOpeningIcon = `
<svg viewBox="0 0 69 66" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 65H15.4606V1H55.8299V65H69" stroke="#111111" stroke-width="3" fill="white" />
</svg>
`, windowIcon = `
<svg viewBox="0 0 50 66" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24.9996 2.23125V63.7697M2.6 33H47.4M1 1H49V65H1V1Z" stroke="#111111" stroke-width="3" fill="white" />
</svg>
`, PredefinedElements = (e, t) => [
  {
    title: e("menuItemWindow"),
    img: windowIcon,
    testId: "window",
    wallFeature: {
      type: Lt.WINDOW,
      windowType: Rn.FIXED,
      size: {
        width: getClosestValue(1e3, t),
        height: getClosestValue(1200, t),
        depth: getClosestValue(5, t)
      },
      groundClearance: getClosestValue(1100, t),
      handleLocation: it.LEFT
    }
  },
  {
    title: e("menuItemDoor"),
    img: doorIcon,
    testId: "door",
    wallFeature: {
      type: Lt.DOOR,
      doorType: Wn.SINGLE,
      size: {
        width: getClosestValue(900, t),
        height: getClosestValue(2100, t),
        depth: getClosestValue(15, t)
      },
      handleLocation: it.LEFT,
      openingDirection: Pn.OUTWARDS
    }
  },
  {
    title: e("menuItemDoorOpening"),
    img: doorOpeningIcon,
    testId: "door-opening",
    wallFeature: {
      type: Lt.DOOR,
      doorType: Wn.OPENING,
      size: {
        width: getClosestValue(900, t),
        height: getClosestValue(2100, t),
        depth: getClosestValue(5, t)
      },
      handleLocation: it.LEFT
    }
  }
], BayWindowRoomIcon = `
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M71.5 26L98 26L98 53V98L2 98L2 26L29 26H31V24L31 2L69.5 2V24V26H71.5Z" fill="white" stroke="black" stroke-width="4" />
</svg>
`, CuboidRoomIcon = `<svg width="100" height="70" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="96" height="66" fill="white" stroke="black" stroke-width="3" />
</svg>`, CuboidDoorWindowRoomIcon = `
<svg viewBox="0 0 100 76.959" xmlns="http://www.w3.org/2000/svg">
	<g fill="#fff" stroke="#000">
		<rect x="2" y="5.034" width="96" height="66" stroke-width="3" />
		<rect x="13.092" y=".94488" width="32.312" height="9.1922" stroke-width="1.8898" />
		<rect x="56.825" y="66.822" width="32.312" height="9.1922" stroke-width="1.8898" />
	</g>
</svg>`, LShapedRoomIcon = `
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M48 49.5L48 51.5L50 51.5L98 51.5L98 98L2 98L2 2L48 2L48 49.5Z" fill="white" stroke="black" stroke-width="4" />
</svg>
`, wallHeight = 2400;
function getLRoom() {
  return {
    corners: [
      { id: "corner-1", ...u(-2e3, 0, -2e3) },
      { id: "corner-2", ...u(0, 0, -2e3) },
      { id: "corner-3", ...u(0, 0, 1e3) },
      { id: "corner-4", ...u(3e3, 0, 1e3) },
      { id: "corner-5", ...u(3e3, 0, 3e3) },
      { id: "corner-6", ...u(-2e3, 0, 3e3) }
    ],
    walls: [
      { id: "wall-1", leftIndex: 0, rightIndex: 1, height: wallHeight },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: wallHeight },
      { id: "wall-3", leftIndex: 2, rightIndex: 3, height: wallHeight },
      { id: "wall-4", leftIndex: 3, rightIndex: 4, height: wallHeight },
      { id: "wall-5", leftIndex: 4, rightIndex: 5, height: wallHeight },
      { id: "wall-6", leftIndex: 5, rightIndex: 0, height: wallHeight }
    ],
    floors: [
      {
        id: "floor",
        nodes: [5, 4, 3, 2, 1, 0]
      }
    ],
    ceilings: [
      {
        id: "ceiling",
        nodes: [5, 4, 3, 2, 1, 0]
      }
    ]
  };
}
function getLRoomImperial() {
  return {
    corners: [
      { id: "corner-1", ...u(-2e3, 0, -2e3) },
      { id: "corner-2", ...u(260.6, 0, -2e3) },
      { id: "corner-3", ...u(260.6, 0, 1048) },
      { id: "corner-4", ...u(3308.6, 0, 1048) },
      { id: "corner-5", ...u(3308.6, 0, 3308.6) },
      { id: "corner-6", ...u(-2e3, 0, 3308.6) }
    ],
    walls: [
      { id: "wall-1", leftIndex: 0, rightIndex: 1, height: wallHeight },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: wallHeight },
      { id: "wall-3", leftIndex: 2, rightIndex: 3, height: wallHeight },
      { id: "wall-4", leftIndex: 3, rightIndex: 4, height: wallHeight },
      { id: "wall-5", leftIndex: 4, rightIndex: 5, height: wallHeight },
      { id: "wall-6", leftIndex: 5, rightIndex: 0, height: wallHeight }
    ],
    floors: [],
    ceilings: []
  };
}
function getBayWindowRoom() {
  return {
    corners: [
      { id: "corner-1", ...u(-2e3, 0, -1e3) },
      { id: "corner-2", ...u(0, 0, -1e3) },
      { id: "corner-3", ...u(0, 0, -3e3) },
      { id: "corner-4", ...u(2e3, 0, -3e3) },
      { id: "corner-5", ...u(2e3, 0, -1e3) },
      { id: "corner-6", ...u(4e3, 0, -1e3) },
      { id: "corner-7", ...u(4e3, 0, 3e3) },
      { id: "corner-8", ...u(-2e3, 0, 3e3) }
    ],
    walls: [
      { id: "wall-1", leftIndex: 0, rightIndex: 1, height: wallHeight },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: wallHeight },
      { id: "wall-3", leftIndex: 2, rightIndex: 3, height: wallHeight },
      { id: "wall-4", leftIndex: 3, rightIndex: 4, height: wallHeight },
      { id: "wall-5", leftIndex: 4, rightIndex: 5, height: wallHeight },
      { id: "wall-6", leftIndex: 5, rightIndex: 6, height: wallHeight },
      { id: "wall-7", leftIndex: 6, rightIndex: 7, height: wallHeight },
      { id: "wall-8", leftIndex: 7, rightIndex: 0, height: wallHeight }
    ],
    floors: [],
    ceilings: []
  };
}
function getBayWindowRoomImperial() {
  return {
    corners: [
      { id: "corner-1", ...u(-2336.8, 0, -866.4) },
      { id: "corner-2", ...u(-203.2, 0, -866.4) },
      { id: "corner-3", ...u(-203.2, 0, -3e3) },
      { id: "corner-4", ...u(1930.4, 0, -3e3) },
      { id: "corner-5", ...u(1930.4, 0, -866.4) },
      { id: "corner-6", ...u(4064, 0, -866.4) },
      { id: "corner-7", ...u(4064, 0, 3096) },
      { id: "corner-8", ...u(-2336.8, 0, 3096) }
    ],
    walls: [
      { id: "wall-1", leftIndex: 0, rightIndex: 1, height: wallHeight },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: wallHeight },
      { id: "wall-3", leftIndex: 2, rightIndex: 3, height: wallHeight },
      { id: "wall-4", leftIndex: 3, rightIndex: 4, height: wallHeight },
      { id: "wall-5", leftIndex: 4, rightIndex: 5, height: wallHeight },
      { id: "wall-6", leftIndex: 5, rightIndex: 6, height: wallHeight },
      { id: "wall-7", leftIndex: 6, rightIndex: 7, height: wallHeight },
      { id: "wall-8", leftIndex: 7, rightIndex: 0, height: wallHeight }
    ],
    floors: [],
    ceilings: []
  };
}
function getCuboidRoom(e = 5e3, t = 3e3, n = wallHeight) {
  return {
    corners: [
      { id: "corner-1", ...u(e * -0.5, 0, t * -0.5) },
      { id: "corner-2", ...u(e * 0.5, 0, t * -0.5) },
      { id: "corner-3", ...u(e * 0.5, 0, t * 0.5) },
      { id: "corner-4", ...u(e * -0.5, 0, t * 0.5) }
    ],
    walls: [
      { id: "wall-1", leftIndex: 0, rightIndex: 1, height: n },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: n },
      { id: "wall-3", leftIndex: 2, rightIndex: 3, height: n },
      { id: "wall-4", leftIndex: 3, rightIndex: 0, height: n }
    ],
    floors: [],
    ceilings: []
  };
}
function getCuboidRoomImperial() {
  return {
    corners: [
      { id: "corner-1", ...u(-2500, 0, -1500) },
      { id: "corner-2", ...u(2681.6, 0, -1500) },
      { id: "corner-3", ...u(2681.6, 0, 1548) },
      { id: "corner-4", ...u(-2500, 0, 1548) }
    ],
    walls: [
      { id: "wall-1", leftIndex: 0, rightIndex: 1, height: wallHeight },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: wallHeight },
      { id: "wall-3", leftIndex: 2, rightIndex: 3, height: wallHeight },
      { id: "wall-4", leftIndex: 3, rightIndex: 0, height: wallHeight }
    ],
    floors: [],
    ceilings: []
  };
}
function getCuboidRoomWithDoorAndWindowImperial() {
  return {
    corners: [
      { id: "corner-1", ...u(-2500, 0, -1500) },
      { id: "corner-2", ...u(2681.6, 0, -1500) },
      { id: "corner-3", ...u(2681.6, 0, 1548) },
      { id: "corner-4", ...u(-2500, 0, 1548) }
    ],
    walls: [
      {
        id: "wall-1",
        leftIndex: 0,
        rightIndex: 1,
        height: 2400.3,
        features: [
          {
            type: Lt.WINDOW,
            windowType: Rn.HINGED,
            size: {
              width: 700,
              height: 1e3,
              depth: 20
            },
            groundClearance: 1100,
            positionAlongWall: 795,
            id: void 0
          }
        ]
      },
      {
        id: "wall-2",
        leftIndex: 1,
        rightIndex: 2,
        height: 2400.3
      },
      {
        id: "wall-3",
        leftIndex: 2,
        rightIndex: 3,
        height: 2400.3,
        features: [
          {
            type: Lt.DOOR,
            doorType: Wn.SINGLE,
            size: {
              width: 800,
              height: 2100,
              depth: 50
            },
            positionAlongWall: 614.9999999999998,
            id: void 0
          }
        ]
      },
      {
        id: "wall-4",
        leftIndex: 3,
        rightIndex: 0,
        height: 2400.3
      }
    ],
    floors: [],
    ceilings: []
  };
}
function getCuboidRoomWithDoorAndWindow() {
  return {
    corners: [
      { id: "corner-1", ...u(-2500, 0, -1500) },
      { id: "corner-2", ...u(2500, 0, -1500) },
      { id: "corner-3", ...u(2500, 0, 1500) },
      { id: "corner-4", ...u(-2500, 0, 1500) }
    ],
    walls: [
      {
        id: "wall-1",
        leftIndex: 0,
        rightIndex: 1,
        height: 2400,
        features: [
          {
            type: Lt.WINDOW,
            windowType: Rn.HINGED,
            size: {
              width: 700,
              height: 1e3,
              depth: 20
            },
            groundClearance: 1e3,
            positionAlongWall: 975,
            id: void 0
          }
        ]
      },
      { id: "wall-2", leftIndex: 1, rightIndex: 2, height: 2400 },
      {
        id: "wall-3",
        leftIndex: 2,
        rightIndex: 3,
        height: 2400,
        features: [
          {
            type: Lt.DOOR,
            doorType: Wn.SINGLE,
            size: {
              width: 800,
              height: 2100,
              depth: 50
            },
            positionAlongWall: 805,
            id: void 0
          }
        ]
      },
      { id: "wall-4", leftIndex: 3, rightIndex: 0, height: 2400 }
    ],
    floors: [],
    ceilings: []
  };
}
const PredefinedRoomsData = (e, t, n, o) => [
  {
    title: o("predefinedRoomRectangleTitle"),
    testId: "kvadrat-predefined-menu-item-cuboid",
    img: CuboidRoomIcon,
    onClick: () => n(e ? getCuboidRoom() : getCuboidRoomImperial())
  },
  {
    title: o("predefinedRoomTitleLshape"),
    testId: "kvadrat-predefined-menu-item-l-shape",
    img: LShapedRoomIcon,
    onClick: () => n(e ? getLRoom() : getLRoomImperial())
  },
  {
    title: o("predefinedRoomTitleTshape"),
    testId: "kvadrat-predefined-menu-item-bay-window",
    img: BayWindowRoomIcon,
    onClick: () => n(e ? getBayWindowRoom() : getBayWindowRoomImperial())
  },
  t && {
    title: o("predefinedRoomRectangleTitle"),
    testId: "kvadrat-predefined-menu-item-cuboid-window-door",
    img: CuboidDoorWindowRoomIcon,
    onClick: () => n(
      e ? getCuboidRoomWithDoorAndWindow() : getCuboidRoomWithDoorAndWindowImperial()
    )
  }
].filter(Boolean);
function useI18n() {
  const { i18nStore: e } = useStores();
  return {
    ...useSubscribableStore(e),
    translate: e.translate
  };
}
function useMenuContext() {
  var f;
  const e = useKvadratApi(), { translate: t } = useI18n(), { useMetric: n } = useMeasurementSystem(), { featureFlagStore: o, userInteractionStore: r } = useStores(), i = o.get(), s = useContext(MenuContext), a = useContext(EditedEntityContext);
  if (!s)
    throw new Error("Menu context has not been initialized yet.");
  const l = (h) => {
    const E = { ...e.getBlueprint(), rooms: [h] };
    e.setBlueprint(E), e.reCenterView();
  }, d = async (h, E = "front-angled") => {
    const I = [MenuState.CEILING_COVERINGS, MenuState.FLOOR_COVERINGS, MenuState.WALL_COVERINGS];
    I.includes(h) && !I.includes(s.menuState) && r.clearSelectedCollidableId(), r.setIsContextMenuOpen(!1), s.goTo(h), await e.setEditorMode(EditorMode.EDITOR_MODE_3D, E);
  }, c = (a == null ? void 0 : a.entity) && getStructuralObjectTitleTranslationKey(a.entity), m = {
    [MenuState.CLOSED]: {
      type: MenuOptionType.LIST,
      page: {
        title: ""
      },
      items: []
    },
    [MenuState.MODIFY_ROOM]: {
      type: MenuOptionType.SECTIONS,
      page: {
        title: t("menuRoomsTitle")
      },
      items: [
        {
          title: t("menuRoomSectionPredefinedRooms"),
          type: MenuOptionType.BUTTONS,
          items: PredefinedRoomsData(n, !!i.devMode, l, t)
        }
      ]
    },
    [MenuState.STRUCTURAL_OBJECTS]: {
      type: MenuOptionType.SECTIONS,
      page: {
        title: t("menuWindowsDoorsTitle"),
        subTitle: t("menuRoomsSubtitle")
      },
      items: [
        {
          title: t("menuDoorTitle"),
          type: MenuOptionType.DRAG_BUTTONS,
          items: PredefinedElements(t, n).filter((h) => bt(h.wallFeature))
        },
        {
          title: t("menuWindowTitle"),
          type: MenuOptionType.DRAG_BUTTONS,
          items: PredefinedElements(t, n).filter((h) => Yt(h.wallFeature))
        }
      ]
    },
    [MenuState.ROOM_STYLE]: {
      type: MenuOptionType.LIST,
      page: {
        title: t("menuRoomStyleTitle")
      },
      items: [
        {
          title: t("menuWallCoveringTitle"),
          type: "icon",
          img: "https://content.dexf.ikea.com/cdn/images/customitem/K83xzEFJ4O/MSC42465546_00001140.svg",
          testId: "kvadrat-change-a-wall",
          onClick: () => d(MenuState.WALL_COVERINGS),
          imageAltText: t("menuWallCoveringAltImage")
        },
        {
          title: t("menuFloorCoveringTitle"),
          type: "icon",
          img: "https://content.dexf.ikea.com/cdn/images/customitem/hNlhFo03OM/MSC42465548_00001138.svg",
          testId: "kvadrat-change-a-floor",
          onClick: () => d(MenuState.FLOOR_COVERINGS),
          imageAltText: t("menuFloorCoveringAltImage")
        },
        {
          title: t("menuCeilingCoveringTitle"),
          type: "icon",
          img: "https://content.dexf.ikea.com/cdn/images/customitem/LlgNkKXEBe/MSC42465547_00001139.svg",
          testId: "kvadrat-change-a-ceiling",
          onClick: () => d(MenuState.CEILING_COVERINGS, "front"),
          imageAltText: t("menuCeilingCoveringAltImage")
        }
      ]
    },
    [MenuState.WALL_COVERINGS]: {
      type: MenuOptionType.COMPONENT,
      page: {
        title: t("menuWallCoveringTitle")
      },
      component: WallCoverings
    },
    [MenuState.FLOOR_COVERINGS]: {
      type: MenuOptionType.COMPONENT,
      page: {
        title: t("menuFloorCoveringTitle")
      },
      component: FloorCoverings
    },
    [MenuState.CEILING_COVERINGS]: {
      type: MenuOptionType.COMPONENT,
      page: {
        title: t("menuCeilingCoveringTitle")
      },
      component: CeilingCoverings
    },
    [MenuState.EDIT_STRUCTURAL_OBJECT]: {
      type: MenuOptionType.COMPONENT,
      page: {
        title: c ? t(c) : ""
      },
      component: EditFeature
    }
  }, p = m[s.menuState], g = ((f = m[s.previousMenuState[s.previousMenuState.length - 1]]) == null ? void 0 : f.page.title) || "";
  return { ...s, menuOptions: m, activeMenu: p, previousMenuStateTitle: g };
}
function getStructuralObjectTitleTranslationKey(e) {
  const t = getParametricObjectProperties(e);
  switch (t.type) {
    case Lt.WINDOW:
      return "menuEditWindowTitle";
    case Lt.DOOR:
      switch (t.doorType) {
        case Wn.OPENING:
          return "menuEditDoorOpeningTitle";
        case Wn.DOUBLE:
        case Wn.SINGLE:
          return "menuEditDoorTitle";
      }
  }
}
function useEditorStore() {
  const { editorStore: e } = useStores();
  return useSubscribableStore(e);
}
function useEditedEntity() {
  const { goTo: e, menuState: t } = useMenuContext(), n = useCore(), o = useKvadratApi(), { editorMode: r } = useEditorStore(), [i, s] = useState(
    () => getDescendantWithEditing(n.services.sceneManager.scene)
  ), a = useCallback(
    (d, c) => {
      const m = d === "remove" ? null : c;
      s(m), e(m ? MenuState.EDIT_STRUCTURAL_OBJECT : MenuState.CLOSED), r === EditorMode.EDITOR_MODE_3D && o.frameSelectedTarget();
    },
    [s, e, r]
  ), l = useCallback(
    (d) => {
      if (d !== "remove")
        return;
      const c = getDescendantWithEditing(n.services.sceneManager.scene);
      c && (c.addComponent(new EditingComponent()), c.addComponent(new SelectedComponent())), t === MenuState.EDIT_STRUCTURAL_OBJECT && a("update", c);
    },
    [s, e, a, t]
  );
  return useComponentListener(CustomComponentIds.EDITING_COMPONENT_ID, a), useComponentListener(ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID, l), i;
}
function useFeatureFlagStore() {
  const { featureFlagStore: e } = useStores();
  return useSubscribableStore(e);
}
function useHistoryUpdates(e = []) {
  const [t, n] = useState(null), [o, r] = useState(Date.now()), i = useCallback(
    (s, a, l) => {
      const d = l.historyEvent.name;
      e.includes(d) || (n(d), r(Date.now()));
    },
    [n, r, e.join(",")]
  );
  return useComponentListener(ComponentIds.HISTORY_CHANGED_EVENT_COMPONENT_ID, i), { key: o, eventType: t };
}
function useRangedValue(e, t, n, o) {
  const [r, i] = useState(e), [s, a] = useState(r), [l, d] = useState(""), { getMaxLimitError: c, getMinLimitError: m, noValueTranslation: p, customValidator: g } = o, f = () => d(""), h = () => {
    f(), i(s);
  }, E = (R) => {
    if (isNaN(R)) {
      d(p);
      return;
    }
    if (R < n) {
      d(m(n));
      return;
    }
    if (R > t) {
      d(c(t));
      return;
    }
    return !0;
  }, I = useCallback(
    (R) => {
      if (d(""), i(R), !E(R))
        return;
      const A = g == null ? void 0 : g(R);
      if (A) {
        d(A);
        return;
      }
      return !0;
    },
    [
      n,
      t,
      i,
      d,
      a,
      g,
      m,
      c,
      p
    ]
  );
  return {
    value: r,
    lastValidValue: s,
    setLastValidValue: a,
    minLimit: n,
    maxLimit: t,
    setValue: I,
    validateLimits: E,
    resetValue: h,
    error: l,
    clearError: f
  };
}
const convertToMMFrom = {
  cm: cmToMm,
  m: mToMm,
  mm: (e) => e
}, convertFromMMTo = {
  cm: mmToCm,
  m: mmToM,
  mm: (e) => e
};
function useRangedMeasurement(e, t, n, o) {
  const r = useKvadratApi(), { translate: i, locale: s } = useI18n(), a = useMemo(
    () => ({
      metricFormat: o.metricFormat,
      useMetric: o.useMetric
    }),
    [o.metricFormat, o.useMetric]
  ), [l, d] = useState(formatValue(e, s, a)), c = a.useMetric ? i("unitCm") : "", m = useCallback((I) => {
    var R;
    return (R = o.customValidator) == null ? void 0 : R.call(o, I);
  }, [o.customValidator]), p = useCallback(
    (I) => i(o.maxLimitTranslationKey, { unit: c, value: formatValue(I, s, a) }),
    [r, o.maxLimitTranslationKey, c, a]
  ), g = useCallback(
    (I) => i(o.minLimitTranslationKey, { unit: c, value: formatValue(I, s, a) }),
    [r, o.minLimitTranslationKey, c, a]
  ), f = useRangedValue(e, t, n, {
    ...o,
    noValueTranslation: i(o.noValueTranslationKey),
    getMaxLimitError: p,
    getMinLimitError: g,
    customValidator: m
  });
  useEffect(() => {
    d(formatValue(f.value, s, a));
  }, [o.useMetric, s, a]);
  const h = (I) => {
    const R = isNumber(I) ? I : parseStringValueToMM(I, a), A = a.useMetric ? ~~R : R;
    return d(isNumber(I) ? formatValue(A, s, a) : I), f.setValue(A);
  }, E = useCallback(
    (I, R) => {
      var ne;
      const A = isNumber(I) ? I : parseStringValueToMM(I, a), F = a.useMetric ? ~~A : A;
      if (!h(F))
        return;
      const z = (ne = o.applyValue) == null ? void 0 : ne.call(o, F, R);
      isErrorCode(z) ? d(formatValue(f.lastValidValue, s, a)) : (f.setLastValidValue(F), a.useMetric || d(formatValue(F, s, a)));
    },
    [o.applyValue, d, h, s, a]
  );
  return {
    ...f,
    applyValue: E,
    setValue: h,
    inputValue: l,
    formattedValue: formatValue(f.value, s, a)
  };
}
function formatValue(e, t, { useMetric: n, metricFormat: o }) {
  return n ? toDisplayCm(convertFromMMTo[o](e), t, -1) : toDisplayFtIn(mmToInch(e));
}
function parseStringValueToMM(e, { useMetric: t, metricFormat: n }) {
  if (t && e) {
    const o = parseMetric(e);
    return convertToMMFrom[n](o);
  }
  if (!t) {
    const o = parseImperial(e);
    return o === void 0 ? NaN : inchToMm(o);
  }
  return NaN;
}
const RECENT_MATERIAL_KEY = "IKEA_KVADRAT_RECENT_MATERIALS", useRecentMaterials = (e) => {
  const { configurationStore: t } = useStores(), { materialTags: n } = t.get(), o = `${RECENT_MATERIAL_KEY}_${e}`, [r, i] = useState(
    () => JSON.parse(window.localStorage.getItem(o) ?? "[]")
  );
  useEffect(() => {
    localStorage.setItem(o, JSON.stringify(r));
  }, [r]);
  const s = useCallback(
    (a) => {
      i((l) => l.some(({ id: d }) => d === a.id) ? l : uniqBy([a, ...l], "id").slice(0, 5));
    },
    [i]
  );
  return n != null && n.length ? [r.filter(
    (l) => n.some((d) => {
      var c;
      return (c = l.tags) == null ? void 0 : c.includes(d);
    })
  ), s] : [r, s];
};
function useSelectedCollidable() {
  const { userInteractionStore: e, selectedCollidableStore: t } = useStores(), [n, o] = useState();
  return useEffect(
    () => t.subscribe(() => o(e.get().selectedCollidable)),
    [t, o, e]
  ), n;
}
function useSelectedMaterial() {
  const { userInteractionStore: e } = useStores(), { selectedCollidable: t } = e.get();
  if (t && isCollidableWithMaterialSupport(t))
    return t.entity.material;
}
function getCeilingHeights(e) {
  const t = e.walls.flatMap(
    (o) => ht(o.height) ? o.height : o.height.vertices.map((r) => r.y)
  );
  return Array.from(new Set(t));
}
function createBlueprintStore(e) {
  const { subscribe: n, set: o } = writable(e);
  let r = e, i = writable(JSON.parse(JSON.stringify(e))), s;
  const a = writable(0);
  let l = r.rooms.map((M) => getDecoratedRoom(M, r.materials));
  function d(M) {
    r = M, l = r.rooms.map((b) => getDecoratedRoom(b, M.materials)), o(M);
  }
  function c(M) {
    i.set(JSON.parse(JSON.stringify(M)));
  }
  function m() {
    d(JSON.parse(JSON.stringify(get(i))));
  }
  function p() {
    return r;
  }
  function g() {
    return l;
  }
  function f(M) {
    if (M)
      return r.rooms[0].walls.find((b) => b.id === M);
  }
  function h(M) {
    if (M)
      return r.rooms[0].floors.find((b) => b.id === M);
  }
  function E(M) {
    if (M)
      return r.rooms[0].ceilings.find((b) => b.id === M);
  }
  function I(M) {
    if (M)
      return r.rooms[0].walls.flatMap((b) => b.features).find((b) => (b == null ? void 0 : b.id) === M);
  }
  function R(M) {
    if (M)
      return l[0].walls.find((b) => b.id === M);
  }
  function A(M) {
    if (M)
      return l[0].floors.find((b) => b.id === M);
  }
  function F(M) {
    if (M)
      return l[0].ceilings.find((b) => b.id === M);
  }
  function z(M) {
    return l[0].walls.flatMap((b) => b.features).find((b) => (b == null ? void 0 : b.id) === M);
  }
  function ne(M, b, L) {
    d(M), b && (sendEvent(InsightsEventType.SET_BLUEPRINT, M, L || IpexMomentEnum.nonInteraction), c(M)), a.set(Date.now());
  }
  function k(M, b, L = !0) {
    const x = f(M);
    if (!x)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const j = r.rooms[0], D = {
      ...b,
      id: b.id || generateId(getWallFeatureIds(r.rooms), "wall-feature-"),
      ...Yt(b) && {
        groundClearance: On(b.groundClearance, 0, x.height - b.size.height)
      }
    }, J = (x.features || []).concat(D).sort(te()), oe = {
      ...x,
      features: J
    }, se = hasInvalidWallFeatures(oe, j.corners);
    if (se)
      return se;
    const ke = replaceItemInArrayById(j.walls, M, oe), Re = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, {
        ...j,
        walls: ke
      })
    };
    return d(Re), L && c(Re), D;
  }
  function q(M, b) {
    const L = f(M);
    if (!L)
      return console.warn("Can not fix a wall feature on a wall that does not exist"), !1;
    const x = (L.features || []).concat(b).sort(te()), j = {
      ...L,
      features: x
    };
    return hasInvalidWallFeatures(j, r.rooms[0].corners);
  }
  function X(M) {
    if (!r.rooms[0])
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    let L;
    const { walls: x } = l[0];
    return Yt(M) ? L = getNextFreeWindowSpace(M, x) : bt(M) && (L = getNextFreeDoorSpace(M, x)), L ? k(L.wall.id, {
      ...M,
      positionAlongWall: L.positionAlongWall
    }) : ErrorCodes.WALL_FEATURE_NO_AVAILABLE_FREE_SPACE;
  }
  function ae(M, b, L = !0) {
    const x = ve(
      M,
      {
        positionAlongWall: b
      },
      !1
    );
    return isErrorCode(x) || L && (sendEvent(InsightsEventType.UPDATE_WALL_FEATURE_POSITION, {
      wallFeature: x,
      positionAlongWall: b,
      schema: r
    }), c(r)), x;
  }
  function ve(M, b, L = !0) {
    const x = r.rooms[0], j = I(M), D = z(M);
    if (!j || !D)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    const J = f(D.wallId);
    if (!J)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const oe = {
      ...j,
      ...b
    }, se = {
      ...J,
      features: replaceItemInArrayById(J.features || [], M, oe).sort(te())
    }, ke = hasInvalidWallFeatures(se, x.corners);
    if (ke)
      return ke;
    const Re = {
      ...x,
      walls: replaceItemInArrayById(x.walls, J.id, se)
    }, Ge = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, Re)
    };
    return d(Ge), L && (sendEvent(InsightsEventType.UPDATE_WALL_FEATURE, {
      updatedWallFeature: oe,
      schema: Ge
    }), c(Ge)), oe;
  }
  function De(M, b = !0) {
    var oe;
    const L = r.rooms[0], x = z(M), j = f(x == null ? void 0 : x.wallId);
    if (!j || !x)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    const D = {
      ...j,
      features: (oe = j.features) == null ? void 0 : oe.filter((se) => se.id !== M)
    }, J = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, {
        ...L,
        walls: replaceItemInArrayById(L.walls, j.id, D)
      })
    };
    d(J), b && c(J);
  }
  function Le(M, b, L = !0) {
    return ue(M, b, L);
  }
  function ue(M, b, L = !0) {
    const x = f(M);
    if (!x)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const j = r.rooms[0], D = {
      ...b,
      id: generateId(
        j.corners.map(({ id: Ve }) => Ve),
        "corner-"
      )
    }, J = [...j.corners, D];
    let oe, se;
    if (x.features) {
      const Ve = _($(b, J[x.leftIndex])), T = x.features.findIndex((G) => G.positionAlongWall > Ve);
      oe = T >= 0 ? x.features.slice(0, T) : x.features, oe.length < x.features.length && (se = x.features.slice(T).map((G) => ({
        ...G,
        positionAlongWall: G.positionAlongWall - Ve
      })));
    }
    const ke = {
      id: generateId(getWallIds(r.rooms), "wall-"),
      features: se,
      leftIndex: J.length - 1,
      rightIndex: x.rightIndex,
      height: Z(0),
      materialId: x.materialId
    }, Re = replaceItemInArrayById(j.walls, x.id, {
      ...x,
      features: oe,
      rightIndex: J.length - 1
    });
    Re.push(ke);
    const Ge = j.floors.map((Ve, T) => ({
      ...Ve,
      nodes: [...addNodeBasedOnWallIndexes(j.floors[T].nodes, x.leftIndex, x.rightIndex, J.length)]
    })), Fe = j.ceilings.map((Ve, T) => ({
      ...Ve,
      nodes: [
        ...addNodeBasedOnWallIndexes(j.ceilings[T].nodes, x.leftIndex, x.rightIndex, J.length)
      ]
    })), Xe = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, {
        ...j,
        corners: J,
        walls: Re,
        ceilings: Fe,
        floors: Ge
      })
    };
    d(Xe), L && (sendEvent(InsightsEventType.SPLIT_WALL, {
      roomIndex: 0,
      wallId: x.id,
      splitPosition: b,
      schema: Xe
    }), c(Xe));
  }
  function le(M, b, L = !0) {
    const x = f(M);
    if (!x)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const j = r.rooms[0], { leftIndex: D, rightIndex: J } = x, oe = j.corners[D], se = j.corners[J];
    let ke = replaceItemInArray(j.corners, D, {
      ...oe,
      ...U(oe, b)
    });
    ke = replaceItemInArray(ke, J, {
      ...se,
      ...U(se, b)
    });
    const Re = [D, J], Ge = j.walls.map((G) => Re.includes(G.leftIndex) ? repositionWallFeaturesAfterWallResize(G, j.corners, ke) : G);
    let Fe = {
      ...j,
      corners: ke,
      walls: Ge
    };
    const Xe = hasInvalidWallFeaturesInRoom(Fe);
    if (Xe)
      return Xe;
    const Ve = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, Fe)
    };
    d(Ve);
    const T = hasIntersectingWallsInRoom(getDecoratedRoom(Fe, Ve.materials));
    if (T)
      return T;
    L && (sendEvent(InsightsEventType.MOVE_WALL, {
      schema: s.get(),
      diff: b,
      p1: Ve.rooms[0].corners[D],
      p2: Ve.rooms[0].corners[J]
    }), c(Ve));
  }
  function we(M, b, L = !0) {
    const x = r.rooms[0], j = x.corners.findIndex((Fe) => Fe.id === M);
    if (j < 0)
      return ErrorCodes.INVALID_CORNER_REFERENCE;
    const D = {
      ...x.corners[j],
      ...U(x.corners[j], b)
    }, J = replaceItemInArray(x.corners, j, D), oe = x.walls.map((Fe) => Fe.leftIndex === j ? repositionWallFeaturesAfterWallResize(Fe, x.corners, J) : Fe);
    let se = {
      ...x,
      corners: J,
      walls: oe
    };
    const ke = hasInvalidWallFeaturesInRoom(se);
    if (ke)
      return ke;
    const Re = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, se)
    };
    d(Re);
    const Ge = hasIntersectingWallsInRoom(getDecoratedRoom(se, Re.materials));
    if (Ge)
      return Ge;
    L && (sendEvent(InsightsEventType.MOVE_CORNER, {
      schema: s.get(),
      diff: b,
      ...D
    }), c(Re));
  }
  function ee(M, b = !0) {
    var Te;
    const L = r.rooms[0];
    if (!L || L.corners.length === 3)
      return ErrorCodes.CORNER_INSUFFICIENT_REMAINING;
    const x = L.corners.findIndex((Q) => Q.id === M);
    if (x < 0)
      return ErrorCodes.INVALID_CORNER_REFERENCE;
    const j = L.corners.filter((Q, Se) => Se !== x), [D, J] = L.walls.filter(
      (Q) => Q.leftIndex === x || Q.rightIndex === x
    );
    if (!D || !J) {
      console.warn("Can only delete a corner if both its walls are found");
      return;
    }
    const oe = R(D.rightIndex === x ? D.id : J.id), se = R(D.rightIndex === x ? J.id : D.id);
    if (!oe || !se) {
      console.warn("Can only delete a corner if both its walls are found");
      return;
    }
    const [ke] = [oe, se].sort((Q, Se) => (Se == null ? void 0 : Se.length) - (Q == null ? void 0 : Q.length)).filter((Q) => Q == null ? void 0 : Q.materialId).map((Q) => Q == null ? void 0 : Q.materialId), Re = _($(se.p2, oe.p1)), Ge = (Te = se.features) == null ? void 0 : Te.map((Q) => {
      const Se = se.length - Q.positionAlongWall, pt = Re - Se;
      return {
        ...Q,
        positionAlongWall: pt
      };
    }), Fe = [...oe.features || [], ...Ge || []].sort(te()).filter((Q, Se, pt) => !(Q.positionAlongWall < 0 || Q.positionAlongWall + Q.size.width > Re || isErrorCode(areWallFeaturesColliding(pt[Se - 1], pt[Se])))), Xe = {
      height: D.height,
      id: generateId(getWallIds(r.rooms), "wall-"),
      features: Fe,
      leftIndex: oe.leftIndex,
      rightIndex: se.rightIndex,
      materialId: ke
    }, Ve = [...L.walls, Xe].filter((Q) => !(oe.id === Q.id || se.id === Q.id)).map((Q) => decreaseIndicesForWall(Q, x)), T = L.ceilings.map((Q) => ({
      ...Q,
      nodes: Q.nodes.filter((Se) => Se !== x).map((Se) => decreaseIfNumHigher(Se, x))
    })), G = L.floors.map((Q) => ({
      ...Q,
      nodes: Q.nodes.filter((Se) => Se !== x).map((Se) => decreaseIfNumHigher(Se, x))
    })), ce = {
      ...L,
      corners: j,
      walls: Ve,
      ceilings: T,
      floors: G
    }, Ee = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, ce)
    }, xe = isInvalidRoom(getDecoratedRoom(ce, Ee.materials));
    if (xe)
      return sendEvent(InsightsEventType.ERROR_DELETE_CORNER, {
        cornerIndex: x,
        cornerId: M,
        error: "Change would cause an invalid room"
      }), xe;
    d(Ee), b && c(Ee);
  }
  function W(M, b, L, x) {
    if (KVADRAT_WALL_WIDTH_MAX < b)
      return ErrorCodes.WALL_RESIZE_EXCEED_MAX_VALUE;
    const j = R(M);
    if (!j)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const D = L === Direction.RIGHT ? j.p1 : j.p2, J = L === Direction.RIGHT ? j.nextWall.p1 : j.previousWall.p2, oe = $(J, D), se = P(V(oe), b), ke = {
      ...U(se, D),
      id: generateId(
        r.rooms[0].corners.map(({ id: Q }) => Q),
        "corner-"
      )
    };
    let Re;
    if (me(oe, se))
      return ErrorCodes.WALL_RESIZE_SAME_SIZE;
    const Ge = L === Direction.RIGHT ? j.nextWall : j.previousWall;
    hasPerpedicularAngleBasedOnDirection(j, L) && extrudeWallWhenZeroAngle(Ge, ue);
    let Fe = r.rooms[0];
    const Xe = L === Direction.RIGHT ? j.rightIndex : j.leftIndex, Ve = L === Direction.RIGHT ? j.nextWall.rightIndex : j.previousWall.leftIndex;
    if (hasPerpedicularAngleBasedOnDirection(j, L)) {
      const Q = Fe.corners[Ve], Se = {
        ...Q,
        ...U($(ke, J), Q)
      };
      Re = replaceItemInArray(Fe.corners, Xe, ke), Re = replaceItemInArray(Re, Ve, Se);
    } else
      Re = replaceItemInArray(Fe.corners, Xe, ke);
    const T = [];
    L === Direction.LEFT && pe(Re[Xe], j.previousWall.p1) < 1 && T.push(j.leftIndex), L === Direction.RIGHT && pe(Re[Xe], j.nextWall.p2) < 1 && T.push(j.rightIndex), T.length && (T.sort((Q, Se) => Se - Q).forEach((Q) => {
      const Se = Fe.corners[Q];
      Re = Re.filter((pt) => pt.id !== Se.id), ee(Se.id, !1);
    }), Fe = r.rooms[0]);
    const G = [Xe, Ve], ce = Fe.walls.map((Q) => G.includes(Q.leftIndex) ? repositionWallFeaturesAfterWallResize(Q, Fe.corners, Re) : Q), Ee = {
      ...Fe,
      corners: Re,
      walls: ce
    }, xe = isInvalidRoom(getDecoratedRoom(Ee, r.materials));
    if (!x && xe)
      return sendEvent(InsightsEventType.ERROR_RESIZE_WALL, {
        oldMeasurement: oe,
        newMeasurement: se,
        errorCode: ErrorCodes[xe],
        error: "Change would cause an invalid room"
      }), xe;
    const Te = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, Ee)
    };
    d(Te), x || (sendEvent(InsightsEventType.RESIZE_WALL, {
      oldMeasurement: oe,
      newMeasurement: se,
      schema: Te
    }), c(Te));
  }
  function Z(M = 0) {
    const b = r.rooms[M];
    if (!b)
      return 0;
    const L = getCeilingHeights(b);
    if (L.length > 1)
      throw new KvadratReferenceError(ErrorCodes.CEILING_HEIGHT_NOT_CONSTANT);
    return L.length === 1 ? L[0] : 0;
  }
  function he(M, b = !0) {
    const L = On(M, KVADRAT_CEILING_HEIGHT_MIN, KVADRAT_CEILING_HEIGHT_MAX);
    if (Z() == L)
      return;
    const x = {
      ...r,
      rooms: r.rooms.map((D) => ({
        ...D,
        walls: D.walls.map((J) => ({
          ...J,
          height: L
        }))
      }))
    }, j = findFirstTruthyValue(x.rooms, (D) => hasInvalidWallFeaturesInRoom(D));
    if (j)
      return j;
    d(x), b && (sendEvent(InsightsEventType.SET_CEILING_HEIGHT, {
      clampedHeight: L,
      schema: x
    }), c(x));
  }
  function Ce() {
    const M = isInvalidSchema(g());
    if (M)
      return m(), sendEvent(InsightsEventType.ERROR_ROOM_CHANGE, {
        invalidRoom: r.rooms[0],
        error: "Change would cause an invalid room"
      }), M;
    c(r);
  }
  function de(M, b, L = !0) {
    const x = r.rooms[0], j = f(M);
    if (!j)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    let D = {
      ...r.materials
    };
    D[b.id] || (D[b.id] = b);
    const J = {
      ...j,
      materialId: b.id
    }, oe = {
      ...x,
      walls: replaceItemInArrayById(x.walls, j.id, J)
    }, se = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, oe),
      materials: D
    };
    d(se), L && (sendEvent(InsightsEventType.UPDATE_WALL_MATERIAL, {
      schema: se,
      material: b,
      wallId: M
    }), c(se));
  }
  function ye(M, b = !0) {
    if (r.rooms[0].walls.forEach((L) => {
      de(L.id, M, !1);
    }), b)
      return sendEvent(InsightsEventType.UPDATE_ALL_WALL_MATERIALS, {
        schema: r,
        material: M
      }), Ce();
  }
  function Ae(M, b, L = !0) {
    const x = r.rooms[0], j = h(M);
    if (!j)
      return ErrorCodes.INVALID_FLOOR_REFERENCE;
    let D = {
      ...r.materials
    };
    D[b.id] || (D[b.id] = b);
    const J = {
      ...j,
      materialId: b.id
    }, oe = {
      ...x,
      floors: replaceItemInArrayById(x.floors, j.id, J)
    }, se = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, oe),
      materials: D
    };
    d(se), L && (sendEvent(InsightsEventType.UPDATE_FLOOR_MATERIAL, {
      schema: se,
      material: b,
      floorId: M
    }), c(se));
  }
  function He(M, b = !0) {
    if (r.rooms[0].floors.forEach((L) => {
      Ae(L.id, M, !1);
    }), !!b)
      return sendEvent(InsightsEventType.UPDATE_ALL_FLOOR_MATERIALS, {
        schema: r,
        material: M
      }), Ce();
  }
  function be(M, b, L = !0) {
    const x = r.rooms[0], j = E(M);
    if (!j)
      return ErrorCodes.INVALID_CEILING_REFERENCE;
    let D = { ...r.materials };
    D[b.id] || (D[b.id] = b);
    const J = {
      ...j,
      materialId: b.id
    }, oe = {
      ...x,
      ceilings: replaceItemInArrayById(x.ceilings, j.id, J)
    }, se = {
      ...r,
      rooms: replaceItemInArray(r.rooms, 0, oe),
      materials: D
    };
    d(se), L && (sendEvent(InsightsEventType.UPDATE_CEILING_MATERIAL, {
      schema: se,
      material: b,
      ceilingId: M
    }), c(se));
  }
  function Y(M, b = !0) {
    if (r.rooms[0].ceilings.forEach((L) => {
      be(L.id, M, !1);
    }), !!b)
      return sendEvent(InsightsEventType.UPDATE_ALL_CEILING_MATERIALS, {
        schema: r,
        material: M
      }), Ce();
  }
  function Me() {
  }
  function Qe(M) {
    const b = l[0], L = b.corners.findIndex(byId(M)), [x, j] = b.walls.filter(
      (D) => D.leftIndex === L || D.rightIndex === L
    );
    return (x.length < MERGE_OFFSET || j.length < MERGE_OFFSET) && ee(M, !1), Ce();
  }
  function Je(M, b) {
    throw new Error("NOT IMPLEMENTED");
  }
  function qe(M) {
    throw new Error("NOT IMPLEMENTED");
  }
  function nt() {
  }
  function ct() {
  }
  function at() {
  }
  function et() {
    return [];
  }
  function ut() {
  }
  function je(M, b) {
    throw new Error("NOT IMPLEMENTED");
  }
  function ot(M, b) {
    throw new Error("NOT IMPLEMENTED");
  }
  return s = {
    dispose: at,
    subscribe: n,
    resetToSavedState: m,
    setSavedState: c,
    subscribeToCompoundUpdates: i.subscribe,
    subscribeBlueprintReplaced: a.subscribe,
    setBlueprint: ne,
    get: p,
    getDecoratedRooms: g,
    getCeilingHeight: Z,
    updateSetCeilingHeight: nt,
    setCeilingHeight: he,
    endSetCeilingHeight: ct,
    commitChanges: Ce,
    getWallById: f,
    getFloorById: h,
    getCeilingById: E,
    getWallFeatureById: I,
    getDecoratedWallById: R,
    getDecoratedFloorById: A,
    getDecoratedCeilingById: F,
    getDecoratedWallFeatureById: z,
    // Walls
    resizeWall: W,
    updateMoveWall: Je,
    endMoveWall: qe,
    moveWall: le,
    applyMaterialToWall: de,
    applyMaterialToAllWalls: ye,
    // Floors
    applyMaterialToFloor: Ae,
    applyMaterialToAllFloors: He,
    // Floors
    applyMaterialToCeiling: be,
    applyMaterialToAllCeilings: Y,
    // Corners
    addCorner: Le,
    splitWall: ue,
    updateMoveCorner: Me,
    endMoveCorner: Qe,
    moveCorner: we,
    deleteCorner: ee,
    // Wall features
    addWallFeature: k,
    addWallFeatureToClosestWall: X,
    updateWallFeature: ve,
    updateWallFeaturePosition: ae,
    isInvalidPositionForFeature: q,
    deleteWallFeature: De,
    setDoorHandleSide: je,
    setOpeningDirection: ot,
    getProductPolyhedra: et,
    resetPreviewMaterials: ut
  }, s;
}
const canvas2d = writable();
function createCanvasStore(e, t) {
  return derived([e, t], ([n, o]) => {
    const { scale: r, offset: i } = o;
    let s = Number.MAX_SAFE_INTEGER, a = Number.MAX_SAFE_INTEGER, l = Number.MIN_SAFE_INTEGER, d = Number.MIN_SAFE_INTEGER;
    n.forEach((m) => {
      for (let p = 0; p < m.corners.length; p++) {
        const g = m.corners[p], { x: f, y: h } = ge.add(i, ge.muls(asVec2(g), r));
        f < s && (s = f), h < a && (a = h), f > l && (l = f), h > d && (d = h);
      }
    });
    const c = MEASUREMENT_OFFSET;
    return {
      bounds: {
        // This fulfills the requirement of measurement lines being fully inside the canvas when auto-zooming
        minX: s - c,
        minY: a - c,
        maxX: l + c,
        maxY: d + c
      }
    };
  });
}
function getBoundsUsingCanvas(e, t = { width: 0, height: 0 }) {
  let n = Number.MAX_SAFE_INTEGER, o = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER, i = Number.MIN_SAFE_INTEGER;
  e.flatMap((g) => g.corners).forEach((g) => {
    n = Math.min(n, g.x), o = Math.max(o, g.x), r = Math.min(r, g.z), i = Math.max(i, g.z);
  });
  const s = o - n, a = i - r, l = t.width < 700 ? 4e3 : t.width < 1200 ? 2500 : 1e3, d = t.height < 500 ? 5e3 : t.height < 800 ? 3e3 : t.height < 1200 ? 2e3 : 1e3, m = Math.min(t.width / (s + l), t.height / (a + d), 0.8);
  return {
    bounds: {
      x: s * m,
      y: a * m
    },
    scale: m,
    min: { x: n, y: r },
    max: { x: o, y: i }
  };
}
function getCanvasCenter(e, t = { width: 0, height: 0 }) {
  const { min: n, scale: o, bounds: r } = getBoundsUsingCanvas(e, t);
  return {
    bounds: r,
    scale: o,
    offset: {
      x: -n.x * o + t.width / 2 - r.x / 2,
      y: -n.y * o + t.height / 2 - r.y / 2
    }
  };
}
function autoZoomCenterCanvas(e, t, n, o = !1) {
  const { offset: r } = e.get(), { offset: i, scale: s } = getCanvasCenter(t, n), { min: a, max: l } = getBoundsUsingCanvas(t, n), d = ge.add(ge.muls(a, s), r), c = ge.add(ge.muls(l, s), r);
  (o || d.x < 0 || d.y < 0 || c.x > n.width || c.y > n.height) && (e.setZoom(s), e.setOffset(i));
}
function getInBoundsOffset(e, t, n, o = { width: 0, height: 0 }) {
  const { min: r, max: i } = getBoundsUsingCanvas(e, o), s = 30, a = ge.add(ge.muls(r, n), t), l = ge.add(ge.muls(i, n), t);
  let d = { ...t }, c = !1;
  return l.x < s && (d.x = t.x + s - l.x, c = !0), l.y < s && (d.y = t.y + s - l.y, c = !0), a.x > o.width - s && (c = !0, d.x = t.x + o.width - s - a.x), a.y > o.height - s && (d.y = t.y + o.height - s - a.y, c = !0), {
    ...d,
    roomOutsideScreen: c
  };
}
let measurementEl;
function getMeasurementSizeApproximation(e, t) {
  const n = t === "metric" ? toDisplayCm(mmToCm(e)) + " cm" : toDisplayFtIn(mmToInch(e));
  return measurementEl = measurementEl != null && measurementEl.parentElement ? measurementEl : document.getElementById(KVADRATMEASUREMENT_ID), measurementEl ? (n && (measurementEl.innerText = n), y(Math.max(measurementEl.clientWidth, 40), Math.max(measurementEl.clientHeight, 40))) : y(40, 40);
}
function getAllCollidablesForRooms(e, t, n) {
  return e.flatMap((o) => [
    // The order below determines which collidables are found first when doing collision detection.
    // So even if a corner and a wall are on the same coordinates, the corner will be identified as
    // the hovered collidable and not the wall
    ...t ? getCornerCollidables(o) : [],
    ...n ? getWallFeatureCollidables(o.walls) : [],
    ...getWallCollidables(o.walls),
    ...getFloorCollidables(o.floors),
    ...getCeilingCollidables(o.ceilings)
  ]);
}
function getFloorCollidables(e) {
  return e.map((t, n) => ({
    type: CollidableType.FLOOR,
    index: n,
    id: t.id,
    entity: t
  }));
}
function getCeilingCollidables(e) {
  return e.map((t, n) => ({
    type: CollidableType.CEILING,
    index: n,
    id: t.id,
    entity: t
  }));
}
function getWallCollidables(e) {
  return e.map((t, n) => ({
    type: CollidableType.WALL,
    id: t.id,
    index: n,
    entity: t
  }));
}
function getWallFeatureCollidables(e) {
  return e.flatMap(
    (t) => (t.features || []).map((n, o) => ({
      type: CollidableType.WALL_FEATURE,
      id: n.id,
      index: o,
      entity: n
    }))
  );
}
function getCornerCollidables(e) {
  return e.corners.map((t, n) => ({
    id: t.id,
    type: CollidableType.CORNER,
    index: n,
    entity: {
      ...t,
      previousWall: e.walls.filter((o) => o.leftIndex === n).sort()[0],
      nextWall: e.walls.filter((o) => o.rightIndex === n).sort()[0]
    }
  }));
}
function findCollidable(e, t) {
  if (t)
    return e.find((n) => t === n.id);
}
function getLocalSpaceCoordinateFromScreenPointer(e, t, n) {
  const { x: o, y: r } = ge.sub(e, t);
  return st(u(o, 0, r), n);
}
function getGridAlignedCoordinate({ x: e, y: t, z: n }, o) {
  return u(
    Math.floor(e / o) * o,
    Math.floor(t / o) * o,
    Math.floor(n / o) * o
  );
}
function nearestPointOnWall(e, t) {
  const { p1: n, p2: o } = e;
  return We(n, o, t);
}
function getSnapAlignedCoordinate(e, t, n) {
  let o, r, i, s = Number.MAX_SAFE_INTEGER, a = Number.MAX_SAFE_INTEGER, l = Number.MAX_SAFE_INTEGER, d = !1, c = !1, m = !1, { x: p, y: g, z: f } = e;
  for (const h of t)
    o = Math.abs(h.x - e.x), r = Math.abs(h.y - e.y), i = Math.abs(h.z - e.z), o < s && o < n && (s = o, p = h.x, d = !0), r < a && r < n && (a = r, g = h.y, c = !0), i < l && i < n && (l = i, f = h.z, m = !0);
  return {
    x: p,
    y: g,
    z: f,
    isSnappingX: d,
    isSnappingY: c,
    isSnappingZ: m
  };
}
function getGridSnapSize(e, t) {
  const n = inchToMm(1);
  return e > 0.4 ? t ? 1 : n / 16 : e > 0.2 ? t ? 5 : n / 16 : t ? cmToMm(1) : n;
}
function repositionWhenOutsideCanvas(e, t, n, o, r, i, s) {
  let a = t;
  return e.x + r + n > i && (a.x = e.x - r - n), e.y + r + n > s && (a.y = e.y - r - o), a;
}
function getTooltipPosition(e, t, n) {
  var l;
  const o = (l = document.getElementById("tooltip")) == null ? void 0 : l.getBoundingClientRect();
  let r = (o == null ? void 0 : o.width) || 70;
  const i = (o == null ? void 0 : o.height) || 35, s = 20;
  let a = ge.add(e, y(s, -i / 2));
  return a = repositionWhenOutsideCanvas(
    e,
    a,
    r,
    i,
    s,
    t,
    n
  ), a;
}
function getContextMenuPosition(e, t, n, o, r) {
  var m;
  const i = (m = document.getElementById("kvadrat-context-menu")) == null ? void 0 : m.getBoundingClientRect();
  let s = (i == null ? void 0 : i.width) || 104;
  const a = (i == null ? void 0 : i.height) || 56, l = 20;
  let d = ge.add(e, y(l, l));
  const c = () => {
    if (e.x > d.x) {
      if (r > 1)
        for (let p = 1; p < r; p++)
          s += 44;
      d = { x: d.x - s, y: d.y };
    }
    e.y > d.y && (d = { x: d.x, y: d.y - a });
  };
  if (isWallCollidable(t) || isWallFeatureCollidable(t)) {
    const p = ge.muls(
      ge.normalize(y(-t.entity.direction.z, t.entity.direction.x)),
      l
    );
    d = ge.add(e, p), c();
  }
  if (isCornerCollidable(t)) {
    const p = ge.muls(
      ge.normalize(y(-t.entity.previousWall.direction.z, t.entity.previousWall.direction.x)),
      l
    ), g = ge.muls(
      ge.normalize(y(-t.entity.nextWall.direction.z, t.entity.nextWall.direction.x)),
      l
    ), f = ge.avg(p, g);
    d = ge.add(e, f), c();
  }
  return d = repositionWhenOutsideCanvas(
    e,
    d,
    s,
    a,
    l,
    n,
    o
  ), d;
}
function showWhenPrioritizedMeasurements(e, t) {
  return !t || !!e.isPrioritized;
}
function createCollidablesStore(e, t) {
  const n = derived(
    [e, t],
    ([, o]) => getAllCollidablesForRooms(
      e.getDecoratedRooms(),
      !!(o.dragCorners || o.splitWalls),
      !!o.wallFeatures
    )
  );
  return {
    subscribe: n.subscribe,
    get() {
      return get(n);
    }
  };
}
const defaultConfiguration = {
  // Include other default settings here
  dexfBaseUrl: "https://api.dexf.ikea.com/",
  dexfSegment: "production",
  dexfAppName: "kvadrat",
  kompisProxyUrl: "https://kompis-proxy.azurewebsites.net",
  measurementSystem: "metric",
  uiOptions: {
    enableActionMenu: !1,
    enable2D3DToggle: !1
  },
  enabledFeatures: {
    thickWalls: !0,
    editor2D: !0,
    splitWalls: !0,
    dragCorners: !0,
    devMode: !1
  },
  lightingOptions: {
    // TODO: Point to a proper DEXF asset url when DEXF allows .env files
    environmentMapUrl: "https://content.dexf.ikea.com/cdn/images/setting/ead38377-b63c-4598-8ddc-b9950ef67b90.jpg",
    environmentMapIntensity: 1.8
  },
  analytics: "prod",
  materialDefaults: [
    {
      id: tn.CEILING,
      url: "https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/7uge7ob7tide.glb",
      previewUrl: ""
    },
    {
      id: tn.WALL,
      url: "https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/7uge7ob7tide.glb",
      previewUrl: ""
    },
    {
      id: tn.THICKNESS,
      url: "",
      previewUrl: "",
      colorCode: "#ccc"
    },
    {
      id: tn.WALL_HOLE_SIDE,
      url: "",
      previewUrl: "",
      colorCode: "#FFFFFF"
    },
    {
      id: tn.WALLFEATURE,
      url: "",
      previewUrl: "",
      colorCode: "#FFFFFF"
    },
    {
      id: tn.WALLFEATURE_ELEMENT,
      url: "",
      previewUrl: "",
      colorCode: "#FFFFFF"
    },
    {
      id: tn.FLOOR,
      url: "https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/6jnmdxs9nscp.glb",
      previewUrl: ""
    },
    {
      id: tn.SKIRTING,
      url: "",
      previewUrl: "",
      colorCode: "#FFFFFF"
    }
  ]
};
function createConfigurationStore(e) {
  let t = mergeConfiguration(defaultConfiguration, e);
  const { subscribe: n, set: o } = writable(t), r = n((d) => {
    t = d;
  });
  function i(d) {
    o(mergeConfiguration(t, d));
  }
  function s() {
    return {
      ...t,
      proxyUrl: t.useProxy && t.kompisProxyUrl || ""
    };
  }
  function a() {
    r();
  }
  function l(d) {
    o({ ...t, materialTags: d });
  }
  return {
    subscribe: n,
    dispose: a,
    applyConfiguration: i,
    get: s,
    setMaterialTags: l
  };
}
function mergeConfiguration(e, { materialDefaults: t = [], ...n }) {
  const o = uniqBy([...t, ...e.materialDefaults || []], "id");
  return {
    ...merge({}, e, n),
    materialDefaults: o
  };
}
const id$2 = "kvadrat-door-opening", template$2 = {
  id: "kvadrat-door-opening",
  family: "KVADRAT",
  size: {
    width: 900,
    height: 2100,
    depth: 5
  },
  comSize: {
    width: 900,
    height: 2100,
    depth: 5
  }
}, doorOpeningProduct = {
  id: id$2,
  template: template$2
}, id$1 = "kvadrat-door", template$1 = {
  id: "kvadrat-door",
  family: "KVADRAT",
  size: {
    width: 900,
    height: 2100,
    depth: 15
  },
  comSize: {
    width: 900,
    height: 2100,
    depth: 15
  }
}, doorProduct = {
  id: id$1,
  template: template$1
}, id = "kvadrat-window", template = {
  id: "kvadrat-window",
  family: "KVADRAT",
  size: {
    width: 1e3,
    height: 1200,
    depth: 5
  },
  comSize: {
    width: 1e3,
    height: 1200,
    depth: 5
  }
}, windowProduct = {
  id,
  template
}, templateId$3 = "kvadrat-door", name$3 = "base door", description$3 = "base template for doors", inherits$3 = [
  "kvadrat-door-opening"
], components$3 = {
  connectors: [
    {
      name: "door-top-front-edge",
      type: "host",
      offers: [
        "door-top-front-edge"
      ],
      tags: [
        "kvadrat"
      ],
      position: {
        origin: {
          relation: "left-top-front",
          relativeTo: "bound"
        },
        transform: [
          35,
          -20,
          0,
          0,
          0,
          0
        ]
      },
      lastPosition: {
        origin: {
          relation: "right-top-front",
          relativeTo: "bound"
        },
        transform: [
          -35,
          -20,
          0,
          0,
          0,
          0
        ]
      }
    }
  ]
}, doorTemplate = {
  templateId: templateId$3,
  name: name$3,
  description: description$3,
  inherits: inherits$3,
  components: components$3
}, templateId$2 = "kvadrat-door-opening", name$2 = "base opening", description$2 = "base template for openings", inherits$2 = [
  "kvadrat-wall-feature"
], components$2 = {
  connectors: [
    {
      name: "edge-constrain",
      type: "guest",
      demands: [
        "wall-floor-edge"
      ],
      position: {
        origin: {
          relation: "center-bottom-back",
          relativeTo: "bound"
        },
        transform: [
          0,
          0,
          0,
          45,
          0,
          0
        ]
      },
      required: !0,
      priority: 0
    }
  ]
}, doorOpeningTemplate = {
  templateId: templateId$2,
  name: name$2,
  description: description$2,
  inherits: inherits$2,
  components: components$2
}, templateId$1 = "kvadrat-window", name$1 = "base window", description$1 = "base template for windows", inherits$1 = [
  "kvadrat-wall-feature"
], components$1 = {
  recommendedInitialPositionFromFloor: 1500,
  connectors: [
    {
      name: "window-to-window-align-top-left",
      type: "align",
      demands: [
        "window-to-window-top-right"
      ],
      offers: [
        "window-to-window-top-left"
      ],
      position: {
        origin: {
          relation: "top-left-back",
          relativeTo: "bound"
        }
      },
      activationDistance: 25
    },
    {
      name: "window-to-window-align-top-right",
      type: "align",
      demands: [
        "window-to-window-top-left"
      ],
      offers: [
        "window-to-window-top-right"
      ],
      position: {
        origin: {
          relation: "top-right-back",
          relativeTo: "bound"
        }
      },
      activationDistance: 25
    },
    {
      name: "window-to-window-align-bottom-right",
      type: "align",
      demands: [
        "window-to-window-bottom-left"
      ],
      offers: [
        "window-to-window-bottom-right"
      ],
      position: {
        origin: {
          relation: "bottom-right-back",
          relativeTo: "bound"
        }
      },
      activationDistance: 25
    },
    {
      name: "window-to-window-align-bottom-left",
      type: "align",
      demands: [
        "window-to-window-bottom-right"
      ],
      offers: [
        "window-to-window-bottom-left"
      ],
      position: {
        origin: {
          relation: "bottom-left-back",
          relativeTo: "bound"
        }
      },
      activationDistance: 25
    },
    {
      name: "window-above-vertical-align",
      type: "align",
      offers: [
        "window-above-vertical-align"
      ],
      position: {
        origin: {
          relation: "center-top-back",
          relativeTo: "bound"
        },
        transform: [
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      lastPosition: {
        origin: {
          relation: "center-top-back",
          relativeTo: "bound"
        },
        transform: [
          0,
          9999,
          0,
          0,
          0,
          0
        ]
      }
    }
  ]
}, windowTemplate = {
  templateId: templateId$1,
  name: name$1,
  description: description$1,
  inherits: inherits$1,
  components: components$1
}, templateId = "kvadrat-wall-feature", name = "wall feature", description = "base template for wall features", inherits = [], components = {
  bounds: [
    {
      id: "bound",
      type: "box"
    }
  ],
  selectable: !0,
  outlineable: !0,
  draggable: !0,
  functionalZones: [
    {
      id: "wall feature stacking zone",
      type: "box",
      layer: "stacking-wall-features",
      dimension: {
        top: 15e3,
        front: 70
      }
    }
  ],
  connectors: [
    {
      name: "default",
      type: "guest",
      demands: [
        "wall"
      ],
      tags: [
        "kvadrat"
      ],
      position: {
        origin: {
          relation: "center-center-back",
          relativeTo: "bound"
        },
        transform: [
          0,
          0,
          0,
          90,
          0,
          0
        ]
      },
      required: !0,
      priority: 1
    },
    {
      name: "contain-bottom-left",
      type: "guest",
      demands: [
        "wall"
      ],
      tags: [
        "kvadrat"
      ],
      required: !0,
      position: {
        origin: {
          relation: "left-bottom-back",
          relativeTo: "bound"
        },
        transform: [
          10,
          10,
          0,
          90,
          0,
          0
        ]
      }
    },
    {
      name: "contain-top-right",
      type: "guest",
      demands: [
        "wall"
      ],
      tags: [
        "kvadrat"
      ],
      required: !0,
      position: {
        origin: {
          relation: "top-right-back",
          relativeTo: "bound"
        },
        transform: [
          -10,
          -10,
          0,
          90,
          0,
          0
        ]
      }
    }
  ]
}, wallFeatureTemplate = {
  templateId,
  name,
  description,
  inherits,
  components
}, base = {
  range: "KVADRAT",
  rangeVersion: "1.0.0"
}, templateRoot = {
  ...base,
  schemaVersion: "draft-03",
  templates: [wallFeatureTemplate, windowTemplate, doorTemplate, doorOpeningTemplate]
}, catalogRoot = {
  ...base,
  schemaVersion: "draft-02",
  products: [windowProduct, doorProduct, doorOpeningProduct]
}, dynamicRange = {
  template: templateRoot,
  catalog: catalogRoot
};
class WallSplitter {
  constructor(t) {
    C(this, "roomRelationsUtil");
    this.entityManager = t, this.roomRelationsUtil = new RoomRelationsUtil();
  }
  splitWall(t, n, o) {
    var M, b;
    const r = (((M = getRoomSurfaceRelationsComponent(t)) == null ? void 0 : M.edges) ?? []).find((L) => {
      const x = getEdgeCornerPoints(L);
      return x ? closestOnEdge(n, x).equals(n) : !1;
    }), i = (((b = getRoomSurfaceRelationsComponent(t)) == null ? void 0 : b.edges) ?? []).find((L) => {
      const x = getEdgeCornerPoints(L);
      return x ? closestOnEdge(n, x).equals(o) : !1;
    });
    if (!r || !i)
      return;
    const s = HierarchyUtils.findInUpwardsHierarchy(
      t,
      (L) => hasRoomComponent(L)
    ), a = this.findCorners(t, r, i);
    if (!a)
      return;
    const { c1: l, c2: d, c3: c, c4: m, firstEdge: p, lastEdge: g } = a, f = createEntity(void 0, this.entityManager), h = createEntity(void 0, this.entityManager), E = createEntity(void 0, this.entityManager), I = createEntity(void 0, this.entityManager), R = createEntity(void 0, this.entityManager), [A, F, z, ne, k, q, X, ae, ve, De, Le, ue] = requireKvadratIds([t, l, d, c, m, p, g, f, h, E, I, R]), we = createOrUpdateWallEntity(void 0, void 0, [Le, z, ne, ue], this.entityManager), ee = requireKvadratId(we), W = getEdgeRelationComponent(p), Z = getCornerPosition(l) ?? VectorConstants.ZERO, he = getCornerPosition(d) ?? VectorConstants.ZERO, Ce = [W == null ? void 0 : W.surface1, W == null ? void 0 : W.surface2].filter(isTruthy).map(requireKvadratId).concat(ee), de = [q, ae, De], ye = n.pointOnLine(Z, he) ? n : o, Ae = closestOnEdge(ye, [Z, he]);
    I.addComponent(new CornerComponent(Ce, de)), TransformUtils.setLocalPosition(I, Ae), HierarchyUtils.setParentMaintainTransform(I, s);
    const He = getEdgeRelationComponent(g), be = getCornerPosition(c) ?? VectorConstants.ZERO, Y = getCornerPosition(m) ?? VectorConstants.ZERO, Me = [He == null ? void 0 : He.surface1, He == null ? void 0 : He.surface2].filter(isTruthy).map(requireKvadratId).concat(ee), Qe = [X, ve, De], qe = closestOnEdge(n === ye ? o : n, [be, Y]);
    R.addComponent(new CornerComponent(Me, Qe)), TransformUtils.setLocalPosition(R, qe), HierarchyUtils.setParentMaintainTransform(R, s);
    const nt = getCornerComponent(d);
    if (!nt)
      return;
    const ct = [...nt.surfacePersistentIds.filter((L) => L !== A), ee], at = [...nt.edgePersistentIds.filter((L) => L !== q), ae];
    d.addComponent(new CornerComponent(ct, at));
    const et = getCornerComponent(c);
    if (!et)
      return;
    const ut = [...et.surfacePersistentIds.filter((L) => L !== A), ee], je = [...et.edgePersistentIds.filter((L) => L !== X), ve];
    c.addComponent(new CornerComponent(ut, je)), HierarchyUtils.setParentMaintainTransform(we, s), hasWallComponent(t) ? we.addComponent(new WallComponent()) : hasCeilingComponent(t) ? we.addComponent(new CeilingComponent()) : hasFloorComponent(t) && we.addComponent(new FloorComponent());
    const ot = [F, Le, ue, k];
    t.addComponent(new RoomSurfaceComponent(ot)), this.modifyAdjacentSurface(t, p, d, Le), this.modifyAdjacentSurface(t, g, m, ue), f.addComponent(new EdgeComponent()), HierarchyUtils.setParentMaintainTransform(f, s), h.addComponent(new EdgeComponent()), HierarchyUtils.setParentMaintainTransform(h, s), E.addComponent(new EdgeComponent()), HierarchyUtils.setParentMaintainTransform(E, s), s && this.roomRelationsUtil.addRoomRelations(s);
  }
  modifyAdjacentSurface(t, n, o, r) {
    var d;
    const i = [], s = requireEdgeRelationComponent(n), a = t.id === (s == null ? void 0 : s.surface1.id) ? s.surface2 : s.surface1;
    a && ((d = getRoomSurfaceRelationsComponent(a)) == null || d.corners.forEach((c) => {
      i.push(requireKvadratId(c)), c.id === o.id && i.push(r);
    }));
    const l = a == null ? void 0 : a.id;
    i.length > 0 && l && a.addComponent(new RoomSurfaceComponent(i));
  }
  findCorners(t, n, o) {
    let r = n, i = o, s = null, a = null, l = null, d = null;
    const c = getRoomSurfaceRelationsComponent(t), m = getEdgeRelationComponent(n), p = getEdgeRelationComponent(o), g = getEdgeRelationComponent(i);
    return !c || !m || !p || !g ? null : (c.corners.forEach((f) => {
      s ? a ? l ? l.id == g.corner1.id ? d = g.corner2 : l.id == g.corner2.id && (d = g.corner1) : f.id == g.corner1.id ? l = g.corner1 : f.id == g.corner2.id && (l = g.corner2) : r.id === n.id ? s.id === m.corner1.id ? a = m.corner2 : s.id === m.corner2.id && (a = m.corner1) : s.id == p.corner1.id ? a = p.corner2 : s.id == p.corner2.id && (a = p.corner1) : (f.id === m.corner1.id ? (s = m.corner1, r = n) : f.id === m.corner2.id ? (s = m.corner2, r = n) : f.id === p.corner1.id ? (s = p.corner1, r = o) : f.id === p.corner2.id && (s = p.corner2, r = o), i = r.id === n.id ? o : n);
    }), s && a && l && d ? { c1: s, c2: a, c3: l, c4: d, firstEdge: r, lastEdge: i } : null);
  }
}
const CONFIG_ENTITY_ID = "RoomServiceConfigEntityId";
class RoomService {
  constructor(t, n) {
    C(this, "configEntity");
    this.entityManager = t, this.sceneManager = n, this.configEntity = this.getOrCreateConfigEntity();
  }
  getOrCreateConfigEntity() {
    const t = findEntityByKvadratId(CONFIG_ENTITY_ID, this.entityManager);
    if (t)
      return t;
    const n = this.entityManager.createEntity();
    return n.addComponent(new DisplayNameComponent("RoomService config entity")), n.addComponent(new DisabledRoomConnectorsConfigComponent([])), n.addComponent(new KvadratIdComponent(CONFIG_ENTITY_ID)), n.addComponent(new KvadratComponent()), n;
  }
  getRoom() {
    return getDescendantWithRoom(this.sceneManager.root) ?? null;
  }
  getDisabledConnectorKeys() {
    const t = this.getRoom();
    return t ? getDescendantsWithKvadrat(t).flatMap(
      (n) => {
        var o;
        return (o = n.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)) == null ? void 0 : o.connectors.filter((r) => r.enabled).map(({ key: r }) => r);
      }
    ).filter(isTruthy) : [];
  }
  disableConnectorsByKey(t) {
    const n = this.getRoom();
    n && getDescendantsWithKvadrat(n).forEach((o) => {
      const r = o.getComponent(
        ComponentIds.CONNECTORS_COMPONENT_ID
      );
      if (r && r.connectors.some((i) => t.includes(i.key))) {
        const i = r.connectors.map((s) => t.includes(s.key) ? s.enable(!1) : s);
        o.addComponent(new ConnectorsComponent(i));
      }
    });
  }
  applyDisabledConnectorsConfigToRoom(t) {
    const n = t ?? this.getRoom(), o = this.generateDisabledConnectorsComponent(n);
    o === null ? n == null || n.removeComponent(ComponentIds.DISABLED_CONNECTOR_KEYS_COMPONENT_ID) : (n != null && n.hasComponent(ComponentIds.DISABLED_CONNECTOR_KEYS_COMPONENT_ID) && n.removeComponent(ComponentIds.DISABLED_CONNECTOR_KEYS_COMPONENT_ID), n == null || n.addComponent(o));
  }
  generateDisabledConnectorsComponent(t) {
    var s, a;
    const n = this.configEntity.getComponent(
      ComponentIds.DISABLED_ROOM_CONNECTORS_COMPONENT_ID
    );
    if (!n)
      return null;
    const o = t ?? this.getRoom();
    if (!o)
      return null;
    const r = o.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID), i = ((a = (s = r == null ? void 0 : r.connectors) == null ? void 0 : s.filter((l) => n.connectorKeys.includes(l.key))) == null ? void 0 : a.map(({ key: l }) => l)) ?? [];
    return i.length ? new DisabledConnectorsComponent(i) : null;
  }
}
class SystemManager {
  constructor(t) {
    C(this, "systems");
    this.entityManager = t, this.systems = /* @__PURE__ */ new Set();
  }
  /**
   * Register a system and keep track of it
   */
  addSystem(t) {
    this.systems.add(t), this.entityManager.registerSystem(t);
  }
  /**
   * Unregister a system and remove it from our list
   */
  disposeSystem(t) {
    this.entityManager.unregisterSystem(t), this.systems.delete(t);
  }
  /**
   * Unregister all Kvadrat systems
   */
  disposeAll() {
    this.systems.forEach((t) => this.entityManager.unregisterSystem(t)), this.systems.clear();
  }
}
class ValidationManager {
  constructor(t) {
    C(this, "validations");
    this.core = t, this.validations = /* @__PURE__ */ new Set();
  }
  /**
   * Add a validation and keep track of it
   */
  addValidation(t) {
    this.validations.add(t), this.core.addValidation(t);
  }
  /**
   * Remove a validation and remove it from our list
   */
  disposeValidation(t) {
    this.core.removeValidation(t), this.validations.delete(t);
  }
  /**
   * Remove all Kvadrat validations
   */
  disposeAll() {
    this.validations.forEach((t) => this.core.removeValidation(t)), this.validations.clear();
  }
}
const Ot = class Ot extends KvadratSystemBase {
  constructor() {
    super(ComponentIds.IS_DRAGGED_COMPONENT_ID);
    C(this, "id", Ot.systemId);
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  onAddComponent(n, o) {
    isDoorOrWindow(n) && n.addComponent(new SelectedComponent());
  }
};
C(Ot, "systemId", "Kvadrat-AddSelectionOnDragSystem");
let AddSelectionOnDragSystem = Ot;
class BlueprintUpdateSystem extends KvadratSystemBase {
  constructor(n) {
    super(ComponentIds.IS_DRAGGED_COMPONENT_ID);
    C(this, "id", "Kvadrat-BlueprintUpdateSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.updateBlueprint = n;
  }
  onAddComponent(n, o) {
    isDoorOrWindow(n) && n.addComponent(new ExcludeWallFeatureFromBlueprintComponent()), this.updateBlueprint(!1);
  }
  onRemoveComponent(n, o) {
    isDoorOrWindow(n) && removeExcludeWallFeatureFromBlueprintComponent(n), this.updateBlueprint(!0);
  }
}
class CustomMeshSystem extends KvadratSystemBase {
  constructor(n, o, r, i, s) {
    super(CustomComponentIds.CUSTOM_MESH_COMPONENT);
    C(this, "id", "Kvadrat-CustomMeshSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.sceneManager = n, this.entityManager = o, this.viewer = r, this.viewerBridge = i, this.viewerObjectInputManager = s;
  }
  // Core-Viewer bridge should have this but something is weird. Copying in meantime.
  adjustModelTransform(n, o, r, i) {
    const s = o.createEmpty(n);
    return s.setPosition(TransformUtils.worldPosition(n)), r.setParent(s), i.position && r.setPosition(i.position), i.rotation && r.setRotation(MathUtils.quaternionFromEulerDegrees(i.rotation)), s;
  }
  connectMesh(n, o) {
    var p;
    const r = ComponentUtils.snapRoot(n);
    if (!r)
      return;
    const i = hasRoomSurfaceComponent(r) && getSurfaceFrontFacingSize(r) || ((p = ColliderUtils.colliderShapeComponent(r)) == null ? void 0 : p.polyhedron.axisAlignedBoundingBox.size) || VectorConstants.ZERO, s = new IPEXViewerObject(o.meshId, this.viewer, this.entityManager, n), a = this.adjustModelTransform(
      n,
      this.viewerBridge,
      s,
      // Custom mesh has origin at lower left corner and different rotation, therefore offset it from the entity.
      new ModelTransform(i.timesElementWise(o.offsetPosition), o.offsetRotation)
    );
    this.viewer.set_parent(s.getViewerObjectId(), a.getViewerObjectId()), a.setVisible(!0);
    const l = new ViewerObjectComponent(a);
    n.addComponent(l);
    const d = HierarchyUtils.parent(n);
    d != null && d.hasComponent(ComponentIds.RENDERED_COMPONENT_ID) || n.removeComponent(ComponentIds.RENDERED_COMPONENT_ID), hasKvadratActiveComponent(this.sceneManager.root) && this.viewerObjectInputManager.registerInputEvents(n);
    const m = n.hasComponent(ComponentIds.SELECTED_COMPONENT_ID);
    l.viewerObject.setOutlined(m);
  }
  deleteMesh(n, o) {
    this.viewer.object_exists(o.meshId) && this.viewer.delete_object(o.meshId, !0);
    const r = n.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
    r && (r.viewerObject.deleteObject(), n.removeComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID));
  }
  onAddComponent(n, o) {
    this.connectMesh(n, o);
  }
  onUpdateComponent(n, o, r) {
    this.deleteMesh(n, o), this.connectMesh(n, r);
  }
  onRemoveComponent(n, o) {
    this.deleteMesh(n, o);
  }
}
function createQuarterCylinderPolyhedron(e) {
  const t = createQuarterCircle(e);
  return PolyhedronUtils.polyhedronFromConvexPolygon(t, 1);
}
function createQuarterCircle(e) {
  const t = [VectorConstants.ZERO], n = Math.PI / 2, o = n / e;
  for (let r = 0; r <= n; r += o) {
    const i = Math.cos(r), s = Math.sin(r);
    t.push(new Vector(i, 0, s));
  }
  return t;
}
function transformArc(e) {
  var c;
  const t = getDoorComponent(e), n = (c = getParametricObjectComponent(e)) == null ? void 0 : c.size, o = getOpeningDirectionComponent(e), r = HierarchyUtils.findInHierarchy(e, hasOpeningArcComponent);
  if (!t || !o || !r || !n)
    return;
  let i = 0;
  t.handleLocation === it.RIGHT ? o.openingDirection === Pn.INWARDS ? i = 0 : i = 1 : o.openingDirection === Pn.INWARDS ? i = 3 : i = 2;
  const s = t.handleLocation === it.RIGHT ? -1 : 1, a = n.width / 2 * s, l = -n.height / 2 + 1, d = new Transform(
    new Vector(a, l, 0),
    MathUtils.quaternionFromEulerRadians(0, i * Math.PI / 2, 0)
  );
  TransformUtils.setLocalTransform(r, d);
}
const DOOR_OPENING_ZONE_PRIMARY_LAYER_ID = "door-opening-zone-primary", DOOR_OPENING_ZONE_SECONDARY_LAYER_ID = "door-opening-zone-secondary", PRIMARY_ZONE_ID = "door-opening-zone-primary", SECONDARY_ZONE_ID = "door-opening-zone-secondary";
class DoorOpeningZonesSystem extends KvadratSystemBase {
  constructor() {
    super(CustomComponentIds.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
    C(this, "id", "Kvadrat-DoorsOpeningZoneSystem");
    C(this, "mandatoryComponents", [
      CustomComponentIds.KVADRAT_COMPONENT_ID,
      CustomComponentIds.ROOM_DOOR_COMPONENT_ID
    ]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  updateFunctionalOpeningZone(n, o) {
    const { width: r, height: i, depth: s } = o, a = r + 10, l = createQuarterCylinderPolyhedron(4).scale(new Vector(a, i, a)), d = new Vector(r / 2, -i / 2, -s / 2), c = l.transform(
      new Transform(d, MathUtils.quaternionFromEulerRadians(0, Math.PI, 0))
    ), m = l.transform(
      new Transform(d, MathUtils.quaternionFromEulerRadians(0, Math.PI / 2, 0))
    ), p = new FunctionalZone(
      PRIMARY_ZONE_ID,
      DOOR_OPENING_ZONE_PRIMARY_LAYER_ID,
      c
    ), g = new FunctionalZone(
      SECONDARY_ZONE_ID,
      DOOR_OPENING_ZONE_SECONDARY_LAYER_ID,
      m
    );
    n.addComponent(createOrUpdateFunctionalZonesLocalComponent(n, [p, g]));
  }
  onAddComponent(n, o) {
    this.updateFunctionalOpeningZone(n, o.size);
  }
  onUpdateComponent(n, o, r) {
    this.updateFunctionalOpeningZone(n, r.size);
  }
  onRemoveComponent(n, o) {
    const r = getFunctionalZones(n).filter(
      (i) => i.id !== PRIMARY_ZONE_ID && i.id !== SECONDARY_ZONE_ID
    );
    r.length > 0 ? n.addComponent(new FunctionalZonesLocalComponent(r)) : n.removeComponent(ComponentIds.FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID);
  }
}
class DoorOpeningArcCreationSystem extends KvadratSystemBase2 {
  constructor(n) {
    super(CustomComponentIds.OPENING_ARC_COMPONENT_ID, CustomComponentIds.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
    C(this, "id", "Kvadrat-DoorOpeningArcCreationSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.viewer = n;
  }
  onAddComponent(n, o) {
    this.createOpeningArc(n);
  }
  onUpdateComponent2(n, o, r) {
    const i = HierarchyUtils.findInHierarchy(n, hasOpeningArcComponent);
    i && this.createOpeningArc(i);
  }
  createOpeningArc(n) {
    var f;
    const o = HierarchyUtils.parent(n);
    if (!o)
      return;
    const r = (f = getParametricObjectComponent(o)) == null ? void 0 : f.size, i = getDoorComponent(o), s = getOpeningDirectionComponent(o);
    if (!r || !i || !s)
      return;
    const a = 20, l = new Vector(r.width, 0, r.width), d = createQuarterCircle(a).map((h) => h.timesElementWise(l)).toReversed(), c = new Float32Array(
      d.map((h) => [h.X, h.Y, h.Z]).flat().map((h) => h / 1e3)
    ), m = new Uint16Array(
      new Array(a).fill(null).map((h, E) => [0, E + 1, E + 2]).flat()
    ), p = this.viewer.create_material();
    this.viewer.set_base_color(p, {
      r: 1,
      g: 1,
      b: 1
    }), this.viewer.set_opacity(p, 0.3);
    const g = this.viewer.create_custom_mesh(
      {
        positions: c,
        indices: m
      },
      p
    );
    n.addComponent(new CustomMeshComponent(g)), transformArc(o);
  }
}
class DoorOpeningArcTransformSystem extends KvadratSystemBase2 {
  constructor() {
    super(CustomComponentIds.OPENING_DIRECTION_COMPONENT_ID, CustomComponentIds.ROOM_DOOR_COMPONENT_ID);
    C(this, "id", "Kvadrat-DoorOpeningArcTransformSystem");
    C(this, "mandatoryComponents", [
      CustomComponentIds.KVADRAT_COMPONENT_ID,
      CustomComponentIds.ROOM_DOOR_COMPONENT_ID
    ]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  onUpdateComponent(n, o, r) {
    transformArc(n);
  }
  onUpdateComponent2(n, o, r) {
    transformArc(n);
  }
}
class EditorModeCameraAdaptionSystem extends SystemBase2 {
  constructor(n, o) {
    super(CustomComponentIds.EDITOR_MODE_COMPONENT_ID, ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
    C(this, "id", "Kvadrat-EditorModeCameraAdaptionSystem");
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.cameraActions = n, this.editorStore = o;
  }
  onAddComponent(n, o) {
    this.adjustCamera(n);
  }
  onUpdateComponent(n, o, r) {
    this.adjustCamera(n);
  }
  onRemoveComponent2(n, o) {
    var l;
    const r = (l = o.entity) == null ? void 0 : l.hasComponent(CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID), i = getEditorModeComponent(o.entityStateBeforeLoadingSnapshot), s = getEditorModeComponent(o.entity), a = i && s && !i.eq(s);
    r && a && this.adjustCamera(n);
  }
  adjustCamera(n) {
    if (!this.editorStore.get().open)
      return;
    const o = "replace", r = getEditorModeComponent(n);
    if (!r)
      return;
    const { mode: i, view: s, frameSelected: a } = r;
    i === EditorMode.EDITOR_MODE_2D ? this.cameraActions.cameraTransitionToTopDownView(o).then(() => {
      var l;
      this.editorStore.setEditorMode(((l = getEditorModeComponent(n)) == null ? void 0 : l.mode) || EditorMode.EDITOR_MODE_2D), this.cameraActions.reCenterView();
    }) : i === EditorMode.EDITOR_MODE_3D && (this.editorStore.setEditorMode(EditorMode.EDITOR_MODE_3D), s === "front" ? a ? this.cameraActions.frameSelectedTarget() : this.cameraActions.cameraTransitionToFrontView(o) : this.cameraActions.cameraTransitionToAngledFrontView(o));
  }
}
function hideAwayFacingSurfaces(e, t) {
  var o;
  const n = hasKvadratActiveComponent(t.root) && ((o = getEditorModeComponent(t.root)) == null ? void 0 : o.mode) === EditorMode.EDITOR_MODE_2D;
  getDescendantsWithRoomSurface(t.scene).forEach((r) => {
    const i = entityIsFacingCamera(r, e);
    [r, ...getDescendantsWithKvadrat(r)].forEach((s) => {
      if (i) {
        if (n && hasParametricObjectComponent(s)) {
          s.removeComponent(ComponentIds.RENDERED_COMPONENT_ID);
          return;
        }
        s.hasComponent(ComponentIds.RENDERED_COMPONENT_ID) || s.addComponent(new RenderedComponent());
      } else
        s.removeComponent(ComponentIds.RENDERED_COMPONENT_ID);
    });
  });
}
function entityIsFacingCamera(e, t) {
  const n = TransformUtils.worldTransform(e);
  return n.up.dot(t.minus(n.position)) >= 0;
}
const yt = class yt extends SystemBase {
  constructor(n) {
    super(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID);
    C(this, "id", yt.systemId);
    C(this, "mandatoryComponents", [ComponentIds.CAMERA_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.sceneManager = n;
  }
  onAddComponent(n, o) {
    hideAwayFacingSurfaces(o.transform.position, this.sceneManager);
  }
  onUpdateComponent(n, o, r) {
    hideAwayFacingSurfaces(r.transform.position, this.sceneManager);
  }
};
C(yt, "systemId", "Kvadrat-HideRoomSurfacesNotFacingCameraSystem");
let HideRoomSurfacesNotFacingCameraSystem = yt;
class KvadratActiveSystem extends SystemBase {
  constructor(n) {
    super(CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID);
    C(this, "id", "Kvadrat-ActiveComponentSystem");
    C(this, "doingChangesOnComponent", [CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID]);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.viewerObjectInputManager = n;
  }
  onAddComponent(n, o) {
    getDescendantsWithShouldBeInteractable(n).forEach((r) => {
      const i = getShouldBeInteractableComponent(r);
      i && (i.draggable && r.addComponent(new DraggableComponent()), i.selectable && r.addComponent(new SelectableComponent()), this.viewerObjectInputManager.registerInputEvents(r));
    });
  }
  onRemoveComponent(n, o) {
    getDescendantsWithShouldBeInteractable(n).forEach((r) => {
      r.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID), r.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID), r.removeComponent(ComponentIds.SELECTED_COMPONENT_ID);
      const i = r.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
      i && i.viewerObject.unregisterInputEvents();
    });
  }
}
class MaterialComponentSystem extends KvadratSystemBase2 {
  constructor() {
    super(CustomComponentIds.ROOM_MATERIAL_COMPONENT_ID, CustomComponentIds.ROOM_MATERIAL_PREVIEW_COMPONENT_ID);
    C(this, "id", "Kvadrat-MaterialComponentSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  rebuildMaterialStorage(n) {
    const o = findRoomEntityUpAndDownInHierarchy(n);
    if (!o)
      return;
    const r = getDescendantsWithMaterial(o).map((l) => {
      var d;
      return (d = getMaterialComponent(l)) == null ? void 0 : d.material;
    }), i = getDescendantsWithMaterialPreview(o).map(
      (l) => {
        var d;
        return (d = getMaterialPreviewComponent(l)) == null ? void 0 : d.material;
      }
    ), s = [...r, ...i].filter(isTruthy), a = keyBy(s, "id");
    o.addComponent(new MaterialStorageComponent(a));
  }
  onAddComponent(n, o) {
    this.rebuildMaterialStorage(n);
  }
  onUpdateComponent(n, o, r) {
    this.rebuildMaterialStorage(n);
  }
  onRemoveComponent(n, o) {
    this.rebuildMaterialStorage(n);
  }
  onAddComponent2(n, o) {
    this.rebuildMaterialStorage(n);
  }
  onUpdateComponent2(n, o, r) {
    this.rebuildMaterialStorage(n);
  }
  onRemoveComponent2(n, o) {
    this.rebuildMaterialStorage(n);
  }
}
class ParametricObjectColliderSystem extends KvadratSystemBase {
  constructor() {
    super(CustomComponentIds.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
    C(this, "id", "Kvadrat-ParametricObjectColliderSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  updateColliderShape(n, o) {
    const r = Cuboid.fromSize(o.size.vector);
    n.addComponent(new ColliderShapeComponent(r, [`whatever_${n.id}`])), RelativeConnectorRepositioner.repositionRelativeConnectorsFromBounds(n);
  }
  onAddComponent(n, o) {
    this.updateColliderShape(n, o);
  }
  onUpdateComponent(n, o, r) {
    this.updateColliderShape(n, r);
  }
  onRemoveComponent(n, o) {
    n.removeComponent(ComponentIds.COLLIDER_SHAPE_COMPONENT_ID);
  }
}
class RoomPartComponentSystem extends KvadratSystemBase5 {
  constructor() {
    super(
      CustomComponentIds.ROOM_CORNER_COMPONENT_ID,
      CustomComponentIds.ROOM_WALL_COMPONENT_ID,
      CustomComponentIds.ROOM_CEILING_COMPONENT_ID,
      CustomComponentIds.ROOM_FLOOR_COMPONENT_ID,
      CustomComponentIds.ROOM_EDGE_COMPONENT_ID
    );
    C(this, "id", "Kvadrat-RoomPartComponentSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  onAddComponent(n, o) {
    n.addComponent(new RoomPartComponent(RoomPartType.CORNER));
  }
  onUpdateComponent(n, o, r) {
    n.addComponent(new RoomPartComponent(RoomPartType.CORNER));
  }
  onAddComponent2(n, o) {
    n.addComponent(new RoomPartComponent(RoomPartType.WALL));
  }
  onUpdateComponent2(n, o, r) {
    n.addComponent(new RoomPartComponent(RoomPartType.WALL));
  }
  onAddComponent3(n, o) {
    n.addComponent(new RoomPartComponent(RoomPartType.CEILING));
  }
  onUpdateComponent3(n, o, r) {
    n.addComponent(new RoomPartComponent(RoomPartType.CEILING));
  }
  onAddComponent4(n, o) {
    n.addComponent(new RoomPartComponent(RoomPartType.FLOOR));
  }
  onUpdateComponent4(n, o, r) {
    n.addComponent(new RoomPartComponent(RoomPartType.FLOOR));
  }
  onAddComponent5(n, o) {
    n.addComponent(new RoomPartComponent(RoomPartType.EDGE));
  }
  onUpdateComponent5(n, o, r) {
    n.addComponent(new RoomPartComponent(RoomPartType.EDGE));
  }
}
class RoomReloadingSystem extends KvadratSystemBase {
  constructor(n) {
    super(CustomComponentIds.SCENE_RELOADING_COMPONENT_ID);
    C(this, "id", "Kvadrat-RoomReloadingSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    C(this, "disabledConnectorKeys", []);
    this.roomService = n;
  }
  onAddComponent(n, o) {
    this.disabledConnectorKeys = this.roomService.getDisabledConnectorKeys();
  }
  onRemoveComponent(n, o) {
    this.roomService.disableConnectorsByKey(this.disabledConnectorKeys);
  }
}
class RoomSystem extends KvadratSystemBase {
  constructor(n, o, r) {
    super(CustomComponentIds.BLUEPRINT_COMPONENT_ID);
    C(this, "id", "Kvadrat-RoomSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", [
      ComponentIds.CONNECTORS_COMPONENT_ID,
      CustomComponentIds.ROOM_COMPONENT_ID,
      ComponentIds.COLLIDER_SHAPE_COMPONENT_ID
    ]);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    // Move these to Room Service (core store)
    C(this, "systems");
    this.roomService = n, this.systemManager = o, this.roomGenerator = r, this.systems = [
      new RoomReloadingSystem(this.roomService),
      new RoomSurfaceComponentSystem(),
      new EdgeComponentSystem(),
      new CornerComponentSystem(),
      // new ObstacleComponentSystem(this.entityManager),
      new MaterialComponentSystem()
    ], this.systems.forEach((i) => this.systemManager.addSystem(i));
  }
  enable() {
    this.isEnabled || (super.enable(), this.systems.forEach((n) => n.enable()));
  }
  disable() {
    super.disable(), this.systems.forEach((n) => n.disable());
  }
  onAddComponent(n, o) {
    this.roomGenerator.generateRoomFromBlueprint(n, o.blueprint);
  }
}
class SnapshotRestoreMeshSystem extends SystemBase2 {
  constructor(n, o, r) {
    super(ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID, ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
    C(this, "id", "Kvadrat-SnapshotRestoreMeshSystem");
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.viewer = n, this.updateBlueprint = o, this.sceneManager = r;
  }
  onRemoveComponent(n, o) {
    getDescendantsWithParametricObject(this.sceneManager.scene).forEach((r) => {
      const i = getParametricObjectComponent(r);
      removeParametricObjectComponent(r), r.addComponent(i);
    }), HierarchyUtils.getDescendantsWithComponent(
      this.sceneManager.scene,
      CustomComponentIds.OPENING_ARC_COMPONENT_ID
    ).forEach((r) => {
      const i = getOpeningArcComponent(r);
      removeOpeningArcComponent(r), r.addComponent(i);
    }), this.updateBlueprint(!1);
  }
  onRemoveComponent2(n, o) {
    const r = o.entityStateBeforeLoadingSnapshot, i = r == null ? void 0 : r.getComponent(
      CustomComponentIds.CUSTOM_MESH_COMPONENT
    );
    i != null && i.meshId && this.viewer.delete_object(i.meshId, !0);
  }
}
class StaleRoomConnectionsUpdateSystem extends KvadratSystemBase {
  constructor(n) {
    super(CustomComponentIds.UPDATE_HOST_CONNECTIONS_COMPONENT_ID);
    C(this, "id", "Kvadrat-StaleRoomConnectionsUpdateSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.sceneManager = n;
  }
  updateStaleHostConnections(n) {
    const o = getStaleConnections(n), r = new Set(
      o.hostConnections.map((i) => i.guestConnectorEntity)
    );
    o.hostConnections.length > 0 && n.removeComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID), r.forEach((i) => {
      const s = SnapUtils.getClosestSnap(i, n);
      s == null || s.performMoveAndConnect();
    });
  }
  onAddComponent(n, o) {
    this.updateStaleHostConnections(n), removeUpdateHostConnectionsComponent(n);
  }
}
class UpdateUserInteractionSystem extends KvadratSystemBase2 {
  constructor(n) {
    super(ComponentIds.SELECTED_COMPONENT_ID, ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
    C(this, "id", "Kvadrat-UpdateUserInteractionSystem");
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    this.userInteractionStore = n;
  }
  updateSelectedCollidable(n) {
    var r;
    const o = (r = getKvadratIdComponent(n)) == null ? void 0 : r.id;
    o && this.isCollidable(n) && this.userInteractionStore.setSelectedCollidableId(o);
  }
  onAddComponent(n, o) {
    this.updateSelectedCollidable(n);
  }
  onUpdateComponent(n, o, r) {
    this.updateSelectedCollidable(n);
  }
  onRemoveComponent(n, o) {
    var i;
    const r = (i = getKvadratIdComponent(n)) == null ? void 0 : i.id;
    r && this.isCollidable(n) && get(this.userInteractionStore).selectedCollidableId === r && this.userInteractionStore.clearSelectedCollidableId();
  }
  onRemoveComponent2(n, o) {
    var i;
    if (!n.hasComponent(ComponentIds.SELECTED_COMPONENT_ID))
      return;
    const r = (i = getKvadratIdComponent(n)) == null ? void 0 : i.id;
    this.isCollidable(n) && get(this.userInteractionStore).selectedCollidableId !== r && this.userInteractionStore.setSelectedCollidableId(r);
  }
  isCollidable(n) {
    return hasWallComponent(n) || hasDoorComponent(n) || hasWindowComponent(n) || hasFloorComponent(n) || hasCeilingComponent(n);
  }
}
function createGridDescription(e) {
  const t = [];
  for (let i = 0; i <= e; i++) {
    const s = i / e;
    t.push([
      [-0.5, 0, s - 0.5],
      [0, 0, s - 0.5],
      [0, 0, s - 0.5],
      [0.5, 0, s - 0.5]
    ]), t.push([
      [s - 0.5, 0, -0.5],
      [s - 0.5, 0, 0],
      [s - 0.5, 0, 0],
      [s - 0.5, 0, 0.5]
    ]);
  }
  const n = [0, 0, 0, 0], o = t.map(([i, s, a, l]) => {
    const d = (i[0] + s[0]) ** 2, c = (i[2] + s[2]) ** 2;
    let m = 0.85 - Math.sin(d + c);
    const p = [0, 0, 0, clamp(m, 0, 1)];
    return [n, p, p, n];
  }), r = new Array(t.length * 4).fill(0).map((i, s) => s);
  return {
    positions: new Float32Array(t.flat(2)),
    indices: new Uint16Array(r),
    colors: new Float32Array(o.flat(2))
  };
}
class VisualGridPlaneSystem extends SystemBase4 {
  constructor(n) {
    super(
      CustomComponentIds.KVADRAT_ACTIVE_COMPONENT_ID,
      CustomComponentIds.GRID_COMPONENT_ID,
      CustomComponentIds.VISUAL_GRID_PLANE_COMPONENT_ID,
      ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID
    );
    C(this, "id", "Kvadrat-VisualGridPlaneSystem");
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.viewer = n;
  }
  addVisualGrid(n, o) {
    const { size: r, divisions: i } = n, s = createGridDescription(i), a = this.viewer.create_custom_lines(s);
    a.scale = {
      x: r,
      z: r,
      y: 1
    }, a.position.y = -0.1, o.addComponent(new VisualGridPlaneComponent(a));
  }
  disposeVisualGrid(n) {
    removeVisualGridPlaneComponent(n);
  }
  onAddComponent(n, o) {
    n.addComponent(new GridComponent(60, 60));
  }
  onRemoveComponent(n, o) {
    removeGridComponent(n);
  }
  onAddComponent2(n, o) {
    this.addVisualGrid(o, n);
  }
  onRemoveComponent2(n, o) {
    this.disposeVisualGrid(n);
  }
  onRemoveComponent3(n, o) {
    o.object.dispose();
  }
  onRemoveComponent4(n, o) {
    const r = getGridComponent(o.entity), i = getGridComponent(o.entityStateBeforeLoadingSnapshot);
    r && (!i || !i.eq(r)) ? this.addVisualGrid(r, n) : i && !r && o.entity && this.disposeVisualGrid(o.entity);
  }
}
class WallEdgeDragSystem extends KvadratSystemBase {
  constructor(n) {
    super(ComponentIds.VIEWER_DRAG_EVENT_COMPONENT_ID);
    C(this, "id", "Kvadrat-WallEdgeDragSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.apiFunctions = n;
  }
  onAddComponent(n, o) {
    this.resizeWall(n, o.delta);
  }
  onUpdateComponent(n, o, r) {
    this.resizeWall(n, r.delta);
  }
  resizeWall(n, o) {
    var E;
    if (!hasEdgeComponent(n))
      return;
    const r = getEdgeRelationComponent(n);
    if (!r)
      return;
    const i = getSelectedWallEntityBasedOnEdge(n);
    if (!i || !hasWallComponent(i))
      return;
    const s = (E = getKvadratIdComponent(i)) == null ? void 0 : E.id;
    if (!s)
      return;
    const a = getRoomSurfaceRelationsComponent(i), l = (r == null ? void 0 : r.surface1.id) === i.id ? r == null ? void 0 : r.surface2 : r == null ? void 0 : r.surface1;
    if (!l || !a)
      return;
    if (hasCeilingComponent(l)) {
      const I = project(o, VectorConstants.UP).Y;
      return this.apiFunctions.setCeilingHeight(this.apiFunctions.getCeilingHeight() + I, !1);
    }
    const d = TransformUtils.worldTransform(i), c = getFloorCeilingCornersFromEdge(n)[0], m = getFloorCeilingCornersFromEdge(n)[0].id === a.corners[0].id ? Direction.LEFT : Direction.RIGHT, p = project(o, d.right), g = new Vector(p.X, 0, p.Z), h = TransformUtils.worldPosition(c).plus(g).distanceTo(
      TransformUtils.worldPosition(a.corners[m === Direction.LEFT ? 1 : 0])
    );
    this.apiFunctions.resizeWall(s, h, m, !1);
  }
}
class WallFeatureMeshSystem extends KvadratSystemBase2 {
  constructor(n) {
    super(CustomComponentIds.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID, CustomComponentIds.ROOM_DOOR_COMPONENT_ID);
    C(this, "id", "Kvadrat-WallFeatureMeshSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    C(this, "invisibleMaterial");
    C(this, "doorMaterial");
    C(this, "windowMaterial");
    C(this, "handleMaterial");
    this.viewer = n, this.invisibleMaterial = this.viewer.create_material(), this.viewer.set_opacity(this.invisibleMaterial, 0), this.viewer.set_unlit(this.invisibleMaterial, !0), this.doorMaterial = this.createMaterial(1, { r: 241 / 255, g: 242 / 255, b: 239 / 255 }), this.windowMaterial = this.createMaterial(1, { r: 241 / 255, g: 242 / 255, b: 239 / 255 }), this.handleMaterial = this.createMaterial(0.2, { r: 200 / 255, g: 200 / 255, b: 200 / 255 });
  }
  createMaterial(n, o) {
    const r = this.viewer.create_material();
    return this.viewer.set_roughness(r, n), o && this.viewer.set_base_color(r, o), r;
  }
  attachMesh(n, o) {
    const r = {
      depth: o.size.depth / 1e3,
      height: o.size.height / 1e3,
      width: o.size.width / 1e3
    };
    if (!isDoorOrWindow(n))
      return;
    const i = {
      ...getParametricObjectProperties(n),
      size: r
    }, s = this.viewer.create_box(r.width, r.height, r.depth, this.invisibleMaterial), a = [];
    if (!bt(i) || i.doorType !== Wn.OPENING) {
      const d = Be(i, !0);
      for (const c of d) {
        const m = this.getMaterialForGeometry(c.geometryType), p = this.viewer.create_custom_mesh(
          {
            positions: c.positions,
            indices: c.indices,
            normals: c.normals,
            uv0: c.uv0,
            uv1: c.uv1
          },
          m
        );
        this.viewer.set_parent(p, s);
        for (let g = 0; g < c.positions.length; g += 3)
          a.push(
            new Vector(c.positions[g] * 1e3, c.positions[g + 1] * 1e3, c.positions[g + 2] * 1e3)
          );
      }
    }
    let l = VectorConstants.ZERO;
    if (a.length) {
      const p = (MathUtils.axisAlignedBoxFromVertices(a).depth - o.size.depth) / 2, g = hasDoorComponent(n) ? -68 : -80;
      l = new Vector(0, 0, p / o.size.depth + g / o.size.depth);
    }
    n.addComponent(new CustomMeshComponent(s, l));
  }
  getMaterialForGeometry(n) {
    switch (n) {
      case "HANDLE_PART":
        return this.handleMaterial;
      case "DOOR_PART":
        return this.doorMaterial;
      case "WINDOW_PART":
        return this.windowMaterial;
    }
    return null;
  }
  onAddComponent(n, o) {
    this.attachMesh(n, o);
  }
  onUpdateComponent(n, o, r) {
    this.attachMesh(n, r);
  }
  onUpdateComponent2(n, o, r) {
    const i = getParametricObjectComponent(n);
    i && this.attachMesh(n, i);
  }
}
class WallFeaturesStayInPlaceSystem extends KvadratSystemBase {
  constructor() {
    super(CustomComponentIds.SURFACE_RESIZING_COMPONENT_ID);
    C(this, "id", "Kvadrat-WallFeatureStayInPlaceSystem");
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    C(this, "mandatoryComponents", [
      CustomComponentIds.KVADRAT_COMPONENT_ID,
      CustomComponentIds.ROOM_WALL_COMPONENT_ID
    ]);
  }
  moveWallFeatures(n, o) {
    const r = HierarchyUtils.children(n).filter(hasParametricObjectComponent);
    for (const i of r)
      TransformUtils.moveInParentSpace(i, o);
  }
  onAddComponent(n, o) {
    const r = absElementWise(o.sizeChange).timesElementWise(o.centerMoveDirection).times(-0.5);
    r.equals(VectorConstants.ZERO) || this.moveWallFeatures(n, r);
  }
}
const WINDOW_STACKING_ZONE_ID = "wall feature stacking zone";
class WallFeatureStackingFunctionalZonesSystem extends KvadratSystemBase {
  constructor() {
    super(CustomComponentIds.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
    C(this, "id", "Kvadrat-WallFeatureStackingFunctionalZonesSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  updateFunctionalZone(n, o) {
    const r = n.getComponent(
      ComponentIds.FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID
    );
    if (!r)
      return;
    const i = r.zones.find((h) => h.id === WINDOW_STACKING_ZONE_ID), s = r.zones.filter((h) => h.id !== WINDOW_STACKING_ZONE_ID);
    if (!i)
      return;
    const a = TransformUtils.localPosition(n), l = i.polyhedron.axisAlignedBoundingBox, d = o.size.width / l.width, c = i.polyhedron.scale(new Vector(d, 1, 1)), m = l.center.Y + l.height / 2, p = a.Y - o.size.height / 2, g = c.move(new Vector(0, p - m, 0)), f = new FunctionalZone(i.id, i.layer, g);
    n.addComponent(new FunctionalZonesLocalComponent([...s, f]));
  }
  onUpdateComponent(n, o, r) {
    this.updateFunctionalZone(n, r);
  }
  onAddComponent(n, o) {
    this.updateFunctionalZone(n, o);
  }
}
class WallSelectionSystem extends KvadratSystemBase2 {
  constructor(n) {
    super(ComponentIds.SELECTED_COMPONENT_ID, CustomComponentIds.ROOM_CORNER_COMPONENT_ID);
    C(this, "id", "Kvadrat-WallSelectionSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", ["UpdateUserInteractionSystem"]);
    C(this, "systemsAfterMe", null);
    this.entityManager = n, this.disable();
  }
  onAddComponent(n, o) {
    hasWallComponent(n) && this.addWallWidgets(n);
  }
  onUpdateComponent(n, o, r) {
    hasWallComponent(n) && this.addWallWidgets(n);
  }
  onRemoveComponent(n, o) {
    hasWallComponent(n) && this.removeWallWidgets(n);
  }
  onUpdateComponent2(n, o, r) {
    const i = getCornerRelationSurfaces(n).find(
      (s) => hasWallComponent(s) && s.hasComponent(ComponentIds.SELECTED_COMPONENT_ID)
    );
    i && this.addWallWidgets(i);
  }
  /**
   * Creates an entity that contains the notch model
   */
  addNotchEntity(n, o) {
    const r = this.entityManager.createEntity();
    return r.addComponent(
      new ModelInfoComponent("https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/", "fu0bn24ft2id.glb")
    ), r.addComponent(new DraggableComponent()), r.addComponent(new LocalTransformComponent(new Transform(new Vector(0, 0, 0)))), HierarchyUtils.setParent(r, n), this.addNotchArrowEntity(r, o), r;
  }
  //   const positionWithOffset = this.getPositionOfModelWithOffsetInwards(edgeEntity, selectedWallEntity, 90);
  //   const normalOfSelectedWall = getNormalForEntity(selectedWallEntity);
  //   //TODO: rotateDirection applies wrong on different walls ???
  //   let rotation = MathUtils.quaternionFromLookDirection(normalOfSelectedWall, rotateDirection);
  //   TransformUtils.setWorldTransform(notchEntity, new Transform(positionWithOffset, rotation), this.entityManager);
  //   HierarchyUtils.setParent(this.createNotchArrowEntity(notchEntity.id), notchEntity, this.entityManager);
  //   return notchEntity;
  // }
  addNotchArrowEntity(n, o) {
    const r = this.entityManager.createEntity();
    return r.addComponent(
      new ModelInfoComponent("https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/", "0d9g1a97yhtg.glb")
    ), r.addComponent(new LocalTransformComponent(new Transform(new Vector(0, 0, 0)))), HierarchyUtils.setParent(r, n), r;
  }
  addLine(n, o, r) {
  }
  getCornerPositionsForEdge(n) {
    const { corner1: o, corner2: r } = getEdgeRelationComponent(n) ?? {};
    return [
      o ? TransformUtils.localPosition(o) : new Vector(0, 0, 0),
      r ? TransformUtils.localPosition(r) : new Vector(0, 0, 0)
    ];
  }
  /**
   * Adds resize widgets for a wall edge
   */
  addWallResizeWidget(n, o) {
    const [r, i] = this.getCornerPositionsForEdge(n), s = this.addContainerEntity(n, o, r, i);
    this.addLine(s, r, i), this.addNotchEntity(s, o);
  }
  addContainerEntity(n, o, r, i) {
    const s = this.entityManager.createEntity();
    return s.addComponent(
      new LocalTransformComponent(
        new Transform(new Vector(0, 0, 0), getRoomPartNormal(n).getRotationTo(o))
      )
    ), s.addComponent(new DraggableComponent()), s.addComponent(new UIResizeWidgetComponent()), HierarchyUtils.setParent(s, n), s;
  }
  /**
   * Adds the necessary widgets for resizing a wall's width and length
   */
  addWallWidgets(n) {
    const o = getEdgesOfWallEntity(n);
    if (!o)
      return;
    const r = o.topEdge, i = o.bottomEdge;
    if (!r || !i)
      return;
    const s = VectorConstants.LEFT;
    this.addWallResizeWidget(r, s), this.addWallResizeWidget(o.leftEdge, s), this.addWallResizeWidget(o.rightEdge, s);
    const a = findRoomEntityUpAndDownInHierarchy(n) || n;
    removeRoomUnderConstructionForRoomHierarchy(a);
  }
  removeWallWidgets(n) {
    const o = findRoomEntityUpAndDownInHierarchy(n);
    o && getDescendantsWithUIWidgets(o).forEach((r) => this.entityManager.disposeEntity(r));
  }
}
class WallThicknessSystem extends KvadratSystemBase3 {
  constructor(n) {
    super(
      CustomComponentIds.ROOM_CORNER_COMPONENT_ID,
      CustomComponentIds.ROOM_DOOR_COMPONENT_ID,
      CustomComponentIds.ROOM_WINDOW_COMPONENT_ID
    );
    C(this, "id", "Kvadrat-WallThicknessSystem");
    C(this, "mandatoryComponents", [CustomComponentIds.KVADRAT_COMPONENT_ID]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
    this.sceneManager = n;
  }
  onRemoveComponent(n, o) {
    this.removeWallThickness(this.sceneManager.root);
  }
  onRemoveComponent2(n, o) {
    this.removeWallThickness(n);
  }
  onRemoveComponent3(n, o) {
    this.removeWallThickness(n);
  }
  removeWallThickness(n) {
    getDescendantsWithThickness(n).forEach((o) => o.dispose());
  }
}
class WallThicknessToggleSystem extends KvadratSystemBase {
  constructor() {
    super(ComponentIds.RENDERED_COMPONENT_ID);
    C(this, "id", "Kvadrat-WallThicknessToggleSystem");
    C(this, "mandatoryComponents", [
      CustomComponentIds.KVADRAT_COMPONENT_ID,
      CustomComponentIds.ROOM_SURFACE_COMPONENT_ID
    ]);
    C(this, "doingChangesOnComponent", []);
    C(this, "systemsBeforeMe", null);
    C(this, "systemsAfterMe", null);
  }
  onAddComponent(n, o) {
    getChildrenWithThickness(n).forEach((r) => r.addComponent(new RenderedComponent()));
  }
  onRemoveComponent(n, o) {
    getChildrenWithThickness(n).forEach((r) => r.removeComponent(ComponentIds.RENDERED_COMPONENT_ID));
  }
}
class ViewerObjectInputManager {
  constructor(t) {
    this.viewer = t;
  }
  registerInputEvents(t) {
    var s;
    const n = getShouldBeInteractableComponent(t), o = (s = t.getComponent(
      ComponentIds.VIEWER_OBJECT_COMPONENT_ID
    )) == null ? void 0 : s.viewerObject;
    if (o === void 0 || !n)
      return;
    o.registerInputEvents();
    const { selectable: r, draggable: i } = n;
    r || this.viewer.set_enable_on_click(o.getViewerObjectId(), !1, !0), i || this.viewer.set_enable_on_drag(o.getViewerObjectId(), !1, !0);
  }
}
class ZoneVsColliderExceptBetweenKvadratEntities extends ZoneVsColliderRule {
  constructor(t, n, o) {
    super(t, n, o);
  }
  checkIntersectingZones(t, n) {
    return t.hasComponent(CustomComponentIds.KVADRAT_COMPONENT_ID) && n.hasComponent(CustomComponentIds.KVADRAT_COMPONENT_ID) ? null : super.checkIntersectingZones(t, n);
  }
}
class DoorOpeningZonePrimaryValidation extends ZoneVsColliderExceptBetweenKvadratEntities {
  constructor() {
    super(DOOR_OPENING_ZONE_PRIMARY_LAYER_ID, ValidationResultType.WARNING, !1);
  }
}
class DoorOpeningZoneSecondaryValidation extends ZoneVsColliderExceptBetweenKvadratEntities {
  constructor() {
    super(DOOR_OPENING_ZONE_SECONDARY_LAYER_ID, ValidationResultType.WARNING, !1);
  }
}
const layerName = "stacking-wall-features";
class StackingWallFeaturesValidation extends ZoneVsZoneRule {
  constructor() {
    super(layerName, layerName, ValidationResultType.FAIL, !1);
  }
}
class WallFeatureResizeRestriction {
  constructor(t, n) {
    C(this, "id", "WallFeatureResizeRestriction");
    C(this, "isEnabled", !0);
    this.maxMoveX = t, this.maxMoveY = n;
  }
  enable() {
    this.isEnabled = !0;
  }
  disable() {
    this.isEnabled = !1;
  }
  validateCurrentState(t) {
    return null;
  }
  validateSnap(t) {
    const n = ProductUtils.productRefOrEmptyString(t.guest);
    if (t.alignmentInitiatorCandidate)
      return new ValidationResultFail("alignmentInitiatorCandidate present", n);
    const o = TransformUtils.worldTransform(t.guest), r = o.right.timesElementWise(t.movement).size, i = o.up.timesElementWise(t.movement).size;
    return Math.abs(r) < this.maxMoveX ? Math.abs(i) < this.maxMoveY ? null : new ValidationResultWarning("WallFeature moves a bit too much", n) : new ValidationResultFail("WallFeature moves too much", n);
  }
}
class WallFeaturesOnSplitWallsValidationResult extends ValidationResultFail {
  constructor(t, n, o) {
    super("Wall feature placed on split wall", "", o), this.entity = t, this.guestConnections = n;
  }
}
class WallFeaturesOnSplitWallsValidation {
  constructor(t) {
    C(this, "id", "WallFeaturesOnSplitWallsValidation");
    C(this, "isEnabled", !0);
    this.entityManager = t;
  }
  enable() {
    this.isEnabled = !0;
  }
  disable() {
    this.isEnabled = !1;
  }
  // Check if the provided connections have the same host entity.
  // If not, concider the connection to be on multiple walls.
  isOnMultipleWalls(t) {
    const o = t.map((r) => r.hostConnectorEntity).filter(hasWallComponent).map((r) => r.id);
    return new Set(o).size > 1;
  }
  validateCurrentState(t) {
    const n = ConnectionUtils.getGuestConnections(t);
    return n.length && this.isOnMultipleWalls(n) ? new WallFeaturesOnSplitWallsValidationResult(t, n, this) : null;
  }
  validateSnap(t) {
    if (!hasKvadratComponent(t.guest))
      return null;
    const n = this.entityManager.entities.filter(hasWallComponent);
    t.performMove();
    const o = ConnectionUtils.calculateAllConnectionsToHierarchies(t.guest, n);
    return o && this.isOnMultipleWalls(o) ? (t.rollbackMove(), new WallFeaturesOnSplitWallsValidationResult(t.guest, o, this)) : (t.rollbackMove(), null);
  }
}
class StaleConnectionsValidation {
  constructor() {
    C(this, "id", "StaleConnectionsValidation");
    C(this, "isEnabled", !0);
  }
  enable() {
    this.isEnabled = !0;
  }
  disable() {
    this.isEnabled = !1;
  }
  validateCurrentState(t) {
    const { guestConnections: n, hostConnections: o } = getStaleConnections(t);
    return o.length > 0 || n.length > 0 ? new StaleConnectionsValidationResult(t, n, o, this) : null;
  }
  validateSnap() {
    return null;
  }
}
class StaleConnectionsValidationResult extends ValidationResultFail {
  constructor(t, n, o, r) {
    super("Entity has stale connections", "", r), this.entity = t, this.guestConnections = n, this.hostConnections = o;
  }
}
function createCoreStore(e, t) {
  let o, r, i, s, a;
  const l = new WallSplitter(e.services.entityManager), d = new WallFeaturesOnSplitWallsValidation(e.services.entityManager);
  g(), h(), I(), R(), f();
  const c = new RoomRelationsUtil(), m = new StaleConnectionsValidation(), p = debounce(
    () => {
      new Set(
        getKvadratEntities(e.services.sceneManager).reduce((O, S) => {
          const w = m.validateCurrentState(S);
          return w != null && w.hostConnections.length ? [...O, S] : O;
        }, [])
      ).forEach((O) => {
        O.addComponent(new UpdateHostConnectionsComponent());
      });
    },
    500,
    { trailing: !0 }
  );
  function g() {
    const v = e.services.entityManager.createEntity();
    return addStandardRoomComponents(v), HierarchyUtils.setParent(v, e.services.sceneManager.scene), v;
  }
  function f() {
    const v = new DynamicProductCatalog(
      JSON.stringify(dynamicRange.catalog),
      JSON.stringify(dynamicRange.template),
      null
    );
    e.services.productManager.addCatalog(v);
  }
  function h() {
    o = new RoomService(e.services.entityManager, e.services.sceneManager), r = e.services.validations, i = new PlacementService(e.services), s = new SystemManager(e.services.entityManager), a = new ValidationManager(e);
  }
  function E(v) {
    s.addSystem(v);
  }
  function I() {
    const v = new RoomGenerator(e.services), O = new ViewerObjectInputManager(t), { entityManager: S, sceneManager: w } = e.services, N = new DoorOpeningZonesSystem();
    N.disable(), [
      new RoomSystem(o, s, v),
      new KvadratActiveSystem(O),
      new StaleRoomConnectionsUpdateSystem(w),
      new ParametricObjectColliderSystem(),
      new WallSelectionSystem(S),
      new CustomMeshSystem(w, S, t, e.modules.viewer(), O),
      new WallEdgeDragSystem({
        resizeWall: oe,
        getCeilingHeight: se,
        setCeilingHeight: Ge
      }),
      new BlueprintUpdateSystem(ve),
      new RoomPartComponentSystem(),
      new WallFeatureStackingFunctionalZonesSystem(),
      new WallFeatureMeshSystem(t),
      new AddSelectionOnDragSystem(),
      new WallFeaturesStayInPlaceSystem(),
      new HideRoomSurfacesNotFacingCameraSystem(w),
      new WallThicknessToggleSystem(),
      new SnapshotRestoreMeshSystem(t, ve, w),
      new CameraUpdateSystem(w, S),
      new WallThicknessSystem(e.services.sceneManager),
      N,
      new DoorOpeningArcCreationSystem(t),
      new DoorOpeningArcTransformSystem(),
      new VisualGridPlaneSystem(t)
    ].forEach((Oe) => s.addSystem(Oe));
  }
  function R() {
    const v = new DoorOpeningZonePrimaryValidation(), O = new DoorOpeningZoneSecondaryValidation();
    v.disable(), O.disable(), [
      new StackingWallFeaturesValidation(),
      d,
      v,
      O
    ].forEach((w) => {
      a.addValidation(w);
    });
  }
  function A() {
    let v = findRoomEntity(e.services.sceneManager);
    v || (console.warn("[Core store] getBlueprint: Could not find room entity in scene; initializing a new room entity"), v = g());
    const O = getCoreEntities(v);
    return getBlueprintFromCoreState(O);
  }
  const F = A(), { subscribe: z, set: ne } = writable(F);
  let k = F, q = writable(JSON.parse(JSON.stringify(F)));
  const X = writable(0);
  let ae = k.rooms.map((v) => getDecoratedRoom(v, k.materials));
  function ve(v) {
    const O = A();
    return De(O), v && Le(O), O;
  }
  function De(v) {
    k = v, ae = k.rooms.map((O) => getDecoratedRoom(O, v.materials)), ne(v);
  }
  function Le(v) {
    q.set(JSON.parse(JSON.stringify(v)));
  }
  function ue() {
    le(JSON.parse(JSON.stringify(get(q))), !1);
  }
  function le(v, O, S) {
    const w = findRoomEntity(e.services.sceneManager);
    if (!w) {
      console.warn("[Core store] setBlueprint: Could not find room entity");
      return;
    }
    const N = new BlueprintComponent(v);
    w.addComponent(N);
    const ie = ve(!!O);
    hideAwayFacingSurfaces(getCameraEntityPosition(e.services.sceneManager), e.services.sceneManager), O && sendEvent(InsightsEventType.SET_BLUEPRINT, ie, S || IpexMomentEnum.nonInteraction);
  }
  function we() {
    return k;
  }
  function ee() {
    return ae;
  }
  function W(v) {
    if (v)
      return k.rooms[0].walls.find(byId(v));
  }
  function Z(v) {
    if (v)
      return k.rooms[0].floors.find(byId(v));
  }
  function he(v) {
    if (v)
      return k.rooms[0].ceilings.find(byId(v));
  }
  function Ce(v) {
    if (v)
      return k.rooms[0].walls.flatMap((O) => O.features || []).find(byId(v));
  }
  function de(v) {
    if (v)
      return ae[0].walls.find((O) => {
        var S;
        return (S = O.features) == null ? void 0 : S.find((w) => w.id === v);
      });
  }
  function ye(v) {
    if (v)
      return ae[0].walls.find(byId(v));
  }
  function Ae(v) {
    if (v)
      return ae[0].floors.find(byId(v));
  }
  function He(v) {
    if (v)
      return ae[0].ceilings.find(byId(v));
  }
  function be(v) {
    if (v)
      return ae[0].walls.flatMap((O) => O.features || []).find((O) => O.id === v);
  }
  function Y() {
    const v = e.services.snapshotService.takeSnapshot("");
    return (O, S) => {
      const w = Me();
      if (w)
        return e.services.snapshotService.loadSnapshot(v), w;
      ve(O), S == null || S();
    };
  }
  function Me() {
    var Ie;
    const v = findRoomEntity(e.services.sceneManager);
    if (!v)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const O = getCoreEntities(v), S = (Ie = CollisionUtils) == null ? void 0 : Ie.getAllCollisions(v, null, Object.values(O).flat()).filter(
      (re) => re.self.id !== re.other.id && hasKvadratComponent(re.other) && hasKvadratComponent(re.self)
    ), w = S.find(
      (re) => hasCeilingComponent(re.self) && isDoorOrWindow(re.other) || hasCeilingComponent(re.other) && isDoorOrWindow(re.self)
    );
    if (w) {
      if (hasWindowComponent(w.self) || hasWindowComponent(w.other))
        return ErrorCodes.WINDOW_COLLIDING_WITH_CEILING;
      if (hasDoorComponent(w.self) || hasDoorComponent(w.other))
        return ErrorCodes.DOOR_COLLIDING_WITH_CEILING;
    }
    const N = S.find(
      (re) => hasWallComponent(re.self) && isDoorOrWindow(re.other) || hasWallComponent(re.other) && isDoorOrWindow(re.self)
    );
    if (N) {
      if (hasWindowComponent(N.self) || hasWindowComponent(N.other))
        return ErrorCodes.WINDOW_COLLIDING_WITH_WALL;
      if (hasDoorComponent(N.self) || hasDoorComponent(N.other))
        return ErrorCodes.DOOR_COLLIDING_WITH_WALL;
    }
    return S != null && S.length ? ErrorCodes.WALLS_INTERSECTING : getDescendantsWithParametricObject(v).flatMap((re) => r.validateCurrentState(re, !1)).filter(
      (re) => re.resultType.name === "FAIL" && isRequiredConnectorsValidationResult(re) && re.unfulfilledConnectors.some(
        (Ue) => Ue.tags().includes("kvadrat")
      )
    ).length ? ErrorCodes.WALL_FEATURE_OUT_OF_BOUNDS : [
      ...getDescendantsWithWindow(v),
      ...getDescendantsWithDoor(v)
    ].flatMap((re) => d.validateCurrentState(re) ?? []).length ? ErrorCodes.WALL_COLLIDING_WITH_WALL_FEATURE : (p(), null);
  }
  function Qe(v, O, S = !0) {
    var re;
    const w = findEntityByKvadratId(v, e.services.entityManager);
    if (!w)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const N = createOrUpdateParametricObjectEntity(
      O,
      e.services.productManager,
      e.services.entityManager
    );
    if (!N)
      return ErrorCodes.UNSUPPORTED_WALL_FEATURE_TYPE;
    const ie = getWallFeatureCandidate(O, N, w);
    if (!ie)
      return ErrorCodes.WALL_FEATURE_NO_AVAILABLE_FREE_SPACE;
    if (r.validateSnap(ie, !1).filter(
      (Ue) => isCollisionValidationResult(Ue) && Ue.collisions.some((Ne) => hasKvadratComponent(Ne.other))
    ).length > 0)
      return e.services.entityManager.disposeEntity(N), ErrorCodes.WALL_FEATURE_NO_AVAILABLE_FREE_SPACE;
    ie.performMoveAndConnect(), ve(S), S && sendEvent(InsightsEventType.ADD_WALL_FEATURE, {
      positionAlongWall: TransformUtils.localPosition(N).X,
      wallFeature: O,
      schema: k
    });
    const Ie = Ce((re = getKvadratIdComponent(N)) == null ? void 0 : re.id);
    return Ie || ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
  }
  function Je(v, O) {
    const S = W(v);
    if (!S)
      return console.warn("Can not fix a wall feature on a wall that does not exist"), !1;
    const w = (S.features || []).concat(O).sort(te()), N = {
      ...S,
      features: w
    };
    return hasInvalidWallFeatures(N, k.rooms[0].corners);
  }
  function qe(v) {
    const O = findRoomEntity(e.services.sceneManager);
    if (!O)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const S = createOrUpdateParametricObjectEntity(
      v,
      e.services.productManager,
      e.services.entityManager
    ), w = HierarchyUtils.getDescendantWithComponent(
      e.services.sceneManager.root,
      ComponentIds.CAMERA_COMPONENT_ID
    ), N = w ? TransformUtils.worldPosition(w) : VectorConstants.ZERO;
    return getDescendantsWithWall(O).sort((Ie, re) => {
      const Ue = getRoomPartNormal(Ie), Ne = getRoomPartNormal(re), Ke = N.minus(TransformUtils.worldPosition(Ie)).normalize().dot(Ue);
      return N.minus(TransformUtils.worldPosition(re)).normalize().dot(Ne) - Ke;
    }).some((Ie) => {
      var Ne;
      const re = i.snapToScene(
        S,
        TransformUtils.worldPosition(Ie),
        void 0,
        SnapActionCandidateSortAndSelectStrategies.SORT_BY_PRIORITY_THEN_DISTANCE
      ), Ue = ((Ne = ComponentUtils.connection(S)) == null ? void 0 : Ne.hostConnectorEntity.id) === Ie.id;
      return re.valid && Ue;
    }) || // If no desirable host could be snapped to, try anywhere.
    i.snapToScene(S).valid ? (ve(!0), getParametricObjectProperties(S)) : (e.services.entityManager.disposeEntity(S), ErrorCodes.WALL_FEATURE_NO_AVAILABLE_FREE_SPACE);
  }
  function nt(v, O, S = !0) {
    const w = be(v);
    if (!w)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    if (O === w.positionAlongWall)
      return ErrorCodes.NO_UPDATE_REQUIRED;
    const N = Qe(
      w.wallId,
      {
        ...w,
        positionAlongWall: O
      },
      !1
    );
    return isErrorCode(N) || S && sendEvent(InsightsEventType.UPDATE_WALL_FEATURE_POSITION, {
      wallFeature: N,
      positionAlongWall: O,
      schema: k
    }), N;
  }
  function ct(v, O, S = !0) {
    let w = findEntityByKvadratId(v, e.services.entityManager);
    if (!w)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    const N = Ce(v);
    if (!N)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    const ie = merge({}, N, O);
    if (isEqual(N, ie))
      return ErrorCodes.NO_UPDATE_REQUIRED;
    const Oe = HierarchyUtils.parent(w);
    if (!Oe)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    if (w = createOrUpdateParametricObjectEntity(
      ie,
      e.services.productManager,
      e.services.entityManager
    ), !w)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    const Ie = (ie.groundClearance ?? 0) + ie.size.height / 2;
    w.addComponent(new RecommendedInitialPositionFromFloorComponent(Ie));
    const re = ie.size.width / 2, Ue = 1e-4, Ne = new WallFeatureResizeRestriction(re, Ue);
    a.addValidation(Ne);
    const Ke = i.snapToTarget(w, Oe);
    return a.disposeValidation(Ne), Ke.valid ? (S && sendEvent(InsightsEventType.UPDATE_WALL_FEATURE, {
      wallFeature: ie,
      featureId: ie.id,
      schema: k
    }), ve(S), Ce(v) || ErrorCodes.INVALID_WALL_FEATURE_REFERENCE) : (createOrUpdateParametricObjectEntity(
      N,
      e.services.productManager,
      e.services.entityManager
    ), ErrorCodes.WALL_FEATURE_NO_AVAILABLE_FREE_SPACE);
  }
  function at(v, O = !0) {
    const S = findEntityByKvadratId(v, e.services.entityManager);
    if (!S)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    e.services.entityManager.disposeEntity(S), ve(O), O && sendEvent(InsightsEventType.DELETE_WALL_FEATURE, {
      id: v,
      schema: k
    });
  }
  function et(v, O, S = !0) {
    const w = findEntityByKvadratId(v, e.services.entityManager);
    if (!w)
      return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
    const N = getDoorComponent(w);
    return N ? (w.addComponent(new DoorComponent(N.doorType, O)), ve(S), Ce(v) || ErrorCodes.INVALID_WALL_FEATURE_REFERENCE) : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
  }
  function ut(v, O, S = !0) {
    const w = findEntityByKvadratId(v, e.services.entityManager);
    return w ? getOpeningDirectionComponent(w) ? (w.addComponent(new OpeningDirectionComponent(O)), ve(S), Ce(v) || ErrorCodes.INVALID_WALL_FEATURE_REFERENCE) : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
  }
  function je(v, O, S = !0) {
    var Ct;
    const w = findRoomEntity(e.services.sceneManager);
    if (!w)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const N = findEntityByKvadratId(v, e.services.entityManager);
    if (!N)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const ie = getRoomSurfaceRelationsComponent(N);
    if (!ie)
      return ErrorCodes.MISSING_WALL_COMPONENTS;
    const Oe = ie.edges.find(byFloorEdge), Ie = ie.edges.find(byCeilingEdge), re = getFloorCorners(N);
    if (!Oe || !Ie || !re)
      return ErrorCodes.MISSING_EDGE_COMPONENTS;
    const Ue = Y();
    addRoomUnderConstructionForRoomHierarchy(w);
    const Ne = TransformUtils.worldPosition(re[0]), Ke = TransformUtils.worldPosition(re[1]);
    let ze = vec3ToVector(O), rt = new Vector(O.x, TransformUtils.localPosition(Ie).Y, O.z);
    const lt = Ke.minus(Ne).normalize().times(0.01);
    ze.equals(TransformUtils.worldPosition(re[0])) ? (ze = ze.plus(lt), rt = rt.plus(lt)) : ze.equals(TransformUtils.worldPosition(re[1])) && (ze = ze.minus(lt), rt = rt.minus(lt));
    const mt = [N, ...ie.corners, ...ie.edges].flatMap(
      (dt) => HierarchyUtils.children(dt)
    );
    mt.forEach(detachEntity), l.splitWall(N, ze, rt);
    const Et = getNextSiblingWall(N);
    if (!Et)
      return ue(), ErrorCodes.INVALID_WALL_REFERENCE;
    const gt = (Ct = getMaterialComponent(N)) == null ? void 0 : Ct.material;
    return gt && Et.addComponent(new MaterialComponent(gt)), removeRoomUnderConstructionForRoomHierarchy(w), mt.forEach((dt) => {
      snapEntityToClosestCandidate(dt, e.services.sceneManager);
    }), Ue(S, () => {
      S && sendEvent(InsightsEventType.SPLIT_WALL, {
        id: v,
        splitPosition: O,
        schema: k
      });
    });
  }
  function ot(v, O, S = !0) {
    return je(v, O, S);
  }
  function M(v, O) {
    const S = findRoomEntity(e.services.sceneManager);
    if (!S)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const w = findEntityByKvadratId(v, e.services.entityManager);
    if (!w)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const N = getRoomSurfaceRelationsComponent(w);
    if (!N)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const ie = Y(), { corners: Oe } = N, Ie = Oe.map(
      (re) => TransformUtils.localPosition(re).plus(vec3ToVector(O))
    );
    return addRoomUnderConstructionForRoomHierarchy(S), updatePositionsForCornerEntities([...Oe], Ie), removeRoomUnderConstructionForRoomHierarchy(S), ie(!1);
  }
  function b(v, O = !0) {
    var Oe, Ie;
    const S = findEntityByKvadratId(v, e.services.entityManager);
    if (!S)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    const w = getPreviousSiblingWall(S), N = getNextSiblingWall(S), ie = Y();
    if (w && N) {
      const re = getFloorCorners(S), Ue = getWallLength(w), Ne = getWallLength(N);
      if (isLessThanThreshold(Ue, MERGE_OFFSET) && (Ue > 0 || Ne > 0)) {
        const Ke = (Oe = getKvadratIdComponent(re[0])) == null ? void 0 : Oe.id;
        if (Ke)
          J(Ke, !1);
        else
          return ErrorCodes.INVALID_CORNER_REFERENCE;
      }
      if (isLessThanThreshold(Ne, MERGE_OFFSET) && (Ue > 0 || Ne > 0)) {
        const Ke = (Ie = getKvadratIdComponent(re[1])) == null ? void 0 : Ie.id;
        if (Ke)
          J(Ke, !1);
        else
          return ErrorCodes.INVALID_CORNER_REFERENCE;
      }
    }
    return ie(O, () => {
      O && sendEvent(InsightsEventType.MOVE_WALL, {
        schema: k,
        id: v
      });
    });
  }
  function L(v, O, S = !0) {
    const w = M(v, O);
    return w || b(v, S);
  }
  function x(v, O) {
    const S = findRoomEntity(e.services.sceneManager);
    if (!S)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const w = findEntityByKvadratId(v, e.services.entityManager);
    if (!w)
      return ErrorCodes.INVALID_CORNER_REFERENCE;
    const N = getCeilingCorner(w);
    if (!N)
      return ErrorCodes.MISSING_CORNER_COMPONENTS;
    const ie = getCornerRelationComponent(w), Oe = getCornerRelationComponent(N);
    if (!ie || !Oe)
      return;
    const Ie = Y(), re = [
      TransformUtils.localPosition(w),
      TransformUtils.localPosition(N)
    ].map((Ue) => Ue.plus(vec3ToVector(O)));
    return addRoomUnderConstructionForRoomHierarchy(S), updatePositionsForCornerEntities([w, N], re), removeRoomUnderConstructionForRoomHierarchy(S), Ie(!1);
  }
  function j(v, O = !0) {
    const S = findEntityByKvadratId(v, e.services.entityManager);
    if (!S)
      return ErrorCodes.INVALID_CORNER_REFERENCE;
    const w = getCornerRelationComponent(S);
    if (!w)
      return ErrorCodes.INVALID_CORNER_REFERENCE;
    if (!getCeilingCorner(S))
      return ErrorCodes.MISSING_CORNER_COMPONENTS;
    const ie = Y(), [Oe] = w.surfaces.filter(
      (Ie) => byWalls(Ie) && isLessThanThreshold(getWallLength(Ie), MERGE_OFFSET)
    );
    return Oe && J(v, !1), ie(O, () => {
      sendEvent(Oe ? InsightsEventType.MERGE_CORNER : InsightsEventType.MOVE_CORNER, {
        schema: k,
        id: v
      });
    });
  }
  function D(v, O, S = !0) {
    const w = x(v, O);
    return w || j(v, S);
  }
  function J(v, O = !0) {
    const S = findRoomEntity(e.services.sceneManager);
    if (!S)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    if (getCoreEntities(S).floorCornerEntities.length < 4)
      return ErrorCodes.CORNER_INSUFFICIENT_REMAINING;
    const N = findEntityByKvadratId(v, e.services.entityManager);
    if (!N)
      return ErrorCodes.INVALID_CORNER_REFERENCE;
    const ie = getCeilingCorner(N);
    if (!ie)
      return ErrorCodes.MISSING_CORNER_COMPONENTS;
    const Oe = getCornerRelationComponent(N), Ie = getCornerRelationComponent(ie), re = Ie == null ? void 0 : Ie.surfaces.find(byCeilings), Ue = Oe == null ? void 0 : Oe.surfaces.find(byFloors);
    if (!Oe || !Ie || !re || !Ue)
      return ErrorCodes.MISSING_CORNER_COMPONENTS;
    const [Ne, Ke] = getLeftAndRightWallForFloorCorner(N) || [], ze = uniqBy(
      [
        N,
        ie,
        Ne,
        Ke,
        ...Oe.edges,
        ...Ie.edges
      ],
      "id"
    ), rt = getOuterFloorCeilingEdges([Ne, Ke], N.id, [
      N.id,
      ie.id
    ]);
    if (!rt)
      return ErrorCodes.MISSING_EDGE_COMPONENTS;
    const lt = Y(), [mt, Et] = rt, [gt, Ct] = getFloorCeilingCornersFromEdge(mt), [dt, ft] = getFloorCeilingCornersFromEdge(Et), It = createOrUpdateEdgeEntity(void 0, void 0, e.services.entityManager), St = createOrUpdateEdgeEntity(void 0, void 0, e.services.entityManager), Mt = [gt, dt, ft, Ct], _t = createOrUpdateWallEntity(
      void 0,
      void 0,
      requireKvadratIds(Mt),
      e.services.entityManager
    ), [Rt] = [Ne, Ke].sort((Ze, Ye) => getWallLength(Ye) - getWallLength(Ze)).map((Ze) => {
      var Ye;
      return (Ye = getMaterialComponent(Ze)) == null ? void 0 : Ye.material;
    }).filter(isTruthy);
    Rt && _t.addComponent(new MaterialComponent(Rt)), addRoomUnderConstruction([...ze, ...Mt, re, Ue]), replaceReferencesInCornerComponent(gt, ze, [St], [_t]), replaceReferencesInCornerComponent(dt, ze, [St], [_t]), replaceReferencesInCornerComponent(ft, ze, [It], [_t]), replaceReferencesInCornerComponent(Ct, ze, [It], [_t]), removeReferencesFromSurfaceComponent(re, ze), removeReferencesFromSurfaceComponent(Ue, ze), HierarchyUtils.setParent(_t, S), HierarchyUtils.setParent(It, S), HierarchyUtils.setParent(St, S);
    const wt = TransformUtils.worldPosition(gt).distanceTo(
      TransformUtils.worldPosition(dt)
    ), Wt = getWallLength(Ne), Pt = getWallLength(Ke), Ft = getDescendantsWithParametricObject(Ne).map((Ze) => {
      const Ye = TransformUtils.localPosition(Ze);
      return {
        localPosition: new Vector(-wt / 2 + Wt / 2 + Ye.X, Ye.Y, Ye.Z),
        wallFeatureEntity: Ze
      };
    }), kt = getDescendantsWithParametricObject(Ke).map((Ze) => {
      const Ye = TransformUtils.localPosition(Ze);
      return {
        localPosition: new Vector(
          wt / 2 - (Pt / 2 - Ye.X),
          // rightWallLength / 2 + TransformUtils.localPosition(wallFeatureEntity).X + (newWallLength - rightWallLength),
          Ye.Y,
          Ye.Z
        ),
        wallFeatureEntity: Ze
      };
    }), vt = getRoomSurfaceRelationsComponent(Ne), Tt = getRoomSurfaceRelationsComponent(Ke), Vt = [...(vt == null ? void 0 : vt.edges) ?? [], ...(Tt == null ? void 0 : Tt.edges) ?? []], Ut = [...(vt == null ? void 0 : vt.corners) ?? [], ...(Tt == null ? void 0 : Tt.corners) ?? []], At = [Ne, Ke, ...Vt, ...Ut].flatMap(
      (Ze) => HierarchyUtils.children(Ze).filter((Ye) => !hasKvadratComponent(Ye))
    );
    return At.forEach(detachEntity), ze.forEach((Ze) => Ze.removeComponent(ComponentIds.CHILD_COMPONENT_ID)), c.addRoomRelations(S), removeRoomUnderConstructionForRoomHierarchy(S), [...Ft, ...kt].forEach(({ localPosition: Ze, wallFeatureEntity: Ye }) => {
      HierarchyUtils.setParent(Ye, _t), TransformUtils.setLocalPosition(Ye, Ze), r.validateCurrentState(Ye, !1).filter(
        (Dt) => isCollisionValidationResult(Dt) && Dt.collisions.some((Bt) => hasKvadratComponent(Bt.other))
      ).length && e.services.entityManager.disposeEntity(Ye);
    }), At.forEach((Ze) => {
      snapEntityToClosestCandidate(Ze, e.services.sceneManager);
    }), ze.forEach((Ze) => e.services.entityManager.disposeEntity(Ze)), lt(O, () => {
      O && sendEvent(InsightsEventType.DELETE_CORNER, {
        id: v,
        schema: k
      });
    });
  }
  function oe(v, O, S, w = !0) {
    var Et, gt, Ct, dt;
    if (KVADRAT_WALL_WIDTH_MAX < O)
      return ErrorCodes.WALL_RESIZE_EXCEED_MAX_VALUE;
    const N = findEntityByKvadratId(v, e.services.entityManager);
    if (!N)
      return ErrorCodes.INVALID_WALL_REFERENCE;
    if (getWallLength(N) === O)
      return ErrorCodes.NO_UPDATE_REQUIRED;
    const ie = ((Et = getRoomSurfaceRelationsComponent(N)) == null ? void 0 : Et.corners.slice(0, 2)) || [], [Oe, Ie] = ie;
    if (!Oe || !Ie)
      return ErrorCodes.MISSING_WALL_COMPONENTS;
    const re = TransformUtils.localPosition(Oe), Ue = TransformUtils.localPosition(Ie), Ne = S === Direction.RIGHT ? Ue.minus(re) : re.minus(Ue), Ke = Ne.normalize().times(O), ze = Ke.minus(Ne);
    if (Ne.equals(Ke))
      return ErrorCodes.WALL_RESIZE_SAME_SIZE;
    const rt = vectorToVec3(ze), lt = S === Direction.RIGHT ? getNextSiblingWall(N) : getPreviousSiblingWall(N);
    let mt;
    if (lt && areWallsPerpendicular(N, lt)) {
      const ft = (gt = getKvadratIdComponent(lt)) == null ? void 0 : gt.id, It = ye(ft);
      if (!ft || !It)
        return ErrorCodes.INVALID_WALL_REFERENCE;
      extrudeWallWhenZeroAngle(It, je), mt = L(ft, rt, !1);
    } else {
      const ft = S === Direction.RIGHT ? (Ct = getKvadratIdComponent(Ie)) == null ? void 0 : Ct.id : (dt = getKvadratIdComponent(Oe)) == null ? void 0 : dt.id;
      if (!ft)
        return ErrorCodes.INVALID_CORNER_REFERENCE;
      mt = D(ft, rt, !1);
    }
    if (mt)
      return mt;
    ve(w), w && sendEvent(InsightsEventType.RESIZE_WALL, {
      wallId: v,
      wallLength: O,
      direction: S,
      schema: k
    });
  }
  function se() {
    const v = findRoomEntity(e.services.sceneManager);
    return v ? getCoreEntities(v).ceilingCornerEntities.reduce(
      (S, w) => Math.max(TransformUtils.worldPosition(w).Y, S),
      0
    ) : (console.warn("[Core store] getCeilingHeight: Could not find room entity"), NaN);
  }
  function ke(v) {
    const O = findRoomEntity(e.services.sceneManager);
    if (!O)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const S = Y(), w = getCoreEntities(O), N = On(v, KVADRAT_CEILING_HEIGHT_MIN, KVADRAT_CEILING_HEIGHT_MAX), ie = se(), Oe = new Vector(0, N - ie, 0), Ie = w.ceilingCornerEntities.map(
      (re) => TransformUtils.localPosition(re).plus(Oe)
    );
    return addRoomUnderConstructionForRoomHierarchy(O), updatePositionsForCornerEntities(w.ceilingCornerEntities, Ie), removeRoomUnderConstructionForRoomHierarchy(O), S(!1);
  }
  function Re(v = !0) {
    return Y()(v, () => {
      v && sendEvent(InsightsEventType.SET_CEILING_HEIGHT, {
        height: se(),
        schema: k
      });
    });
  }
  function Ge(v, O = !0) {
    if (se() !== v)
      return ke(v) || Re(O);
  }
  function Fe() {
    s.disposeAll(), a.disposeAll();
  }
  function Xe() {
    const v = findRoomEntity(e.services.sceneManager);
    if (!v) {
      console.warn("[Core store] resetPreviewMaterials: Could not find room entity");
      return;
    }
    getDescendantsWithMaterialPreview(v).forEach(removeMaterialPreviewComponent), ve(!1);
  }
  function Ve(v, O) {
    const S = v.getComponent(CustomComponentIds.ROOM_MATERIAL_COMPONENT_ID);
    return !(S != null && S.eq(O));
  }
  function T(v, O, S, w = !0) {
    const N = findEntityByKvadratId(v, e.services.entityManager);
    if (!N)
      return ErrorCodes.INVALID_REFERENCE;
    if (w) {
      const ie = new MaterialComponent(O);
      S && Ve(N, ie) && sendEvent(S, {
        schema: k,
        material: O,
        id: v
      }), N.addComponent(ie);
    } else
      N.addComponent(new MaterialPreviewComponent(O));
    ve(w);
  }
  function G(v, O, S, w = !0) {
    if (w) {
      const N = new MaterialComponent(O);
      v.some((Oe) => Ve(Oe, N)) && sendEvent(S, {
        schema: k,
        material: O
      }), v.forEach((Oe) => Oe.addComponent(N));
    } else {
      const N = new MaterialPreviewComponent(O);
      v.forEach((ie) => ie.addComponent(N));
    }
    ve(w);
  }
  function ce(v, O, S = !0) {
    return T(v, O, InsightsEventType.UPDATE_WALL_MATERIAL, S);
  }
  function Ee(v, O, S = !0) {
    return T(v, O, InsightsEventType.UPDATE_FLOOR_MATERIAL, S);
  }
  function xe(v, O, S = !0) {
    return T(v, O, InsightsEventType.UPDATE_CEILING_MATERIAL, S);
  }
  function Te(v, O = !0) {
    const S = findRoomEntity(e.services.sceneManager);
    if (!S)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const w = getCoreEntities(S);
    G(
      w.wallEntities,
      v,
      InsightsEventType.UPDATE_ALL_WALL_MATERIALS,
      O
    );
  }
  function Q(v, O = !0) {
    const S = findRoomEntity(e.services.sceneManager);
    if (!S)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const w = getCoreEntities(S);
    G(
      w.floorEntities,
      v,
      InsightsEventType.UPDATE_ALL_FLOOR_MATERIALS,
      O
    );
  }
  function Se(v, O = !0) {
    const S = findRoomEntity(e.services.sceneManager);
    if (!S)
      return ErrorCodes.INVALID_ROOM_REFERENCE;
    const w = getCoreEntities(S);
    G(
      w.ceilingEntities,
      v,
      InsightsEventType.UPDATE_ALL_CEILING_MATERIALS,
      O
    );
  }
  function pt(v) {
    const O = Me();
    if (O)
      return ue(), sendEvent(InsightsEventType.ERROR_ROOM_CHANGE, {
        invalidRoom: k.rooms[0],
        error: "Change would cause an invalid room"
      }), O;
    sendEvent(InsightsEventType.COMPOUND_UPDATE, {
      description: v,
      schema: k
    }), Le(k);
  }
  function Nt() {
    const v = findRoomEntity(e.services.sceneManager);
    return v ? HierarchyUtils.children(v).flatMap(
      (N) => HierarchyUtils.children(N).filter(
        (ie) => (ie.hasComponent(ComponentIds.PRODUCT_COMPONENT_ID) || ie.hasComponent(ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID)) && !hasKvadratComponent(ie)
      )
    ).map(
      (N) => ColliderUtils.objectOrientedBoundingBoxForHierarchy(N).transform(
        TransformUtils.worldTransform(N)
      )
    ).map((N) => N.vertices.map((ie) => vectorToVec3(ie))) : (console.warn("[Core store] getProductPolyhedra: Could not find room entity"), []);
  }
  return {
    dispose: Fe,
    subscribe: z,
    resetToSavedState: ue,
    setSavedState: Le,
    subscribeToCompoundUpdates: q.subscribe,
    subscribeBlueprintReplaced: X.subscribe,
    setBlueprint: le,
    get: we,
    getDecoratedRooms: ee,
    getCeilingHeight: se,
    updateSetCeilingHeight: ke,
    setCeilingHeight: Ge,
    endSetCeilingHeight: Re,
    commitChanges: pt,
    getWallById: W,
    getFloorById: Z,
    getCeilingById: he,
    getWallFeatureById: Ce,
    getDecoratedWallById: ye,
    getDecoratedWallByFeatureId: de,
    getDecoratedFloorById: Ae,
    getDecoratedCeilingById: He,
    getDecoratedWallFeatureById: be,
    // Temporary
    registerSystem: E,
    // Walls
    resizeWall: oe,
    updateMoveWall: M,
    endMoveWall: b,
    moveWall: L,
    splitWall: je,
    // Corners
    addCorner: ot,
    updateMoveCorner: x,
    endMoveCorner: j,
    moveCorner: D,
    deleteCorner: J,
    // Wall features
    addWallFeature: Qe,
    addWallFeatureToClosestWall: qe,
    updateWallFeature: ct,
    updateWallFeaturePosition: nt,
    isInvalidPositionForFeature: Je,
    deleteWallFeature: at,
    deleteWallFeatureDuring2dMove: at,
    setDoorHandleSide: et,
    setOpeningDirection: ut,
    applyMaterialToAllCeilings: Se,
    applyMaterialToAllFloors: Q,
    applyMaterialToAllWalls: Te,
    applyMaterialToCeiling: xe,
    applyMaterialToFloor: Ee,
    applyMaterialToWall: ce,
    getProductPolyhedra: Nt,
    resetPreviewMaterials: Xe
  };
}
function createDecoratedRoomStore(e) {
  return derived([e], () => e.getDecoratedRooms());
}
const defaultState$1 = {
  open: !1,
  editorMode: EditorMode.EDITOR_MODE_2D
};
function createEditorStore(e, t) {
  const { subscribe: n, update: o } = writable({
    ...defaultState$1,
    ...t
  });
  let r;
  const i = writable(t == null ? void 0 : t.editorMode), s = n((p) => {
    r = p;
  });
  function a() {
    return {
      ...r,
      editorMode: c()
    };
  }
  function l(p) {
    o((g) => ({
      ...g,
      open: p
    }));
  }
  function d(p) {
    o((g) => ({
      ...g,
      editorMode: p
    })), i.set(p);
  }
  function c() {
    var p;
    return ((p = getEditorModeComponent(e.services.sceneManager.root)) == null ? void 0 : p.mode) || EditorMode.EDITOR_MODE_2D;
  }
  function m() {
    s();
  }
  return {
    subscribe: n,
    dispose: m,
    setOpen: l,
    setEditorMode: d,
    getEditorMode: c,
    get: a
  };
}
function createFeatureFlagStore(e) {
  const t = derived(e, (n) => n.enabledFeatures);
  return {
    subscribe: t.subscribe,
    get() {
      return get(t);
    }
  };
}
function createI18nStore(e, t, n, o, r) {
  let i = {
    ...e
  };
  const { subscribe: s, update: a } = writable(i), l = s((h) => {
    i = h;
  });
  c(i.locale, t, r);
  function d() {
    return i;
  }
  function c(h, E, I) {
    m(h), g(h, E, n, o, I);
  }
  function m(h) {
    a((E) => ({
      ...E,
      locale: h,
      countryCode: h.split("-")[1]
    }));
  }
  function p(h, E) {
    var R;
    const I = ((R = i.localizedInformation) == null ? void 0 : R.Kvadrat[h]) || "";
    return I === "" ? h : E ? Object.entries(E).reduce(
      (A, [F, z]) => A.replace(`{{${F}}}`, z),
      I
    ) : I;
  }
  async function g(h, E, I, R, A) {
    const F = await A(h, E, I, R);
    a((z) => ({
      ...z,
      localizedInformation: F
    }));
  }
  function f() {
    l();
  }
  return {
    subscribe: s,
    dispose: f,
    get: d,
    translate: p,
    setupLocalization: c
  };
}
function createSelectedCollidableStore(e) {
  const t = derived([e], ([n]) => n.selectedCollidableId);
  return {
    subscribe: t.subscribe,
    get() {
      return get(t);
    }
  };
}
class EventEmitter {
  constructor() {
    C(this, "callbacks", []);
  }
  subscribe(t) {
    return this.callbacks.push(t), () => this.unsubscribe(t);
  }
  unsubscribe(t) {
    this.callbacks.includes(t) && this.callbacks.splice(this.callbacks.indexOf(t), 1);
  }
  unsubscribeAll() {
    this.callbacks = [];
  }
  emit(...t) {
    for (let n of this.callbacks)
      n(...t);
  }
  get length() {
    return this.callbacks.length;
  }
}
function createShortcutStore() {
  let e = !1;
  const t = {
    mac: {},
    default: {}
  };
  function n(l, d, c = !1) {
    var m;
    return ((m = t[c ? "mac" : "default"])[l] ?? (m[l] = new EventEmitter())).subscribe(d);
  }
  function o(l, d, c = !1) {
    var m;
    (m = t[c ? "mac" : "default"][l]) == null || m.unsubscribe(d);
  }
  function r(l) {
    e = l;
  }
  function i() {
    return e;
  }
  function s() {
    return navigator.userAgent.includes("Mac");
  }
  function a(l) {
    var I;
    if (!e || l.repeat)
      return;
    const d = l.target, c = d.tagName == "KOMPIS-INPUT" || d instanceof HTMLInputElement, m = (I = l.key) == null ? void 0 : I.toLowerCase(), p = l.metaKey && s() ? "cmd" : "", g = l.shiftKey ? "shift" : "", f = l.ctrlKey ? "ctrl" : "";
    if (c)
      return;
    const h = [p, f, g, m].filter(Boolean).join("+"), E = s() && t.mac[h] ? t.mac[h] : t.default[h];
    E && (E.emit(l), l.stopImmediatePropagation());
  }
  return {
    isMac: s,
    isEnabled: i,
    setEnabled: r,
    handleKeyboardEvent: a,
    registerShortcut: n,
    unregisterShortcut: o
  };
}
function createThemeStore(e) {
  const t = e ? monkeyPatchSkapaTheme(e) : SkapaTheme, { subscribe: n } = readable(t);
  return {
    subscribe: n,
    getCustomizedTheme: (o) => ({
      ...t,
      ...o
    })
  };
}
function monkeyPatchSkapaTheme(e) {
  return {
    ...SkapaTheme,
    fontFace: {
      ...SkapaTheme.fontFace,
      sources: SkapaTheme.fontFace.sources.map((t) => ({
        ...t,
        formats: injectProxyUrlIntoFontPaths(t.formats, e)
      }))
    }
  };
}
function injectProxyUrlIntoFontPaths(e, t) {
  const n = Object.entries(e).map(([o, r]) => [
    o,
    {
      ...r,
      url: `${t}${r.url}`
    }
  ]);
  return Object.fromEntries(n);
}
const defaultState = {
  prioritizedWallIds: [],
  dragging: !1,
  panning: !1,
  onboarding: !1,
  scale: DEFAULT_SCALE,
  isPointerPressed: !1,
  allowMaterialPopup: !0,
  materialPopupPosition: y(-1e3, -1e3),
  materialPopupOpen: !1,
  materialPopupVisible: !1,
  materialPopupFocusOnRender: !1,
  offset: {
    x: 500,
    y: 500
  },
  preview: !1,
  contextMenuOpen: !1,
  customCanvasPointerEventsEnabled: !1
};
function createUserInteractionStore(e, t) {
  let n;
  const { subscribe: o, update: r } = writable({
    ...defaultState,
    ...t
  }), i = o((W) => {
    n = W;
  }), s = e.subscribe((W) => {
    r((Z) => {
      const he = findCollidable(W, Z.highlightedWallId);
      return {
        ...Z,
        highlightedWall: isWallCollidable(he) ? he : void 0,
        hoveredCollidable: findCollidable(W, Z.hoveredCollidableId),
        selectedCollidable: findCollidable(W, Z.selectedCollidableId),
        invalidatedCollidable: findCollidable(W, Z.invalidatedCollidableId)
      };
    });
  });
  function a() {
    return n;
  }
  function l(W) {
    r((Z) => ({
      ...Z,
      onboarding: W
    })), window.localStorage.setItem(ONBOARDING_SESSION_KEY, W.toString());
  }
  function d(W) {
    const Z = findCollidable(e.get(), W);
    r((he) => ({
      ...he,
      highlightedWallId: W,
      highlightedWall: isWallCollidable(Z) ? Z : void 0
    }));
  }
  function c() {
    d();
  }
  function m(W) {
    r((Z) => ({
      ...Z,
      invalidatedCollidableId: W,
      invalidatedCollidable: findCollidable(e.get(), W)
    }));
  }
  function p() {
    m();
  }
  function g(W) {
    r((Z) => ({
      ...Z,
      offset: W
    }));
  }
  function f(W) {
    r((Z) => ({
      ...Z,
      dragging: W
    }));
  }
  function h(W) {
    r((Z) => ({
      ...Z,
      panning: W
    }));
  }
  function E(W) {
    const {
      offset: { x: Z, y: he }
    } = n, Ce = Z + W.x, de = he + W.y;
    r((ye) => ({
      ...ye,
      offset: {
        x: Ce,
        y: de
      }
    }));
  }
  function I(W) {
    r((Z) => ({
      ...Z,
      prioritizedWallIds: W
    }));
  }
  function R(W) {
    r((Z) => ({
      ...Z,
      scale: On(W, MIN_SCALE, MAX_SCALE)
    }));
  }
  function A(W, Z) {
    const { scale: he } = n, Ce = On(he + W, MIN_SCALE, MAX_SCALE), de = Ce / he, ye = ge.sub(Z || n.offset, n.offset), Ae = ge.muls(ye, de), He = ge.sub(Ae, ye), be = ge.sub(n.offset, He);
    r((Y) => ({
      ...Y,
      scale: Ce,
      offset: be
    }));
  }
  function F(W, Z) {
    A(W ?? 0.01, Z);
  }
  function z(W, Z) {
    A(-(W ?? 0.01), Z);
  }
  function ne(W) {
    r((Z) => ({
      ...Z,
      preview: W
    }));
  }
  function k(W) {
    r((Z) => ({
      ...Z,
      isPointerPressed: W
    }));
  }
  function q(W) {
    n.selectedCollidableId !== W && r((Z) => ({
      ...Z,
      selectedCollidableId: W,
      selectedCollidable: findCollidable(e.get(), W)
    }));
  }
  function X() {
    q();
  }
  function ae(W) {
    r((Z) => ({
      ...Z,
      hoveredCollidableId: W,
      hoveredCollidable: findCollidable(e.get(), W)
    }));
  }
  function ve() {
    ae();
  }
  function De(W) {
    r((Z) => ({
      ...Z,
      contextMenuOpen: W
    }));
  }
  function Le(W, Z, he) {
    r((Ce) => {
      const de = W && Z || n.materialPopupPosition;
      return {
        ...Ce,
        materialPopupOpen: W,
        materialPopupVisible: W,
        materialPopupPosition: de,
        materialPopupFocusOnRender: he ?? !1
      };
    });
  }
  function ue(W) {
    r((Z) => ({
      ...Z,
      materialPopupVisible: W
    }));
  }
  function le(W) {
    r((Z) => ({
      ...Z,
      customCanvasPointerEventsEnabled: W
    }));
  }
  function we(W) {
    r((Z) => ({
      ...Z,
      allowMaterialPopup: W,
      materialPopupOpen: W === !1 ? !1 : Z.materialPopupOpen
    }));
  }
  function ee() {
    i(), s();
  }
  return {
    subscribe: o,
    dispose: ee,
    get: a,
    setHighlightedWallId: d,
    clearHighlightedWallId: c,
    setOffset: g,
    setIsDragging: f,
    setIsPanning: h,
    pan: E,
    setPrioritizedWallIds: I,
    setPointerPressed: k,
    setZoom: R,
    zoomIn: F,
    zoomOut: z,
    setOnboarding: l,
    setPreview: ne,
    setSelectedCollidableId: q,
    clearSelectedCollidableId: X,
    setInvalidatedCollidableId: m,
    clearInvalidatedCollidableId: p,
    setHoveredCollidableId: ae,
    clearHoveredCollidableId: ve,
    setIsContextMenuOpen: De,
    setIsMaterialPopupOpen: Le,
    setCustomCanvasPointerEventsEnabled: le,
    setAllowMaterialPopup: we,
    setIsMaterialPopupVisible: ue
  };
}
const useWallFeatureAnimation = () => {
  const e = useKvadratApi(), { userInteractionStore: t } = useStores(), [n, o] = useState(), r = useMemo(
    () => ({
      set: (i, s, a) => {
        const l = e.getWallFeatureById(i), d = e.getWallById((l == null ? void 0 : l.wallId) ?? "");
        if (!l || !d)
          return;
        const c = asVec2(d.p1), m = asVec2(d.p2), p = getPointOnLine(
          c,
          m,
          l.positionAlongWall + l.size.width / 2
        ), g = get(canvas2d), { x: f = 0, y: h = 0 } = (g == null ? void 0 : g.getBoundingClientRect()) || {}, E = ge.add(
          positionToSceenCoordinates(p, t.get().offset, t.get().scale),
          { x: f, y: h }
        );
        o({ img: s, start: a, end: E });
      },
      reset: () => {
        o(void 0);
      }
    }),
    []
  );
  return [n, r];
};
function useWallFeatureHeight(e, t, n = 0) {
  const o = useKvadratApi(), { useMetric: r } = useMeasurementSystem(), i = getParametricObjectComponent(e);
  return useRangedMeasurement((i == null ? void 0 : i.size.height) || 0, t, n, {
    noValueTranslationKey: "errorMissingHeight",
    minLimitTranslationKey: "errorMinHeight",
    maxLimitTranslationKey: "errorHeightExceedsCeilingHeight",
    useMetric: r,
    metricFormat: "cm",
    applyValue: (s) => updateWallFeatureHeight(o, e, s)
  });
}
function updateWallFeatureHeight(e, t, n) {
  const o = getKvadratId(t);
  return o ? e.resizeWallFeature(o, {
    height: n
  }) : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
}
function useWallFeatureHeightAndClearance(e, t, n = 0) {
  const o = useKvadratApi(), { useMetric: r } = useMeasurementSystem(), i = "cm", s = getParametricObjectComponent(e), a = useRangedMeasurement(
    (s == null ? void 0 : s.size.height) || 0,
    t,
    n,
    {
      noValueTranslationKey: "errorMissingHeight",
      minLimitTranslationKey: "errorMinHeight",
      maxLimitTranslationKey: "errorHeightExceedsCeilingHeight",
      metricFormat: i,
      useMetric: r,
      applyValue: (d) => {
        const c = l, m = c.validateLimits(c.value), p = updateWallFeature(
          o,
          e,
          d,
          m ? c.value : c.lastValidValue
        );
        !isErrorCode(p) && c.error && m && c.clearError();
      }
    }
  ), l = useRangedMeasurement(getGroundClearance(e), t, 0, {
    noValueTranslationKey: "errorMissingGroundClearance",
    minLimitTranslationKey: "errorMinGroundClearance",
    maxLimitTranslationKey: "errorGroundClearanceExceedsCeilingHeight",
    metricFormat: i,
    useMetric: r,
    applyValue: (d) => {
      const c = a.validateLimits(a.value), m = updateWallFeature(
        o,
        e,
        c ? a.value : a.lastValidValue,
        d
      );
      return !isErrorCode(m) && a.error && c && a.clearError(), m;
    }
  });
  return {
    height: a,
    groundClearance: l
  };
}
function updateWallFeature(e, t, n, o) {
  const r = getKvadratId(t);
  if (!r)
    return ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
  if (e.getCeilingHeight() !== n)
    return e.updateWallFeature(r, {
      groundClearance: o,
      size: { height: n }
    });
}
function useWallFeatureWidth(e, t = 0, n = 0) {
  const o = useKvadratApi(), { useMetric: r } = useMeasurementSystem(), i = getParametricObjectComponent(e);
  return useRangedMeasurement((i == null ? void 0 : i.size.width) || 0, t, n, {
    noValueTranslationKey: "errorMissingWidth",
    minLimitTranslationKey: "errorMinWidth",
    maxLimitTranslationKey: "errorWidthExceedsWallLength",
    metricFormat: "cm",
    useMetric: r,
    applyValue: (s) => updateWallFeatureWidth(o, e, s)
  });
}
function updateWallFeatureWidth(e, t, n) {
  const o = getKvadratId(t);
  return o ? e.resizeWallFeature(o, {
    width: n
  }) : ErrorCodes.INVALID_WALL_FEATURE_REFERENCE;
}
const EditorModeToggleContainer = styled.div`
  pointer-events: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme: e }) => e.space[50]};
`, StyledButton$2 = styled(Button$3)`
  box-shadow: ${({ theme: e }) => e.shadow.sizeDefault} ${SkapaTheme.elevation.color.default};

  &.btn--icon-secondary {
    background-color: ${({ theme: e }) => e.color.bg.primary};
  }
`;
function KvadratEditorModeToggle() {
  const e = useKvadratApi(), { editorMode: t } = useEditorStore(), { translate: n } = useI18n(), [o, r] = useState(!1), i = async (l) => {
    o || (r(!0), await e.setEditorMode(l), e.reCenterView(), r(!1));
  }, s = () => i(EditorMode.EDITOR_MODE_2D), a = () => i(EditorMode.EDITOR_MODE_3D);
  return /* @__PURE__ */ jsxs(
    EditorModeToggleContainer,
    {
      role: "group",
      "aria-label": n("editorModeGroup"),
      className: "kvadrat-disable-during-interaction",
      children: [
        /* @__PURE__ */ jsx(WithTooltip, { text: n("sceneSwitch2d"), children: /* @__PURE__ */ jsx(
          StyledButton$2,
          {
            iconOnly: !0,
            "data-testid": "kvadrat-editormode-toggle-button-2d",
            "aria-label": n("sceneSwitch2d"),
            "aria-pressed": t === EditorMode.EDITOR_MODE_2D,
            size: "small",
            type: t === EditorMode.EDITOR_MODE_2D ? "primary" : "secondary",
            ssrIcon: squareIcon,
            onClick: s
          }
        ) }),
        /* @__PURE__ */ jsx(WithTooltip, { text: n("sceneSwitch3d"), children: /* @__PURE__ */ jsx(
          StyledButton$2,
          {
            iconOnly: !0,
            "data-testid": "kvadrat-editormode-toggle-button-3d",
            "aria-label": n("sceneSwitch3d"),
            "aria-pressed": t === EditorMode.EDITOR_MODE_3D,
            size: "small",
            type: t === EditorMode.EDITOR_MODE_3D ? "primary" : "secondary",
            ssrIcon: cubeIcon,
            onClick: a
          }
        ) })
      ]
    }
  );
}
const StyledButton$1 = styled(Button$3)`
  pointer-events: auto;
`;
function ToggleKvadratButton(e) {
  const { isMobile: t } = useBreakpoints();
  return /* @__PURE__ */ jsx(JustifiedDiv, { $isMobile: t, children: /* @__PURE__ */ jsx(
    StyledButton$1,
    {
      "data-testid": "kvadrat-button",
      type: "primary",
      size: t ? "small" : void 0,
      ...e,
      fluid: t
    }
  ) });
}
const BottomWrapper = styled.div`
  pointer-events: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  position: absolute;
  left: 0;
  align-items: center;
  padding: var(--space-125) var(--space-100);
  z-index: 5;
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-rows: auto;
  justify-content: space-between;
  bottom: 0;
  transform: ${(e) => e.$isKioskMode ? "scale(1.5)" : "scale(1)"};
  grid-template-columns: ${(e) => e.$isMobile ? "1fr" : "repeat(3, 1fr)"};
  gap: ${(e) => e.$isMobile ? "20px" : "0"};
`;
function ActionMenu() {
  var a;
  const { translate: e } = useI18n(), t = useKvadratApi(), { featureFlagStore: n, configurationStore: o } = useStores(), r = useBreakpoints().isMobile, i = !!n.get().kioskMode, s = (a = o.get().uiOptions) == null ? void 0 : a.enable2D3DToggle;
  return (
    // NOTE: dir is set to ltr since PAX planner does not change position of their bottom menu
    // NOTE: until further notice, we will copy their design pattern
    /* @__PURE__ */ jsxs(
      BottomWrapper,
      {
        $isMobile: r,
        $isKioskMode: i,
        dir: "ltr",
        className: "kvadrat-disable-during-interaction",
        children: [
          /* @__PURE__ */ jsx(JustifiedDiv, { $isMobile: r, $align: "left", children: n.get().editor2D && s && /* @__PURE__ */ jsx(KvadratEditorModeToggle, {}) }),
          /* @__PURE__ */ jsx(
            ToggleKvadratButton,
            {
              className: "kvadrat-disable-during-interaction",
              text: e("exitKvadrat"),
              onClick: () => t.close()
            }
          ),
          !r && /* @__PURE__ */ jsx(JustifiedDiv, { $align: "right" })
        ]
      }
    )
  );
}
const RoomSettingIcon = () => [
  /* @__PURE__ */ jsx(
    "path",
    {
      clipRule: "evenodd",
      d: "M9.25 3.75L16.75 3.75V1.5L22.75 1.5V7.5H20.5V11.25H19V7.5H16.75V5.25L9.25 5.25V7.5H7L7 15H9.25V17.25H13V18.75H9.25V21H3.25V15H5.5L5.5 7.5L3.25 7.5L3.25 1.5H9.25V3.75ZM4.75 6L4.75 3L7.75 3V6H4.75ZM18.25 3L21.25 3V6L18.25 6V3ZM4.75 16.5L4.75 19.5H7.75L7.75 16.5H4.75Z",
      fill: "white",
      fillRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      clipRule: "evenodd",
      d: "M19.3633 13.05L14.5904 17.8229V21.0048L17.7724 21.0048L22.5453 16.232L19.3633 13.05ZM16.0904 19.5048V18.4442L19.3633 15.1713L20.4239 16.232L17.1511 19.5048H16.0904Z",
      fill: "white",
      fillRule: "evenodd"
    }
  )
];
function KvadratButton(e) {
  const { isMobile: t } = useBreakpoints(), { open: n } = useEditorStore(), o = useKvadratApi(), r = useCallback(
    once(() => {
      o.open();
    }),
    [n, o]
  );
  return n ? null : /* @__PURE__ */ jsx(
    ToggleKvadratButton,
    {
      ssrIcon: RoomSettingIcon,
      size: t ? "small" : void 0,
      ...e,
      onClick: r
    }
  );
}
function EditedEntityProvider({ children: e }) {
  const t = useCore(), n = useEditedEntity(), o = useMemo(
    () => ({
      isEditing: !!n,
      entity: n,
      closeEditing: () => {
        const r = getDescendantWithEditing(t.services.sceneManager.scene);
        r && removeEditingComponent(r);
      }
    }),
    [t, n]
  );
  return useEffect(() => (t.services.entityManager.subscribeRemove(ComponentIds.SELECTED_COMPONENT_ID, o.closeEditing), () => t.services.entityManager.unsubscribeRemove(ComponentIds.SELECTED_COMPONENT_ID, o.closeEditing)), [o]), /* @__PURE__ */ jsx(EditedEntityContext.Provider, { value: o, children: e });
}
const brandBlue = "#0058a4", grey = {
  50: "#f0f0f0",
  100: "#f5f5f5",
  200: "#dfdfdf",
  250: "#d4d4d4",
  500: "#929292",
  700: "#484848",
  900: "#111111"
}, white = "#ffffff", space = {
  25: "4px",
  50: "8px",
  75: "12px",
  100: "16px",
  150: "24px",
  200: "32px",
  250: "40px",
  300: "48px",
  400: "64px"
}, theme = {
  font: {
    family: {
      latin: "notoIKEAlatin, 'Noto IKEA', Noto Sans, Roboto, Open Sans, sans-serif"
    },
    letterSpacing: {
      0: "0px",
      75: "0px",
      100: "0px",
      200: "0px",
      500: "-0.42px",
      800: "-0.63px"
    },
    size: {
      50: "12px",
      75: "14px",
      100: "16px",
      200: "18px",
      500: "24px",
      800: "36px"
    },
    lineHeight: {
      "75-short": "22px",
      "100-short": "24px",
      "100-long": "26px",
      "200-short": "26px",
      "200-long": "34px",
      "500-short": "35px",
      "800-short": "48px"
    },
    weight: {
      normal: 400,
      bold: 700
    }
  },
  color: {
    brandBlue,
    white,
    grey,
    accent: {
      primary: brandBlue,
      accentDark: "#004f93",
      accentDarkest: "#003e72"
    },
    hover: { primary: "#333333" },
    positive: "#0a8a00",
    negative: "#e00751",
    caution: "#ffa524",
    text: {
      primary: grey[700],
      dark: grey[900],
      lightest: "#767676"
      // TODO: Add to 'grey'
    },
    bg: {
      primary: white,
      inverse: grey[900],
      accent: brandBlue
    },
    border: {
      primary: grey[500],
      light: grey[200],
      dark: grey[900]
    },
    icon: {
      primary: grey[900],
      inverse: white
    },
    disabledUi: grey[200]
  },
  space,
  radius: {
    s: "4px",
    cap: "64px"
  },
  duration: {
    quick: "100ms",
    standard: "200ms"
  },
  transition: {
    easeEasy: "cubic-bezier(0.4, 0, 0.4, 1)"
  },
  shadow: {
    colour: "rgba(0, 0, 0, 0.1)",
    sizeDefault: "0px 4px 16px"
  },
  measurement: {
    padding: space[50]
  },
  mediaQueries: {
    md: "600px",
    lg: "900px"
  }
};
function KvadratProviderWrapper({ children: e, kvadrat: t, baseHeaderLevel: n = 2 }) {
  if (!t)
    return null;
  const o = t.getStores();
  return /* @__PURE__ */ jsx(KvadratContext.Provider, { value: t, children: /* @__PURE__ */ jsx(StoresContext.Provider, { value: o, children: /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(HeaderLevelContext.Provider, { value: n, children: /* @__PURE__ */ jsx(MenuProvider, { children: /* @__PURE__ */ jsx(EditedEntityProvider, { children: e }) }) }) }) }) });
}
function MenuProvider({ children: e }) {
  const [t, n] = useState(MenuState.CLOSED), [o, r] = useState([]), i = useCallback(
    (l, d) => {
      d || r([...o, t]), n(l);
    },
    [t, o]
  ), s = useCallback(() => {
    const l = o[o.length - 1];
    n(l), r(o.slice(0, -1));
  }, [o]), a = useMemo(() => ({ goBack: s, goTo: i, menuState: t, previousMenuState: o }), [t, o]);
  return /* @__PURE__ */ jsx(MenuContext.Provider, { value: a, children: e });
}
function WrappedActionMenu({ kvadrat: e }) {
  return /* @__PURE__ */ jsx(KvadratProviderWrapper, { kvadrat: e, children: /* @__PURE__ */ jsx(ActionMenu, {}) });
}
const StyledButton = styled(Button$3)`
  width: 52px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 0;

  > * {
    border-radius: 0;
    min-height: 100%;
  }

  @media only screen and (min-width: ${theme.mediaQueries.lg}) {
    width: 60px;
    height: 48px;
  }
`;
function IconListMenuButton({ label: e, active: t, icon: n, onClick: o, ...r }) {
  return /* @__PURE__ */ jsx(
    StyledButton,
    {
      onClick: (i) => o(i.currentTarget),
      "aria-label": e,
      $active: t,
      "aria-expanded": t,
      "aria-controls": "scene-panel",
      ssrIcon: n,
      iconOnly: !0,
      ...r,
      type: "primary",
      inverseTheme: t
    }
  );
}
const List$1 = styled.ul`
  background-color: ${SkapaTheme.color.background.inverse};
  border-radius: ${SkapaTheme.border.radius.radius4}px;
  padding: ${SkapaTheme.spacing.space50}px 0;
  margin: 0 ${SkapaTheme.spacing.space50}px;
  list-style: none;
`, ListItem$1 = styled.li`
  border-radius: ${SkapaTheme.border.radius.radius4}px;
  background-color: ${SkapaTheme.color.background.inverse};
  margin: 6px 0;
`, CategoryMenuList = ({
  onMouseLeave: e,
  onMouseEnter: t,
  onFocus: n,
  onBlur: o,
  listItemRef: r,
  className: i,
  onClickCallback: s
}) => {
  const { translate: a } = useI18n(), { menuState: l, goTo: d } = useMenuContext(), c = useFeatureFlagStore(), m = [
    c.predefinedRooms && {
      isMatching: (p) => p === MenuState.MODIFY_ROOM,
      menuState: MenuState.MODIFY_ROOM,
      label: a("menuRoomsTitle"),
      icon: roomLayout,
      testId: "kvadrat-categorymenu-predefined-rooms"
    },
    c.wallFeatures && {
      isMatching: (p) => p === MenuState.STRUCTURAL_OBJECTS,
      menuState: MenuState.STRUCTURAL_OBJECTS,
      label: a("menuWindowsDoorsTitle"),
      icon: openings,
      testId: "kvadrat-categorymenu-doors-windows"
    },
    c.materialAndColors && {
      isMatching: (p) => [
        MenuState.FLOOR_COVERINGS,
        MenuState.CEILING_COVERINGS,
        MenuState.WALL_COVERINGS,
        MenuState.ROOM_STYLE
      ].includes(p),
      menuState: MenuState.ROOM_STYLE,
      label: a("menuRoomStyleTitle"),
      icon: fillBucketIcon,
      testId: "kvadrat-categorymenu-materials-and-colors"
    }
  ].filter(isTruthy);
  return useEffect(() => {
    d(MenuState.CLOSED);
  }, []), useEffect(() => {
    l === MenuState.CLOSED && (s == null || s("close", null)), l === MenuState.EDIT_STRUCTURAL_OBJECT && (s == null || s("open", null));
  }, [l]), /* @__PURE__ */ jsx(List$1, { onMouseLeave: e, role: "list", className: i, children: m.map((p) => /* @__PURE__ */ jsx(
    ListItem$1,
    {
      ref: r,
      onMouseEnter: (g) => t == null ? void 0 : t(g, p.label),
      onFocus: (g) => n == null ? void 0 : n(g, p.label),
      onBlur: o,
      children: /* @__PURE__ */ jsx(
        IconListMenuButton,
        {
          label: p.label,
          active: p.isMatching(l),
          icon: p.icon,
          "data-testid": p.testId,
          onClick: () => {
            p.isMatching(l) ? (s == null || s("close", null), d(MenuState.CLOSED)) : (s == null || s("open", null), d(p.menuState));
          }
        }
      )
    },
    p.testId
  )) });
};
function KvadratCategoryList({ ...e }) {
  return /* @__PURE__ */ jsx(CategoryMenuList, { ...e });
}
const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 80px);
  grid-template-rows: 80px;
  gap: 10px 10px;
  margin-top: 20px;
`, Button$1 = styled.button(
  ({ theme: e }) => css`
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: ${e.font.size[100]};
    font-weight: ${e.font.weight.bold};
  `
), ImageContainer = styled.div(
  ({ theme: e }) => css`
    position: relative;
    flex: 1;
    align-items: center;
    width: 100%;
    max-width: 86px;
    display: flex;
    justify-content: center;
    font-size: ${e.font.size[50]};
    text-align: center;

    svg {
      max-height: 44px;
    }

    &:hover {
      cursor: pointer;
    }

    &:hover svg {
      filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
    }
  `
), Img = styled.span`
  flex: 1;
  align-items: center;
`, Text = styled.p(
  ({ theme: e }) => css`
    display: block;
    text-align: center;
    color: ${e.color.text.primary};
    font-size: ${e.font.size[50]};
    line-height: ${e.font.lineHeight["75-short"]};
    font-weight: ${e.font.weight.normal};
    margin: 0;
    width: 100%;
  `
), ButtonImage = ({ img: e, ...t }) => /* @__PURE__ */ jsx(ImageContainer, { "data-transfer-image-ref": !0, ...t, children: e && (typeof e == "string" ? /* @__PURE__ */ jsx(
  Img,
  {
    dangerouslySetInnerHTML: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __html: e
    }
  }
) : e) }), ButtonItem = ({ children: e, img: t, ...n }) => /* @__PURE__ */ jsxs(Button$1, { ...n, children: [
  /* @__PURE__ */ jsx(ButtonImage, { img: t }),
  /* @__PURE__ */ jsx(Text, { children: e })
] }), AnimatedWallFeature = styled(ButtonImage)`
  transform: translate(-50%, -50%);
  position: fixed;
  pointer-events: none;
  opacity: 0.8;
  top: var(--start-y) px;
  left: var(--start-x) px;

  @keyframes move {
    0% {
      top: var(--start-y);
      left: var(--start-x);
      opacity: 0.8;
    }
    80% {
      opacity: 0;
    }
    100% {
      top: var(--end-y);
      left: var(--end-x);
      opacity: 0;
    }
  }
  animation-name: move;
  animation-duration: 1000ms;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out();

  svg {
    height: 64px;
  }
`, WallFeatureAnimation = ({ animation: { start: e, end: t, img: n }, onAnimationEnd: o }) => /* @__PURE__ */ jsx(
  AnimatedWallFeature,
  {
    style: {
      "--start-x": `${e.x}px`,
      "--start-y": `${e.y}px`,
      "--end-x": `${t.x}px`,
      "--end-y": `${t.y}px`
    },
    img: n,
    onAnimationEnd: o
  }
), ElementsMenu = ({ menuOptions: e }) => {
  const t = useKvadratApi(), { translate: n } = useI18n(), { editorMode: o } = useEditorStore(), { userInteractionStore: r } = useStores(), [i, { set: s, reset: a }] = useWallFeatureAnimation(), l = (p) => bt(p) ? {
    [Wn.DOUBLE]: n("addedDoubleDoor"),
    [Wn.SINGLE]: n("addedDoor"),
    [Wn.OPENING]: n("addedDoorOpening")
  }[p.doorType] : Yt(p) ? n("addedWindow") : n("addedWallFeature"), d = (p, g, f) => {
    r.setIsContextMenuOpen(!1);
    const { x: h, y: E, height: I, width: R } = f.currentTarget.getBoundingClientRect(), A = { x: h + R / 2, y: E + I / 2 }, F = t.addWallFeatureToClosestWall(p);
    isErrorCode(F) ? t.onNotification.emit({
      type: "error",
      title: n("menuFeatureErrorTitle"),
      message: n(ERROR_CODE_TRANSLATION_KEYS[F])
    }) : (announce(l(p)), o === EditorMode.EDITOR_MODE_2D && s(F.id, g, A));
  }, c = useCallback(
    (p, g) => {
      p.currentTarget.style.opacity = "0.2", p.currentTarget.style.background = "unset", t.prepareDragAndDrop(p.nativeEvent, g);
    },
    [t]
  ), m = (p) => {
    p.currentTarget.style.opacity = "1";
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(StyledGrid, { children: e.map(({ title: p, img: g, wallFeature: f, testId: h }) => /* @__PURE__ */ jsx(
      ButtonItem,
      {
        img: g,
        "data-testid": `kvadrat-${h}`,
        draggable: !0,
        onDragStart: (E) => c(E, f),
        onDragEnd: m,
        onClick: (E) => {
          d(f, g ?? "", E);
        },
        "aria-label": p,
        children: p
      },
      h
    )) }),
    i && /* @__PURE__ */ jsx(
      WallFeatureAnimation,
      {
        animation: i,
        onAnimationEnd: a
      },
      `${i.end.x}${i.end.y}`
    )
  ] });
}, HeaderWrapper$1 = styled.div`
  position: relative;
  display: flex;
  padding: 20px;
  height: ${({ theme: e }) => e.space[400]};
`, BackButton = styled(Button$3)`
  margin-right: ${({ theme: e }) => e.space[100]};
`, CloseButton = styled(Button$3)`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${({ theme: e }) => e.space[75]};
`, Header = ({ backBtnAriaLabel: e, onClose: t, title: n, onNavigateBack: o }) => {
  const { translate: r } = useI18n();
  return /* @__PURE__ */ jsxs(HeaderWrapper$1, { children: [
    o && /* @__PURE__ */ jsx(
      BackButton,
      {
        onClick: o,
        iconOnly: !0,
        ssrIcon: ArrowLeftIcon,
        "aria-label": e ? r("menuBackButton", { value: e }) : r("menuBackButtonDefault"),
        "data-testid": "kvadrat-menu-back-button",
        size: "small",
        type: "primary"
      }
    ),
    /* @__PURE__ */ jsx(H, { testId: "kvadrat-sidemenu-header-title", children: n }),
    /* @__PURE__ */ jsx(
      CloseButton,
      {
        size: "small",
        iconOnly: !0,
        ssrIcon: CrossIcon,
        onClick: t,
        "aria-label": r("closeActionMenu"),
        type: "tertiary",
        "data-testid": "kvadrat-menu-quit-button"
      }
    )
  ] });
}, StyledActionListItem = styled(ListViewItem)`
  .containImage {
    object-fit: contain;
    width: 2rem;
    height: 2rem;
    margin-top: 8px;
  }

  .action-list-item__image {
    width: 2rem;
  }
`, ListItem = ({ title: e, img: t, onClick: n, testId: o, type: r = "default", imageAltText: i }) => /* @__PURE__ */ jsx(
  StyledActionListItem,
  {
    onClick: n,
    "data-testid": o,
    title: e,
    image: r === "icon" ? t : "",
    imageAltText: r === "icon" ? `${i}` : void 0,
    imageProps: { className: "containImage" },
    control: "navigational",
    controlIcon: "chevronRight",
    emphasised: !0
  }
), Wrapper$4 = styled.div(
  () => css`
    display: block;
  `
), List = ({ menuOptions: e }) => /* @__PURE__ */ jsx(Wrapper$4, { children: /* @__PURE__ */ jsx(ListView, { id: `ActionListKvadrat-${e[0].title}`, size: "large", children: e.map((t) => {
  if (t.type === "component") {
    const n = t.component;
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(n, {}) }, t.title);
  }
  return /* @__PURE__ */ jsx(ListItem, { ...t }, t.title);
}) }) }), PredefinedRoom = ({ name: e, testId: t, onClick: n, img: o }) => /* @__PURE__ */ jsx(ButtonItem, { "data-testid": t, onClick: n, img: o, children: e }), PredefinedRooms = ({ rooms: e, wallFeatures: t }) => /* @__PURE__ */ jsx(StyledGrid, { children: e.map((n, o) => !t && n.testId === "kvadrat-predefined-menu-item-cuboid-window-door" ? null : /* @__PURE__ */ jsx(
  PredefinedRoom,
  {
    onClick: n.onClick,
    name: n.title,
    testId: n.testId || "",
    img: n.img
  },
  `${o}-${n.title}`
)) }), Wrapper$3 = styled.div`
  border-bottom: 1px rgb(var(--colour-neutral-3, 223, 223, 223)) solid;
  padding-bottom: ${({ theme: e }) => e.space[150]};

  & + & {
    margin-top: ${({ theme: e }) => e.space[150]};
  }
`, SectionWrapper = ({ title: e, children: t }) => /* @__PURE__ */ jsx(Wrapper$3, { children: /* @__PURE__ */ jsxs(Section, { children: [
  /* @__PURE__ */ jsx(H, { children: e }),
  t
] }) }), StyledParagraph = styled(Text$2)`
  margin-bottom: ${({ theme: e }) => e.space[100]};
`, Wrapper$2 = styled.div(
  ({ theme: e }) => css`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    background: ${e.color.white};
    flex-direction: column;
  `
), MenuWrapper = styled.div`
  padding: 20px;
  overflow-y: auto;
`, Menu = ({ onClose: e }) => {
  const t = useRef(null), { featureFlagStore: n } = useStores(), { activeMenu: o, previousMenuStateTitle: r, menuState: i, goBack: s, goTo: a } = useMenuContext(), l = n.get(), { closeEditing: d } = useContext(EditedEntityContext), c = o.component;
  if (useEffect(() => {
    var g;
    if (i !== MenuState.CLOSED) {
      const f = (g = t.current) == null ? void 0 : g.querySelector("h1, h2, h3, h4, h5, h6");
      f && (f.tabIndex = -1, f.focus({
        preventScroll: !0
      }));
    }
  }, [i]), i === MenuState.CLOSED)
    return null;
  const m = () => {
    d(), a(MenuState.CLOSED), e();
  }, p = [
    MenuState.CEILING_COVERINGS,
    MenuState.FLOOR_COVERINGS,
    MenuState.WALL_COVERINGS
  ].includes(i);
  return /* @__PURE__ */ jsxs(Wrapper$2, { ref: t, children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: o.page.title,
        onClose: m,
        backBtnAriaLabel: r,
        onNavigateBack: p ? s : void 0
      }
    ),
    /* @__PURE__ */ jsx(MenuWrapper, { "data-testid": "kvadrat-menu", children: /* @__PURE__ */ jsxs(Fragment, { children: [
      o.type === MenuOptionType.COMPONENT && c && /* @__PURE__ */ jsx(c, {}),
      o.type === MenuOptionType.LIST && /* @__PURE__ */ jsx(List, { menuOptions: o.items }),
      o.type === MenuOptionType.SECTIONS && /* @__PURE__ */ jsxs(Fragment, { children: [
        o.page.subTitle && /* @__PURE__ */ jsx(StyledParagraph, { tagName: "p", children: o.page.subTitle }),
        o.items.map((g, f) => /* @__PURE__ */ jsxs(SectionWrapper, { title: g.title, children: [
          g.type === MenuOptionType.BUTTONS && /* @__PURE__ */ jsx(PredefinedRooms, { wallFeatures: l.wallFeatures, rooms: g.items }),
          g.type === MenuOptionType.DRAG_BUTTONS && /* @__PURE__ */ jsx(ElementsMenu, { menuOptions: g.items })
        ] }, `${f}-${g.title}`))
      ] })
    ] }) })
  ] });
};
function KvadratMenu({ onClose: e }) {
  return /* @__PURE__ */ jsx(Menu, { onClose: e });
}
class GlobalLighting {
  constructor(t) {
    this.viewer = t;
  }
  async setupLighting(t) {
    t.environmentMapUrl && await this.viewer.set_environment_map(t.environmentMapUrl, "env"), t.environmentMapIntensity && this.viewer.set_environment_map_intensity(t.environmentMapIntensity);
  }
}
function enumKeys(e) {
  return Object.keys(e).filter((t) => Number.isNaN(+t));
}
class ViewerIdIndex {
  constructor(t) {
    C(this, "allIds", /* @__PURE__ */ new Set());
    C(this, "lookupTable", /* @__PURE__ */ new Map());
    C(this, "meshTypeToViewerIndexEntry", /* @__PURE__ */ new Map());
    this.viewerObjectExists = t, enumKeys(tn).forEach((n) => {
      this.meshTypeToViewerIndexEntry.set(tn[n], /* @__PURE__ */ new Set());
    });
  }
  add({ viewerId: t, meshType: n, kvadratId: o }) {
    const r = { viewerId: t, meshType: n, kvadratId: o };
    this.getViewerIndexEntry(o) && this.remove(o), this.allIds.add(t), this.lookupTable.set(o, r), this.meshTypeToViewerIndexEntry.get(n).add(r);
  }
  remove(t) {
    const n = this.lookupTable.get(t);
    if (!n)
      return;
    const { viewerId: o, meshType: r } = n;
    this.lookupTable.delete(t), this.allIds.delete(o), this.meshTypeToViewerIndexEntry.get(r).delete(n);
  }
  hasByViewerId(t) {
    return this.pruneStaleEntries(), this.allIds.has(t);
  }
  getViewerIds() {
    return this.pruneStaleEntries(), Array.from(this.allIds.values());
  }
  getViewerIdsByType(t) {
    this.pruneStaleEntries();
    const n = this.meshTypeToViewerIndexEntry.get(t);
    return Array.from(n.values()).map(({ viewerId: o }) => o);
  }
  getViewerIndexEntry(t) {
    if (t)
      return this.pruneStaleEntries(), this.lookupTable.get(t);
  }
  pruneStaleEntries() {
    [...this.lookupTable.values()].forEach(({ kvadratId: t, viewerId: n }) => {
      this.viewerObjectExists.object_exists(n) || this.remove(t);
    });
  }
}
const KVADRAT_META_KEY = "kvadratData", KVADRAT_NAMESPACE = "kvadrat";
class ViewerAdapter {
  constructor({ viewer: t, generator: n, materialDefaults: o, canvas: r, stores: i }) {
    C(this, "viewer");
    C(this, "onZoomIn", new EventEmitter());
    C(this, "onZoomOut", new EventEmitter());
    C(this, "materials");
    C(this, "generator");
    C(this, "canvas");
    C(this, "stores");
    C(this, "selectedKvadratId");
    C(this, "meshTypeVisibilityState");
    C(this, "globalLighting");
    C(this, "defaultTabIndex");
    C(this, "wallOutwardDirections", /* @__PURE__ */ new Map());
    // Since we are responsible for creating and removing the graphical representation of the generated objects, we need a mapping from
    // the id of the kvadrat object to the id of the viewer object.
    C(this, "idIndex");
    C(this, "onMeshCreated", new EventEmitter());
    C(this, "interactionBeginObserver", null);
    C(this, "activeCameraChangedObserver");
    C(this, "materialDefaults");
    this.viewer = t, this.canvas = r, this.generator = n, this.stores = i, this.materialDefaults = o, this.materials = /* @__PURE__ */ new Map(), this.meshTypeVisibilityState = /* @__PURE__ */ new Map(), this.idIndex = new ViewerIdIndex(this.viewer), this.defaultTabIndex = this.viewer.get_canvas_tab_index(), this.loadMaterial = this.loadMaterial.bind(this), this.globalLighting = new GlobalLighting(t), this.globalLighting.setupLighting(this.stores.configurationStore.get().lightingOptions), this.loadMaterials(o), this.generator.subscribe(this.subscribe.bind(this)), this.activeCameraChangedObserver = this.viewer.get_active_camera_changed_observable().add((s, a) => {
      this.handleActiveCameraChanged(a);
    }), this.handleActiveCameraChanged(this.viewer.get_active_camera());
  }
  getCanvas() {
    return this.canvas;
  }
  // IViewer.get_metadata return type is `MetadataValue | any` but docs says it can return undefined
  getMetadata(t) {
    return this.viewer.get_metadata(t, KVADRAT_META_KEY, KVADRAT_NAMESPACE);
  }
  selectViewerEntityByKvadratId(t) {
    var r;
    const { viewerId: n, meshType: o } = this.idIndex.getViewerIndexEntry(t) || {};
    (r = this.stores.configurationStore.get().enabledFeatures) != null && r.materialAndColors;
  }
  subscribe(t) {
    if (t.type === fe.CREATE) {
      switch (t.mesh.type) {
        case tn.WALLFEATURE:
        case tn.WALLFEATURE_ELEMENT:
          return;
      }
      const n = this.createCustomMesh(t.mesh);
      this.onMeshCreated.emit(n);
    } else t.type === fe.DELETE && this.onMeshDeleted(t.id);
  }
  setTabbable(t) {
    const n = t ? this.defaultTabIndex : -1;
    this.viewer.set_canvas_tab_index(n), this.canvas.setAttribute("tabIndex", n.toString());
  }
  getSelectedMeshScreenBounds() {
    const t = this.idIndex.getViewerIndexEntry(this.selectedKvadratId);
    if ((t == null ? void 0 : t.viewerId) === void 0)
      return;
    const n = this.getMetadata(t == null ? void 0 : t.viewerId);
    if (!n || !n.mesh)
      return;
    const o = zn(n.mesh.rotation.y), r = n.mesh.geometry.positions, i = [];
    for (let s = 0; s < r.length - 2; s = s + 3) {
      const a = u(r[s], r[s + 1], r[s + 2]);
      let l = xt(o, a);
      l = U(l, n.mesh.position);
      const d = this.viewer.project_world_position_to_canvas(
        l.x,
        l.y,
        l.z
      );
      d && i.push(d);
    }
    if (!(i.length < 1))
      return getBounds2D(i);
  }
  getMeshTypeVisibility(t) {
    const n = this.meshTypeVisibilityState.get(t);
    return n === void 0 ? !0 : n;
  }
  createCustomMesh(t) {
    var s, a, l;
    t.material && this.loadMaterials([t.material]);
    const n = this.materials.get(((s = t.material) == null ? void 0 : s.id) || t.type) ?? null, o = this.viewer.create_custom_mesh(
      {
        positions: t.geometry.positions,
        indices: t.geometry.indices,
        normals: t.geometry.normals,
        uv0: t.geometry.uv0,
        uv1: t.geometry.uv1
      },
      n
    );
    let r;
    t.parent && (r = (a = this.idIndex.getViewerIndexEntry(t.parent)) == null ? void 0 : a.viewerId), this.viewer.set_visible(o, this.getMeshTypeVisibility(t.type));
    let i = { kvadID: t.sourceId, type: t.type, mesh: t };
    if (r) {
      i.parent = r;
      const d = this.getMetadata(r);
      (l = d == null ? void 0 : d.children) == null || l.push({ meshId: o, type: t.type });
    }
    return this.viewer.add_metadata(o, KVADRAT_META_KEY, i, KVADRAT_NAMESPACE), this.viewer.set_receive_shadow(o, !0), this.idIndex.add({
      kvadratId: t.sourceId,
      viewerId: o,
      meshType: t.type
    }), t.wallOutwardDirection && this.wallOutwardDirections.set(o, t.wallOutwardDirection), o;
  }
  onMeshDeleted(t) {
    const n = this.idIndex.getViewerIndexEntry(t);
    if (!n)
      return;
    const { viewerId: o } = n;
    this.wallOutwardDirections.delete(o), this.viewer.object_exists(o) && this.viewer.delete_object(o, !0), this.idIndex.remove(t);
  }
  loadMaterial(t) {
    if (!t.colorCode)
      return this.viewer.load_material(t.url);
    const n = this.viewer.create_material(), o = parseHexColor(t.colorCode);
    return o && this.viewer.set_base_color(n, o), t.id === tn.THICKNESS ? this.viewer.set_unlit(n, !0) : t.id === tn.WALLFEATURE ? this.viewer.set_opacity(n, 0) : (this.viewer.set_roughness(n, 0.4), this.viewer.set_metallic(n, 0)), n;
  }
  loadMaterials(t) {
    t && t.filter((n) => !this.materials.has(n.id)).forEach((n) => this.materials.set(n.id, this.loadMaterial(n)));
  }
  getBackgroundColor() {
    return this.viewer.get_background_color();
  }
  getOrbitCameraInteractionObserver(t) {
    return t.interaction_begin_observable.add(() => {
      const n = t.offset;
      t.interaction_end_observable.add_once((o) => {
        const r = o.offset - n;
        r < 0 ? this.onZoomIn.emit() : r > 0 && this.onZoomOut.emit();
      });
    });
  }
  getOrthographicCameraInteractionObserver(t) {
    return t.interaction_begin_observable.add(() => {
      const n = t.projection;
      t.interaction_end_observable.add_once((o) => {
        const r = o.projection, i = Math.abs(n.right - n.left), s = Math.abs(r.right - r.left), a = Math.abs(n.top - n.bottom), l = Math.abs(r.top - r.bottom);
        s < i && l < a ? this.onZoomIn.emit() : s > i && l > a && this.onZoomOut.emit();
      });
    });
  }
  handleActiveCameraChanged(t) {
    this.interactionBeginObserver !== null && (t == null || t.interaction_begin_observable.remove(this.interactionBeginObserver), this.interactionBeginObserver.dispose(), this.interactionBeginObserver = null), t instanceof OrbitPlannerCamera ? this.interactionBeginObserver = this.getOrbitCameraInteractionObserver(t) : t instanceof OrthographicPlannerCamera && (this.interactionBeginObserver = this.getOrthographicCameraInteractionObserver(t));
  }
  dispose() {
    var n, o, r;
    this.idIndex.getViewerIds().forEach((i) => this.viewer.delete_object(i, !0)), (n = this.materialDefaults) == null || n.forEach((i) => this.viewer.unload_models(i.url)), this.generator.unsubscribeAll(), this.onZoomIn.unsubscribeAll(), this.onZoomOut.unsubscribeAll(), this.onMeshCreated.unsubscribeAll(), (o = this.interactionBeginObserver) == null || o.dispose(), (r = this.activeCameraChangedObserver) == null || r.dispose();
  }
}
class KvadratOnlyComponentDeserializer extends CustomComponentDeserializer {
  canHandle(t) {
    return new KvadratComponent().serializationKey() === t && super.canHandle(t);
  }
}
const getItemsPath = "webplanner/v1/query/items/retailunit/";
async function fetchKvadratAssets(e, t, n, o, r) {
  const i = `${e}${getItemsPath}${r}/locale/${o}?filter.appId=${n}`, s = await fetch(i, {
    credentials: "same-origin",
    headers: {
      "dexf-api-key": t
    }
  });
  return s.ok, s.json();
}
const roomConfigPath = "/room/configurations", vpcDEXFPath = "vpc/v1";
async function fetchRoomConfiguration(e, t, n) {
  const o = await fetchConfiguration(e, t, n);
  if (!(o != null && o.content))
    throw new RoomConfigurationError(500, RoomConfigurationErrorMessage.LOAD_ERROR);
  return o.content;
}
async function saveRoomConfiguration(e, t, n, o) {
  const r = await saveConfiguration(e, t, n, o);
  if (r != null && r.roomId)
    return r.roomId;
  throw new RoomConfigurationError(500, RoomConfigurationErrorMessage.SAVE_ERROR);
}
async function fetchConfiguration(e, t, n) {
  const o = `${e}${vpcDEXFPath}${roomConfigPath}/${n}`, r = await fetch(o, {
    credentials: "same-origin",
    headers: {
      "dexf-api-key": t
    }
  });
  if (!r.ok)
    throw new RoomConfigurationError(r.status, RoomConfigurationErrorMessage.LOAD_ERROR);
  return await r.json();
}
async function saveConfiguration(e, t, n, o) {
  const r = `${e}${vpcDEXFPath}${roomConfigPath}`, i = {
    applicationId: o,
    content: n,
    version: `${n.versionMajor}.${n.versionMinor}`
  }, s = {
    "dexf-api-key": t,
    // PLANNER API KEY
    "content-type": "application/json"
  }, a = await fetch(r, {
    method: "POST",
    body: JSON.stringify(i),
    credentials: "same-origin",
    headers: s
  });
  if (!a.ok)
    throw new RoomConfigurationError(a.status, RoomConfigurationErrorMessage.SAVE_ERROR);
  return await a.json();
}
class Dexf {
  constructor(t, n, o) {
    this.dexfBaseUrl = t, this.dexfApiKey = n, this.dexfAppName = o;
  }
  async loadConfiguration(t) {
    return fetchRoomConfiguration(this.dexfBaseUrl, this.dexfApiKey, t);
  }
  async saveConfiguration(t) {
    return await saveRoomConfiguration(
      this.dexfBaseUrl,
      this.dexfApiKey,
      t,
      this.dexfAppName
    );
  }
  async fetchAllAssets(t, n) {
    return (await fetchKvadratAssets(this.dexfBaseUrl, this.dexfApiKey, this.dexfAppName, t, n)).data;
  }
}
const settings = {
  thickness: 0.01,
  color: { r: 0, g: 0, b: 0 },
  capLength: 0.03
};
function updateLine(e, t, n) {
  return t.forEach((o) => {
    let r = Number.MIN_SAFE_INTEGER;
    if (ht(o.walls[0].height))
      r = o.walls[0].height;
    else
      throw new Error("Height is missing!");
    let i = Number.MIN_SAFE_INTEGER, s = o.walls[0];
    for (const g of o.walls) {
      const f = st(o.corners[g.rightIndex], 1e3), h = e.project_world_position_to_canvas(f.x, f.y, f.z);
      h && h.x > i && (i = h.x, s = g);
    }
    const a = st(o.corners[s.leftIndex], 1e3), l = st(o.corners[s.rightIndex], 1e3), d = V($(l, a)), c = U(l, P(d, 0.5)), m = c, p = U(c, u(0, r / 1e3, 0));
    n && n.visible ? (n.start = m, n.end = p, n.cap_axis = d, n.update()) : n = new LineMeasureWidget(e, m, p, { r: 0, g: 0, b: 0 }, 0.01, d, 0.1);
  }), n;
}
function getWidthLine({ min: e, max: t }) {
  return {
    start: st(u(e.x, t.y, e.z), 1e3),
    end: st(u(t.x, t.y, e.z), 1e3),
    capDirection: { x: 0, y: 1, z: 0 }
  };
}
function getHeightLine({ min: e, max: t }) {
  return {
    start: st(u(e.x, e.y, e.z), 1e3),
    end: st(u(e.x, t.y, e.z), 1e3),
    capDirection: { x: 1, y: 0, z: 0 }
  };
}
function getDepthLine({ min: e, max: t }) {
  return {
    start: st(u(e.x, t.y, e.z), 1e3),
    end: st(u(e.x, t.y, t.z), 1e3),
    capDirection: { x: 0, y: 1, z: 0 }
  };
}
class LineMeasure {
  constructor(t, n, o, r) {
    C(this, "lineMeasure");
    C(this, "label");
    this.viewer = t, this.canvas = n, this.stores = o, this.config = r, this.label = this.createLabel(r.id), this.lineMeasure = new LineMeasureWidget(
      this.viewer,
      u(0, 0, 0),
      u(0, 0, 0),
      settings.color,
      settings.thickness,
      u(0, 0, 0),
      settings.capLength
    );
  }
  createLabel(t) {
    var r;
    const n = document.createElement("span"), { style: o } = n;
    return n.id = t, o.display = "none", o.position = "absolute", o.top = "0", o.left = "0", o.padding = "0 15px", o.lineHeight = "24px", o.backgroundColor = "#111111", o.color = "white", o.fontFamily = "notoIKEAlatin, 'Noto IKEA', Noto Sans, Roboto, Open Sans, sans-serif", o.fontSize = "12px", o.textAlign = "center", o.fontWeight = "bold", (r = this.canvas.parentElement) == null || r.appendChild(n), n;
  }
  updateLineMeasure(t) {
    const { start: n, end: o, capDirection: r } = this.config.getLine(t);
    this.lineMeasure.visible = !0, this.lineMeasure.start = n, this.lineMeasure.end = o, this.lineMeasure.cap_axis = r, this.lineMeasure.update();
  }
  updateLabel(t) {
    const { label: n } = this;
    n.style.display = "inline-block";
    const o = this.label.getBoundingClientRect(), r = o.width, i = o.height, s = this.lineMeasure.get_2d_midpoint(), a = ((s == null ? void 0 : s.x) || 0) + t.x - r * 0.5, l = ((s == null ? void 0 : s.y) || 0) + t.y - i * 0.5;
    a < t.left || // ..left side boundary
    l < t.top || // ..top boundary
    a > t.right - r || // ..right side boundary
    l > t.bottom - i ? n.style.display = "none" : (n.style.display = "inline-block", n.style.transform = `translate(${a}px, ${l}px)`);
    const d = mToMm(this.lineMeasure.length()), { measurementSystem: c } = this.stores.configurationStore.get();
    n.innerHTML = c === "metric" ? toDisplayCm(mmToCm(d)) : toDisplayFtIn(mmToInch(d));
  }
  update(t, n) {
    this.updateLineMeasure(t), this.updateLabel(n);
  }
  dispose() {
    this.lineMeasure.dispose(), this.label.remove();
  }
}
const dimensions = [
  {
    id: "kvadrat-slider-measurement-width-label",
    dimension: "width",
    getLine: getWidthLine
  },
  {
    id: "kvadrat-slider-measurement-height-label",
    dimension: "height",
    getLine: getHeightLine
  },
  {
    id: "kvadrat-slider-measurement-depth-label",
    dimension: "depth",
    getLine: getDepthLine
  }
];
class CuboidMeasurement {
  constructor(t, n, o, r) {
    C(this, "updateLabelsCallback");
    C(this, "measurements");
    C(this, "updateCameraObserver");
    this.viewer = t, this.canvas = n, this.stores = o, this.measurements = dimensions.map((i) => new LineMeasure(this.viewer, this.canvas, this.stores, i)), this.updateLabelsCallback = this.updateLabels.bind(this), this.updateCameraObserver = t.get_camera_updated_observable().add(this.updateLabelsCallback), this.canvas.addEventListener("resize", this.updateLabelsCallback), this.update(r);
  }
  update(t) {
    const n = this.canvas.getBoundingClientRect();
    this.measurements.forEach((o) => {
      o.update(t, n);
    });
  }
  updateLabels() {
    const t = this.canvas.getBoundingClientRect();
    this.measurements.forEach((n) => {
      n.updateLabel(t);
    });
  }
  destroy() {
    this.measurements.forEach((t) => t.dispose()), this.viewer.get_camera_updated_observable().remove(this.updateCameraObserver), this.canvas.removeEventListener("resize", this.updateLabelsCallback);
  }
}
function createElement(e, t) {
  const n = document.createElement(e);
  return Object.entries(t).forEach(([o, r]) => n.setAttribute(o, r)), n;
}
function cloneElement(e, t) {
  const n = e.cloneNode(!0);
  return Object.entries(t).forEach(([o, r]) => n.setAttribute(o, r)), n;
}
function addEventListener$1(e, t, n) {
  return e.addEventListener(t, n), () => {
    e.removeEventListener(t, n);
  };
}
function throttleRequestAnimationFrame(e) {
  let t = !1;
  return (...n) => {
    t || (t = !0, e(...n), requestAnimationFrame(() => {
      t = !1;
    }));
  };
}
class WallHeightAdjuster {
  constructor(t, n, o, r, i, s) {
    C(this, "walls", []);
    C(this, "viewer");
    C(this, "dragHandler");
    C(this, "dragStartHandler");
    C(this, "dragEndHandler");
    C(this, "widgetMaterial");
    C(this, "invisibleMaterial");
    C(this, "gizmoTable", {});
    C(this, "activeDragHandles", []);
    C(this, "onPointerMove");
    C(this, "onCameraChange");
    C(this, "blueprintUnsubscriber");
    C(this, "cameraUpdatedObservable");
    C(this, "dragging", !1);
    C(this, "arrowsViewerId");
    C(this, "sendError");
    this.viewerAdapter = t, this.canvas = n, this.blueprintStore = o, this.snapSize = s, this.pointerMove = throttleRequestAnimationFrame(this.pointerMove.bind(this)), this.dragHandler = this.onDrag.bind(this), this.dragStartHandler = this.onDragStart.bind(this), this.dragEndHandler = this.onDragEnd.bind(this), this.viewer = t.viewer, this.onCameraChange = this.calculateVisibility.bind(this), this.cameraUpdatedObservable = this.viewer.get_camera_updated_observable().add(this.onCameraChange);
    const a = this.viewer.create_material();
    this.viewer.set_base_color(a, ICOLOR_DEFAULT), this.viewer.set_roughness(a, 1), this.viewer.set_metallic(a, 0), this.viewer.set_unlit(a, !0), this.widgetMaterial = a, this.invisibleMaterial = this.viewer.create_material(), this.viewer.set_opacity(this.invisibleMaterial, 0), this.viewer.set_unlit(this.invisibleMaterial, !0), this.blueprintUnsubscriber = o.subscribe(this.updateBlueprint.bind(this)), this.updateBlueprint(o.get()), this.calculateVisibility(), this.onPointerMove = this.pointerMove.bind(this), n.addEventListener("pointermove", this.onPointerMove), this.arrowsViewerId = create3dChevronsMesh(this.viewer, this.widgetMaterial), this.viewer.set_scale(this.arrowsViewerId, 0.1, 0.1, 1), this.viewer.set_visible(this.arrowsViewerId, !1), this.sendError = debounce(
      (l) => {
        const { translate: d } = r;
        i.onNotification.emit({
          message: d(ERROR_CODE_TRANSLATION_KEYS[l]),
          title: d("notificationTitleMeasurement"),
          type: "error"
        });
      },
      1e3,
      { leading: !0, trailing: !1 }
    );
  }
  pointerMove(t) {
    const n = this.viewer.raycast_object_using_canvas_coordinate(t.offsetX, t.offsetY, this.activeDragHandles);
    if (n) {
      this.canvas.style.cursor = "pointer", !this.dragging && this.viewer.get_base_color(this.widgetMaterial) !== ICOLOR_HOVER && this.viewer.set_base_color(this.widgetMaterial, ICOLOR_HOVER);
      const o = this.viewer.get_parent(n.object);
      this.viewer.get_parent(this.arrowsViewerId) !== o && this.viewer.set_parent(this.arrowsViewerId, o), this.viewer.set_visible(this.arrowsViewerId, !0);
    } else
      this.dragging || (this.canvas.style.cursor = "default", this.viewer.get_base_color(this.widgetMaterial) !== ICOLOR_DEFAULT && this.viewer.set_base_color(this.widgetMaterial, ICOLOR_DEFAULT), this.viewer.set_visible(this.arrowsViewerId, !1));
  }
  updateBlueprint(t) {
    const n = Fn(t);
    if (this.walls = [], n.rooms.length != 1)
      throw new Error("Wall Height adjuster gizmo does not support multiple rooms.");
    n.rooms.forEach((o, r) => {
      const i = {};
      for (let s of o.walls) {
        i[s.id] = !0;
        const a = o.corners[s.leftIndex], l = me(a, o.corners[s.rightIndex]) ? u(1e-3, 0, 0) : $(o.corners[s.rightIndex], a), d = _(l), c = V(l), m = u(-c.z, 0, c.x);
        if (!ht(s.height))
          throw new Error("Non constant wall heights not yet implemented.");
        if (!this.gizmoTable[s.id]) {
          const A = this.viewer.create_empty_object(), F = this.viewer.create_box(1, WALL_TOP_LINE_HEIGHT, 1e-3, this.widgetMaterial);
          this.viewer.set_parent(F, A);
          const z = this.viewer.create_box(
            1,
            WALL_TOP_LINE_DRAG_SIZE,
            WALL_TOP_LINE_DRAG_SIZE,
            this.invisibleMaterial
          );
          this.viewer.set_parent(z, A), this.viewer.get_object_drag_observable(z).add(this.dragHandler), this.viewer.get_object_drag_begin_observable(z).add(this.dragStartHandler), this.viewer.get_object_drag_end_observable(z).add(this.dragEndHandler), this.gizmoTable[s.id] = {
            gizmoId: F,
            dragBoxId: z,
            parentId: A
          };
        }
        let { gizmoId: p, dragBoxId: g, parentId: f } = this.gizmoTable[s.id];
        this.viewer.set_scale(p, d, 1, 1), this.viewer.set_scale(g, d, 1, 1);
        const { x: h, y: E, z: I } = U(U(a, u(0, s.height - WALL_TOP_LINE_HEIGHT * 0.5, 0)), P(l, 0.5));
        this.viewer.set_position(f, h, E, I);
        const R = Math.atan2(-c.z, c.x);
        this.viewer.set_rotation(f, 0, R, 0), this.walls.push({
          roomIdx: r,
          wallId: s.id,
          gizmo: this.gizmoTable[s.id],
          position: K(o.transform, a, 1),
          normal: K(o.transform, m, 0)
        });
      }
      for (let s in this.gizmoTable)
        i[s] || (this.viewer.delete_object(this.gizmoTable[s].gizmoId), this.viewer.delete_object(this.gizmoTable[s].dragBoxId), delete this.gizmoTable[s]);
    });
  }
  onDrag(t, n) {
    this.updateCeilingHeight(n.world_delta.y);
  }
  updateCeilingHeight(t) {
    const n = this.blueprintStore.getCeilingHeight() + t * 1e3, o = Math.round(n / this.snapSize) * this.snapSize, r = this.blueprintStore.updateSetCeilingHeight(o);
    r && this.sendError(r);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragStart(t, n) {
    this.dragging = !0, this.viewer.set_base_color(this.widgetMaterial, ICOLOR_DRAGGING), this.canvas.style.cursor = "grab";
  }
  onDragEnd(t, n) {
    this.dragging = !1, this.updateCeilingHeight(n.world_delta.y), this.blueprintStore.endSetCeilingHeight();
  }
  calculateVisibility() {
    const { position: t } = this.viewer.get_camera_state();
    this.activeDragHandles = [];
    for (const n of this.walls) {
      const o = $(t, n.position), r = B(o, n.normal) > 0;
      this.viewer.set_visible(n.gizmo.gizmoId, r), this.viewer.set_visible(n.gizmo.dragBoxId, r), r && this.activeDragHandles.push(n.gizmo.dragBoxId);
    }
  }
  dispose() {
    this.canvas.removeEventListener("pointermove", this.onPointerMove), this.viewer.get_camera_updated_observable().remove(this.cameraUpdatedObservable), this.blueprintUnsubscriber();
    for (let t of this.walls)
      this.viewer.delete_object(t.gizmo.gizmoId), this.viewer.delete_object(t.gizmo.dragBoxId);
    this.walls = [];
  }
}
function create3dChevronsMesh(e, t) {
  const n = new Float32Array([
    0,
    2,
    0.01,
    -1,
    1,
    0.01,
    -1.5,
    1.5,
    0.01,
    0,
    3,
    0.01,
    1.5,
    1.5,
    0.01,
    1,
    1,
    0.01,
    0,
    -2,
    0.01,
    -1,
    -1,
    0.01,
    -1.5,
    -1.5,
    0.01,
    0,
    -3,
    0.01,
    1.5,
    -1.5,
    0.01,
    1,
    -1,
    0.01
  ]), o = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3,
    0,
    3,
    4,
    0,
    4,
    5,
    0,
    2,
    1,
    0,
    3,
    2,
    0,
    4,
    3,
    0,
    5,
    4,
    6,
    7,
    8,
    6,
    8,
    9,
    6,
    9,
    10,
    6,
    10,
    11,
    6,
    8,
    7,
    6,
    9,
    8,
    6,
    10,
    9,
    6,
    11,
    10
  ]);
  return e.create_custom_mesh(
    {
      positions: n,
      indices: o
    },
    t ?? null
  );
}
class Editor3d {
  constructor(t, n, o, r, i) {
    C(this, "active", !1);
    C(this, "cuboidMeasurements");
    C(this, "wallHeightGizmo");
    // Keep track of all subscriptions so we can unregister them
    // when user closes Kvadrat
    C(this, "registeredEvents", []);
    this.viewerAdapter = t, this.cameraActions = n, this.stores = o, this.canvas = r, this.api = i, this.viewerAdapter.setTabbable(!1), this.onBlueprintChange = this.onBlueprintChange.bind(this), this.onSelectedCollidableChange = this.onSelectedCollidableChange.bind(this);
  }
  registerUnsubscription(t) {
    this.registeredEvents.push(t);
  }
  async open() {
    var n;
    const { editorStore: t } = this.stores;
    this.active = !0, this.viewerAdapter.setTabbable(!1), (n = this.stores.configurationStore.get().enabledFeatures) != null && n.materialAndColors && this.registerUnsubscription(
      // Subscribe to changes to selectedCollidableId
      this.stores.selectedCollidableStore.subscribe(this.onSelectedCollidableChange)
    ), this.registerUnsubscription(
      // Update framing whenever blueprint is updated
      this.stores.blueprintStore.subscribe(this.onBlueprintChange)
    ), t.getEditorMode() === EditorMode.EDITOR_MODE_2D ? await this.cameraActions.cameraTransitionToTopDownView("push") : await this.cameraActions.tryPushOrbitPlannerCameraClone() || await this.cameraActions.cameraTransitionToAngledFrontView("push"), this.addGizmos(), this.registerUnsubscription(
      this.viewerAdapter.onZoomIn.subscribe(() => {
        sendEvent(
          InsightsEventType.SCROLL_ZOOM_IN_3D,
          { editorMode: EditorMode.EDITOR_MODE_3D },
          IpexMomentEnum.showMe
        );
      })
    ), this.registerUnsubscription(
      this.viewerAdapter.onZoomOut.subscribe(() => {
        sendEvent(
          InsightsEventType.SCROLL_ZOOM_OUT_3D,
          {
            editorMode: EditorMode.EDITOR_MODE_3D
          },
          IpexMomentEnum.showMe
        );
      })
    );
  }
  onBlueprintChange(t) {
    if (this.active) {
      const n = cuboidFromBlueprint(t);
      this.cuboidMeasurements && !this.stores.featureFlagStore.get().editor2D && (this.cuboidMeasurements.update(n), this.cameraActions.frameCuboid(n));
    }
  }
  onSelectedCollidableChange() {
    const t = this.stores.userInteractionStore.get().selectedCollidableId;
    t && this.viewerAdapter.selectViewerEntityByKvadratId(t);
  }
  addGizmos() {
    const { featureFlagStore: t, configurationStore: n } = this.stores, { measurementSystem: o } = n.get(), r = o === "metric" ? cmToMm(1) : inchToMm(1);
    if (t.get().editor2D)
      this.wallHeightGizmo = new WallHeightAdjuster(
        this.viewerAdapter,
        this.canvas,
        this.stores.blueprintStore,
        this.stores.i18nStore,
        this.api,
        r
      );
    else {
      const i = cuboidFromBlueprint(this.stores.blueprintStore.get());
      this.cuboidMeasurements = new CuboidMeasurement(this.viewerAdapter.viewer, this.canvas, this.stores, i), this.cameraActions.frameCuboid(i);
    }
  }
  async close() {
    var t;
    this.active = !1, this.stores.editorStore.setOpen(!1), this.viewerAdapter.setTabbable(!0), (t = this.wallHeightGizmo) == null || t.dispose(), this.cuboidMeasurements && (this.cuboidMeasurements.destroy(), this.cuboidMeasurements = void 0), this.registeredEvents.forEach((n) => n());
  }
}
const defaultTransition = {
  duration_seconds: CAMERA_TRANSITION_DURATION_SECONDS,
  interpolation: smoother_step
}, defaultZoomLimits = {
  near: 1,
  far: 20
}, offsetBoundZoomLimits = (e) => ({
  near: defaultZoomLimits.near,
  far: Math.max(defaultZoomLimits.far, e.offset)
}), ANGLED_FRONTVIEW_DIRECTION = new Vector3(0, -0.3, -1).normalize(), ZOOM_3D_SCALE = 0.2;
class CameraActions {
  constructor(t, n, o) {
    C(this, "canvasResizeObserver");
    this.viewer = t, this.viewerAdapter = n, this.stores = o, o.userInteractionStore.subscribe((r) => this.syncOrthographicCameraTo2dCanvas("replace", r)), this.canvasResizeObserver = new ResizeObserver(
      () => this.syncOrthographicCameraTo2dCanvas("replace", o.userInteractionStore.get())
    ), this.canvasResizeObserver.observe(this.viewerAdapter.getCanvas()), this.reCenter3DView = throttle(this.reCenter3DView.bind(this), 100);
  }
  getOrthographicCameraZoom() {
    const { scale: t } = this.stores.userInteractionStore.get(), n = window.innerHeight / 1e3;
    return 1 / t * n;
  }
  async syncOrthographicCameraTo2dCanvas(t = "replace", n) {
    const o = get(canvas2d), r = this.viewer.get_active_camera();
    if (!o || this.stores.editorStore.getEditorMode() !== EditorMode.EDITOR_MODE_2D || !(r instanceof OrthographicPlannerCamera))
      return;
    const { width: i, height: s } = o, { offset: a, scale: l } = n, d = new Vector3(i / 2 - a.x, 1, s / 2 - a.y).scale(1 / l / 1e3);
    r.center_camera_on_position(d), r.size = this.getOrthographicCameraZoom(), await this.changeCamera(t, r, {
      visibleTransition: !1
    });
  }
  // When the user clicks redo to transition into kvadrat mode, the camera transition method is invoked before all
  // custom meshes have been updated. This hack ensures that the viewer ID index has a chance to update before
  // we need to retrieve the list of viewer object IDs to frame.
  // TODO: replace this hack with a more sensible state transitioning solution (i.e. a state machine or statechart)
  async getViewerIds() {
    return await new Promise((t) => {
      window.setTimeout(() => {
        t(this.viewerAdapter.idIndex.getViewerIds());
      }, 10);
    });
  }
  async changeCamera(t, n, o) {
    const { applyDefaultZoomLimits: r, visibleTransition: i, transition: s } = {
      applyDefaultZoomLimits: !0,
      visibleTransition: !0,
      transition: defaultTransition,
      ...o
    };
    r && n instanceof OrbitPlannerCamera && n.set_zoom_limits(offsetBoundZoomLimits(n));
    const a = this.viewer.get_default_view().camera_manager;
    return i ? a[t === "push" ? "push_camera" : "replace_camera"](n, s) : a[t === "push" ? "push_camera_immediate" : "replace_camera_immediate"](n), i ? new Promise((l) => {
      this.viewer.get_camera_transition_end_observable().add_once(() => l());
    }) : Promise.resolve();
  }
  async popCamera(t = !0) {
    return this.viewer.get_default_view().camera_manager.pop_camera(t ? defaultTransition : void 0), t ? new Promise((n) => {
      this.viewer.get_camera_transition_end_observable().add_once(() => n());
    }) : Promise.resolve();
  }
  async cameraTransitionToTopDownView(t = "replace") {
    autoZoomCenterCanvas(
      this.stores.userInteractionStore,
      this.stores.blueprintStore.getDecoratedRooms(),
      this.viewerAdapter.getCanvas(),
      !0
    );
    const n = new OrthographicPlannerCamera(CardinalDirection.TOP, Vector3.Zero(), this.viewer), o = await this.getViewerIds();
    if (o.length) {
      const r = await this.viewer.get_object_bounds_world(...o);
      await n.frame_precise(r), n.size = this.getOrthographicCameraZoom();
    }
    return await this.changeCamera(t, n), n;
  }
  async cameraTransitionToAngledFrontView(t = "replace") {
    const n = new OrbitPlannerCamera(Vector3.Zero(), Vector3.Forward(), this.viewer), o = await this.getViewerIds();
    o.length > 0 && await n.frame_objects(o, !1, 0, ANGLED_FRONTVIEW_DIRECTION), await this.changeCamera(t, n);
  }
  async cameraTransitionToFrontView(t = "replace") {
    const n = new OrbitPlannerCamera(Vector3.Zero(), Vector3.Forward(), this.viewer), o = await this.getViewerIds();
    o.length > 0 && await n.frame_objects(o, !1, 0, IVector3.Back()), await this.changeCamera(t, n);
  }
  async tryPushOrbitPlannerCameraClone() {
    const t = this.viewer.get_active_camera();
    if (!(t instanceof OrbitPlannerCamera))
      return !1;
    const n = t.clone(), o = await this.getViewerIds();
    o.length > 0 && await n.frame_objects(o);
    const r = t.clone();
    return r.set_zoom_limits(offsetBoundZoomLimits(n)), await this.changeCamera("push", r, {
      visibleTransition: !1,
      applyDefaultZoomLimits: !1
    }), !0;
  }
  async reCenterView() {
    const { userInteractionStore: t, editorStore: n, blueprintStore: o } = this.stores;
    n.getEditorMode() === EditorMode.EDITOR_MODE_2D ? autoZoomCenterCanvas(
      t,
      o.getDecoratedRooms(),
      this.viewerAdapter.getCanvas(),
      !0
    ) : await this.reCenter3DView();
  }
  /**
   * Recenters the 3d view but only if an OrbitCamera is at the top of the stack
   */
  async reCenter3DView() {
    const t = this.viewer.get_active_camera();
    if (!(t instanceof OrbitPlannerCamera))
      return;
    const n = await this.getViewerIds(), o = new OrbitPlannerCamera(Vector3.Zero(), t.forward, this.viewer);
    n.length > 0 && await o.frame_objects(n), await this.changeCamera("replace", o);
  }
  frameCuboid(t) {
    const n = new Vector3(t.max.x, t.max.y, t.max.z), o = new Vector3(t.min.x, t.min.y, t.min.z), r = this.viewer.get_active_camera(), i = new OrbitPlannerCamera(
      (r == null ? void 0 : r.position) || Vector3.Zero(),
      n.subtract(o).scale(1 / 1e3),
      this.viewer
    );
    i.set_zoom_limits(offsetBoundZoomLimits(i)), this.viewer.replace_camera(i);
  }
  async frameSelectedTarget() {
    var i;
    const { userInteractionStore: t } = this.stores, { selectedCollidable: n } = t.get();
    if (n === void 0)
      return;
    let o = n;
    if (isWallFeatureCollidable(n)) {
      const s = this.stores.collidablesStore.get().find((a) => a.id === n.entity.wallId);
      s && (o = s);
    }
    const r = (i = this.viewerAdapter.idIndex.getViewerIndexEntry(o.id)) == null ? void 0 : i.viewerId;
    if (r === void 0) {
      console.warn("[CameraActions.frameSelectedTarget] selectedViewerObjectId is undefined");
      return;
    }
    if (!this.viewer.object_exists(r)) {
      console.warn(
        `[CameraActions.frameSelectedTarget] viewer object with id ${r} does not exist`
      );
      return;
    }
    if (isWallCollidable(o)) {
      const s = IVector3.cross(o.entity.direction, { x: 0, y: -1, z: 0 }), a = new OrbitPlannerCamera(IVector3.Zero(), IVector3.Forward(), this.viewer);
      await a.frame_objects([r], !1, 0, s), await this.changeCamera("replace", a);
    }
  }
  zoomIn() {
    var r;
    const { userInteractionStore: t, editorStore: n } = this.stores, o = n.getEditorMode();
    o === EditorMode.EDITOR_MODE_2D ? t.zoomIn() : o === EditorMode.EDITOR_MODE_3D && ((r = this.viewer.get_active_camera()) == null || r.zoom_input({
      delta: ZOOM_3D_SCALE
    })), sendEvent(InsightsEventType.ZOOM_BUTTON_IN, { editorMode: o }, IpexMomentEnum.showMe);
  }
  zoomOut() {
    var r;
    const { userInteractionStore: t, editorStore: n } = this.stores, o = n.getEditorMode();
    o === EditorMode.EDITOR_MODE_2D ? t.zoomOut() : o === EditorMode.EDITOR_MODE_3D && ((r = this.viewer.get_active_camera()) == null || r.zoom_input({
      delta: ZOOM_3D_SCALE
    })), sendEvent(InsightsEventType.ZOOM_BUTTON_OUT, { editorMode: o }, IpexMomentEnum.showMe);
  }
  dispose() {
    this.stores.userInteractionStore.dispose(), this.canvasResizeObserver.disconnect();
  }
}
async function fetchLocalizations(e, t, n, o) {
  const r = new TranslationsService({
    locale: e,
    translationEndpoints: [
      `${t}/addon-app/translations/kvadrat/en-XZ.json`,
      `${t}/addon-app/translations/kvadrat/{language}-{country}.json`
    ],
    translationPrefixApplication: "KVADRAT"
  }), i = new SettingsService({
    locale: e,
    dexfApiKey: n,
    dexfApplicationId: o
  }), [s, a] = await Promise.all([
    r.getTranslations(),
    // cast as we do not use Kompis translations which the response implies.
    i.getApplicationSettings()
  ]);
  return {
    ...a,
    ...s
  };
}
const CORNER_SIZE = 20, DEFAULT_CORNER_FILL_STYLE = "#767676", DEFAULT_MEASUREMENT_LINE = "#484848", DEFAULT_FILL_STYLE = "#ffffff", DEFAULT_STROKE_STYLE = "#000000", DEFAULT_WALL_WIDTH = 4, DEFAULT_MITER_LIMIT = 3, STROKE_STYLES = {
  selected: "#489CE3",
  hovered: "#40B1E1",
  dragged: "#007CC1",
  invalid: "#E00751",
  previewed: "#FFA524",
  ghosted: "#CCCCCC",
  default: DEFAULT_STROKE_STYLE
}, DEFAULT_WALL_FEATURE_BORDER_SIZE = 2, DEFAULT_WALL_FEATURE_DEPTH = 22, DOOR_FEATURE_BORDER_SIZE = 2, DOOR_FEATURE_DEPTH = 16, DOOR_OPENING_FEATURE_BORDER_SIZE = 4, DOOR_OPENING_FEATURE_DEPTH = 14, WINDOW_FEATURE_BORDER_SIZE = 2, WINDOW_FEATURE_DEPTH = 12, DEFAULT_DRAW_HANDLER_PATH_OPTIONS = {
  units: "meters",
  round: !0
}, DEFAULT_DRAW_HANDLER_IMAGE_OPTIONS = {
  units: "meters",
  round: !0,
  anchor: "corner"
}, DEFAULT_PATH_STROKE_STYLE = {
  lineWidth: DEFAULT_WALL_WIDTH,
  strokeStyle: DEFAULT_STROKE_STYLE,
  lineCap: "butt",
  lineJoin: "miter",
  miterLimit: 10,
  lineDashOffset: 0
}, DEFAULT_PATH_FILL_STYLE = {
  ...DEFAULT_PATH_STROKE_STYLE,
  fillStyle: DEFAULT_FILL_STYLE
};
class DrawHandler {
  constructor(t, n = 1, o = y(0, 0)) {
    this.ctx = t, this.scale = n, this.offset = o, this.ctx.resetTransform();
  }
  /** Clears the entire canvas */
  clear() {
    this.ctx.resetTransform(), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
  }
  /** Returns a Path2D object from input PathSegment(s). Each PathSegments has an array of vertices (vec2[]).
   * Positions can be either world-space (meters) or screen-space (pixels).
   */
  path(t, n = {}) {
    const { units: o, round: r } = { ...DEFAULT_DRAW_HANDLER_PATH_OPTIONS, ...n };
    t instanceof Array || (t = [t]);
    const i = new Path2D();
    if (t.length < 1)
      return i;
    for (const s of t) {
      if (s.vertices.length < 2)
        continue;
      const a = s.vertices;
      if (o == "meters")
        for (let c = 0; c < a.length; c++) {
          const m = a[c];
          a[c] = ge.add(ge.muls(m, this.scale), this.offset);
        }
      if (r)
        for (let c = 0; c < a.length; c++)
          a[c] = ge.round(a[c]);
      const [l, ...d] = a;
      i.moveTo(l.x, l.y);
      for (const c of d)
        i.lineTo(c.x, c.y);
      s.closed && i.closePath();
    }
    return i;
  }
  /** Apply a stroke to a Path2D. Calls context.save() and context.restore() to prevent
   * changes to the context state.
   * @param path a Path2D object
   * @param style the style used for the stroke
   */
  stroke(t, n) {
    Object.assign(this.ctx, { ...DEFAULT_PATH_STROKE_STYLE, ...n }), n.lineDash ? this.ctx.setLineDash(n.lineDash) : this.ctx.setLineDash([]), this.ctx.stroke(t);
  }
  /** Apply a fill to a Path2D. Calls context.save() and context.restore() to prevent
   * changes to the context state.
   * @param path a Path2D object
   * @param style the style used for the fill
   * */
  fill(t, n = {}) {
    Object.assign(this.ctx, { ...DEFAULT_PATH_FILL_STYLE, ...n }), this.ctx.fill(t);
  }
  /** Returns a Path2D in the shape of a circle using the arc method.
   * @param pos position of the circle in either meters or pixels
   * @param radius radius in pixels
   * @param options
   */
  circle(t, n, o = {}) {
    const { units: r, round: i } = { ...DEFAULT_DRAW_HANDLER_PATH_OPTIONS, ...o };
    r == "meters" && (t = ge.add(ge.muls(t, this.scale), this.offset)), i && (t = ge.round(t));
    const { x: s, y: a } = t, l = new Path2D();
    return l.arc(s, a, n, 0, 2 * Math.PI), l;
  }
  image(t, n, o = {}) {
    const { units: r, round: i, anchor: s } = { ...DEFAULT_DRAW_HANDLER_IMAGE_OPTIONS, ...o };
    r == "meters" && (n = ge.add(ge.muls(n, this.scale), this.offset)), s == "center" && (n.x -= t.width / 2, n.y -= t.height / 2), i && (n = ge.round(n)), this.ctx.drawImage(t, n.x, n.y);
  }
  line(t, n, o, r = {}) {
    const i = this.path({ vertices: [t, n] }, r);
    this.stroke(i, o);
  }
}
var CollidableState = /* @__PURE__ */ ((e) => (e.SELECTED = "selected", e.HOVERED = "hovered", e.DRAGGED = "dragged", e.PREVIEWED = "preview", e.GHOSTED = "ghosted", e.INVALID = "invalid", e))(CollidableState || {});
const CORNERS = {
  default: createCornerCanvas(CORNER_SIZE),
  hovered: createCornerCanvas(
    CORNER_SIZE,
    "hovered"
    /* HOVERED */
  ),
  selected: createCornerCanvas(
    CORNER_SIZE,
    "selected"
    /* SELECTED */
  ),
  dragged: createCornerCanvas(
    CORNER_SIZE,
    "dragged"
    /* DRAGGED */
  ),
  preview: createCornerCanvas(
    CORNER_SIZE,
    "preview"
    /* PREVIEWED */
  ),
  ghosted: createCornerCanvas(
    CORNER_SIZE,
    "ghosted"
    /* GHOSTED */
  )
}, WALLFEATURE_RENDER_MAP = {
  [Lt.DOOR]: drawDoor,
  [Lt.WINDOW]: drawWindow
};
function createCornerCanvas(e, t) {
  const n = y(e / 2, e / 2), o = document.createElement("canvas");
  o.width = o.height = e;
  const r = new DrawHandler(o.getContext("2d")), i = 10, s = 8, a = 6;
  let l = {
    fillStyle: DEFAULT_CORNER_FILL_STYLE
  }, d = {
    lineWidth: 2,
    fillStyle: DEFAULT_FILL_STYLE
  }, c = {
    fillStyle: DEFAULT_STROKE_STYLE
  }, m = !1;
  switch (t) {
    case "hovered":
      d.strokeStyle = STROKE_STYLES.hovered, c.fillStyle = STROKE_STYLES.hovered, l.fillStyle = STROKE_STYLES.hovered, m = !0;
      break;
    case "selected":
      d.strokeStyle = STROKE_STYLES.selected, c.fillStyle = STROKE_STYLES.selected, l.fillStyle = STROKE_STYLES.selected, m = !0;
      break;
    case "dragged":
      d.strokeStyle = STROKE_STYLES.dragged, c.fillStyle = STROKE_STYLES.dragged, l.fillStyle = STROKE_STYLES.dragged, m = !0;
      break;
    case "preview":
      d.strokeStyle = STROKE_STYLES.previewed, c.fillStyle = STROKE_STYLES.previewed, l.fillStyle = STROKE_STYLES.previewed, m = !0;
      break;
    case "ghosted":
      d.strokeStyle = STROKE_STYLES.ghosted, c.fillStyle = STROKE_STYLES.ghosted, l.fillStyle = STROKE_STYLES.ghosted, m = !0;
      break;
  }
  return m && drawPoint(r, n, i, l), drawPoint(r, n, s, d), drawPoint(r, n, a, c), o;
}
function drawRoomLayout({
  ctx: e,
  rooms: t,
  roomsPreview: n,
  offset: o,
  scale: r,
  // hovered item with mouse (corner, wall, feature)
  hoveredCollidable: i,
  // selected item with mouse (corner, wall, feature)
  selectedCollidable: s,
  // when a item is dragged (corner, wall, feature)
  draggedCollidable: a,
  // programmatically selected/highlighted wall,
  highlightedWall: l,
  // When a wall is not valid
  invalidatedCollidable: d,
  // the point where we start drawing the element on the canvas instead of a DOM html element absolute positioned under the mouse
  ghostEntity: c,
  featureFlags: m,
  measurements: p,
  positionAlongWallHoveringWithMouse: g
}) {
  e.save();
  const f = new DrawHandler(e, r, o);
  if (f.clear(), n) {
    drawMeasurementLines(f, p), drawWallsGhosted(f, n), drawWallsPrimary(f, {
      rooms: t,
      highlightedWall: l
    });
    const h = keyBy(
      t.flatMap((I) => I.corners),
      "id"
    ), E = n.flatMap(({ corners: I }) => I).filter((I) => !h[I.id] || !me(h[I.id], I));
    (m.dragCorners || m.splitWalls) && (drawCornersPrimary(f, t), drawCornersGhosted(f, E));
  } else
    drawMeasurementLines(f, p), drawWallsPrimary(
      f,
      {
        rooms: t,
        hoveredCollidable: i,
        selectedCollidable: s,
        draggedCollidable: a,
        highlightedWall: l,
        invalidatedCollidable: d,
        ghostEntity: c
      },
      g
    ), (m.dragCorners || m.splitWalls) && drawCornersPrimary(f, t, {
      selectedCollidable: s,
      hoveredCollidable: i,
      draggedCollidable: a
    });
  e.restore();
}
function drawWallsPrimary(e, {
  rooms: t,
  hoveredCollidable: n,
  highlightedWall: o,
  invalidatedCollidable: r,
  selectedCollidable: i,
  draggedCollidable: s,
  ghostEntity: a
}, l) {
  const d = {
    strokeStyle: STROKE_STYLES.selected
  };
  for (const c of t) {
    drawRoom(e, c), isWallCollidable(n) && (e.line(asVec2(n.entity.p1), asVec2(n.entity.p2), {
      strokeStyle: STROKE_STYLES.hovered
    }), drawResizeArrowsForWall(
      e,
      n.entity,
      {
        strokeStyle: n === i ? STROKE_STYLES.selected : STROKE_STYLES.hovered
      },
      l
    )), o && e.line(asVec2(o.entity.p1), asVec2(o.entity.p2), d), isWallCollidable(i) && (e.line(asVec2(i.entity.p1), asVec2(i.entity.p2), d), !isWallCollidable(n) && !r && drawResizeArrowsForWall(e, i.entity, {
      strokeStyle: STROKE_STYLES.selected
    })), isWallCollidable(r) && e.line(asVec2(r.entity.p1), asVec2(r.entity.p2), {
      strokeStyle: STROKE_STYLES.invalid
    }), isWallCollidable(s) && e.line(asVec2(s.entity.p1), asVec2(s.entity.p2), {
      strokeStyle: STROKE_STYLES.dragged
    }), drawWallFeatures(e, c.walls);
    for (const m of c.invalidWalls)
      e.line(asVec2(c.corners[m.leftIndex]), asVec2(c.corners[m.rightIndex]), {
        strokeStyle: STROKE_STYLES.invalid
      });
  }
  isWallFeatureCollidable(n) && drawWallFeature(e, n.entity, {
    strokeStyle: STROKE_STYLES.hovered
  }), isWallFeatureCollidable(i) && drawWallFeature(e, i.entity, {
    strokeStyle: STROKE_STYLES.selected
  }), isWallFeatureCollidable(s) && drawWallFeature(e, s.entity, {
    strokeStyle: STROKE_STYLES.dragged
  }), isWallFeatureCollidable(r) && drawWallFeature(e, r.entity, {
    strokeStyle: STROKE_STYLES.invalid
  }), a && drawWallFeature(e, a.wallFeature, {
    strokeStyle: STROKE_STYLES[a.state]
  });
}
function drawWallsGhosted(e, t) {
  const n = {
    lineWidth: 4,
    miterLimit: DEFAULT_MITER_LIMIT,
    lineDash: [10, 10],
    strokeStyle: STROKE_STYLES.previewed
  };
  let o = [];
  for (const i of t)
    for (let s = 0, [a] = i.walls; s < i.walls.length; s++, a = a.nextWall)
      o.push(asVec2(i.corners[a.leftIndex]));
  const r = e.path({ vertices: o, closed: !0 });
  e.stroke(r, n);
  for (const i of t)
    drawWallFeatures(e, i.walls, { strokeStyle: n.strokeStyle });
}
function drawCornersPrimary(e, t, { selectedCollidable: n, hoveredCollidable: o, draggedCollidable: r } = {}) {
  const i = {
    units: "meters",
    round: !0,
    anchor: "center"
  }, s = t.flatMap((c) => c.corners), a = isCornerCollidable(o) ? o.entity : void 0, l = isCornerCollidable(n) ? n.entity : void 0, d = isCornerCollidable(r) ? r.entity : void 0;
  for (const c of s)
    e.image(CORNERS.default, asVec2(c), i);
  if (a && e.image(CORNERS.hovered, asVec2(a), i), l && e.image(CORNERS.selected, asVec2(l), i), d && e.image(CORNERS.dragged, asVec2(d), i), isWallCollidable(n)) {
    const { p1: c, p2: m } = n.entity;
    e.image(CORNERS.hovered, asVec2(c), i), e.image(CORNERS.hovered, asVec2(m), i);
  }
  if (isWallCollidable(o)) {
    const { p1: c, p2: m } = o.entity;
    e.image(CORNERS.hovered, asVec2(c), i), e.image(CORNERS.hovered, asVec2(m), i);
  }
  if (isWallCollidable(r)) {
    const { p1: c, p2: m } = r.entity;
    e.image(CORNERS.dragged, asVec2(c), i), e.image(CORNERS.dragged, asVec2(m), i);
  }
}
function drawCornersGhosted(e, t) {
  const n = {
    units: "meters",
    round: !0,
    anchor: "center"
  };
  for (const o of t)
    e.image(CORNERS.preview, asVec2(o), n);
}
function drawWallFeatures(e, t, n) {
  t.flatMap((o) => o.features || []).forEach((o) => drawWallFeature(e, o, n));
}
function drawWallFeature(e, t, n) {
  (WALLFEATURE_RENDER_MAP[t.type] || drawRect)(e, t, n);
}
function drawRect(e, t, n = {
  depth: DEFAULT_WALL_FEATURE_DEPTH,
  borderSize: DEFAULT_WALL_FEATURE_BORDER_SIZE
}) {
  const o = e.path(createWallFeaturePath(e, t, n.depth, n.borderSize));
  e.fill(o, n.fillStyle), e.stroke(o, {
    lineWidth: n.borderSize,
    ...n.strokeStyle
  });
}
function drawWindow(e, t, n) {
  Yt(t) && (drawRect(e, t, {
    depth: WINDOW_FEATURE_DEPTH,
    borderSize: WINDOW_FEATURE_BORDER_SIZE,
    strokeStyle: n
  }), e.line(asVec2(t.p1), asVec2(t.p2), {
    ...n,
    lineWidth: WINDOW_FEATURE_BORDER_SIZE
  }));
}
function drawDoor(e, t, n) {
  if (!bt(t))
    return;
  const o = t.doorType === Wn.OPENING, r = o ? DOOR_OPENING_FEATURE_BORDER_SIZE : DOOR_FEATURE_BORDER_SIZE, i = o ? DOOR_OPENING_FEATURE_DEPTH : DOOR_FEATURE_DEPTH;
  if (o) {
    drawRect(e, t, {
      depth: i,
      borderSize: r,
      strokeStyle: {
        strokeStyle: "#DFDFDF",
        ...n
      }
    });
    const s = [
      r,
      // stroke
      t.size.width * e.scale - r * 3,
      // empty gap
      i + r,
      // stroke
      t.size.width * e.scale - r * 3,
      // empty gap
      i + r
      // remaining stroke
    ];
    drawRect(e, t, {
      depth: i,
      borderSize: r,
      strokeStyle: {
        ...n,
        lineDash: s
      },
      fillStyle: {
        fillStyle: "transparent"
      }
    });
  } else
    drawRect(e, t, { depth: i, borderSize: r, strokeStyle: n });
}
function createWallFeaturePath(e, t, n = DEFAULT_WALL_FEATURE_DEPTH, o = DEFAULT_WALL_FEATURE_BORDER_SIZE) {
  const { size: r } = t, i = asVec2(t.direction), s = ge.rotateRightAngleClockwise(i), a = ge.rotateRightAngleCounterClockwise(i), l = (n - o) / 2 / e.scale, d = o / 2 / e.scale, c = ge.sum(asVec2(t.p1), ge.muls(i, d), ge.muls(s, l)), m = ge.add(c, ge.muls(i, r.width - d * 2)), p = ge.add(m, ge.muls(a, l * 2)), g = ge.add(c, ge.muls(a, l * 2));
  return {
    vertices: [c, m, p, g],
    closed: !0
  };
}
function drawPoint(e, t, n, o, r = !1, i = !0) {
  const s = e.circle(t, n, { round: i });
  e.fill(s, o), r && e.stroke(s, o);
}
function drawResizeArrowsForWall(e, t, n, o) {
  var h;
  const r = asVec2(t.p1), i = asVec2(t.p2), s = getDirection(r, i), a = ge.avg(r, i), l = ge.rotateRightAngleClockwise(s), d = ge.rotateRightAngleCounterClockwise(s), c = 20 / e.scale, m = t.length / 2 - c / 2, p = {
    id: `fauxWallFeature-${t.id}`,
    positionAlongWall: m,
    type: Lt.WINDOW,
    size: {
      width: c,
      height: 0,
      depth: 0
    }
  }, g = (h = t.features) == null ? void 0 : h.some(
    (E) => areWallFeaturesColliding(p, E)
  );
  let f = o ? ge.add(ge.muls(s, o), r) : a;
  drawResizeHandle(
    e,
    f,
    s,
    l,
    g,
    n
  ), drawResizeHandle(
    e,
    f,
    s,
    d,
    g,
    n
  );
}
function drawResizeHandle(e, t, n, o, r = !1, i = {}) {
  const s = e.scale, a = 6 / s, l = (r ? 9 : 3) / s, d = ge.sum(t, ge.muls(n, a), ge.muls(o, a + l)), c = ge.add(t, ge.muls(o, a * 2 + l)), m = ge.sum(t, ge.muls(n, -a), ge.muls(o, a + l)), p = e.path({ vertices: [d, c, m] });
  e.stroke(p, {
    lineWidth: 4,
    lineCap: "square",
    strokeStyle: STROKE_STYLES.selected,
    ...i
  });
}
function drawRoom(e, t) {
  const n = {
    lineWidth: DEFAULT_WALL_WIDTH,
    miterLimit: DEFAULT_MITER_LIMIT,
    fillStyle: DEFAULT_FILL_STYLE
  };
  let o = [];
  for (let i = 0, [s] = t.walls; i < t.walls.length; i++, s = s.nextWall)
    o.push(asVec2(t.corners[s.leftIndex]));
  const r = e.path({ vertices: o, closed: !0 });
  e.stroke(r, n);
}
function drawMeasurementLines(e, t) {
  const n = t.flatMap(
    (r) => createMeasurementPath(e, r.p1, r.p2)
  ), o = e.path(n);
  e.stroke(o, {
    lineCap: "butt",
    lineWidth: 1,
    strokeStyle: DEFAULT_MEASUREMENT_LINE
  });
}
function createMeasurementPath(e, t, n) {
  const o = e.scale, r = MEASUREMENT_OFFSET / o, i = ge.normalize(ge.rotateRightAngleCounterClockwise(ge.sub(n, t))), s = ge.muls(i, r), a = ge.muls(s, 0.1);
  t = ge.add(t, s), n = ge.add(n, s);
  const l = ge.add(t, a), d = ge.sub(t, a), c = ge.add(n, a), m = ge.sub(n, a);
  return [{ vertices: [t, n] }, { vertices: [l, t, d] }, { vertices: [c, m] }];
}
const touch = {
  START: "touchstart",
  MOVE: "touchmove",
  CANCEL: "touchcancel",
  END: "touchend"
}, mouse = {
  DOWN: "mousedown",
  UP: "mouseup",
  MOVE: "mousemove"
}, pan = {
  START: "panstart",
  MOVE: "panmove",
  END: "panend"
};
function pannable(e) {
  let t, n, o, r;
  const i = throttleRequestAnimationFrame((m) => {
    const p = m, g = p.clientX - t, f = p.clientY - n;
    e.dispatchEvent(new CustomEvent(pan.MOVE, { detail: { dx: g, dy: f } })), t = p.clientX, n = p.clientY;
  });
  function s(m) {
    const p = m;
    (p.button === 2 || p.button === 0) && (t = p.clientX, n = p.clientY, e.dispatchEvent(new CustomEvent(pan.START, { detail: { x: t, y: n } })), window.addEventListener(mouse.MOVE, i), window.addEventListener(mouse.UP, a));
  }
  function a(m) {
    const p = m, g = p.clientX - t, f = p.clientY - n;
    e.dispatchEvent(new CustomEvent(pan.END, { detail: { dx: g, dy: f } })), window.removeEventListener(mouse.MOVE, i), window.removeEventListener(mouse.UP, a);
  }
  const l = throttleRequestAnimationFrame((m) => {
    m.preventDefault();
    const p = m;
    if (p.touches.length !== 1)
      return;
    o = p.touches[0].clientX / 2, r = p.touches[0].clientY / 2;
    const g = o - t, f = r - n;
    e.dispatchEvent(new CustomEvent(pan.MOVE, { detail: { dx: g, dy: f } })), t = o, n = r;
  });
  function d(m) {
    const p = m;
    p.touches.length === 1 && (t = p.touches[0].clientX / 2, n = p.touches[0].clientY / 2, e.dispatchEvent(new CustomEvent(pan.START, { detail: { x: t, y: n } })), window.addEventListener(touch.MOVE, l), window.addEventListener(touch.CANCEL, c), window.addEventListener(touch.END, c));
  }
  function c() {
    const m = o - t, p = r - n;
    e.dispatchEvent(new CustomEvent(pan.END, { detail: { dx: m, dy: p } })), window.removeEventListener(touch.MOVE, l), window.removeEventListener(touch.CANCEL, c), window.removeEventListener(touch.END, c);
  }
  return e.addEventListener(touch.START, d), e.addEventListener(mouse.DOWN, s), {
    destroy() {
      e.removeEventListener(touch.START, d), e.removeEventListener(mouse.DOWN, s);
    }
  };
}
const zoom = {
  WHEEL: "wheel",
  IN: "zoomin",
  OUT: "zoomout"
}, pointer = {
  DOWN: "pointerdown",
  MOVE: "pointermove",
  UP: "pointerup",
  OUT: "pointerout",
  LEAVE: "pointerleave"
};
function zoomable(e) {
  const t = [];
  let n = { x: 0, y: 0 }, o = { x: 0, y: 0 }, r = 0;
  function i(d) {
    d.preventDefault();
    const c = d, m = { x: c.x, y: c.y }, p = (Math.abs(c.deltaY) > 10 ? 10 : Math.abs(c.deltaY)) * 1e-3;
    c.deltaY < 0 ? e.dispatchEvent(new CustomEvent(zoom.IN, { detail: { pointerCoords: m, scale: p } })) : e.dispatchEvent(new CustomEvent(zoom.OUT, { detail: { pointerCoords: m, scale: p } }));
  }
  const s = throttleRequestAnimationFrame((d) => {
    d.preventDefault();
    const c = d, m = t.findIndex((p) => p.pointerId === c.pointerId);
    if (t.splice(m, 1, c), t.length === 2) {
      d.preventDefault();
      const p = t.filter((F) => F.pointerId !== c.pointerId)[0], g = {
        x: p.clientX,
        y: p.clientY
      }, f = {
        x: c.clientX,
        y: c.clientY
      }, h = ge.sub(g, f), E = ge.divs(ge.add(g, f), 2), I = ge.length(h), R = I - r, A = Math.abs(R) * 5e-4;
      r = I, e.dispatchEvent(
        new CustomEvent(R > 0 ? zoom.IN : zoom.OUT, {
          detail: { scale: A, pointerCoords: E }
        })
      );
    }
  });
  function a(d) {
    const c = d;
    c.type != "contextmenu" && (t.push(c), t.length === 2 && (n = { x: t[0].clientX, y: t[0].clientY }, o = { x: t[1].clientX, y: t[1].clientY }, r = ge.length(ge.sub(n, o))), e.addEventListener(pointer.MOVE, s), e.addEventListener(pointer.UP, l), e.addEventListener(pointer.OUT, l), e.addEventListener(pointer.LEAVE, l));
  }
  function l(d) {
    const c = d;
    for (let m = 0; m < t.length; m++)
      t[m].pointerId === c.pointerId && t.splice(m, 1);
    t.length < 2 && (n = { x: 0, y: 0 }, o = { x: 0, y: 0 }, r = 0), t.length === 0 && (e.removeEventListener(pointer.MOVE, s), e.removeEventListener(pointer.UP, l), e.removeEventListener(pointer.OUT, l), e.removeEventListener(pointer.LEAVE, l));
  }
  return e.addEventListener(pointer.DOWN, a), e.addEventListener(zoom.WHEEL, i), {
    destroy() {
      e.removeEventListener(zoom.WHEEL, i), e.removeEventListener(pointer.DOWN, a), e.removeEventListener(pointer.MOVE, s), e.removeEventListener(pointer.UP, l), e.removeEventListener(pointer.OUT, l), e.removeEventListener(pointer.LEAVE, l);
    }
  };
}
let proxyDragElement, canvasElement, img, dropPayload, drawer, unregisterDragEvent;
function showDroppedElement() {
  canvasElement.style.opacity = "1";
}
function hideDroppedElement() {
  canvasElement.style.opacity = "0";
}
function cleanupElements() {
  proxyDragElement.remove(), unregisterDragEvent == null || unregisterDragEvent(), dropPayload = void 0;
}
function prepareDrop(e, t, n) {
  const o = e.target, r = (o == null ? void 0 : o.querySelector("[data-transfer-image-ref")) || o || document.createElement("div");
  proxyDragElement && cleanupElements(), dropPayload = t;
  const { width: i, height: s } = r.getBoundingClientRect();
  proxyDragElement = document.body.appendChild(
    createElement("div", {
      class: "kvadrat-drag-element",
      style: `
        width: ${i}px;
        height: ${s}px;
        transform: translate3d(-50%, -50%, 0) translate3d(${e.clientX || -1e3}px, ${e.clientY || -1e3}px, 0);
      `
    })
  ), proxyDragElement.appendChild(
    cloneElement(r, {
      class: `${r.classList} kvadrat-drag-ghost`
    })
  ), canvasElement = proxyDragElement.appendChild(
    createElement("canvas", {
      class: "kvadrat-drag-canvas-element"
    })
  ), drawer = new DrawHandler(canvasElement.getContext("2d")), updateDropElementCanvas(t, n), img = proxyDragElement.appendChild(new Image()), e instanceof DragEvent && e.dataTransfer && (e.dataTransfer.effectAllowed = "move", e.dataTransfer.setData("text/plain", ""), img.setAttribute("class", "kvadrat-drag-image"), img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=", e.dataTransfer.setDragImage(img, 1e4, 0)), unregisterDragEvent = addEventListener$1(document.body, "dragover", (a) => {
    a.dataTransfer.dropEffect = "move", proxyDragElement.style.transform = `translate3d(-50%, -50%, 0) translate3d(${a.clientX || -1e3}px, ${a.clientY || -1e3}px, 0)`, a.preventDefault();
  }), o == null || o.addEventListener(
    "dragend",
    () => {
      cleanupElements();
    },
    {
      once: !0
    }
  );
}
function updateDropElementCanvas(e, t) {
  drawer.scale = t, drawer.offset = y(64 / 2, 0), canvasElement.width = 64, canvasElement.height = e.size.width * t, drawWallFeature(drawer, {
    ...e,
    featureIndex: -1,
    wallIndex: -1,
    wallId: "",
    direction: tt.z,
    p1: u(0, 0, 0),
    p2: u(0, 0, e.size.width)
  });
}
function droppable(e, t) {
  const n = e;
  if (!t.enabled)
    return;
  const { blueprintStore: o, userInteractionStore: r, configurationStore: i } = getStores();
  function s(p) {
    if (p.preventDefault(), !dropPayload) {
      p.dataTransfer && (p.dataTransfer.dropEffect = "none");
      return;
    }
    proxyDragElement.classList.add("kvadrat-drag-on-canvas"), proxyDragElement.style.width = `${canvasElement.width}px`, proxyDragElement.style.height = `${canvasElement.height}px`, r.setIsDragging(!0);
  }
  const a = throttleRequestAnimationFrame((p) => {
    if (p.preventDefault(), !dropPayload)
      return;
    const { scale: g, offset: f } = r.get(), h = n.getBoundingClientRect(), E = p.clientY - h.y, I = p.clientX - h.x, R = getLocalSpaceCoordinateFromScreenPointer(y(I, E), f, g), A = 100 / g;
    let F;
    const z = getGridSnapSize(g, i.get().measurementSystem === "metric"), ne = getNearestWallEntry(
      dropPayload,
      R,
      A,
      z,
      o.getDecoratedRooms()[0]
    );
    if (ne) {
      const k = {
        ...dropPayload,
        positionAlongWall: ne.position
      };
      F = {
        roomIndex: 0,
        wallIndex: ne.wall.index,
        wallId: ne.wall.id,
        wallFeature: k
      }, r.setPrioritizedWallIds([ne.wall.id]), hideDroppedElement();
    } else
      showDroppedElement();
    t.onMove(F);
  });
  function l(p) {
    if (p.preventDefault(), !dropPayload)
      return;
    const { scale: g, offset: f } = r.get(), h = n.getBoundingClientRect(), E = p.clientY - h.y, I = p.clientX - h.x, R = getLocalSpaceCoordinateFromScreenPointer(y(I, E), f, g), A = 100 / g, F = getGridSnapSize(g, i.get().measurementSystem === "metric"), z = getNearestWallEntry(
      dropPayload,
      R,
      A,
      F,
      o.getDecoratedRooms()[0]
    );
    if (z) {
      const ne = {
        ...dropPayload,
        positionAlongWall: z.position
      };
      t.onDrop({
        roomIndex: 0,
        wallIndex: z.wall.index,
        wallId: z.wall.id,
        wallFeature: ne
      });
    } else
      t.onDropOutside({
        roomIndex: 0,
        wallIndex: -1,
        wallId: "",
        wallFeature: dropPayload
      });
    r.setIsDragging(!1);
  }
  function d() {
    r.setIsDragging(!1), r.setPrioritizedWallIds([]), t.onDropEnd(), cleanupElements();
  }
  function c() {
    r.setIsDragging(!1), t.onDropLeave();
  }
  const m = [
    addEventListener$1(n, "dragenter", s),
    addEventListener$1(n, "dragover", a),
    addEventListener$1(n, "dragleave", c),
    addEventListener$1(n, "dragend", d),
    addEventListener$1(n, "drop", l)
  ];
  return {
    destroy() {
      m.reverse().forEach((p) => p());
    }
  };
}
function getNearestWallEntry(e, t, n, o, r) {
  return r.walls.map((i) => {
    if (e.size.width > i.length)
      return;
    const { p1: s, p2: a } = i, l = We(s, a, t), d = pe(l, t), c = pe(l, s), m = On(c - e.size.width / 2, 0, i.length - e.size.width);
    if (d < n)
      return {
        wall: i,
        distanceToNearestPointOnWall: d,
        position: Math.floor(m / o) * o
      };
  }).filter(Boolean).reduce((i, s) => i && s && i.distanceToNearestPointOnWall < s.distanceToNearestPointOnWall ? i : s, void 0);
}
const cornerSize = 8;
function findCollision(e, t, n, o) {
  return o.find((r) => isCornerCollidable(r) ? isPointerOnCorner(e, t, n, r) : isWallFeatureCollidable(r) ? isPointerOnWallFeature(e, t, n, r) : isWallCollidable(r) ? isPointerOnWall(e, t, n, r) : !1);
}
function isPointerOnCorner(e, t, n, o) {
  const r = cornerSize * 1.5;
  return ge.length(ge.sub(transformPoint(o.entity, t, n), e)) <= r;
}
function isPointerOnWallFeature(e, t, n, o) {
  const r = o.entity, i = asVec2($(r.p2, r.p1)), s = Math.atan2(-i.y, i.x), a = _(P($(r.p2, r.p1), n)), l = ge.sub(e, transformPoint(r.p1, t, n)), d = ge.rotate(l, s);
  return d.x > 0 && d.x < a && d.y < 16 && d.y > -16;
}
function isPointerOnWall(e, t, n, o) {
  const i = o.entity, s = _(P($(i.p1, i.p2), n)), a = getMagnitude(
    e.x - i.p1.x * n - t.x,
    e.y - i.p1.z * n - t.y
  ), l = getMagnitude(
    e.x - i.p2.x * n - t.x,
    e.y - i.p2.z * n - t.y
  );
  return a + l >= s - 0.5 && a + l <= s + 0.5;
}
function setPrioritizedWalls(e, t, n) {
  let o = [e.id, t.id];
  e.length === t.length && o.pop(), n.setPrioritizedWallIds(o);
}
function mutationObserver(e, { callback: t, options: n }) {
  const o = new MutationObserver(t);
  return o.observe(e, n), {
    destroy: () => o.disconnect()
  };
}
function getDirectionUsingAngle(e, t) {
  const n = t * 180 / Math.PI;
  let o = Direction.RIGHT;
  return e === Direction.RIGHT ? n >= 180 || n <= -90 ? o = Direction.LEFT : o = Direction.RIGHT : e === Direction.LEFT && (n >= 180 || n <= -90 ? o = Direction.RIGHT : o = Direction.LEFT), o;
}
function getValidationResult(e, t, n) {
  const o = n ? parseMetric(e) : parseImperial(e);
  if (o === void 0 || isNaN(o))
    return { valid: !1, value: t };
  const r = n ? cmToMm(o) : inchToMm(o);
  return validateWidthSize(r) ? {
    valid: !0,
    value: r
  } : { valid: !1, value: t };
}
function getIconRotationStyle(e, t) {
  let n = e * 180 / Math.PI;
  return n >= 180 || n <= -90 ? n = t === Direction.LEFT ? n + 90 : n - 90 : n = t === Direction.LEFT ? n - 90 : n + 90, n;
}
function getIconDirection(e, t) {
  const n = Math.abs(e * 180 / Math.PI);
  return n < 45 || n >= 135 ? t === Direction.LEFT ? Direction.LEFT : Direction.RIGHT : t === Direction.LEFT ? Direction.UP : Direction.DOWN;
}
function getInputBoxStyle(e, t, n, o, r) {
  const { width: i, height: s } = n;
  let a = t, l = "flex";
  return r && o ? `left: ${Math.ceil(e.x)}px;
      top: ${Math.ceil(e.y)}px;
      display: ${l};` : (t >= Math.PI / 2 ? a = t - Math.PI : t < -Math.PI / 2 && (a = t + Math.PI), (isNaN(e.x) || isNaN(e.y) || e.x > i || e.x < 0 || e.y > s || e.y < 0) && (l = "none"), `transform:
    translate(-50%, -50%)
    translate(${Math.ceil(e.x)}px, ${Math.ceil(e.y)}px)
    rotate(${a}rad)
    translateZ(0);
    display: ${l};`);
}
function add_css$5(e) {
  append_styles(e, "svelte-jnrxgp", '.idle-measurement-label.svelte-jnrxgp{display:flex;align-items:center;line-height:var(--line-height-100-long);position:relative;border:none;background:inherit;font-size:inherit;font-style:inherit;font-family:inherit;background-color:white;border-radius:var(--radius-s)}.idle-measurement-label.svelte-jnrxgp:focus-within{outline:unset}.idle-measurement-label.svelte-jnrxgp:hover{box-shadow:unset}.idle-measurement-label.svelte-jnrxgp::after{content:"";position:absolute;bottom:0;left:0;width:100%;height:1px;background-color:transparent}.idle-measurement-label.svelte-jnrxgp:hover{cursor:pointer}.idle-measurement-label.svelte-jnrxgp:hover::after{background-color:var(--colour-grey-500)}.idle-measurement-suffix.svelte-jnrxgp{color:var(--colour-text-lightest)}.idle-measurement-divider.svelte-jnrxgp{width:6px}');
}
function create_if_block$4(e) {
  let t, n, o;
  return {
    c() {
      t = element("div"), n = space$1(), o = element("span"), o.textContent = "cm", attr(t, "class", "idle-measurement-divider svelte-jnrxgp"), attr(o, "class", "idle-measurement-suffix svelte-jnrxgp");
    },
    m(r, i) {
      insert(r, t, i), insert(r, n, i), insert(r, o, i);
    },
    d(r) {
      r && (detach(t), detach(n), detach(o));
    }
  };
}
function create_fragment$9(e) {
  let t, n, o, r, i, s = (
    /*useMetric*/
    e[1] && create_if_block$4()
  );
  return {
    c() {
      t = element("button"), n = element("span"), o = text(
        /*label*/
        e[0]
      ), r = space$1(), s && s.c(), attr(n, "data-testid", "kvadrat-idle-measurement-label"), attr(t, "class", "idle-measurement-label svelte-jnrxgp"), attr(t, "style", i = /*targeted*/
      e[2] ? "box-shadow: unset; outline: unset;" : "box-shadow: var(--shadow-size-default) var(--colour-shadow-dark);");
    },
    m(a, l) {
      insert(a, t, l), append(t, n), append(n, o), append(t, r), s && s.m(t, null);
    },
    p(a, [l]) {
      l & /*label*/
      1 && set_data(
        o,
        /*label*/
        a[0]
      ), /*useMetric*/
      a[1] ? s || (s = create_if_block$4(), s.c(), s.m(t, null)) : s && (s.d(1), s = null), l & /*targeted*/
      4 && i !== (i = /*targeted*/
      a[2] ? "box-shadow: unset; outline: unset;" : "box-shadow: var(--shadow-size-default) var(--colour-shadow-dark);") && attr(t, "style", i);
    },
    i: noop,
    o: noop,
    d(a) {
      a && detach(t), s && s.d();
    }
  };
}
function instance$a(e, t, n) {
  let { label: o } = t, { useMetric: r } = t, { targeted: i } = t;
  return e.$$set = (s) => {
    "label" in s && n(0, o = s.label), "useMetric" in s && n(1, r = s.useMetric), "targeted" in s && n(2, i = s.targeted);
  }, [o, r, i];
}
class MeasurementLabel extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$a, create_fragment$9, safe_not_equal, { label: 0, useMetric: 1, targeted: 2 }, add_css$5);
  }
}
function relayPointerEventsTo(e, t) {
  const n = e, o = t;
  function r(d) {
    const c = new WheelEvent(d.type, d);
    d.preventDefault(), o == null || o.dispatchEvent(c);
  }
  function i() {
    n.removeEventListener("pointerup", l), n.removeEventListener("pointerout", l), n.removeEventListener("pointermove", l), n.removeEventListener("pointerdown", l);
  }
  function s(d) {
    if (d.touches.length < 2)
      return;
    n.addEventListener("pointerdown", l), n.addEventListener("pointermove", l), n.addEventListener("pointerout", l), n.addEventListener("pointerup", l);
    const c = new TouchEvent("touchstart", {
      ...d,
      touches: Array.from(d.touches),
      targetTouches: Array.from(d.targetTouches),
      changedTouches: Array.from(d.changedTouches)
    });
    d.preventDefault(), o == null || o.dispatchEvent(c);
  }
  function a(d) {
    d.touches.length > 0 || i();
  }
  function l(d) {
    const c = new PointerEvent(d.type, d);
    d.preventDefault(), o == null || o.dispatchEvent(c);
  }
  return n.addEventListener("wheel", r), n.addEventListener("touchstart", s), n.addEventListener("touchend", a), {
    destroy() {
      i(), n.removeEventListener("touchend", a), n.removeEventListener("touchstart", s), n.removeEventListener("wheel", r);
    }
  };
}
function add_css$4(e) {
  append_styles(e, "svelte-15urzzt", ".context-menu-action-material.svelte-15urzzt{display:flex;justify-content:center;align-items:center;margin-left:0.25rem}");
}
function create_fragment$8(e) {
  let t, n;
  return {
    c() {
      t = element("div"), attr(t, "class", n = null_to_empty(
        /*$$props*/
        e[1].class
      ) + " svelte-15urzzt");
    },
    m(o, r) {
      insert(o, t, r), e[3](t);
    },
    p(o, [r]) {
      r & /*$$props*/
      2 && n !== (n = null_to_empty(
        /*$$props*/
        o[1].class
      ) + " svelte-15urzzt") && attr(t, "class", n);
    },
    i: noop,
    o: noop,
    d(o) {
      o && detach(t), e[3](null);
    }
  };
}
function instance$9(e, t, n) {
  var o = this && this.__rest || function(l, d) {
    var c = {};
    for (var m in l) Object.prototype.hasOwnProperty.call(l, m) && d.indexOf(m) < 0 && (c[m] = l[m]);
    if (l != null && typeof Object.getOwnPropertySymbols == "function") for (var p = 0, m = Object.getOwnPropertySymbols(l); p < m.length; p++)
      d.indexOf(m[p]) < 0 && Object.prototype.propertyIsEnumerable.call(l, m[p]) && (c[m[p]] = l[m[p]]);
    return c;
  };
  let r, i, { element: s } = t;
  onMount(() => {
    try {
      i = createRoot(r);
    } catch (l) {
      console.warn("react-adapter failed to mount.", { err: l });
    }
  }), afterUpdate(() => {
    if (i) {
      const { children: l, class: d, element: c } = t, m = o(t, ["children", "class", "element"]);
      i.render(React.createElement(s, m, l));
    }
  }), onDestroy(() => {
    try {
      i.unmount();
    } catch (l) {
      console.warn("react-adapter failed to unmount.", { err: l });
    }
  });
  function a(l) {
    binding_callbacks[l ? "unshift" : "push"](() => {
      r = l, n(0, r);
    });
  }
  return e.$$set = (l) => {
    n(1, t = assign(assign({}, t), exclude_internal_props(l))), "element" in l && n(2, s = l.element);
  }, t = exclude_internal_props(t), [r, t, s, a];
}
class ReactAdapter extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$9, create_fragment$8, safe_not_equal, { element: 2 }, add_css$4);
  }
}
const ChevronIconWrapper = styled.div`
  height: 24px;
  width: 24px;
`, Button = styled.button`
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background: unset;
  border-radius: unset;
  background-color: transparent;
  min-width: 36px;
  ${({ side: e }) => e === "left" ? css`
          border-radius: var(--radius-s) 0 0 var(--radius-s);
        ` : css`
          border-radius: 0 var(--radius-s) var(--radius-s) 0;
        `};
  &:hover {
    background-color: var(--colour-brand-blue);
    color: white;
  }
  &:disabled {
    color: var(--colour-grey-200);
    pointer-events: none;
  }
`;
function ShowDirectionButton({
  hasChanged: e,
  rotation: t,
  onClick: n,
  onFocus: o,
  onMouseOver: r,
  onMouseOut: i,
  onBlur: s,
  arrowDirection: a,
  newMeasurementType: l,
  side: d
}) {
  const { translate: c } = useI18n(), m = (f, h) => {
    const E = f === HighlightType.DECREASE ? getIconDirection(t, h === Direction.LEFT ? Direction.RIGHT : Direction.LEFT) : getIconDirection(t, h);
    return camelCase(
      `${f} Measurements ${E}`
    ) || "";
  }, p = l === HighlightType.NONE ? void 0 : c(m(l, a)), g = useMemo(() => getIconRotationStyle(t, a), [t, a]);
  return /* @__PURE__ */ jsx(WithTooltip, { text: p, wrapperStyle: { height: "100%" }, children: /* @__PURE__ */ jsx(
    Button,
    {
      "aria-label": p,
      disabled: !e,
      onClick: n,
      onFocus: o,
      onMouseOver: r,
      onMouseOut: i,
      onBlur: s,
      side: d,
      children: e ? /* @__PURE__ */ jsx(ChevronIconWrapper, { children: /* @__PURE__ */ jsx(ArrowBelowLineIcon, { rotation: g }) }) : /* @__PURE__ */ jsx(ArrowDisabledIcon, {})
    }
  ) });
}
const ShowDirectionButtonHoc = ({ kvadratApi: e, ...t }) => /* @__PURE__ */ jsx(KvadratProviderWrapper, { kvadrat: e, children: /* @__PURE__ */ jsx(ShowDirectionButton, { ...t }) });
function TempInputWrapper({ kvadratApi: e, ...t }) {
  if (!e)
    return null;
  const n = e.getStores();
  return /* @__PURE__ */ jsx(KvadratContext.Provider, { value: e, children: /* @__PURE__ */ jsx(StoresContext.Provider, { value: n, children: /* @__PURE__ */ jsx(Input, { ...t }) }) });
}
function add_css$3(e) {
  append_styles(e, "svelte-1i8ffvx", `.collapsed-button.svelte-1i8ffvx svg{margin:-10px -4px;display:block}.container.svelte-1i8ffvx.svelte-1i8ffvx{position:absolute;left:0;top:0;white-space:nowrap;-ms-touch-action:manipulation;touch-action:manipulation;transform:translate3d(-50%, -50%, 0)}.container.svelte-1i8ffvx.svelte-1i8ffvx:hover,.container.svelte-1i8ffvx.svelte-1i8ffvx:focus-within{z-index:1}.container.focus.svelte-1i8ffvx.svelte-1i8ffvx{z-index:2}.container.prioritized.svelte-1i8ffvx.svelte-1i8ffvx{z-index:3}.kvadrat-measurement-input{width:100px;margin:5px var(--space-75)}.kvadrat-form-field{margin:0}.idle-measurement.svelte-1i8ffvx.svelte-1i8ffvx{padding:var(--measurement-padding);background-color:transparent;cursor:pointer;border-radius:var(--radius-s)}.idle-measurement.svelte-1i8ffvx.svelte-1i8ffvx:focus-within,.idle-measurement.svelte-1i8ffvx.svelte-1i8ffvx:hover{background-color:white;box-shadow:unset;outline:2px solid rgb(var(--colour-neutral-7, 17, 17, 17));transition:outline 0.2s ease-out,
      box-shadow 0.2s ease-out}.collapsed-button.svelte-1i8ffvx.svelte-1i8ffvx{background:var(--colour-bg);box-shadow:var(--shadow-size-default) var(--colour-shadow-dark);padding:3px;display:flex;justify-content:center;align-items:center}.collapsed-measurement.svelte-1i8ffvx.svelte-1i8ffvx{position:fixed;top:-100vh;left:-100vw}.collapsed-button.svelte-1i8ffvx:hover>.collapsed-measurement.svelte-1i8ffvx,.collapsed-button.svelte-1i8ffvx:focus-within .collapsed-measurement.svelte-1i8ffvx{position:absolute;top:unset;left:unset;display:flex;padding:var(--measurement-padding);background:var(--colour-bg);border-radius:var(--radius-s);outline:2px solid rgb(var(--colour-neutral-7, 17, 17, 17))}.inner-container.svelte-1i8ffvx.svelte-1i8ffvx{background:var(--colour-bg);box-shadow:var(--shadow-size-default) var(--colour-shadow-dark);border-radius:var(--radius-s);display:flex;align-items:stretch;min-height:50px}.extra-padding.svelte-1i8ffvx.svelte-1i8ffvx{padding:0 var(--space-50)}.tooltip.svelte-1i8ffvx.svelte-1i8ffvx{position:absolute;top:-50px;left:50%;height:auto;transform:translate(-50%, 0);padding:8px 12px;background-color:black;border-radius:5px;font-size:12px;color:white;pointer-events:none;transition:opacity 200ms}.tooltip.isHoveringDirectionButtons.svelte-1i8ffvx.svelte-1i8ffvx{opacity:0;transition-duration:100ms}`);
}
function create_else_block(e) {
  let t, n, o, r, i;
  return n = new MeasurementLabel({
    props: {
      label: (
        /*formattedValue*/
        e[10]
      ),
      useMetric: (
        /*useMetric*/
        e[3]
      ),
      targeted: (
        /*targeted*/
        e[7]
      )
    }
  }), {
    c() {
      t = element("div"), create_component(n.$$.fragment), attr(t, "class", "idle-measurement svelte-1i8ffvx"), attr(t, "data-testid", "kvadrat-measurement-label");
    },
    m(s, a) {
      insert(s, t, a), mount_component(n, t, null), o = !0, r || (i = listen(
        t,
        "click",
        /*onFocusCollapsed*/
        e[21]
      ), r = !0);
    },
    p(s, a) {
      const l = {};
      a[0] & /*formattedValue*/
      1024 && (l.label = /*formattedValue*/
      s[10]), a[0] & /*useMetric*/
      8 && (l.useMetric = /*useMetric*/
      s[3]), a[0] & /*targeted*/
      128 && (l.targeted = /*targeted*/
      s[7]), n.$set(l);
    },
    i(s) {
      o || (transition_in(n.$$.fragment, s), o = !0);
    },
    o(s) {
      transition_out(n.$$.fragment, s), o = !1;
    },
    d(s) {
      s && detach(t), destroy_component(n), r = !1, i();
    }
  };
}
function create_if_block_3$2(e) {
  let t, n, o, r, i, s, a, l;
  return n = new ReactAdapter({
    props: {
      element: SsrIcon,
      paths: ellipsesHorizontalIcon
    }
  }), i = new MeasurementLabel({
    props: {
      label: (
        /*formattedValue*/
        e[10]
      ),
      useMetric: (
        /*useMetric*/
        e[3]
      ),
      targeted: (
        /*targeted*/
        e[7]
      )
    }
  }), {
    c() {
      t = element("div"), create_component(n.$$.fragment), o = space$1(), r = element("div"), create_component(i.$$.fragment), attr(r, "class", "collapsed-measurement svelte-1i8ffvx"), attr(t, "class", "collapsed-button svelte-1i8ffvx"), attr(t, "data-testid", "kvadrat-measurement-label");
    },
    m(d, c) {
      insert(d, t, c), mount_component(n, t, null), append(t, o), append(t, r), mount_component(i, r, null), s = !0, a || (l = listen(
        t,
        "click",
        /*onFocusCollapsed*/
        e[21]
      ), a = !0);
    },
    p(d, c) {
      const m = {};
      c[0] & /*formattedValue*/
      1024 && (m.label = /*formattedValue*/
      d[10]), c[0] & /*useMetric*/
      8 && (m.useMetric = /*useMetric*/
      d[3]), c[0] & /*targeted*/
      128 && (m.targeted = /*targeted*/
      d[7]), i.$set(m);
    },
    i(d) {
      s || (transition_in(n.$$.fragment, d), transition_in(i.$$.fragment, d), s = !0);
    },
    o(d) {
      transition_out(n.$$.fragment, d), transition_out(i.$$.fragment, d), s = !1;
    },
    d(d) {
      d && detach(t), destroy_component(n), destroy_component(i), a = !1, l();
    }
  };
}
function create_if_block$3(e) {
  let t, n = (
    /*translate*/
    e[18](
      /*dimensionConfig*/
      e[0].toolTipKey
    ) + ""
  ), o, r, i, s, a, l, d, c, m, p = (
    /*showDirectionIcons*/
    e[12] && create_if_block_2$2(e)
  );
  a = new ReactAdapter({
    props: {
      element: TempInputWrapper,
      kvadratApi: (
        /*api*/
        e[19]
      ),
      id: (
        /*measurementId*/
        e[15]
      ),
      type: "number",
      className: "kvadrat-measurement-input",
      formClassName: "kvadrat-form-field",
      onChange: (
        /*onInput*/
        e[20]
      ),
      autoFocus: !0,
      inputMode: (
        /*useMetric*/
        e[3] ? InputModeEnum.decimal : InputModeEnum.measurement
      ),
      value: (
        /*editValue*/
        e[6]
      ),
      suffixLabel: (
        /*useMetric*/
        e[3] ? "cm" : null
      ),
      onFocus: (
        /*onClick*/
        e[28]
      ),
      testId: "kvadrat-measurement-input"
    }
  });
  let g = (
    /*showDirectionIcons*/
    e[12] && create_if_block_1$2(e)
  );
  return {
    c() {
      t = element("div"), o = text(n), r = space$1(), i = element("div"), p && p.c(), s = space$1(), create_component(a.$$.fragment), l = space$1(), g && g.c(), attr(t, "class", "tooltip svelte-1i8ffvx"), attr(t, "aria-live", "polite"), toggle_class(
        t,
        "isHoveringDirectionButtons",
        /*isHoveringDirectionButtons*/
        e[8]
      ), attr(i, "class", "inner-container svelte-1i8ffvx"), attr(
        i,
        "aria-label",
        /*translate*/
        e[18]("measurementInputArea")
      ), toggle_class(i, "extra-padding", !/*showDirectionIcons*/
      e[12]);
    },
    m(f, h) {
      insert(f, t, h), append(t, o), insert(f, r, h), insert(f, i, h), p && p.m(i, null), append(i, s), mount_component(a, i, null), append(i, l), g && g.m(i, null), d = !0, c || (m = listen(
        i,
        "focusout",
        /*onComponentBlur*/
        e[24]
      ), c = !0);
    },
    p(f, h) {
      (!d || h[0] & /*dimensionConfig*/
      1) && n !== (n = /*translate*/
      f[18](
        /*dimensionConfig*/
        f[0].toolTipKey
      ) + "") && set_data(o, n), (!d || h[0] & /*isHoveringDirectionButtons*/
      256) && toggle_class(
        t,
        "isHoveringDirectionButtons",
        /*isHoveringDirectionButtons*/
        f[8]
      ), /*showDirectionIcons*/
      f[12] && p.p(f, h);
      const E = {};
      h[0] & /*useMetric*/
      8 && (E.inputMode = /*useMetric*/
      f[3] ? InputModeEnum.decimal : InputModeEnum.measurement), h[0] & /*editValue*/
      64 && (E.value = /*editValue*/
      f[6]), h[0] & /*useMetric*/
      8 && (E.suffixLabel = /*useMetric*/
      f[3] ? "cm" : null), a.$set(E), /*showDirectionIcons*/
      f[12] && g.p(f, h);
    },
    i(f) {
      d || (transition_in(p), transition_in(a.$$.fragment, f), transition_in(g), d = !0);
    },
    o(f) {
      transition_out(p), transition_out(a.$$.fragment, f), transition_out(g), d = !1;
    },
    d(f) {
      f && (detach(t), detach(r), detach(i)), p && p.d(), destroy_component(a), g && g.d(), c = !1, m();
    }
  };
}
function create_if_block_2$2(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: ShowDirectionButtonHoc,
      kvadratApi: (
        /*api*/
        e[19]
      ),
      hasChanged: (
        /*newMeasurement*/
        e[9].hasChanged
      ),
      rotation: (
        /*rotation*/
        e[11]
      ),
      onClick: (
        /*func*/
        e[34]
      ),
      onFocus: (
        /*onHoverLeftButton*/
        e[26]
      ),
      onMouseOver: (
        /*onHoverLeftButton*/
        e[26]
      ),
      onMouseOut: (
        /*handleMouseOut*/
        e[25]
      ),
      onBlur: (
        /*handleMouseOut*/
        e[25]
      ),
      arrowDirection: (
        /*newMeasurement*/
        e[9].type === HighlightType.INCREASE || /*newMeasurement*/
        e[9].type === HighlightType.NONE ? Direction.LEFT : Direction.RIGHT
      ),
      newMeasurementType: (
        /*newMeasurement*/
        e[9].type
      ),
      side: "left"
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*newMeasurement*/
      512 && (i.hasChanged = /*newMeasurement*/
      o[9].hasChanged), r[0] & /*newMeasurement*/
      512 && (i.arrowDirection = /*newMeasurement*/
      o[9].type === HighlightType.INCREASE || /*newMeasurement*/
      o[9].type === HighlightType.NONE ? Direction.LEFT : Direction.RIGHT), r[0] & /*newMeasurement*/
      512 && (i.newMeasurementType = /*newMeasurement*/
      o[9].type), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_1$2(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: ShowDirectionButtonHoc,
      kvadratApi: (
        /*api*/
        e[19]
      ),
      hasChanged: (
        /*newMeasurement*/
        e[9].hasChanged
      ),
      rotation: (
        /*rotation*/
        e[11]
      ),
      onClick: (
        /*func_1*/
        e[35]
      ),
      onFocus: (
        /*onHoverRightButton*/
        e[27]
      ),
      onMouseOver: (
        /*onHoverRightButton*/
        e[27]
      ),
      onMouseOut: (
        /*handleMouseOut*/
        e[25]
      ),
      onBlur: (
        /*handleMouseOut*/
        e[25]
      ),
      arrowDirection: (
        /*newMeasurement*/
        e[9].type === HighlightType.INCREASE || /*newMeasurement*/
        e[9].type === HighlightType.NONE ? Direction.RIGHT : Direction.LEFT
      ),
      newMeasurementType: (
        /*newMeasurement*/
        e[9].type
      ),
      side: "right"
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*newMeasurement*/
      512 && (i.hasChanged = /*newMeasurement*/
      o[9].hasChanged), r[0] & /*newMeasurement*/
      512 && (i.arrowDirection = /*newMeasurement*/
      o[9].type === HighlightType.INCREASE || /*newMeasurement*/
      o[9].type === HighlightType.NONE ? Direction.RIGHT : Direction.LEFT), r[0] & /*newMeasurement*/
      512 && (i.newMeasurementType = /*newMeasurement*/
      o[9].type), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_fragment$7(e) {
  let t, n, o, r, i, s, a, l;
  const d = [create_if_block$3, create_if_block_3$2, create_else_block], c = [];
  function m(p, g) {
    return (
      /*focus*/
      p[5] ? 0 : (
        /*minimizeMeasurement*/
        p[13] ? 1 : 2
      )
    );
  }
  return n = m(e), o = c[n] = d[n](e), {
    c() {
      t = element("div"), o.c(), attr(t, "data-testid", "kvadrat-measurement-container"), attr(t, "class", "container kvadrat-disable-during-interaction svelte-1i8ffvx"), attr(t, "style", r = getInputBoxStyle(
        /*position*/
        e[1],
        /*focus*/
        e[5] ? 0 : (
          /*rotation*/
          e[11]
        ),
        /*canvas*/
        e[2],
        /*containerElement*/
        e[4],
        /*focus*/
        e[5]
      )), toggle_class(
        t,
        "prioritized",
        /*isPrioritized*/
        e[14]
      ), toggle_class(
        t,
        "focus",
        /*focus*/
        e[5]
      );
    },
    m(p, g) {
      insert(p, t, g), c[n].m(t, null), e[36](t), s = !0, a || (l = [
        listen(
          window,
          "keydown",
          /*onKeyDown*/
          e[22],
          !0
        ),
        listen(t, "click", stop_propagation(
          /*click_handler*/
          e[33]
        )),
        action_destroyer(i = relayPointerEventsTo.call(
          null,
          t,
          /*canvas*/
          e[2]
        )),
        listen(
          t,
          "mouseenter",
          /*mouseenter_handler*/
          e[37]
        ),
        listen(
          t,
          "focusin",
          /*focusin_handler*/
          e[38]
        ),
        listen(
          t,
          "mouseleave",
          /*mouseleave_handler*/
          e[39]
        ),
        listen(
          t,
          "focusout",
          /*focusout_handler*/
          e[40]
        )
      ], a = !0);
    },
    p(p, g) {
      let f = n;
      n = m(p), n === f ? c[n].p(p, g) : (group_outros(), transition_out(c[f], 1, 1, () => {
        c[f] = null;
      }), check_outros(), o = c[n], o ? o.p(p, g) : (o = c[n] = d[n](p), o.c()), transition_in(o, 1), o.m(t, null)), (!s || g[0] & /*position, focus, canvas, containerElement*/
      54 && r !== (r = getInputBoxStyle(
        /*position*/
        p[1],
        /*focus*/
        p[5] ? 0 : (
          /*rotation*/
          p[11]
        ),
        /*canvas*/
        p[2],
        /*containerElement*/
        p[4],
        /*focus*/
        p[5]
      ))) && attr(t, "style", r), i && is_function(i.update) && g[0] & /*canvas*/
      4 && i.update.call(
        null,
        /*canvas*/
        p[2]
      ), (!s || g[0] & /*focus*/
      32) && toggle_class(
        t,
        "focus",
        /*focus*/
        p[5]
      );
    },
    i(p) {
      s || (transition_in(o), s = !0);
    },
    o(p) {
      transition_out(o), s = !1;
    },
    d(p) {
      p && detach(t), c[n].d(), e[36](null), a = !1, run_all(l);
    }
  };
}
function instance$8(e, t, n) {
  let o, r, i, s, a, { value: l } = t, { dimensionConfig: d } = t, { position: c } = t, { canvas: m } = t, { measurement: p } = t, { selectedCollidableType: g } = t, f, h = !1, E = "", I = !1, R = !1, A;
  const { rotation: F, disabled: z, showDirectionIcons: ne, minimizeMeasurement: k, isPrioritized: q, onApply: X, id: ae, collidableId: ve } = p, { blueprintStore: De, i18nStore: Le, userInteractionStore: ue, decoratedRoomStore: le, blueprintStorePreview: we, configurationStore: ee } = getStores();
  component_subscribe(e, le, (D) => n(44, s = D)), component_subscribe(e, ee, (D) => n(32, a = D));
  const { translate: W } = Le, Z = getApi();
  let he = Direction.RIGHT, Ce = !1;
  function de(D, J) {
    return D === J ? {
      hasChanged: !1,
      type: HighlightType.NONE
    } : {
      hasChanged: !0,
      type: J > D ? HighlightType.INCREASE : HighlightType.DECREASE
    };
  }
  function ye(D) {
    Y();
    const J = r ? mmToCm(l) : mmToInch(l), oe = r ? parseMetric(D) : parseImperial(D);
    n(9, o = de(J, oe ?? 0)), n(6, E = D), (g !== CollidableType.WALL_FEATURE || g == null) && (ue.setHighlightedWallId(A), oe && oe > 49 ? qe() : ue.setPreview(!1));
  }
  function Ae() {
    z || (n(5, h = !0), n(6, E = i), k && sendEvent(InsightsEventType.MINIMIZED_MEASUREMENT_CLICKED, { collidableId: ve, position: c, value: l }));
  }
  function He(D) {
    h && (D.key === "Enter" ? (be(Direction.RIGHT, InsightsInteractionType.KEY_DOWN), D.stopImmediatePropagation()) : D.key === "Escape" && (I = !1, n(6, E = i), Je(), Y(), D.stopImmediatePropagation()));
  }
  function be(D, J) {
    if (!o.hasChanged)
      return;
    const oe = getValidationResult(E, l, r);
    oe.valid ? (X == null || X(oe.value, getDirectionUsingAngle(D, F)), I = !0, Je()) : Me(Number(E)), l !== oe.value && sendEvent(InsightsEventType.MEASUREMENT_INPUT, {
      type: g !== CollidableType.WALL_FEATURE ? CollidableType.WALL : CollidableType.WALL_FEATURE,
      valid: oe.valid,
      value: E,
      metric: r,
      interaction: InsightsInteractionType[J],
      pattern: E.replace(/\d+\/\d+/g, "Fraction").replace(/\d+/g, "Number")
    });
  }
  function Y() {
    ue.setInvalidatedCollidableId(void 0);
  }
  function Me(D) {
    n(5, h = !0);
    let J = W("notificationMessageMeasurementInvalid");
    D > d.maxValue ? J = W(d.limitExceededErrorMessage, {
      lowerRange: 0,
      upperRange: d.maxValue
    }) : D <= 0 && (J = W("notificiationMessageNegativeValue")), ue.setInvalidatedCollidableId(ve || void 0), Z.onNotification.emit({
      type: "error",
      title: W("notificationTitleMeasurement"),
      message: J
    });
  }
  function Qe(D) {
    const J = f.contains(D.relatedTarget);
    !I && !J && be(Direction.RIGHT, InsightsInteractionType.BLUR), !getValidationResult(E, l, r).valid && !J && (Y(), Je()), o.hasChanged || Je();
  }
  function Je() {
    n(5, h = !1), I = !1, n(9, o = {
      hasChanged: !1,
      type: HighlightType.NONE
    }), ue.setHighlightedWallId(void 0), ue.setPreview(!1), he = Direction.RIGHT;
  }
  function qe() {
    if (!getValidationResult(E, l, r).valid)
      return;
    const D = getDirectionUsingAngle(he, F), J = s[0].walls.find(byId(ve));
    if (!J)
      return;
    const oe = D === Direction.RIGHT ? J.nextWall.id : J.previousWall.id;
    ue.setHighlightedWallId(oe), we.setBlueprint(De.get()), we.resizeWall(J.id, getValidationResult(E, l, r).value, getDirectionUsingAngle(he, F), !0), ue.setPreview(!0);
  }
  function nt() {
    ue.setHighlightedWallId(void 0), ue.setPreview(!1), he = Direction.RIGHT, n(8, Ce = !1);
  }
  const ct = () => {
    he = Direction.LEFT, n(8, Ce = !0), qe();
  }, at = () => {
    he = Direction.RIGHT, n(8, Ce = !0), qe();
  }, et = () => {
    p.collidableId && (ue.setSelectedCollidableId(p.collidableId), ue.setIsContextMenuOpen(!1));
  };
  function ut(D) {
    bubble.call(this, e, D);
  }
  const je = () => be(Direction.LEFT, InsightsInteractionType.CLICKED), ot = () => be(Direction.RIGHT, InsightsInteractionType.CLICKED);
  function M(D) {
    binding_callbacks[D ? "unshift" : "push"](() => {
      f = D, n(4, f);
    });
  }
  const b = () => {
    n(7, R = !0);
  }, L = () => {
    n(7, R = !0);
  }, x = () => {
    n(7, R = !1);
  }, j = () => {
    n(7, R = !1);
  };
  return e.$$set = (D) => {
    "value" in D && n(29, l = D.value), "dimensionConfig" in D && n(0, d = D.dimensionConfig), "position" in D && n(1, c = D.position), "canvas" in D && n(2, m = D.canvas), "measurement" in D && n(30, p = D.measurement), "selectedCollidableType" in D && n(31, g = D.selectedCollidableType);
  }, e.$$.update = () => {
    e.$$.dirty[1] & /*$configurationStore*/
    2 && n(3, r = a.measurementSystem === "metric"), e.$$.dirty[0] & /*useMetric, value*/
    536870920 && n(10, i = r ? toDisplayCm(mmToCm(l)) : toDisplayFtIn(mmToInch(l)));
  }, n(9, o = {
    hasChanged: !1,
    type: HighlightType.NONE
  }), [
    d,
    c,
    m,
    r,
    f,
    h,
    E,
    R,
    Ce,
    o,
    i,
    F,
    ne,
    k,
    q,
    ae,
    le,
    ee,
    W,
    Z,
    ye,
    Ae,
    He,
    be,
    Qe,
    nt,
    ct,
    at,
    et,
    l,
    p,
    g,
    a,
    ut,
    je,
    ot,
    M,
    b,
    L,
    x,
    j
  ];
}
class MeasurementInput extends SvelteComponent {
  constructor(t) {
    super(), init(
      this,
      t,
      instance$8,
      create_fragment$7,
      safe_not_equal,
      {
        value: 29,
        dimensionConfig: 0,
        position: 1,
        canvas: 2,
        measurement: 30,
        selectedCollidableType: 31
      },
      add_css$3,
      [-1, -1]
    );
  }
}
function get_each_context(e, t, n) {
  const o = e.slice();
  return o[8] = t[n], o[10] = n, o;
}
function create_if_block$2(e) {
  var o;
  let t, n;
  return t = new MeasurementInput({
    props: {
      canvas: (
        /*canvas*/
        e[0]
      ),
      measurement: (
        /*measurement*/
        e[8]
      ),
      position: (
        /*measurement*/
        e[8].position
      ),
      value: (
        /*measurement*/
        e[8].value
      ),
      dimensionConfig: (
        /*dimensionConfiguration*/
        e[5]
      ),
      selectedCollidableType: (
        /*selectedCollidable*/
        (o = e[2]) == null ? void 0 : o.type
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(r, i) {
      mount_component(t, r, i), n = !0;
    },
    p(r, i) {
      var a;
      const s = {};
      i & /*canvas*/
      1 && (s.canvas = /*canvas*/
      r[0]), i & /*measurements*/
      2 && (s.measurement = /*measurement*/
      r[8]), i & /*measurements*/
      2 && (s.position = /*measurement*/
      r[8].position), i & /*measurements*/
      2 && (s.value = /*measurement*/
      r[8].value), i & /*selectedCollidable*/
      4 && (s.selectedCollidableType = /*selectedCollidable*/
      (a = r[2]) == null ? void 0 : a.type), t.$set(s);
    },
    i(r) {
      n || (transition_in(t.$$.fragment, r), n = !0);
    },
    o(r) {
      transition_out(t.$$.fragment, r), n = !1;
    },
    d(r) {
      destroy_component(t, r);
    }
  };
}
function create_each_block(e, t) {
  let n, o = !/*measurement*/
  t[8].hideMeasurement && showWhenPrioritizedMeasurements(
    /*measurement*/
    t[8],
    /*$userInteractionStore*/
    t[3].prioritizedWallIds.length
  ), r, i, s = o && create_if_block$2(t);
  return {
    key: e,
    first: null,
    c() {
      n = empty(), s && s.c(), r = empty(), this.first = n;
    },
    m(a, l) {
      insert(a, n, l), s && s.m(a, l), insert(a, r, l), i = !0;
    },
    p(a, l) {
      t = a, l & /*measurements, $userInteractionStore*/
      10 && (o = !/*measurement*/
      t[8].hideMeasurement && showWhenPrioritizedMeasurements(
        /*measurement*/
        t[8],
        /*$userInteractionStore*/
        t[3].prioritizedWallIds.length
      )), o ? s ? (s.p(t, l), l & /*measurements, $userInteractionStore*/
      10 && transition_in(s, 1)) : (s = create_if_block$2(t), s.c(), transition_in(s, 1), s.m(r.parentNode, r)) : s && (group_outros(), transition_out(s, 1, 1, () => {
        s = null;
      }), check_outros());
    },
    i(a) {
      i || (transition_in(s), i = !0);
    },
    o(a) {
      transition_out(s), i = !1;
    },
    d(a) {
      a && (detach(n), detach(r)), s && s.d(a);
    }
  };
}
function create_fragment$6(e) {
  let t = [], n = /* @__PURE__ */ new Map(), o, r, i = ensure_array_like(
    /*measurements*/
    e[1]
  );
  const s = (a) => (
    /*measurement*/
    a[8].id
  );
  for (let a = 0; a < i.length; a += 1) {
    let l = get_each_context(e, i, a), d = s(l);
    n.set(d, t[a] = create_each_block(d, l));
  }
  return {
    c() {
      for (let a = 0; a < t.length; a += 1)
        t[a].c();
      o = empty();
    },
    m(a, l) {
      for (let d = 0; d < t.length; d += 1)
        t[d] && t[d].m(a, l);
      insert(a, o, l), r = !0;
    },
    p(a, [l]) {
      l & /*canvas, measurements, dimensionConfiguration, selectedCollidable, $userInteractionStore*/
      47 && (i = ensure_array_like(
        /*measurements*/
        a[1]
      ), group_outros(), t = update_keyed_each(t, l, s, 1, a, i, n, o.parentNode, outro_and_destroy_block, create_each_block, o, get_each_context), check_outros());
    },
    i(a) {
      if (!r) {
        for (let l = 0; l < i.length; l += 1)
          transition_in(t[l]);
        r = !0;
      }
    },
    o(a) {
      for (let l = 0; l < t.length; l += 1)
        transition_out(t[l]);
      r = !1;
    },
    d(a) {
      a && detach(o);
      for (let l = 0; l < t.length; l += 1)
        t[l].d(a);
    }
  };
}
function instance$7(e, t, n) {
  let o, { canvas: r } = t, { measurements: i } = t, { selectedCollidable: s } = t;
  const { i18nStore: a, userInteractionStore: l } = getStores();
  component_subscribe(e, l, (c) => n(3, o = c));
  const d = {
    maxValue: KVADRAT_WALL_WIDTH_MAX,
    toolTipKey: "changeSizeLabel",
    limitExceededErrorMessage: "notificationMessageMeasurementWidthLimitExceeded"
  };
  return e.$$set = (c) => {
    "canvas" in c && n(0, r = c.canvas), "measurements" in c && n(1, i = c.measurements), "selectedCollidable" in c && n(2, s = c.selectedCollidable);
  }, [
    r,
    i,
    s,
    o,
    l,
    d
  ];
}
class Measurement2d extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$7, create_fragment$6, safe_not_equal, {
      canvas: 0,
      measurements: 1,
      selectedCollidable: 2
    });
  }
}
function createCeilingActions(e, t) {
  const { blueprintStore: n, userInteractionStore: o, i18nStore: r, featureFlagStore: i } = t;
  return {
    select(s, a) {
      sendEvent(
        InsightsEventType.SELECT_CEILING,
        {
          roomIndex: s,
          id: a.id,
          schema: n.get()
        },
        IpexMomentEnum.whatIsMe
      );
    },
    deselect() {
    },
    move() {
    },
    moveEnd() {
    },
    delete() {
    },
    getContextMenuActions(s, a) {
      return [
        i.get().materialAndColors && {
          icon: fillBucketIcon,
          testId: "kvadrat-material-2d-button",
          tooltip: r.translate("contextmenuMaterialAndColor"),
          action: () => {
            if (!isCeilingCollidable(a))
              return;
            const l = 20;
            return e.setEditorMode(EditorMode.EDITOR_MODE_3D, "front").then(() => {
              const d = e.getSelectedMeshScreenBounds();
              o.setIsMaterialPopupOpen(
                !0,
                {
                  x: ((d == null ? void 0 : d.max.x) ?? 0) + l,
                  y: ((d == null ? void 0 : d.min.y) ?? 0) + l
                },
                !0
              ), sendEvent(InsightsEventType.MATERIAL_POPUP_OPENED, {
                collidableType: a.type,
                wallId: a.entity.id,
                wallIndex: a.index,
                interaction: InsightsInteractionType[InsightsInteractionType.CONTEXT_MENU]
              });
            }), !0;
          }
        }
      ].filter(isTruthy);
    }
  };
}
function createCornerActions(e, t) {
  const { blueprintStore: n, featureFlagStore: o, userInteractionStore: r, i18nStore: i, configurationStore: s } = t, { translate: a } = i;
  let l, d, c;
  return {
    select(m, p) {
      l = d = p.entity, sendEvent(
        InsightsEventType.SELECT_CORNER,
        {
          roomIndex: m,
          vertexIndex: p.index
        },
        IpexMomentEnum.whatIsMe
      );
    },
    deselect() {
      r.setPrioritizedWallIds([]);
    },
    move(m, p, g) {
      if (!o.get().dragCorners)
        return;
      const { scale: f } = r.get(), { measurementSystem: h } = s.get(), E = 10 / f, I = getGridSnapSize(f, h === "metric"), R = n.getDecoratedRooms()[m], [A, F] = R.walls.filter(
        (q) => q.leftIndex === p.index || q.rightIndex === p.index
      );
      setPrioritizedWalls(A, F, r);
      const z = [...R.corners.filter(({ id: q }) => p.id !== q), d];
      l = U(l, g);
      const ne = getGridAlignedCoordinate(l, I), k = getSnapAlignedCoordinate(ne, z, E);
      c = $(k, R.corners[p.index]), n.updateMoveCorner(p.id, c);
    },
    moveEnd(m, p) {
      const g = !me(d, p.entity);
      if (r.setPrioritizedWallIds([]), !g)
        return;
      const f = n.endMoveCorner(p.id);
      if (isErrorCode(f)) {
        const h = n.get().rooms[m];
        sendNotification(f, e, a, r, h), sendEvent(InsightsEventType.ERROR_ROOM_CHANGE, {
          action: InsightsEventType[InsightsEventType.MOVE_CORNER],
          schema: n.get(),
          error: a(ERROR_CODE_TRANSLATION_KEYS[f])
        });
        return;
      }
    },
    delete(m, p, g) {
      const f = n.deleteCorner(p.id);
      sendNotification(f, e, a, r, n.getDecoratedRooms()[m]), isErrorCode(f) || sendEvent(InsightsEventType.DELETE_CORNER, {
        cornerId: p.id,
        interaction: InsightsInteractionType[g],
        schema: n.get()
      });
    },
    getContextMenuActions(m, p) {
      var h;
      const g = ((h = n.get().rooms[m]) == null ? void 0 : h.corners.length) > 3, { splitWalls: f } = o.get();
      return g && f ? [
        {
          icon: trashCanIcon,
          testId: "kvadrat-delete-corner-button",
          tooltip: a("contextmenuDeleteCorner"),
          action: () => (this.delete(m, p, InsightsInteractionType.CONTEXT_MENU), r.setPrioritizedWallIds([]), !0)
        }
      ] : [];
    }
  };
}
function createFloorActions(e, t) {
  const { blueprintStore: n, featureFlagStore: o, userInteractionStore: r, i18nStore: i } = t;
  return {
    select(s, a) {
      sendEvent(
        InsightsEventType.SELECT_FLOOR,
        {
          roomIndex: s,
          id: a.id,
          schema: n.get()
        },
        IpexMomentEnum.whatIsMe
      );
    },
    deselect() {
    },
    move() {
    },
    moveEnd() {
    },
    delete() {
    },
    getContextMenuActions(s, a) {
      return [
        o.get().materialAndColors && {
          icon: fillBucketIcon,
          testId: "kvadrat-material-2d-button",
          tooltip: i.translate("contextmenuMaterialAndColor"),
          action: () => {
            if (!isFloorCollidable(a))
              return;
            const l = 20;
            return e.setEditorMode(EditorMode.EDITOR_MODE_3D, "front-angled").then(() => {
              const d = e.getSelectedMeshScreenBounds();
              r.setIsMaterialPopupOpen(
                !0,
                {
                  x: ((d == null ? void 0 : d.max.x) ?? 0) + l,
                  y: ((d == null ? void 0 : d.min.y) ?? 0) + l
                },
                !0
              ), sendEvent(InsightsEventType.MATERIAL_POPUP_OPENED, {
                collidableType: a.type,
                wallId: a.entity.id,
                wallIndex: a.index,
                interaction: InsightsInteractionType[InsightsInteractionType.CONTEXT_MENU]
              });
            }), !0;
          }
        }
      ].filter(isTruthy);
    }
  };
}
function createWallActions(e, t) {
  const {
    blueprintStore: n,
    blueprintStorePreview: o,
    featureFlagStore: r,
    userInteractionStore: i,
    i18nStore: s,
    configurationStore: a
  } = t, { translate: l } = s;
  let d, c, m, p, g, f, h, E, I, R, A = !1, F = !1, z;
  return {
    select(ne, k) {
      const q = n.get().rooms[ne], X = k.entity;
      c = d = q.corners[X.leftIndex], m = q.corners[X.rightIndex], f = asVec2(V($(X.p1, X.p2))), h = y(0, 1), E = Math.abs(ge.dot(h, f));
      const ae = [X.leftIndex, X.rightIndex];
      I = q.corners.filter((ve, De) => !ae.includes(De)), sendEvent(
        InsightsEventType.SELECT_WALL,
        {
          roomIndex: ne,
          wallIndex: k.index,
          schema: n.get()
        },
        IpexMomentEnum.whatIsMe
      );
    },
    deselect() {
      i.setPrioritizedWallIds([]);
    },
    move(ne, k, q, X) {
      const { scale: ae, offset: ve } = i.get(), { measurementSystem: De } = a.get(), Le = 10 / ae, ue = getGridSnapSize(ae, De === "metric"), le = k.entity;
      if (setPrioritizedWalls(le.previousWall, le.nextWall, i), !A) {
        const Ae = getLocalSpaceCoordinateFromScreenPointer(
          y(X.clientX, X.clientY),
          ve,
          ae
        );
        g = p = nearestPointOnWall(le, Ae);
        const He = n.get().rooms[ne], be = [le.leftIndex, le.rightIndex];
        I = He.corners.filter((Y, Me) => !be.includes(Me)), R = [g];
      }
      if (!A && (isLessThanThreshold(le.previousWallAngle) || isLessThanThreshold(le.nextWallAngle))) {
        n.updateMoveWall(k.id, u(0, 0, 0)), extrudeWallWhenZeroAngle(le, n.splitWall), F = !0, A = !0;
        return;
      }
      A = !0, c = U(c, q), m = U(m, q), p = U(p, q);
      const we = getGridAlignedCoordinate(c, ue), ee = getGridAlignedCoordinate(m, ue), W = getGridAlignedCoordinate(p, ue), Z = getSnapAlignedCoordinate(we, I, Le), he = getSnapAlignedCoordinate(ee, I, Le), Ce = getSnapAlignedCoordinate(
        W,
        R,
        Le
      );
      z = $(we, le.p1), Z.isSnappingX ? z.x = Z.x - le.p1.x : he.isSnappingX ? z.x = he.x - le.p2.x : Ce.isSnappingX && (z.x = Ce.x - le.p1.x - (g.x - d.x)), Z.isSnappingZ ? z.z = Z.z - le.p1.z : he.isSnappingZ ? z.z = he.z - le.p2.z : Ce.isSnappingZ && (z.z = Ce.z - le.p1.z - (g.z - d.z));
      const de = E >= 0.5 ? z.x : 0, ye = E < 0.5 ? z.z : 0;
      n.updateMoveWall(k.id, u(de, 0, ye));
    },
    moveEnd(ne, k) {
      const q = k.entity, X = n.endMoveWall(k.id);
      i.setPrioritizedWallIds([]), me(d, q.p1) || (X ? (sendNotification(X, e, l, i, n.getDecoratedRooms()[ne]), sendEvent(InsightsEventType.ERROR_ROOM_CHANGE, {
        action: InsightsEventType[InsightsEventType.MOVE_WALL],
        schema: n.get(),
        error: l(ERROR_CODE_TRANSLATION_KEYS[X])
      })) : sendEvent(F ? InsightsEventType.EXTRUDE : InsightsEventType.MOVE_WALL, {
        roomIndex: ne,
        wallId: q.id,
        wallIndex: k.index,
        diff: z,
        schema: n.get()
      })), F = !1, A = !1;
    },
    getContextMenuActions(ne, k) {
      return [
        r.get().splitWalls && t.editorStore.getEditorMode() === EditorMode.EDITOR_MODE_2D && {
          icon: wallDividerIcon,
          testId: "kvadrat-split-wall-button",
          tooltip: s.translate("contextmenuWallSplit"),
          onHover: (q) => {
            isWallCollidable(k) && (i.setPreview(!0), o.setBlueprint(n.get(), !1), o.splitWall(k.id, nearestPointOnWall(k.entity, q), !1));
          },
          onHoverOut: () => {
            i.setPreview(!1), o.setBlueprint(n.get());
          },
          action: (q) => {
            if (i.setPreview(!1), !!isWallCollidable(k))
              return n.splitWall(k.id, nearestPointOnWall(k.entity, q)), i.setPrioritizedWallIds([]), !0;
          }
        },
        r.get().materialAndColors && {
          icon: fillBucketIcon,
          testId: "kvadrat-material-2d-button",
          tooltip: s.translate("contextmenuMaterialAndColor"),
          action: () => {
            if (!isWallCollidable(k))
              return;
            const q = 20;
            return e.setEditorMode(EditorMode.EDITOR_MODE_3D, "front", !0).then(() => {
              const X = e.getSelectedMeshScreenBounds();
              i.setIsMaterialPopupOpen(
                !0,
                {
                  x: ((X == null ? void 0 : X.max.x) ?? 0) + q,
                  y: ((X == null ? void 0 : X.min.y) ?? 0) + q
                },
                !0
              ), sendEvent(InsightsEventType.MATERIAL_POPUP_OPENED, {
                collidableType: k.type,
                wallId: k.entity.id,
                wallIndex: k.index,
                interaction: InsightsInteractionType[InsightsInteractionType.CONTEXT_MENU]
              });
            }), !0;
          }
        }
      ].filter(isTruthy);
    }
  };
}
function createWallFeatureActions(e, t) {
  const { blueprintStore: n, i18nStore: o, userInteractionStore: r } = t;
  return {
    select(i, s) {
      const a = s.entity, d = n.get().rooms[i].walls[a.wallIndex];
      sendEvent(
        InsightsEventType.SELECT_WALL_FEATURE,
        {
          roomIndex: i,
          wall: d,
          wallFeature: a
        },
        IpexMomentEnum.whatIsMe
      );
    },
    deselect() {
      r.setPrioritizedWallIds([]);
    },
    move(i, s, a, l) {
      const d = new DataTransfer(), c = s.entity;
      n.deleteWallFeatureDuring2dMove(c.id, !1);
      const m = get(canvas2d);
      r.setCustomCanvasPointerEventsEnabled(!0);
      const p = addEventListener$1(document.body, "pointermove", (h) => {
        document.body.dispatchEvent(createCustomEvent("dragover", h, d)), m.dispatchEvent(createCustomEvent("dragover", h, d));
      }), g = addEventListener$1(document.body, "pointerout", (h) => {
        m.dispatchEvent(createCustomEvent("dragleave", h, d));
      }), f = addEventListener$1(document.body, "pointerup", (h) => {
        p(), g(), f(), m.dispatchEvent(createCustomEvent("drop", h, d)), m.dispatchEvent(createCustomEvent("dragend", h, d)), r.setCustomCanvasPointerEventsEnabled(!1);
      });
      e.prepareDragAndDrop(createCustomEvent("dragstart", l, d), c), m.dispatchEvent(createCustomEvent("dragenter", l, d)), m.dispatchEvent(createCustomEvent("dragover", l, d));
    },
    moveEnd() {
    },
    delete(i, s, a) {
      const l = s.entity;
      n.deleteWallFeature(l.id), sendEvent(InsightsEventType.DELETE_WALL_FEATURE, {
        roomIndex: i,
        wallIndex: l.wallIndex,
        featureIndex: s.index,
        wallFeature: l,
        schema: n.get(),
        interaction: InsightsInteractionType[a]
      });
    },
    getContextMenuActions(i, s) {
      return [
        {
          icon: pencilIcon,
          testId: "kvadrat-edit-wallfeature-button",
          tooltip: o.translate("edit"),
          action: () => {
            const a = findEntityByKvadratId(s.id, e.core.services.entityManager);
            a == null || a.addComponent(new EditingComponent());
          }
        },
        {
          icon: trashCanIcon,
          testId: "kvadrat-delete-wallfeature-button",
          tooltip: o.translate("deleteWallFeature"),
          action: () => (this.delete(i, s, InsightsInteractionType.CONTEXT_MENU), !0)
        }
      ];
    }
  };
}
function getEventProp(e, t) {
  return "touches" in t ? e === "movementX" || e === "movementY" ? 0 : t.touches[0][e] : t[e];
}
function createCustomEvent(e, t, n) {
  return new DragEvent(e, {
    ...t,
    clientX: getEventProp("clientX", t),
    clientY: getEventProp("clientY", t),
    screenX: getEventProp("screenX", t),
    screenY: getEventProp("screenY", t),
    movementX: getEventProp("movementX", t),
    movementY: getEventProp("movementY", t),
    dataTransfer: n
  });
}
function createEditorActions(e, t) {
  return {
    [CollidableType.CEILING]: createCeilingActions(e, t),
    [CollidableType.CORNER]: createCornerActions(e, t),
    [CollidableType.FLOOR]: createFloorActions(e, t),
    [CollidableType.WALL_FEATURE]: createWallFeatureActions(e, t),
    [CollidableType.WALL]: createWallActions(e, t)
  };
}
function add_css$2(e) {
  append_styles(e, "svelte-c8n8zm", "#tooltip.svelte-c8n8zm{position:absolute;padding:8px 12px;background-color:black;border-radius:5px;font-size:12px;color:white;pointer-events:none}");
}
function create_fragment$5(e) {
  let t, n, o;
  return {
    c() {
      t = element("div"), n = text(
        /*text*/
        e[0]
      ), attr(t, "id", "tooltip"), attr(t, "style", o = `left:${Math.round(
        /*x*/
        e[1]
      )}px; top:${Math.round(
        /*y*/
        e[2]
      )}px;`), attr(t, "class", "svelte-c8n8zm");
    },
    m(r, i) {
      insert(r, t, i), append(t, n);
    },
    p(r, [i]) {
      i & /*text*/
      1 && set_data(
        n,
        /*text*/
        r[0]
      ), i & /*x, y*/
      6 && o !== (o = `left:${Math.round(
        /*x*/
        r[1]
      )}px; top:${Math.round(
        /*y*/
        r[2]
      )}px;`) && attr(t, "style", o);
    },
    i: noop,
    o: noop,
    d(r) {
      r && detach(t);
    }
  };
}
function instance$6(e, t, n) {
  let { text: o } = t, { x: r } = t, { y: i } = t;
  return e.$$set = (s) => {
    "text" in s && n(0, o = s.text), "x" in s && n(1, r = s.x), "y" in s && n(2, i = s.y);
  }, [o, r, i];
}
class CanvasTooltip extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$6, create_fragment$5, safe_not_equal, { text: 0, x: 1, y: 2 }, add_css$2);
  }
}
function isBoundingBoxColliding(e, t) {
  return e.min.x < t.max.x && e.max.x > t.min.x && e.min.y < t.max.y && e.max.y > t.min.y;
}
const MINIMIZE_WALL_THRESHOLD = MEASUREMENT_OFFSET * 2, HIDE_WALL_THRESHOLD = 50, MINITEXTCOMPONENT_DIMENSIONS = y(28, 12);
function getAxisAlignedBoundingBox(e, t, n = 0) {
  const o = Math.abs(n);
  o > Math.PI / 4 && o < Math.PI / 4 * 3 && (t = ge.transpose(t));
  const r = ge.divs(t, 2);
  return {
    min: ge.sub(e, r),
    max: ge.add(e, r)
  };
}
function getCollisionPointsAndBoundaries(e, t, n, o) {
  const r = ge.muls(ge.normalize(y(e.direction.z, -e.direction.x)), MEASUREMENT_OFFSET), i = e.checkForLeftCollision ? e.p2 : e.p1, s = P(V($(e.center, i)), 22), a = ge.add(transformPoint(e.center, t, n), r), l = ge.add(
    asVec2(s),
    ge.add(transformPoint(i, t, n), r)
  ), d = getAngle(asVec2(e.p1), asVec2(e.p2)), c = getAxisAlignedBoundingBox(
    a,
    getMeasurementSizeApproximation(e.length, o),
    d
  ), m = getAxisAlignedBoundingBox(
    l,
    MINITEXTCOMPONENT_DIMENSIONS,
    d
  );
  return e.checkForLeftCollision && e.checkForRightCollision ? {
    centerpointInScreenSpace: a,
    centerpointBoundingBox: c,
    endpointPositionInScreenSpace: a,
    endpointBoundingBox: c
  } : {
    centerpointInScreenSpace: a,
    centerpointBoundingBox: c,
    endpointPositionInScreenSpace: l,
    endpointBoundingBox: m
  };
}
function getMeasurement(e, t, n, o, r) {
  let i = !1, s = !1, a = calculateMeasurementPosition(e.center, e.direction, n, o), l = a;
  const d = t.includes(e.id);
  if (d)
    i = s = !1;
  else if (e.checkForLeftCollision && e.checkForRightCollision) {
    const p = t.some(
      (g) => g === e.nextWall.id || g === e.previousWall.id
    );
    if (i = e.length * o < MEASUREMENT_OFFSET, p) {
      const g = getCollisionPointsAndBoundaries(e, n, o, r), f = getCollisionPointsAndBoundaries(e.nextWall, n, o, r), h = getCollisionPointsAndBoundaries(
        e.previousWall,
        n,
        o,
        r
      );
      (isBoundingBoxColliding(
        g.centerpointBoundingBox,
        f.centerpointBoundingBox
      ) || isBoundingBoxColliding(
        g.centerpointBoundingBox,
        h.centerpointBoundingBox
      )) && (s = !0);
    } else
      s = e.length * o < MEASUREMENT_OFFSET * 2;
  } else if (e.checkForLeftCollision !== e.checkForRightCollision) {
    const p = e.checkForLeftCollision ? e.previousWall : e.nextWall, g = getCollisionPointsAndBoundaries(e, n, o, r), f = getCollisionPointsAndBoundaries(p, n, o, r), h = t.includes(p.id);
    l = g.endpointPositionInScreenSpace, isBoundingBoxColliding(
      g.endpointBoundingBox,
      f.endpointBoundingBox
    ) && !h ? i = !0 : isBoundingBoxColliding(
      g.centerpointBoundingBox,
      f.centerpointBoundingBox
    ) ? !h && Math.abs(e.length - p.length) * o <= 1 ? (p !== e.nextWall || p.checkForLeftCollision && p.checkForRightCollision) && (s = !0, a = g.endpointPositionInScreenSpace) : (h && isBoundingBoxColliding(
      g.centerpointBoundingBox,
      f.centerpointBoundingBox
    ) || // Wall is not wide enough to fit the measurement
    e.length * o < MINIMIZE_WALL_THRESHOLD || // If the centers are colliding, then the shortest one should be minimized
    e.length < p.length || // Sibling wall is minimized and there is still a collision
    e.length > p.length && p.length * o >= HIDE_WALL_THRESHOLD && isBoundingBoxColliding(
      g.centerpointBoundingBox,
      f.endpointBoundingBox
    )) && (s = !0, a = g.endpointPositionInScreenSpace) : e.length * o < MINIMIZE_WALL_THRESHOLD && (s = !0, a = g.endpointPositionInScreenSpace), e.length * o < HIDE_WALL_THRESHOLD && (i = !0);
  }
  const c = getAngle(asVec2(e.p1), asVec2(e.p2));
  return {
    id: [
      // Generate a deterministic id for this measurement. Any changes to these values
      // will lead to a new id and Svelte will recreate the measurmentInput element instead
      // of using a cached version
      e.id,
      c,
      a.x,
      a.y,
      d,
      i,
      s,
      e.rightIndex,
      e.leftIndex
    ].join("-"),
    collidableId: e.id,
    value: e.length,
    rotation: c,
    showDirectionIcons: !0,
    p1: asVec2(e.p1),
    p2: asVec2(e.p2),
    hideMeasurement: i,
    minimizeMeasurement: s,
    position: a,
    endpointPosition: l,
    isPrioritized: d
  };
}
function calculateMeasurementPosition(e, t, n, o) {
  const r = ge.muls(ge.normalize(y(t.z, -t.x)), MEASUREMENT_OFFSET);
  return ge.add(transformPoint(e, n, o), r);
}
function getTopWallIndex(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    e[n].center.z < e[t].center.z && (t = n);
  return t;
}
function getMeasurements(e, t, n, o, r, i, s) {
  const a = t.flatMap((l) => {
    const d = getTopWallIndex(l.walls), c = l.walls[d];
    let m = c;
    const p = [];
    do {
      if (m.id === (s == null ? void 0 : s.wallId) && !s.isInvalid) {
        const g = getClosestEntityCornerPosition(m, s, ClosestEntitySide.LEFT), f = getClosestEntityCornerPosition(
          m,
          s,
          ClosestEntitySide.RIGHT
        ), h = _($(g, m.p1)), E = {
          ...m,
          index: -1,
          p1: g,
          p2: s.p1,
          features: void 0,
          checkForRightCollision: !0,
          nextWallAngle: 0,
          center: getCenter(g, s.p1),
          length: _($(s.p1, g))
        }, I = {
          ...m,
          index: -1,
          p1: s.p2,
          p2: f,
          features: void 0,
          checkForLeftCollision: !0,
          previousWallAngle: 0,
          center: getCenter(s.p2, f),
          length: _($(f, s.p2))
        }, R = {
          ...m,
          index: -1,
          p1: s.p1,
          p2: s.p2,
          checkForLeftCollision: !1,
          checkForRightCollision: !1,
          previousWallAngle: 0,
          nextWallAngle: 0,
          center: getCenter(s.p1, s.p2),
          length: _($(s.p2, s.p1))
        };
        R.previousWall = E, R.nextWall = I, I.previousWall = R, E.nextWall = R, p.push(
          {
            ...getMeasurement(E, n, o, r, i),
            onApply: (A) => {
              const F = A - E.length, z = On(
                s.positionAlongWall + F,
                h,
                h + E.length + I.length
              );
              e.updateWallFeaturePosition(s.id, z);
            },
            showDirectionIcons: !1,
            id: `${m.id}-${s.id}-left-part-${s.positionAlongWall}-${s.featureIndex}`
          },
          {
            ...getMeasurement(R, n, o, r, i),
            onApply: (A) => {
              e.resizeWallFeature(s.id, { width: A });
            },
            showDirectionIcons: !1,
            id: `${m.id}-${s.id}-center-part-${s.positionAlongWall}-${s.featureIndex}`
          },
          {
            ...getMeasurement(I, n, o, r, i),
            onApply: (A) => {
              const F = I.length - A, z = On(
                s.positionAlongWall + F,
                h,
                h + E.length + I.length
              );
              e.updateWallFeaturePosition(s.id, z);
            },
            showDirectionIcons: !1,
            id: `${m.id}-${s.id}-right-part-${s.positionAlongWall}-${s.featureIndex}`
          }
        );
      } else {
        const { id: g } = m;
        p.push({
          ...getMeasurement(m, n, o, r, i),
          onApply: (f, h) => {
            h && e.resizeWallAndAutoZoom(g, f, h);
          }
        });
      }
      m = m.nextWall;
    } while (m !== c);
    return p;
  });
  for (let l = 0; l < a.length - 2; l++)
    for (let d = l + 1; d < a.length - 1; d++) {
      const c = a[l], m = a[d];
      if (!c.hideMeasurement && !m.hideMeasurement) {
        const p = ge.length(ge.sub(c.position, m.position));
        p < 40 && (c.hideMeasurement = !c.isPrioritized, m.hideMeasurement = !m.isPrioritized), p >= 20 && p < 40 && (c.position = c.endpointPosition, m.position = m.endpointPosition);
      }
    }
  return a;
}
function instance$5(e) {
  return onMount(() => {
    const t = document.querySelector("button.idle-measurement-label");
    t == null || t.focus();
  }), [];
}
class AutofocusMeasurement extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$5, null, safe_not_equal, {});
  }
}
const ContextMenuContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
  -ms-touch-action: none;
  touch-action: none;
  background: var(--colour-bg);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  padding: 0 var(--space-100) 0 14px;
  height: var(--space-300);
  display: flex;
  align-items: center;
  z-index: 2;
  ${({ disabled: e }) => e && `
    pointer-events: none;
    opacity: 0.5;
  `}
  z-index: 3;
`, Draggable = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0;
  height: 100%;
  cursor: move;
  margin-right: var(--space-100);

  &:focus {
    outline: none;
  }

  ${({ $dragging: e }) => e && `
    cursor: grabbing;
  `}
`;
function ContextMenu({
  initialPosition: e = y(0, 0),
  disabled: t = !1,
  children: n,
  setDraggedPosition: o
}) {
  const [r, i] = useState(!1), s = useRef(y(0, 0)), a = useRef(null), { translate: l } = useI18n();
  useEffect(() => {
    const m = e, p = throttleRequestAnimationFrame((g) => {
      !r || !a.current || (m.x += g.clientX - s.current.x, m.y += g.clientY - s.current.y, s.current = y(g.clientX, g.clientY), a.current.style.transform = `translate3d(${m.x}px, ${m.y}px, 0)`);
    });
    return r && document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
  }, [r]);
  const d = (m) => {
    i(!0), s.current = y(m.clientX, m.clientY);
  }, c = (m) => {
    const { x: p, y: g } = m.currentTarget.getBoundingClientRect();
    i(!1), o == null || o(y(p, g)), sendEvent(InsightsEventType.DRAGGING_CONTEXT_MENU, { start: s.current, position: { x: p, y: g } });
  };
  return /* @__PURE__ */ jsxs(
    ContextMenuContainer,
    {
      id: "kvadrat-context-menu",
      ref: a,
      disabled: t,
      onClick: (m) => m.stopPropagation(),
      "aria-label": l("contextMenuDraggable"),
      role: "group",
      style: { transform: `translate3d(${e.x}px, ${e.y}px, 0)` },
      children: [
        /* @__PURE__ */ jsx(
          Draggable,
          {
            className: "draggable",
            onPointerDown: d,
            onPointerUp: c,
            "data-testid": "kvadrat-context-menu-drag-handle",
            $dragging: r,
            children: /* @__PURE__ */ jsx(DragIcon, {})
          }
        ),
        n
      ]
    }
  );
}
const ContextMenuHoc = ({
  kvadratApi: e,
  contextMenuActions: t,
  onHoverContextMenuAction: n,
  onHoverOutContextMenuAction: o,
  executeContextMenuAction: r,
  ...i
}) => /* @__PURE__ */ jsx(KvadratProviderWrapper, { kvadrat: e, children: /* @__PURE__ */ jsx(ContextMenu, { ...i, children: t.map((s) => /* @__PURE__ */ jsx(WithTooltip, { text: s.tooltip, children: /* @__PURE__ */ jsx(
  Button$3,
  {
    type: "tertiary",
    ssrIcon: s.icon,
    "data-testid": s.testId,
    onMouseOver: n(s),
    onMouseOut: o(s),
    onClick: r(s),
    size: "small",
    iconOnly: !0
  }
) }, s.testId)) }) });
function add_css$1(e) {
  append_styles(e, "svelte-zb112j", ".kvadrat-measurement.svelte-zb112j{padding:var(--measurement-padding);visibility:hidden;user-select:none;position:fixed;pointer-events:none;left:-10000px;top:-10000px}canvas.svelte-zb112j{image-rendering:pixelated;display:none;position:absolute;left:0;top:0;touch-action:none;bottom:0;right:0}.show.svelte-zb112j{display:block}.grabbing.svelte-zb112j{cursor:grabbing}.pointing.svelte-zb112j{cursor:pointer}");
}
function create_if_block_3$1(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: ContextMenuHoc,
      kvadratApi: (
        /*api*/
        e[11]
      ),
      initialPosition: (
        /*positionClickedWithMouse*/
        e[3]
      ),
      contextMenuActions: (
        /*contextMenuActions*/
        e[4]
      ),
      onHoverContextMenuAction: (
        /*onHoverContextMenuAction*/
        e[30]
      ),
      onHoverOutContextMenuAction: (
        /*onHoverOutContextMenuAction*/
        e[31]
      ),
      executeContextMenuAction: (
        /*executeContextMenuAction*/
        e[32]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*positionClickedWithMouse*/
      8 && (i.initialPosition = /*positionClickedWithMouse*/
      o[3]), r[0] & /*contextMenuActions*/
      16 && (i.contextMenuActions = /*contextMenuActions*/
      o[4]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_2$1(e) {
  let t, n;
  return t = new Measurement2d({
    props: {
      canvas: (
        /*$canvas2d*/
        e[9]
      ),
      measurements: (
        /*measurements*/
        e[6]
      ),
      selectedCollidable: (
        /*selectedCollidable*/
        e[0]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*$canvas2d*/
      512 && (i.canvas = /*$canvas2d*/
      o[9]), r[0] & /*measurements*/
      64 && (i.measurements = /*measurements*/
      o[6]), r[0] & /*selectedCollidable*/
      1 && (i.selectedCollidable = /*selectedCollidable*/
      o[0]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_1$1(e) {
  let t, n;
  return t = new AutofocusMeasurement({}), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block$1(e) {
  let t, n;
  return t = new CanvasTooltip({
    props: {
      text: (
        /*tooltip*/
        e[5].text
      ),
      x: (
        /*tooltip*/
        e[5].x
      ),
      y: (
        /*tooltip*/
        e[5].y
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*tooltip*/
      32 && (i.text = /*tooltip*/
      o[5].text), r[0] & /*tooltip*/
      32 && (i.x = /*tooltip*/
      o[5].x), r[0] & /*tooltip*/
      32 && (i.y = /*tooltip*/
      o[5].y), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_fragment$4(e) {
  let t, n, o, r, i, s, a, l, d, c, m, p = (
    /*$userInteractionStore*/
    e[1].contextMenuOpen && /*selectedCollidable*/
    e[0] && /*$editorStore*/
    e[10].editorMode === EditorMode.EDITOR_MODE_2D && create_if_block_3$1(e)
  ), g = (
    /*$editorStore*/
    e[10].editorMode === EditorMode.EDITOR_MODE_2D && /*ready*/
    e[2] && create_if_block_2$1(e)
  ), f = (
    /*ready*/
    e[2] && create_if_block_1$1()
  ), h = (
    /*tooltip*/
    e[5].text && create_if_block$1(e)
  );
  return {
    c() {
      t = element("canvas"), n = space$1(), p && p.c(), o = space$1(), g && g.c(), r = space$1(), f && f.c(), i = space$1(), h && h.c(), s = space$1(), a = space$1(), l = element("div"), attr(
        t,
        "width",
        /*width*/
        e[8]
      ), attr(
        t,
        "height",
        /*height*/
        e[7]
      ), attr(t, "data-testid", "kvadrat-2d-canvas"), attr(t, "class", "svelte-zb112j"), toggle_class(
        t,
        "grabbing",
        /*$userInteractionStore*/
        e[1].dragging || /*$userInteractionStore*/
        e[1].panning
      ), toggle_class(
        t,
        "pointing",
        /*$userInteractionStore*/
        e[1].hoveredCollidable && !/*$userInteractionStore*/
        e[1].dragging
      ), toggle_class(
        t,
        "show",
        /*$editorStore*/
        e[10].editorMode === EditorMode.EDITOR_MODE_2D
      ), attr(l, "id", KVADRATMEASUREMENT_ID), attr(l, "class", "kvadrat-measurement svelte-zb112j");
    },
    m(E, I) {
      insert(E, t, I), e[43](t), insert(E, n, I), p && p.m(E, I), insert(E, o, I), g && g.m(E, I), insert(E, r, I), f && f.m(E, I), insert(E, i, I), h && h.m(E, I), insert(E, s, I), insert(E, a, I), insert(E, l, I), d = !0, c || (m = [
        listen(
          t,
          "touchstart",
          /*onPointerPress*/
          e[23]
        ),
        listen(
          t,
          "touchmove",
          /*onPointerMove*/
          e[22]
        ),
        listen(
          t,
          "touchend",
          /*onPointerRelease*/
          e[24],
          { passive: !0 }
        ),
        listen(
          t,
          "mousemove",
          /*onPointerMove*/
          e[22]
        ),
        listen(
          t,
          "mouseout",
          /*onPointerRelease*/
          e[24]
        ),
        listen(
          t,
          "blur",
          /*onPointerRelease*/
          e[24]
        ),
        listen(
          t,
          "mousedown",
          /*onPointerPress*/
          e[23]
        ),
        listen(
          t,
          "mouseup",
          /*onPointerRelease*/
          e[24]
        ),
        listen(
          t,
          "zoomin",
          /*handleZoomIn*/
          e[28]
        ),
        listen(
          t,
          "zoomout",
          /*handleZoomOut*/
          e[29]
        ),
        listen(
          t,
          "panstart",
          /*handlePanStart*/
          e[25]
        ),
        listen(
          t,
          "panmove",
          /*handlePanMove*/
          e[26]
        ),
        listen(
          t,
          "panend",
          /*handlePanEnd*/
          e[27]
        ),
        action_destroyer(pannable.call(null, t)),
        action_destroyer(zoomable.call(null, t)),
        action_destroyer(droppable.call(
          null,
          t,
          /*droppableConfig*/
          e[20]
        )),
        action_destroyer(mutationObserver.call(
          null,
          t,
          /*mutationObserverConfig*/
          e[18]
        )),
        action_destroyer(mutationObserver.call(
          null,
          t,
          /*centerCanvasOnSizeChange*/
          e[19]
        )),
        listen(t, "contextmenu", contextmenu_handler),
        listen(
          document.body,
          "keydown",
          /*handleKeydown*/
          e[21]
        )
      ], c = !0);
    },
    p(E, I) {
      (!d || I[0] & /*width*/
      256) && attr(
        t,
        "width",
        /*width*/
        E[8]
      ), (!d || I[0] & /*height*/
      128) && attr(
        t,
        "height",
        /*height*/
        E[7]
      ), (!d || I[0] & /*$userInteractionStore*/
      2) && toggle_class(
        t,
        "grabbing",
        /*$userInteractionStore*/
        E[1].dragging || /*$userInteractionStore*/
        E[1].panning
      ), (!d || I[0] & /*$userInteractionStore*/
      2) && toggle_class(
        t,
        "pointing",
        /*$userInteractionStore*/
        E[1].hoveredCollidable && !/*$userInteractionStore*/
        E[1].dragging
      ), (!d || I[0] & /*$editorStore*/
      1024) && toggle_class(
        t,
        "show",
        /*$editorStore*/
        E[10].editorMode === EditorMode.EDITOR_MODE_2D
      ), /*$userInteractionStore*/
      E[1].contextMenuOpen && /*selectedCollidable*/
      E[0] && /*$editorStore*/
      E[10].editorMode === EditorMode.EDITOR_MODE_2D ? p ? (p.p(E, I), I[0] & /*$userInteractionStore, selectedCollidable, $editorStore*/
      1027 && transition_in(p, 1)) : (p = create_if_block_3$1(E), p.c(), transition_in(p, 1), p.m(o.parentNode, o)) : p && (group_outros(), transition_out(p, 1, 1, () => {
        p = null;
      }), check_outros()), /*$editorStore*/
      E[10].editorMode === EditorMode.EDITOR_MODE_2D && /*ready*/
      E[2] ? g ? (g.p(E, I), I[0] & /*$editorStore, ready*/
      1028 && transition_in(g, 1)) : (g = create_if_block_2$1(E), g.c(), transition_in(g, 1), g.m(r.parentNode, r)) : g && (group_outros(), transition_out(g, 1, 1, () => {
        g = null;
      }), check_outros()), /*ready*/
      E[2] ? f ? I[0] & /*ready*/
      4 && transition_in(f, 1) : (f = create_if_block_1$1(), f.c(), transition_in(f, 1), f.m(i.parentNode, i)) : f && (group_outros(), transition_out(f, 1, 1, () => {
        f = null;
      }), check_outros()), /*tooltip*/
      E[5].text ? h ? (h.p(E, I), I[0] & /*tooltip*/
      32 && transition_in(h, 1)) : (h = create_if_block$1(E), h.c(), transition_in(h, 1), h.m(s.parentNode, s)) : h && (group_outros(), transition_out(h, 1, 1, () => {
        h = null;
      }), check_outros());
    },
    i(E) {
      d || (transition_in(p), transition_in(g), transition_in(f), transition_in(h), d = !0);
    },
    o(E) {
      transition_out(p), transition_out(g), transition_out(f), transition_out(h), d = !1;
    },
    d(E) {
      E && (detach(t), detach(n), detach(o), detach(r), detach(i), detach(s), detach(a), detach(l)), e[43](null), p && p.d(E), g && g.d(E), f && f.d(E), h && h.d(E), c = !1, run_all(m);
    }
  };
}
const activeRoomIndex$1 = 0, contextmenu_handler = (e) => e.preventDefault();
function instance$4(e, t, n) {
  let o, r, i, s, a, l, d, c, m, p, g, f, h, E, I, R, A, F, z;
  component_subscribe(e, canvas2d, (T) => n(9, h = T));
  var ne = this && this.__rest || function(T, G) {
    var ce = {};
    for (var Ee in T) Object.prototype.hasOwnProperty.call(T, Ee) && G.indexOf(Ee) < 0 && (ce[Ee] = T[Ee]);
    if (T != null && typeof Object.getOwnPropertySymbols == "function") for (var xe = 0, Ee = Object.getOwnPropertySymbols(T); xe < Ee.length; xe++)
      G.indexOf(Ee[xe]) < 0 && Object.prototype.propertyIsEnumerable.call(T, Ee[xe]) && (ce[Ee[xe]] = T[Ee[xe]]);
    return ce;
  };
  let { canvas3DSize: k } = t;
  const q = getStores(), X = getApi(), { blueprintStore: ae, blueprintStorePreview: ve, canvasStore: De, collidablesStore: Le, decoratedRoomStore: ue, editorStore: le, i18nStore: we, userInteractionStore: ee, featureFlagStore: W, configurationStore: Z } = q;
  component_subscribe(e, Le, (T) => n(51, R = T)), component_subscribe(e, ue, (T) => n(41, I = T)), component_subscribe(e, le, (T) => n(10, z = T)), component_subscribe(e, ee, (T) => n(1, E = T)), component_subscribe(e, W, (T) => n(52, A = T)), component_subscribe(e, Z, (T) => n(42, F = T));
  const he = { x: -1e3, y: -1e3, text: "" }, { translate: Ce } = we;
  let de, ye = !1, Ae = y(0, 0), He = y(0, 0), be, Y, Me = -1, Qe, Je;
  const { wallFeatures: qe } = W.get(), nt = {
    callback: je,
    options: {
      attributes: !0,
      attributeFilter: ["width", "height"]
    }
  }, ct = {
    callback: () => {
      X.reCenterView();
    },
    options: {
      attributes: !0,
      attributeFilter: ["width", "height"]
    }
  }, at = {
    enabled: !!qe,
    onDropEnd: () => {
      n(35, be = void 0), je();
    },
    onDropLeave: () => {
      n(35, be = void 0), je();
    },
    onDropOutside: ({ wallIndex: T, wallFeature: G }) => {
      if (G.id) {
        const ce = ae.commitChanges();
        ce && sendEvent(InsightsEventType.ERROR_ROOM_CHANGE, {
          action: InsightsEventType[InsightsEventType.DELETE_WALL_FEATURE],
          schema: ae.get(),
          error: Ce(ERROR_CODE_TRANSLATION_KEYS[ce])
        }), sendEvent(InsightsEventType.DELETE_WALL_FEATURE, {
          roomIndex: activeRoomIndex$1,
          wallIndex: T,
          featureIndex: -1,
          wallFeature: G,
          schema: ae.get(),
          interaction: InsightsInteractionType.DROPPED
        });
      }
      je();
    },
    onDrop: ({ wallId: T, wallFeature: G }) => {
      n(35, be = void 0);
      let ce = G.positionAlongWall;
      ae.isInvalidPositionForFeature(T, G) && (ce = getNearestSnapPositionForWallFeatureOnWall(G, X.getWallById(T)));
      const xe = X.addWallFeature(T, Object.assign(Object.assign({}, G), { positionAlongWall: ce }), InsightsInteractionType.DROPPED);
      if (isErrorCode(xe)) {
        G.id && ae.resetToSavedState();
        return;
      }
      ee.setSelectedCollidableId(xe.id), je();
    },
    onMove: (T) => {
      if (je(), !T) {
        n(35, be = void 0);
        return;
      }
      const G = ae.getDecoratedWallById(T.wallId);
      if (!G)
        return;
      const ce = V(G.direction), Ee = getNearestSnapPositionForWallFeatureOnWall(T.wallFeature, G), xe = U(G.p1, P(ce, Ee)), Te = U(G.p1, P(ce, Ee + T.wallFeature.size.width));
      let Q = Object.assign(Object.assign({}, T.wallFeature), {
        featureIndex: -1,
        wallId: G.id,
        positionAlongWall: Ee,
        p1: xe,
        p2: Te,
        direction: V($(Te, xe)),
        center: getCenter(xe, Te),
        wallIndex: T.wallIndex
      });
      const Se = ae.isInvalidPositionForFeature(T.wallId, Q);
      Se && (Q = Object.assign(Object.assign({}, Q), {
        isInvalid: !!Se,
        positionAlongWall: T.wallFeature.positionAlongWall,
        p1: U(G.p1, P(ce, T.wallFeature.positionAlongWall)),
        p2: U(G.p1, P(ce, T.wallFeature.positionAlongWall + T.wallFeature.size.width))
      })), n(35, be = {
        wallFeature: Q,
        state: Se ? CollidableState.INVALID : CollidableState.DRAGGED
      }), ee.clearSelectedCollidableId();
    }
  }, et = debounce(
    (T, G, ce) => {
      sendEvent(T, G, ce);
    },
    500
  );
  function ut(T) {
    if (Me === T)
      return;
    Me = T;
    const G = f.filter((Ee) => Ee.isPrioritized), ce = f.filter((Ee) => showWhenPrioritizedMeasurements(Ee, G.length));
    drawRoomLayout({
      ctx: de,
      offset: s,
      scale: i,
      rooms: I,
      roomsPreview: E.preview ? ve.getDecoratedRooms() : void 0,
      hoveredCollidable: E.hoveredCollidable,
      selectedCollidable: c,
      draggedCollidable: E.dragging ? E.selectedCollidable : void 0,
      highlightedWall: E.highlightedWall,
      invalidatedCollidable: E.invalidatedCollidable,
      ghostEntity: be,
      measurements: ce,
      positionAlongWallHoveringWithMouse: Je,
      featureFlags: A
    });
  }
  function je() {
    requestAnimationFrame(ut);
  }
  function ot() {
    ee.setIsContextMenuOpen(!1), ee.clearHoveredCollidableId(), n(35, be = void 0);
  }
  function M(T) {
    var G, ce;
    if (!c)
      return;
    const Ee = T.target;
    if (Ee.tagName == "KOMPIS-INPUT" || Ee instanceof HTMLInputElement)
      return;
    const Te = q.shortcutStore.isMac(), { key: Q } = T;
    (Te && Q === "Backspace" || Q === "Delete") && ((ce = (G = p[c.type]).delete) === null || ce === void 0 || ce.call(G, activeRoomIndex$1, c, InsightsInteractionType.KEY_DOWN), ot(), T.stopImmediatePropagation());
  }
  const b = throttleRequestAnimationFrame((T) => {
    if (E.customCanvasPointerEventsEnabled)
      return;
    const { clientX: G, clientY: ce } = "touches" in T ? T.touches[0] : T, { left: Ee, top: xe } = h.getBoundingClientRect();
    if (Ae = y(G - Ee, ce - xe), E.isPointerPressed && c) {
      ee.clearHoveredCollidableId();
      const Te = getLocalSpaceCoordinateFromScreenPointer(y(Ae.x / l * l, Ae.y / l * l), s, i);
      ee.setIsDragging(!0);
      const Q = $(Te, Y);
      Y = Te, p[c.type].move(activeRoomIndex$1, c, Q, T), je();
    } else {
      const Te = findCollision(Ae, s, i, R), Q = Te == null ? void 0 : Te.id;
      Q !== E.hoveredCollidableId && ee.setHoveredCollidableId(Q);
      const Se = getLocalSpaceCoordinateFromScreenPointer(y(Ae.x, Ae.y), s, i);
      isWallCollidable(Te) && (Je = _($(nearestPointOnWall(Te.entity, Se), Te.entity.p1))), isWallFeatureCollidable(Te) && (c == null ? void 0 : c.id) !== Q ? n(5, d = Object.assign(Object.assign({}, getTooltipPosition(Ae, h.width, h.height)), {
        text: L(Te.entity)
      })) : n(5, d = he), je();
    }
  });
  function L(T) {
    let G = T.type;
    return bt(T) && T.doorType === Wn.OPENING && (G = "DoorOpening"), Ce(camelCase(`menuItem${G}`));
  }
  function x(T) {
    if (ee.setIsContextMenuOpen(!1), "button" in T && T.button !== 0)
      return;
    n(5, d = he), je();
    const { clientX: G, clientY: ce } = "touches" in T ? T.touches[0] : T, { left: Ee, top: xe } = h.getBoundingClientRect();
    Ae = He = y(G - Ee, ce - xe), ee.setPointerPressed(!0);
    const Te = findCollision(Ae, s, i, R);
    Y = getLocalSpaceCoordinateFromScreenPointer(Ae, s, i), c && c !== Te && (p[c.type].deselect(activeRoomIndex$1, c), ee.setInvalidatedCollidableId(void 0)), ee.setSelectedCollidableId(Te == null ? void 0 : Te.id), Te && (p[Te.type].select(activeRoomIndex$1, Te), T.stopImmediatePropagation());
  }
  function j() {
    E.dragging && c && (p[c.type].moveEnd(activeRoomIndex$1, c), je()), He.x === Ae.x && He.y === Ae.y && c && (ee.setIsContextMenuOpen(g.length > 0), n(3, Qe = getContextMenuPosition(Ae, c, h.width, h.height, g.length))), ee.setPointerPressed(!1), ee.setIsDragging(!1);
  }
  function D() {
    const { offset: T, scale: G } = getCanvasCenter(I, h);
    ee.setZoom(G), ee.setOffset(T);
  }
  onMount(() => {
    addEventListener("orientationchange", D), de = h.getContext("2d"), n(2, ye = !0);
    const T = ae.subscribeBlueprintReplaced(ot);
    D(), je();
    const G = De.subscribe(() => {
      je();
    });
    return () => {
      G(), T();
    };
  }), onDestroy(() => {
    removeEventListener("orientationchange", D);
  });
  function J() {
    ee.get().onboarding && (sendEvent(InsightsEventType.ONBOARDING_CLOSED, {
      closeType: InsightsInteractionType[InsightsInteractionType.PAN],
      coordinatesClicked: Ae
    }), ee.setOnboarding(!1)), ee.setIsPanning(!0);
  }
  function oe(T) {
    X.pan({ x: T.detail.dx, y: T.detail.dy });
  }
  function se() {
    ee.setIsPanning(!1);
    const { x: T, y: G } = getInBoundsOffset(I, s, i, h);
    ee.setOffset({ x: T, y: G }), sendEvent(InsightsEventType.PAN_CAMERA, {
      schema: ae.get(),
      coordinatesClicked: Ae
    });
  }
  function ke(T) {
    var G, ce;
    ee.get().onboarding && (sendEvent(InsightsEventType.ONBOARDING_CLOSED, {
      closeType: InsightsInteractionType[InsightsInteractionType.ZOOM_SCROLL_IN]
    }), ee.setOnboarding(!1)), ee.setIsContextMenuOpen(!1);
    const Ee = getInBoundsOffset(I, E.offset, i, h), { roomOutsideScreen: xe } = Ee, Te = ne(Ee, ["roomOutsideScreen"]);
    ee.setOffset(Te), ee.zoomIn(
      (G = T == null ? void 0 : T.detail) === null || G === void 0 ? void 0 : G.scale,
      (ce = T.detail) === null || ce === void 0 ? void 0 : ce.pointerCoords
    ), et(
      InsightsEventType.SCROLL_ZOOM_IN,
      {
        editorMode: le.getEditorMode(),
        roomOutsideScreen: xe,
        offset: Te
      },
      IpexMomentEnum.showMe
    );
  }
  function Re(T) {
    var G, ce;
    ee.get().onboarding && (sendEvent(InsightsEventType.ONBOARDING_CLOSED, {
      closeType: InsightsInteractionType[InsightsInteractionType.ZOOM_SCROLL_OUT]
    }), ee.setOnboarding(!1)), ee.zoomOut(
      (G = T == null ? void 0 : T.detail) === null || G === void 0 ? void 0 : G.scale,
      (ce = T.detail) === null || ce === void 0 ? void 0 : ce.pointerCoords
    ), ee.setIsContextMenuOpen(!1), et(InsightsEventType.SCROLL_ZOOM_OUT, { editorMode: le.getEditorMode() }, IpexMomentEnum.showMe);
  }
  function Ge(T) {
    if (c)
      return () => {
        var G;
        (G = T.onHover) === null || G === void 0 || G.call(T, Y);
      };
  }
  function Fe(T) {
    if (c)
      return () => {
        var G;
        (G = T.onHoverOut) === null || G === void 0 || G.call(T);
      };
  }
  function Xe(T) {
    if (c)
      return () => {
        ee.setIsContextMenuOpen(!1), T.action(Y) && ot();
      };
  }
  function Ve(T) {
    binding_callbacks[T ? "unshift" : "push"](() => {
      h = T, canvas2d.set(h);
    });
  }
  return e.$$set = (T) => {
    "canvas3DSize" in T && n(33, k = T.canvas3DSize);
  }, e.$$.update = () => {
    e.$$.dirty[1] & /*canvas3DSize*/
    4 && n(8, o = k.width), e.$$.dirty[1] & /*canvas3DSize*/
    4 && n(7, r = k.height), e.$$.dirty[0] & /*$userInteractionStore*/
    2 && n(36, i = E.scale), e.$$.dirty[0] & /*$userInteractionStore*/
    2 && n(37, s = E.offset), e.$$.dirty[1] & /*$configurationStore*/
    2048 && n(40, a = F.measurementSystem === "metric"), e.$$.dirty[1] & /*scale, useMetricMeasures*/
    544 && (l = getGridSnapSize(i, a)), e.$$.dirty[0] & /*$userInteractionStore*/
    2 && n(0, c = E.selectedCollidable), e.$$.dirty[0] & /*selectedCollidable*/
    1 | e.$$.dirty[1] & /*ghostEntity*/
    16 && n(39, m = isWallFeatureCollidable(c) ? c.entity : be == null ? void 0 : be.wallFeature), e.$$.dirty[0] & /*selectedCollidable*/
    1 | e.$$.dirty[1] & /*actions*/
    128 && n(4, g = c ? p[c.type].getContextMenuActions(activeRoomIndex$1, c) : []), e.$$.dirty[0] & /*$userInteractionStore*/
    2 | e.$$.dirty[1] & /*$decoratedRoomStore, offset, scale, $configurationStore, activeCollidable*/
    3424 && n(6, f = getMeasurements(X, I, E.prioritizedWallIds, s, i, F.measurementSystem, m));
  }, n(5, d = he), n(38, p = createEditorActions(X, q)), [
    c,
    E,
    ye,
    Qe,
    g,
    d,
    f,
    r,
    o,
    h,
    z,
    X,
    Le,
    ue,
    le,
    ee,
    W,
    Z,
    nt,
    ct,
    at,
    M,
    b,
    x,
    j,
    J,
    oe,
    se,
    ke,
    Re,
    Ge,
    Fe,
    Xe,
    k,
    D,
    be,
    i,
    s,
    p,
    m,
    a,
    I,
    F,
    Ve
  ];
}
class Editor2d extends SvelteComponent {
  constructor(t) {
    super(), init(
      this,
      t,
      instance$4,
      create_fragment$4,
      safe_not_equal,
      {
        canvas3DSize: 33,
        setCenterZoomCanvas: 34
      },
      add_css$1,
      [-1, -1, -1]
    );
  }
  get setCenterZoomCanvas() {
    return this.$$.ctx[34];
  }
}
function add_css(e) {
  append_styles(e, "svelte-e0gflr", '.disabled{pointer-events:none}.kvadrat-disable-pointer-events{pointer-events:none}.isInteracting.svelte-e0gflr .kvadrat-disable-during-interaction{pointer-events:none}.elevated.svelte-e0gflr{z-index:1}.kvadrat-drag-element{box-sizing:border-box;display:flex;left:0px;pointer-events:none;position:fixed;top:0px;transform-origin:center center;z-index:100}.kvadrat-drag-canvas-element{display:none;width:100%;height:100%;pointer-events:none;image-rendering:pixelated;background-color:transparent}.kvadrat-drag-ghost{filter:drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7))}.kvadrat-drag-element.kvadrat-drag-on-canvas .kvadrat-drag-ghost{display:none}.kvadrat-drag-element.kvadrat-drag-on-canvas .kvadrat-drag-canvas-element{display:block}.kvadrat-drag-image{position:fixed;left:-100vw;top:-100vw}div.svelte-e0gflr{--font-family-latin:"notoIKEAlatin", "Noto IKEA", "Noto Sans", "Roboto", "Open Sans", "sans-serif";--colour-brand-blue:#0058a3;--colour-white:#ffffff;--colour-grey-100:#f5f5f5;--colour-grey-200:#dfdfdf;--colour-grey-500:#929292;--colour-grey-700:#484848;--colour-grey-900:#111111;--colour-primary-accent:var(--colour-brand-blue);--colour-primary-accent-dark:#004f93;--colour-primary-accent-darkest:#003e72;--colour-positive:#0a8a00;--colour-negative:#e00751;--colour-caution:#ffa524;--colour-text:var(--colour-grey-700);--colour-text-dark:var(--colour-grey-900);--colour-text-lightest:#767676;--colour-bg:var(--colour-white);--colour-bg-inverse:var(--colour-grey-900);--colour-bg-accent:var(--colour-primary-accent);--colour-border-light:var(--colour-grey-200);--colour-border:var(--colour-grey-500);--colour-border-dark:var(--colour-grey-900);--colour-icon:var(--colour-grey-900);--colour-icon-inverse:var(--colour-white);--colour-disabled-ui:var(--colour-grey-200);--letter-spacing:0px;--font-size-100:16px;--font-size-50:12px;--line-height-100-short:24px;--line-height-100-long:26px;--space-25:4px;--space-50:8px;--space-75:12px;--space-100:16px;--space-125:20px;--space-150:24px;--space-200:32px;--space-250:40px;--space-300:48px;--space-400:64px;--radius-s:4px;--radius-cap:64px;--duration-quick:100ms;--duration-standard:200ms;--ease-easy:cubic-bezier(0.4, 0, 0.4, 1);--primary-hover:#333333;--colour-shadow-dark:rgba(0, 0, 0, 0.1);--shadow-size-default:0px 4px 16px;--measurement-padding:var(--space-50);letter-spacing:var(--letter-spacing);color:var(--colour-text);font-family:var(--font-family-latin);font-size:var(--font-size-100);line-height:var(--line-height-100-short);display:inline}');
}
function create_fragment$3(e) {
  let t, n;
  const o = (
    /*#slots*/
    e[3].default
  ), r = create_slot(
    o,
    e,
    /*$$scope*/
    e[2],
    null
  );
  return {
    c() {
      t = element("div"), r && r.c(), attr(t, "class", null_to_empty(KVADRAT_UI_SELECTOR) + " svelte-e0gflr"), attr(
        t,
        "dir",
        /*writeDirection*/
        e[0]
      ), toggle_class(t, "elevated", !0), toggle_class(
        t,
        "isInteracting",
        /*isInteracting*/
        e[1]
      );
    },
    m(i, s) {
      insert(i, t, s), r && r.m(t, null), n = !0;
    },
    p(i, [s]) {
      r && r.p && (!n || s & /*$$scope*/
      4) && update_slot_base(
        r,
        o,
        i,
        /*$$scope*/
        i[2],
        n ? get_slot_changes(
          o,
          /*$$scope*/
          i[2],
          s,
          null
        ) : get_all_dirty_from_scope(
          /*$$scope*/
          i[2]
        ),
        null
      ), (!n || s & /*writeDirection*/
      1) && attr(
        t,
        "dir",
        /*writeDirection*/
        i[0]
      ), (!n || s & /*isInteracting*/
      2) && toggle_class(
        t,
        "isInteracting",
        /*isInteracting*/
        i[1]
      );
    },
    i(i) {
      n || (transition_in(r, i), n = !0);
    },
    o(i) {
      transition_out(r, i), n = !1;
    },
    d(i) {
      i && detach(t), r && r.d(i);
    }
  };
}
function instance$3(e, t, n) {
  let { $$slots: o = {}, $$scope: r } = t, { writeDirection: i } = t, { isInteracting: s = !1 } = t;
  return e.$$set = (a) => {
    "writeDirection" in a && n(0, i = a.writeDirection), "isInteracting" in a && n(1, s = a.isInteracting), "$$scope" in a && n(2, r = a.$$scope);
  }, [i, s, r, o];
}
class SkapaStyle extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$3, create_fragment$3, safe_not_equal, { writeDirection: 0, isInteracting: 1 }, add_css);
  }
}
/*! mobile-drag-drop 2.3.0-rc.1 | Copyright (c) 2019 Tim Ruffles | MIT License */
var CLASS_PREFIX = "dnd-poly-", CLASS_DRAG_IMAGE = CLASS_PREFIX + "drag-image", CLASS_DRAG_IMAGE_SNAPBACK = CLASS_PREFIX + "snapback", CLASS_DRAG_OPERATION_ICON = CLASS_PREFIX + "icon", EVENT_PREFIX = "dnd-poly-", EVENT_DRAG_DRAGSTART_PENDING = EVENT_PREFIX + "dragstart-pending", EVENT_DRAG_DRAGSTART_CANCEL = EVENT_PREFIX + "dragstart-cancel", ALLOWED_EFFECTS = ["none", "copy", "copyLink", "copyMove", "link", "linkMove", "move", "all"], DROP_EFFECTS = ["none", "copy", "move", "link"];
function detectFeatures() {
  var e = {
    dragEvents: "ondragstart" in document.documentElement,
    draggable: "draggable" in document.documentElement,
    userAgentSupportingNativeDnD: void 0
  }, t = !!window.chrome || /chrome/i.test(navigator.userAgent);
  return e.userAgentSupportingNativeDnD = !(/iPad|iPhone|iPod|Android/.test(navigator.userAgent) || t && "ontouchstart" in document.documentElement), e;
}
function supportsPassiveEventListener() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch {
  }
  return e;
}
var supportsPassive = supportsPassiveEventListener();
function isDOMElement(e) {
  return e && e.tagName;
}
function addDocumentListener(e, t, n) {
  document.addEventListener(e, t, supportsPassive ? { passive: n } : !1);
}
function removeDocumentListener(e, t) {
  document.removeEventListener(e, t);
}
function onEvt(e, t, n, o) {
  o === void 0 && (o = !1);
  var r = supportsPassive ? { passive: !0, capture: o } : o;
  return e.addEventListener(t, n, r), {
    off: function() {
      e.removeEventListener(t, n, r);
    }
  };
}
function prepareNodeCopyAsDragImage(e, t) {
  if (e.nodeType === 1) {
    for (var n = getComputedStyle(e), o = 0; o < n.length; o++) {
      var r = n[o];
      t.style.setProperty(r, n.getPropertyValue(r), n.getPropertyPriority(r));
    }
    if (t.style.pointerEvents = "none", t.removeAttribute("id"), t.removeAttribute("class"), t.removeAttribute("draggable"), t.nodeName === "CANVAS") {
      var i = e, s = t, a = i.getContext("2d").getImageData(0, 0, i.width, i.height);
      s.getContext("2d").putImageData(a, 0, 0);
    }
  }
  if (e.hasChildNodes())
    for (var o = 0; o < e.childNodes.length; o++)
      prepareNodeCopyAsDragImage(e.childNodes[o], t.childNodes[o]);
}
function createDragImage(e) {
  var t = e.cloneNode(!0);
  return prepareNodeCopyAsDragImage(e, t), t;
}
function average(e) {
  return e.length === 0 ? 0 : e.reduce(function(t, n) {
    return n + t;
  }, 0) / e.length;
}
function isTouchIdentifierContainedInTouchEvent(e, t) {
  for (var n = 0; n < e.changedTouches.length; n++) {
    var o = e.changedTouches[n];
    if (o.identifier === t)
      return !0;
  }
  return !1;
}
function updateCentroidCoordinatesOfTouchesIn(e, t, n) {
  for (var o = [], r = [], i = 0; i < t.touches.length; i++) {
    var s = t.touches[i];
    o.push(s[e + "X"]), r.push(s[e + "Y"]);
  }
  n.x = average(o), n.y = average(r);
}
var TRANSFORM_CSS_VENDOR_PREFIXES = ["", "-webkit-"];
function extractTransformStyles(e) {
  return TRANSFORM_CSS_VENDOR_PREFIXES.map(function(t) {
    var n = e.style[t + "transform"];
    return !n || n === "none" ? "" : n.replace(/translate\(\D*\d+[^,]*,\D*\d+[^,]*\)\s*/g, "");
  });
}
function translateElementToPoint(e, t, n, o, r) {
  r === void 0 && (r = !0);
  var i = t.x, s = t.y;
  o && (i += o.x, s += o.y), r && (i -= parseInt(e.offsetWidth, 10) / 2, s -= parseInt(e.offsetHeight, 10) / 2);
  for (var a = "translate3d(" + i + "px," + s + "px, 0)", l = 0; l < TRANSFORM_CSS_VENDOR_PREFIXES.length; l++) {
    var d = TRANSFORM_CSS_VENDOR_PREFIXES[l] + "transform";
    e.style[d] = a + " " + n[l];
  }
}
function applyDragImageSnapback(e, t, n, o) {
  var r = getComputedStyle(e);
  if (r.visibility === "hidden" || r.display === "none") {
    o();
    return;
  }
  t.classList.add(CLASS_DRAG_IMAGE_SNAPBACK);
  var i = getComputedStyle(t), s = parseFloat(i.transitionDuration);
  if (isNaN(s) || s === 0) {
    o();
    return;
  }
  var a = e.getBoundingClientRect(), l = {
    x: a.left,
    y: a.top
  };
  l.x += document.body.scrollLeft || document.documentElement.scrollLeft, l.y += document.body.scrollTop || document.documentElement.scrollTop, l.x -= parseInt(r.marginLeft, 10), l.y -= parseInt(r.marginTop, 10);
  var d = parseFloat(i.transitionDelay), c = Math.round((s + d) * 1e3);
  translateElementToPoint(t, l, n, void 0, !1), setTimeout(o, c);
}
var DataTransfer$1 = function() {
  function e(t, n) {
    this._dataStore = t, this._setDragImageHandler = n, this._dropEffect = DROP_EFFECTS[0];
  }
  return Object.defineProperty(e.prototype, "dropEffect", {
    get: function() {
      return this._dropEffect;
    },
    set: function(t) {
      this._dataStore.mode !== 0 && ALLOWED_EFFECTS.indexOf(t) > -1 && (this._dropEffect = t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "types", {
    get: function() {
      if (this._dataStore.mode !== 0)
        return Object.freeze(this._dataStore.types);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "effectAllowed", {
    get: function() {
      return this._dataStore.effectAllowed;
    },
    set: function(t) {
      this._dataStore.mode === 2 && ALLOWED_EFFECTS.indexOf(t) > -1 && (this._dataStore.effectAllowed = t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setData = function(t, n) {
    if (this._dataStore.mode === 2) {
      if (t.indexOf(" ") > -1)
        throw new Error("illegal arg: type contains space");
      this._dataStore.data[t] = n, this._dataStore.types.indexOf(t) === -1 && this._dataStore.types.push(t);
    }
  }, e.prototype.getData = function(t) {
    if (this._dataStore.mode === 1 || this._dataStore.mode === 2)
      return this._dataStore.data[t] || "";
  }, e.prototype.clearData = function(t) {
    if (this._dataStore.mode === 2) {
      if (t && this._dataStore.data[t]) {
        delete this._dataStore.data[t];
        var n = this._dataStore.types.indexOf(t);
        n > -1 && this._dataStore.types.splice(n, 1);
        return;
      }
      this._dataStore.data = {}, this._dataStore.types = [];
    }
  }, e.prototype.setDragImage = function(t, n, o) {
    this._dataStore.mode === 2 && this._setDragImageHandler(t, n, o);
  }, e;
}();
function tryFindDraggableTarget(e) {
  var t = e.target;
  do
    if (t.draggable !== !1 && (t.draggable === !0 || t.getAttribute && t.getAttribute("draggable") === "true"))
      return t;
  while ((t = t.parentNode) && t !== document.body);
}
function determineDropEffect(e, t) {
  return e ? e === ALLOWED_EFFECTS[0] ? DROP_EFFECTS[0] : e.indexOf(ALLOWED_EFFECTS[1]) === 0 || e === ALLOWED_EFFECTS[7] ? DROP_EFFECTS[1] : e.indexOf(ALLOWED_EFFECTS[4]) === 0 ? DROP_EFFECTS[3] : e === ALLOWED_EFFECTS[6] ? DROP_EFFECTS[2] : DROP_EFFECTS[1] : t.nodeType === 3 && t.tagName === "A" ? DROP_EFFECTS[3] : DROP_EFFECTS[1];
}
function createDragEventFromTouch(e, t, n, o, r, i, s) {
  s === void 0 && (s = null);
  var a = t.changedTouches[0], l = new Event(n, {
    bubbles: !0,
    cancelable: o
  });
  l.dataTransfer = i, l.relatedTarget = s, l.screenX = a.screenX, l.screenY = a.screenY, l.clientX = a.clientX, l.clientY = a.clientY, l.pageX = a.pageX, l.pageY = a.pageY;
  var d = e.getBoundingClientRect();
  return l.offsetX = l.clientX - d.left, l.offsetY = l.clientY - d.top, l;
}
function dispatchDragEvent(e, t, n, o, r, i, s) {
  i === void 0 && (i = !0), s === void 0 && (s = null);
  var a = createDragEventFromTouch(
    t,
    n,
    e,
    i,
    document.defaultView,
    r,
    s
  ), l = !t.dispatchEvent(a);
  return o.mode = 0, l;
}
function determineDragOperation(e, t) {
  if (!e || e === ALLOWED_EFFECTS[7])
    return t;
  if (t === DROP_EFFECTS[1]) {
    if (e.indexOf(DROP_EFFECTS[1]) === 0)
      return DROP_EFFECTS[1];
  } else if (t === DROP_EFFECTS[3]) {
    if (e.indexOf(DROP_EFFECTS[3]) === 0 || e.indexOf("Link") > -1)
      return DROP_EFFECTS[3];
  } else if (t === DROP_EFFECTS[2] && (e.indexOf(DROP_EFFECTS[2]) === 0 || e.indexOf("Move") > -1))
    return DROP_EFFECTS[2];
  return DROP_EFFECTS[0];
}
var DragOperationController = function() {
  function e(t, n, o, r) {
    this._initialEvent = t, this._config = n, this._sourceNode = o, this._dragOperationEndedCb = r, this._dragOperationState = 0, this._immediateUserSelection = null, this._currentDropTarget = null, this._lastTouchEvent = t, this._initialTouch = t.changedTouches[0], this._touchMoveHandler = this._onTouchMove.bind(this), this._touchEndOrCancelHandler = this._onTouchEndOrCancel.bind(this), addDocumentListener("touchmove", this._touchMoveHandler, !1), addDocumentListener("touchend", this._touchEndOrCancelHandler, !1), addDocumentListener("touchcancel", this._touchEndOrCancelHandler, !1);
  }
  return e.prototype._setup = function() {
    var t = this;
    this._dragOperationState = 1, this._currentDragOperation = DROP_EFFECTS[0], this._dragDataStore = {
      data: {},
      effectAllowed: void 0,
      mode: 3,
      types: []
    }, this._currentHotspotCoordinates = {
      x: null,
      y: null
    }, this._dragImagePageCoordinates = {
      x: null,
      y: null
    };
    var n = this._sourceNode;
    if (this._dataTransfer = new DataTransfer$1(this._dragDataStore, function(s, a, l) {
      n = s, (typeof a == "number" || typeof l == "number") && (t._dragImageOffset = {
        x: a || 0,
        y: l || 0
      });
    }), this._dragDataStore.mode = 2, this._dataTransfer.dropEffect = DROP_EFFECTS[0], dispatchDragEvent("dragstart", this._sourceNode, this._lastTouchEvent, this._dragDataStore, this._dataTransfer))
      return this._dragOperationState = 3, this._cleanup(), !1;
    updateCentroidCoordinatesOfTouchesIn("page", this._lastTouchEvent, this._dragImagePageCoordinates);
    var o = this._config.dragImageSetup(n);
    if (this._dragImageTransforms = extractTransformStyles(o), o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", o.style.zIndex = "999999", o.classList.add(CLASS_DRAG_IMAGE), o.classList.add(CLASS_DRAG_OPERATION_ICON), this._dragImage = o, !this._dragImageOffset)
      if (this._config.dragImageOffset)
        this._dragImageOffset = {
          x: this._config.dragImageOffset.x,
          y: this._config.dragImageOffset.y
        };
      else if (this._config.dragImageCenterOnTouch) {
        var r = getComputedStyle(n);
        this._dragImageOffset = {
          x: 0 - parseInt(r.marginLeft, 10),
          y: 0 - parseInt(r.marginTop, 10)
        };
      } else {
        var i = n.getBoundingClientRect(), r = getComputedStyle(n);
        this._dragImageOffset = {
          x: i.left - this._initialTouch.clientX - parseInt(r.marginLeft, 10) + i.width / 2,
          y: i.top - this._initialTouch.clientY - parseInt(r.marginTop, 10) + i.height / 2
        };
      }
    return translateElementToPoint(
      this._dragImage,
      this._dragImagePageCoordinates,
      this._dragImageTransforms,
      this._dragImageOffset,
      this._config.dragImageCenterOnTouch
    ), this._iterationIntervalId = window.setInterval(function() {
      t._iterationLock || (t._iterationLock = !0, t._dragAndDropProcessModelIteration(), t._iterationLock = !1);
    }, this._config.iterationInterval), !0;
  }, e.prototype._cleanup = function() {
    this._iterationIntervalId && (clearInterval(this._iterationIntervalId), this._iterationIntervalId = null), removeDocumentListener("touchmove", this._touchMoveHandler), removeDocumentListener("touchend", this._touchEndOrCancelHandler), removeDocumentListener("touchcancel", this._touchEndOrCancelHandler), this._dragImage && (this._dragImage = null), this._dragOperationEndedCb(this._config, this._lastTouchEvent, this._dragOperationState);
  }, e.prototype._onTouchMove = function(t) {
    var n = this;
    if (isTouchIdentifierContainedInTouchEvent(t, this._initialTouch.identifier) !== !1) {
      if (this._lastTouchEvent = t, this._dragOperationState === 0) {
        var o = void 0;
        if (this._config.dragStartConditionOverride)
          try {
            o = this._config.dragStartConditionOverride(t);
          } catch (i) {
            console.error("dnd-poly: error in dragStartConditionOverride hook: " + i), o = !1;
          }
        else
          o = t.touches.length === 1;
        if (!o) {
          this._cleanup();
          return;
        }
        this._setup() === !0 && (this._initialEvent.preventDefault(), t.preventDefault());
        return;
      }
      if (t.preventDefault(), updateCentroidCoordinatesOfTouchesIn("client", t, this._currentHotspotCoordinates), updateCentroidCoordinatesOfTouchesIn("page", t, this._dragImagePageCoordinates), this._config.dragImageTranslateOverride)
        try {
          var r = !1;
          if (this._config.dragImageTranslateOverride(
            t,
            {
              x: this._currentHotspotCoordinates.x,
              y: this._currentHotspotCoordinates.y
            },
            this._immediateUserSelection,
            function(i, s) {
              n._dragImage && (r = !0, n._currentHotspotCoordinates.x += i, n._currentHotspotCoordinates.y += s, n._dragImagePageCoordinates.x += i, n._dragImagePageCoordinates.y += s, translateElementToPoint(
                n._dragImage,
                n._dragImagePageCoordinates,
                n._dragImageTransforms,
                n._dragImageOffset,
                n._config.dragImageCenterOnTouch
              ));
            }
          ), r)
            return;
        } catch {
        }
      translateElementToPoint(
        this._dragImage,
        this._dragImagePageCoordinates,
        this._dragImageTransforms,
        this._dragImageOffset,
        this._config.dragImageCenterOnTouch
      );
    }
  }, e.prototype._onTouchEndOrCancel = function(t) {
    if (isTouchIdentifierContainedInTouchEvent(t, this._initialTouch.identifier) !== !1) {
      if (this._config.dragImageTranslateOverride)
        try {
          this._config.dragImageTranslateOverride(void 0, void 0, void 0, function() {
          });
        } catch {
        }
      if (this._dragOperationState === 0) {
        this._cleanup();
        return;
      }
      t.preventDefault(), this._dragOperationState = t.type === "touchcancel" ? 3 : 2;
    }
  }, e.prototype._dragAndDropProcessModelIteration = function() {
    var t = this, n = this._currentDragOperation;
    this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = DROP_EFFECTS[0];
    var o = dispatchDragEvent(
      "drag",
      this._sourceNode,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer
    );
    if (o && (this._currentDragOperation = DROP_EFFECTS[0]), o || this._dragOperationState === 2 || this._dragOperationState === 3) {
      var r = this._dragOperationEnded(this._dragOperationState);
      if (r) {
        applyDragImageSnapback(this._sourceNode, this._dragImage, this._dragImageTransforms, function() {
          t._finishDragOperation();
        });
        return;
      }
      this._finishDragOperation();
      return;
    }
    var i = this._config.elementFromPoint(
      this._currentHotspotCoordinates.x,
      this._currentHotspotCoordinates.y
    ), s = this._currentDropTarget;
    i !== this._immediateUserSelection && i !== this._currentDropTarget && (this._immediateUserSelection = i, this._currentDropTarget !== null && (this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = DROP_EFFECTS[0], dispatchDragEvent(
      "dragexit",
      this._currentDropTarget,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer,
      !1
    )), this._immediateUserSelection === null ? this._currentDropTarget = this._immediateUserSelection : (this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = determineDropEffect(this._dragDataStore.effectAllowed, this._sourceNode), dispatchDragEvent(
      "dragenter",
      this._immediateUserSelection,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer
    ) ? (this._currentDropTarget = this._immediateUserSelection, this._currentDragOperation = determineDragOperation(
      this._dataTransfer.effectAllowed,
      this._dataTransfer.dropEffect
    )) : this._immediateUserSelection !== document.body && (this._currentDropTarget = document.body))), s !== this._currentDropTarget && isDOMElement(s) && (this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = DROP_EFFECTS[0], dispatchDragEvent(
      "dragleave",
      s,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer,
      !1,
      this._currentDropTarget
    )), isDOMElement(this._currentDropTarget) && (this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = determineDropEffect(this._dragDataStore.effectAllowed, this._sourceNode), dispatchDragEvent(
      "dragover",
      this._currentDropTarget,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer
    ) === !1 ? this._currentDragOperation = DROP_EFFECTS[0] : this._currentDragOperation = determineDragOperation(
      this._dataTransfer.effectAllowed,
      this._dataTransfer.dropEffect
    )), n !== this._currentDragOperation && this._dragImage.classList.remove(CLASS_PREFIX + n);
    var a = CLASS_PREFIX + this._currentDragOperation;
    this._dragImage.classList.add(a);
  }, e.prototype._dragOperationEnded = function(t) {
    var n = this._currentDragOperation === DROP_EFFECTS[0] || this._currentDropTarget === null || t === 3;
    return n ? isDOMElement(this._currentDropTarget) && (this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = DROP_EFFECTS[0], dispatchDragEvent(
      "dragleave",
      this._currentDropTarget,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer,
      !1
    )) : isDOMElement(this._currentDropTarget) && (this._dragDataStore.mode = 1, this._dataTransfer.dropEffect = this._currentDragOperation, dispatchDragEvent(
      "drop",
      this._currentDropTarget,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer
    ) === !0 ? this._currentDragOperation = this._dataTransfer.dropEffect : this._currentDragOperation = DROP_EFFECTS[0]), n;
  }, e.prototype._finishDragOperation = function() {
    this._dragDataStore.mode = 3, this._dataTransfer.dropEffect = this._currentDragOperation, dispatchDragEvent(
      "dragend",
      this._sourceNode,
      this._lastTouchEvent,
      this._dragDataStore,
      this._dataTransfer,
      !1
    ), this._dragOperationState = 2, this._cleanup();
  }, e;
}(), config = {
  iterationInterval: 150,
  tryFindDraggableTarget,
  dragImageSetup: createDragImage,
  elementFromPoint: function(e, t) {
    return document.elementFromPoint(e, t);
  }
}, activeDragOperation;
function onTouchstart(e) {
  if (!activeDragOperation) {
    var t = config.tryFindDraggableTarget(e);
    if (t)
      try {
        activeDragOperation = new DragOperationController(e, config, t, dragOperationEnded);
      } catch (n) {
        throw dragOperationEnded(config, e, 3), n;
      }
  }
}
function onDelayTouchstart(e) {
  var t = e.target, n = function() {
    i.off(), s.off(), a.off(), l.off(), onTouchstart(e);
  }, o = function(d) {
    i.off(), s.off(), a.off(), l.off(), t && t.dispatchEvent(new CustomEvent(EVENT_DRAG_DRAGSTART_CANCEL, { bubbles: !0, cancelable: !0 })), clearTimeout(r);
  };
  t && t.dispatchEvent(new CustomEvent(EVENT_DRAG_DRAGSTART_PENDING, { bubbles: !0, cancelable: !0 }));
  var r = window.setTimeout(n, config.holdToDrag), i = onEvt(t, "touchend", o), s = onEvt(t, "touchcancel", o), a = onEvt(t, "touchmove", o), l = onEvt(window, "scroll", o, !0);
}
function dragOperationEnded(e, t, n) {
  if (n === 0 && e.defaultActionOverride)
    try {
      e.defaultActionOverride(t), t.defaultPrevented;
    } catch {
    }
  activeDragOperation = null;
}
function polyfill(e) {
  if (e && Object.keys(e).forEach(function(n) {
    config[n] = e[n];
  }), !config.forceApply) {
    var t = detectFeatures();
    if (t.userAgentSupportingNativeDnD && t.draggable && t.dragEvents)
      return !1;
  }
  return config.holdToDrag ? addDocumentListener("touchstart", onDelayTouchstart, !1) : addDocumentListener("touchstart", onTouchstart, !1), !0;
}
function create_fragment$2(e) {
  let t, n, o, r, i;
  const s = (
    /*#slots*/
    e[2].default
  ), a = create_slot(
    s,
    e,
    /*$$scope*/
    e[1],
    null
  );
  return {
    c() {
      t = space$1(), n = element("div"), a && a.c();
    },
    m(l, d) {
      insert(l, t, d), insert(l, n, d), a && a.m(n, null), o = !0, r || (i = listen(
        document.body,
        "keydown",
        /*handleKeydown*/
        e[0]
      ), r = !0);
    },
    p(l, [d]) {
      a && a.p && (!o || d & /*$$scope*/
      2) && update_slot_base(
        a,
        s,
        l,
        /*$$scope*/
        l[1],
        o ? get_slot_changes(
          s,
          /*$$scope*/
          l[1],
          d,
          null
        ) : get_all_dirty_from_scope(
          /*$$scope*/
          l[1]
        ),
        null
      );
    },
    i(l) {
      o || (transition_in(a, l), o = !0);
    },
    o(l) {
      transition_out(a, l), o = !1;
    },
    d(l) {
      l && (detach(t), detach(n)), a && a.d(l), r = !1, i();
    }
  };
}
function instance$2(e, t, n) {
  let { $$slots: o = {}, $$scope: r } = t;
  const { shortcutStore: i, userInteractionStore: s, blueprintStore: a, featureFlagStore: l } = getStores(), d = getApi(), c = {
    interaction: InsightsInteractionType[InsightsInteractionType.KEY_DOWN]
  };
  function m(I) {
    i.handleKeyboardEvent(I);
  }
  onMount(() => {
    const I = [
      i.registerShortcut("+", h),
      i.registerShortcut("-", E),
      i.registerShortcut("c", f),
      i.registerShortcut("escape", p),
      i.registerShortcut("arrowdown", g),
      i.registerShortcut("arrowleft", g),
      i.registerShortcut("arrowright", g),
      i.registerShortcut("arrowup", g),
      i.registerShortcut("shift+arrowdown", (R) => g(R, 10)),
      i.registerShortcut("shift+arrowleft", (R) => g(R, 10)),
      i.registerShortcut("shift+arrowright", (R) => g(R, 10)),
      i.registerShortcut("shift+arrowup", (R) => g(R, 10))
    ];
    return () => I.forEach((R) => R());
  });
  function p() {
    const { contextMenuOpen: I, materialPopupOpen: R } = s.get();
    I && (s.setIsContextMenuOpen(!1), s.setPreview(!1)), R && (s.setIsMaterialPopupOpen(!1), s.setPreview(!1));
  }
  function g(I, R = 1) {
    const A = s.get().selectedCollidable;
    let F = 0, z = 0;
    if (I.key === "ArrowLeft" ? F = -10 * R : I.key === "ArrowRight" && (F = 10 * R), I.key === "ArrowDown" ? z = 10 * R : I.key === "ArrowUp" && (z = -10 * R), A || d.pan({ x: F, y: z }), isCornerCollidable(A) && l.get().dragCorners && decorateInsightEventWith(c, () => a.moveCorner(A.id, { x: F, y: 0, z }, !0)), isWallCollidable(A)) {
      const ne = y(0, 1), k = Math.abs(ge.dot(ne, asVec2(A.entity.direction))), q = k >= 0.5 ? F : 0, X = k < 0.5 ? z : 0;
      decorateInsightEventWith(c, () => a.moveWall(A.id, { x: q, y: 0, z: X }, !0));
    }
    if (isWallFeatureCollidable(A)) {
      const ne = y(0, 1), k = A.entity, q = Math.abs(ge.dot(ne, asVec2(k.direction))), X = q < 0.5 ? F : 0, ae = q >= 0.5 ? z : 0, ve = Object.values(k.direction).includes(-1);
      let De = k.positionAlongWall;
      if (ve ? De -= X || ae : De += X || ae, De === k.positionAlongWall)
        return;
      decorateInsightEventWith(c, () => a.updateWallFeaturePosition(A.id, De, !0));
    }
  }
  function f() {
    decorateInsightEventWith(c, () => d.reCenterView());
  }
  function h() {
    decorateInsightEventWith(c, () => d.zoomIn());
  }
  function E() {
    decorateInsightEventWith(c, () => d.zoomOut());
  }
  return e.$$set = (I) => {
    "$$scope" in I && n(1, r = I.$$scope);
  }, [m, r, o];
}
class KeyboardEventListener extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$2, create_fragment$2, safe_not_equal, {});
  }
}
const useDrag = (e, t) => {
  const [n, o] = useState(!1), r = useRef(), i = useCallback(
    (s) => {
      var a;
      return s !== null && (r.current = new Draggable$1(s, {
        onDragStart: () => {
          o(!0);
        },
        onDrag: (l, d, c) => {
          var m;
          (m = r.current) == null || m.set(d, c);
        },
        onDragEnd: () => {
          o(!1);
        },
        filterTarget: t
      }), e && ((a = r.current) == null || a.set(e.x, e.y))), s;
    },
    [e]
  );
  return useEffect(() => () => {
    var s;
    (s = r == null ? void 0 : r.current) == null || s.destroy();
  }, []), { isDragging: n, nodeRef: i };
}, useOutsideClick = (e) => {
  const t = useRef(null);
  return useEffect(() => {
    const n = (o) => {
      t.current && o.target instanceof HTMLElement && !t.current.contains(o.target) && e();
    };
    return document.addEventListener("pointerdown", n), () => {
      document.removeEventListener("pointerdown", n);
    };
  }, [e]), t;
}, MaterialSelectorPopup = styled.div`
  background: white;
  width: 220px;
  min-height: 310px;
  cursor: move;
`, MaterialPopup = ({ position: e }) => {
  const t = useSelectedMaterial(), { blueprintStore: n, userInteractionStore: o } = useStores(), r = () => {
    n.resetPreviewMaterials();
  }, [i, s] = useState(!0);
  useEffect(() => {
    s(o.get().materialPopupOpen && o.get().materialPopupVisible);
  }, [o.get().materialPopupOpen, o.get().materialPopupVisible]);
  const a = useSelectedCollidable(), l = useApplyMaterial((a == null ? void 0 : a.type) ?? CollidableType.WALL), d = (a == null ? void 0 : a.type) ?? CollidableType.WALL, [, c] = useRecentMaterials(d), { data: m, error: p, isLoading: g } = useMaterials(), f = m ? addCustomMaterialsToCategory(m, n.get().materials, "color") : null, h = COLLIDABLE_MATERIALCATEGORY_MAP[(a == null ? void 0 : a.type) ?? CollidableType.WALL] || "", E = useMemo(
    () => (f == null ? void 0 : f.filter((q) => q.tags.includes(h))) || [],
    [f, h]
  ), I = useCallback(() => {
    o.setIsMaterialPopupVisible(!1), sendEvent(InsightsEventType.MATERIAL_POPUP_CLOSED, {
      interaction: InsightsInteractionType[InsightsInteractionType.BLUR]
    });
  }, [o]), { isDragging: R, nodeRef: A } = useDrag(e, (q) => q instanceof HTMLElement ? q.classList.contains("materialSelectorPopup") : !1), F = useOutsideClick(I);
  if (!(a && isCollidableWithMaterialSupport(a)) || p || E.length === 0)
    return null;
  const z = (q) => (X, ae) => {
    l(X, { commit: q, all: ae }), q && c(X);
  }, ne = z(), k = z(!0);
  return /* @__PURE__ */ jsx("div", { ref: F, hidden: !i, children: /* @__PURE__ */ jsx(MaterialSelectorPopup, { ref: A, className: "materialSelectorPopup", children: /* @__PURE__ */ jsx(
    MaterialSelector,
    {
      isLoading: g,
      materialCategories: E,
      selectedMaterial: t == null ? void 0 : t.id,
      layout: "compact",
      onApplyMaterial: k,
      onBlurMaterial: r,
      onFocusMaterial: ne,
      onHoverMaterial: ne,
      onClose: () => {
        o.setIsMaterialPopupOpen(!1), sendEvent(InsightsEventType.MATERIAL_POPUP_CLOSED, {
          interaction: InsightsInteractionType[InsightsInteractionType.CLICKED]
        });
      },
      isDragging: R,
      collidableType: d
    },
    a.type
  ) }) });
}, MaterialPopupHoc = ({ kvadratApi: e, position: t }) => /* @__PURE__ */ jsx(KvadratProviderWrapper, { kvadrat: e, children: /* @__PURE__ */ jsx(MaterialPopup, { position: t }) });
function create_fragment$1(e) {
  let t, n;
  return t = new MeasurementInput({
    props: {
      selectedCollidableType: CollidableType.WALL,
      canvas: (
        /*canvas*/
        e[0]
      ),
      value: (
        /*height*/
        e[3]
      ),
      dimensionConfig: (
        /*dimensionConfig*/
        e[4]
      ),
      position: (
        /*position*/
        e[1]
      ),
      measurement: (
        /*measurement*/
        e[2]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, [r]) {
      const i = {};
      r & /*canvas*/
      1 && (i.canvas = /*canvas*/
      o[0]), r & /*height*/
      8 && (i.value = /*height*/
      o[3]), r & /*position*/
      2 && (i.position = /*position*/
      o[1]), r & /*measurement*/
      4 && (i.measurement = /*measurement*/
      o[2]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function instance$1(e, t, n) {
  let o, r, i, { viewer: s } = t, { canvas: a } = t, l, d = y(), c = null;
  const m = getApi(), p = {
    maxValue: KVADRAT_CEILING_HEIGHT_MAX,
    toolTipKey: "changeCeilingHeight",
    limitExceededErrorMessage: "notificationMessageMeasurementInvalid"
    // TODO: add new label for height limit?
  }, { blueprintStore: g, i18nStore: { translate: f } } = getStores();
  component_subscribe(e, g, (A) => n(7, i = A));
  const { onNotification: h } = getApi();
  onDestroy(() => {
    c !== null && (s.get_camera_updated_observable().remove(c), c.dispose(), c = null), removeEventListener("resize", I), l.dispose();
  }), onMount(() => (c = s.get_camera_updated_observable().add(() => I()), addEventListener("resize", I), g.subscribe((A) => {
    A && I();
  })));
  function E() {
    var A, F;
    const z = l.get_2d_midpoint();
    n(
      1,
      d.x = (A = z == null ? void 0 : z.x) !== null && A !== void 0 ? A : NaN,
      d
    ), n(
      1,
      d.y = (F = z == null ? void 0 : z.y) !== null && F !== void 0 ? F : NaN,
      d
    );
  }
  function I() {
    l = updateLine(s, i.rooms, l), E();
  }
  function R(A) {
    const F = m.setCeilingHeight(A);
    F && h.emit({
      type: "error",
      title: f("notificationTitleMeasurement"),
      message: f(ERROR_CODE_TRANSLATION_KEYS[F])
    });
  }
  return e.$$set = (A) => {
    "viewer" in A && n(6, s = A.viewer), "canvas" in A && n(0, a = A.canvas);
  }, e.$$.update = () => {
    e.$$.dirty & /*$blueprintStore*/
    128 && n(3, o = ht(i.rooms[0].walls[0].height) ? i.rooms[0].walls[0].height : Number.MIN_SAFE_INTEGER);
  }, n(2, r = {
    rotation: 0,
    id: "measurement-3d-height",
    showDirectionIcons: !1,
    endpointPosition: y(),
    p1: y(),
    p2: y(),
    collidableId: "",
    onApply: R
  }), [
    a,
    d,
    r,
    o,
    p,
    g,
    s,
    i
  ];
}
class Measurement3d extends SvelteComponent {
  constructor(t) {
    super(), init(this, t, instance$1, create_fragment$1, safe_not_equal, { viewer: 6, canvas: 0 });
  }
}
const StyledText = styled(Text$2)(
  ({ theme: e }) => css`
    position: absolute;
    top: ${e.space[150]};
    left: 0;
    right: 0;
    text-align: center;
    user-select: none;
  `
), DefineRoomHeader = () => {
  const { translate: e } = useI18n();
  return /* @__PURE__ */ jsx(StyledText, { tagName: "h3", headingSize: "m", children: e("editRoomHeader") });
}, WrappedDefineRoomHeader = ({ kvadrat: e }) => /* @__PURE__ */ jsx(KvadratProviderWrapper, { kvadrat: e, children: /* @__PURE__ */ jsx(DefineRoomHeader, {}) }), ButtonWrapper = styled.div(
  ({ theme: e, $center: t }) => css`
    display: flex;
    gap: ${e.space[100]};
    justify-content: ${t ? "center" : "space-between"};
    padding: 0 ${e.space[150]} ${e.space[150]};

    @media (max-width: ${e.mediaQueries.md}) {
      justify-content: ${t ? "flex-end" : "space-between"};
    }
  `
), OnboardingButtons = ({
  className: e,
  isFirstStep: t,
  isLastStep: n,
  onNext: o,
  onPrevious: r,
  onDone: i
}) => {
  const { isMobile: s } = useBreakpoints(), { translate: a } = useI18n();
  return /* @__PURE__ */ jsxs(ButtonWrapper, { $center: t, className: e, children: [
    !t && /* @__PURE__ */ jsx(
      Button$3,
      {
        ssrIcon: ArrowLeftIcon,
        iconPosition: "leading",
        fluid: !0,
        type: "secondary",
        onClick: r,
        iconOnly: s,
        children: !s && a("onboardingPrevious")
      }
    ),
    !n && /* @__PURE__ */ jsx(
      Button$3,
      {
        ssrIcon: ArrowRightIcon,
        iconPosition: "trailing",
        fluid: !0,
        type: "primary",
        onClick: o,
        iconOnly: s,
        autoFocus: t,
        children: !s && a("onboardingNext")
      }
    ),
    n && /* @__PURE__ */ jsx(
      Button$3,
      {
        fluid: !0,
        type: "primary",
        onClick: i,
        iconOnly: s,
        ssrIcon: s ? CheckmarkIcon : void 0,
        children: !s && a("onboardingDone")
      }
    )
  ] });
}, DotWrapper = styled.div`
  width: 13px;
  height: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    > div {
      width: 13px;
      height: 13px;
    }
  }
`, Dot = styled.div(
  () => css`
    border-radius: 100px;
    transition:
      height 250ms ease-in-out,
      width 250ms ease-in-out,
      background-color 250ms ease;
  `,
  ({ $status: e, theme: t }) => ({
    active: css`
        width: 13px;
        height: 13px;
        background-color: ${t.color.accent.primary};
      `,
    visited: css`
        width: 5px;
        height: 5px;
        background-color: ${t.color.accent.primary};
      `,
    inactive: css`
        width: 5px;
        height: 5px;
        background-color: ${t.color.grey[500]};
      `
  })[e]
), Line = styled.div(
  ({ theme: e, $active: t }) => css`
    height: 1px;
    width: 74px;
    background-color: ${t ? e.color.accent.primary : e.color.grey[500]};
    margin: 0 ${e.space[25]};
  `
), Wrapper$1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`, OnboardingStepper = ({ step: e, onClickStep: t, allSteps: n }) => {
  const o = {
    first: {
      1: "active",
      2: "visited",
      3: "visited"
    },
    second: {
      1: "inactive",
      2: "active",
      3: "visited"
    },
    third: {
      1: "inactive",
      2: "inactive",
      3: "active"
    }
  };
  return /* @__PURE__ */ jsxs(Wrapper$1, { children: [
    /* @__PURE__ */ jsx(DotWrapper, { onClick: () => t(0), role: "button", "aria-label": n[0].text, "aria-current": e === 0, children: /* @__PURE__ */ jsx(Dot, { $status: o.first[e] }) }),
    /* @__PURE__ */ jsx(Line, { $active: e > 1 }),
    /* @__PURE__ */ jsx(DotWrapper, { onClick: () => t(1), role: "button", "aria-label": n[1].text, "aria-current": e === 1, children: /* @__PURE__ */ jsx(Dot, { $status: o.second[e] }) }),
    /* @__PURE__ */ jsx(Line, { $active: e > 2 }),
    /* @__PURE__ */ jsx(DotWrapper, { onClick: () => t(2), role: "button", "aria-label": n[2].text, "aria-current": e === 2, children: /* @__PURE__ */ jsx(Dot, { $status: o.third[e] }) })
  ] });
}, videos = {
  stepOne: {
    desktop: "https://www.cte.ikeadt.com/addon-app/kvadrat-preview/static-assets/videos/onboarding/desktop_step_1.webp",
    mobile: "https://www.cte.ikeadt.com/addon-app/kvadrat-preview/static-assets/videos/onboarding/mobile_step_1.webp"
  },
  stepTwo: {
    desktop: "https://www.cte.ikeadt.com/addon-app/kvadrat-preview/static-assets/videos/onboarding/desktop_step_2.webp",
    mobile: "https://www.cte.ikeadt.com/addon-app/kvadrat-preview/static-assets/videos/onboarding/mobile_step_2.webp"
  },
  stepThree: {
    desktop: "https://www.cte.ikeadt.com/addon-app/kvadrat-preview/static-assets/videos/onboarding/desktop_step_3.webp",
    mobile: "https://www.cte.ikeadt.com/addon-app/kvadrat-preview/static-assets/videos/onboarding/mobile_step_3.webp"
  }
}, useOnboarding = () => {
  const [e, t] = useState(0), { translate: n } = useI18n(), o = [
    {
      step: 1,
      title: n("onboardingMoveWallsTitle"),
      text: n("onboardingMoveWallsBody"),
      video: {
        alt: n("onboardingMoveWallsVideoAlt"),
        src: videos.stepOne.desktop,
        srcSet: `${videos.stepOne.mobile} 640w, ${videos.stepOne.desktop} 800w`,
        sizes: "(max-width: 600px) 640px, 800px"
      }
    },
    {
      step: 2,
      title: n("onboardingChangeMeasurementsTitle"),
      text: n("onboardingChangeMeasurementsBody"),
      video: {
        alt: n("onboardingChangeMeasurementsVideoAlt"),
        src: videos.stepTwo.desktop,
        srcSet: `${videos.stepTwo.mobile} 640w, ${videos.stepTwo.desktop} 800w`,
        sizes: "(max-width: 600px) 640px, 800px"
      }
    },
    {
      step: 3,
      title: n("onboardingAddACornerTitle"),
      text: n("onboardingAddACornerBody", {
        splitWallTranslation: `<strong>${n("contextmenuWallSplit")}</strong>`
      }),
      video: {
        alt: n("onboardingAddACornerVideoAlt"),
        src: videos.stepThree.desktop,
        srcSet: `${videos.stepThree.mobile} 640w, ${videos.stepThree.desktop} 800w`,
        sizes: "(max-width: 600px) 640px, 800px"
      }
    }
  ], r = o.length, i = useMemo(
    () => ({
      nextStep: () => {
        const s = Math.min(e + 1, r - 1);
        t(s);
      },
      previousStep: () => {
        const s = Math.max(e - 1, 0);
        t(s);
      },
      goToStep: (s) => {
        const a = clamp$1(s, 0, r - 1);
        t(a);
      }
    }),
    [e]
  );
  return [
    {
      ...o[e],
      isFirstStep: e === 0,
      isLastStep: e === r - 1,
      stepContents: o
    },
    i
  ];
}, Background = styled.div(
  ({ theme: e }) => css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 15;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: ${e.color.grey[500]}80;
  `
), Wrapper = styled.div(
  ({ theme: e }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    margin: 0 ${e.space[100]};
    border-radius: ${e.space[50]};
    background-color: ${e.color.white};
    width: 288px;
    min-height: 510px;
    box-shadow: ${e.shadow.sizeDefault} ${e.shadow.colour};

    @media (min-width: ${e.mediaQueries.md}) {
      width: 600px;
      min-height: 740px;
    }

    @media (max-width: ${e.mediaQueries.lg}) and (orientation: landscape),
      (max-height: ${e.mediaQueries.md}) and (orientation: landscape) {
      width: 95%;
      height: 95%;
      min-height: unset;
    }
  `
), HeaderWrapper = styled.div`
  justify-content: flex-end;
  display: flex;
  grid-area: header;

  @media (max-height: 350px) and (orientation: landscape) {
    display: none;
  }
`, ContentWrapper = styled.div(
  ({ theme: e }) => css`
    @media (max-width: ${e.mediaQueries.lg}) and (orientation: landscape),
      (max-height: ${e.mediaQueries.md}) and (orientation: landscape) {
      margin: auto 0;
      flex-direction: row;
      width: 100%;
      min-height: auto;

      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto 1fr;
      grid-template-areas:
        "header header"
        "image content";
    }
  `
), StyledImg = styled.img(
  ({ theme: e }) => css`
    width: 100%;
    aspect-ratio: 4 / 3;
    margin: auto 0;

    @media (max-width: ${e.mediaQueries.md}) and (orientation: landscape) {
      height: 168px;
      width: auto;
    }

    @media (min-width: ${e.mediaQueries.lg}) {
      height: auto;
      width: 100%;
    }
  `
), ImageWrapper = styled.div(
  ({ theme: e }) => css`
    display: flex;
    justify-content: center;

    @media (max-width: ${e.mediaQueries.lg}) and (orientation: landscape),
      (max-height: ${e.mediaQueries.md}) and (orientation: landscape) {
      grid-area: image;
    }
  `
), ProgressBarWrapper = styled.div(
  ({ theme: e }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: ${e.space[50]};
  `
), TextAndProgressWrapper = styled.div(
  ({ theme: e }) => css`
    display: flex;
    flex-direction: column;
    @media (max-width: ${e.mediaQueries.lg}) and (orientation: landscape),
      (max-height: ${e.mediaQueries.md}) and (orientation: landscape) {
      grid-area: content;
    }
  `
), TextWrapper = styled.div(
  ({ theme: e }) => css`
    display: flex;
    flex-flow: column;
    padding: ${e.space[50]} ${e.space[150]} ${e.space[150]} ${e.space[150]};
    gap: ${e.space[75]};
  `
), StyledCloseButton = styled(Button$3)`
  margin: ${(e) => e.theme.space[50]};
`, OnboardingButtonsInMobile = styled(OnboardingButtons)`
  margin-top: auto;
  padding-bottom: 0;

  @media (orientation: portrait) {
    display: none;
  }

  @media (min-height: ${theme.mediaQueries.md}) and (orientation: landscape) {
    display: none;
  }
`, OnboardingButtonsOnDesktop = styled(OnboardingButtons)`
  @media (max-height: ${theme.mediaQueries.md}) and (orientation: landscape) {
    display: none;
  }
`, OnboardingModal = () => {
  const { i18nStore: e } = useStores(), [{ step: t, title: n, text: o, video: r, isFirstStep: i, isLastStep: s, stepContents: a }, { nextStep: l, previousStep: d, goToStep: c }] = useOnboarding(), { isMobile: m } = useBreakpoints(), { userInteractionStore: p } = useStores();
  useEffect(() => {
    sendEvent(InsightsEventType.ONBOARDING_OPENED);
  }, []);
  const g = () => {
    p.setOnboarding(!1), sendEvent(InsightsEventType.ONBOARDING_CLOSED, { step: t, reason: "Closed" });
  }, f = () => {
    p.setOnboarding(!1), sendEvent(InsightsEventType.ONBOARDING_CLOSED, { step: t, reason: "Done" });
  }, h = useOutsideClick(g);
  return createPortal(
    /* @__PURE__ */ jsx(Background, { children: /* @__PURE__ */ jsxs(
      Wrapper,
      {
        ref: h,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "kvadratOnboardingTitle",
        "aria-describedby": "kvadratOnboardingDescription",
        children: [
          /* @__PURE__ */ jsxs(ContentWrapper, { children: [
            /* @__PURE__ */ jsx(HeaderWrapper, { children: /* @__PURE__ */ jsx(
              StyledCloseButton,
              {
                ssrIcon: CrossIcon,
                size: "small",
                iconOnly: !0,
                type: "tertiary",
                onClick: g,
                "aria-label": e.translate("onboardingClose")
              }
            ) }),
            /* @__PURE__ */ jsx(ImageWrapper, { children: /* @__PURE__ */ jsx(StyledImg, { ...r }) }),
            /* @__PURE__ */ jsxs(TextAndProgressWrapper, { children: [
              /* @__PURE__ */ jsx(ProgressBarWrapper, { children: /* @__PURE__ */ jsx(OnboardingStepper, { step: t, onClickStep: c, allSteps: a }) }),
              /* @__PURE__ */ jsxs(TextWrapper, { children: [
                /* @__PURE__ */ jsx(Text$2, { id: "kvadratOnboardingTitle", headingSize: m ? "s" : "m", tagName: "h2", children: n }),
                /* @__PURE__ */ jsx(
                  Text$2,
                  {
                    id: "kvadratOnboardingDescription",
                    bodySize: m ? "m" : "l",
                    dangerouslySetInnerHTML: {
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      __html: o
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(
                OnboardingButtonsInMobile,
                {
                  isFirstStep: i,
                  isLastStep: s,
                  onDone: f,
                  onNext: l,
                  onPrevious: d
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx(
            OnboardingButtonsOnDesktop,
            {
              isFirstStep: i,
              isLastStep: s,
              onDone: f,
              onNext: l,
              onPrevious: d
            }
          )
        ]
      }
    ) }),
    document.body
  );
}, WrappedOnboardingModal = ({ kvadratApi: e }) => /* @__PURE__ */ jsx(KvadratProviderWrapper, { kvadrat: e, children: /* @__PURE__ */ jsx(OnboardingModal, {}) });
function create_if_block(e) {
  let t, n;
  return t = new SkapaStyle({
    props: {
      writeDirection: (
        /*writeDirection*/
        e[9]
      ),
      isInteracting: (
        /*isInteracting*/
        e[8]
      ),
      $$slots: { default: [create_default_slot] },
      $$scope: { ctx: e }
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*writeDirection*/
      512 && (i.writeDirection = /*writeDirection*/
      o[9]), r[0] & /*isInteracting*/
      256 && (i.isInteracting = /*isInteracting*/
      o[8]), r[0] & /*api, $userInteractionStore, canvas3DSize, canvas, viewer, $editorStore, $featureFlagStore, contextMenuCoordinates, contextMenuActions, selectedCollidable, isDragging*/
      7423 | r[1] & /*$$scope*/
      512 && (i.$$scope = { dirty: r, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_6(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: ContextMenuHoc,
      kvadratApi: (
        /*api*/
        e[0]
      ),
      initialPosition: (
        /*contextMenuCoordinates*/
        e[6]
      ),
      contextMenuActions: (
        /*contextMenuActions*/
        e[10]
      ),
      onHoverContextMenuAction: (
        /*onHoverContextMenuAction*/
        e[20]
      ),
      onHoverOutContextMenuAction: (
        /*onHoverOutContextMenuAction*/
        e[21]
      ),
      executeContextMenuAction: (
        /*executeContextMenuAction*/
        e[22]
      ),
      setDraggedPosition: (
        /*setDraggedPosition*/
        e[19]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*api*/
      1 && (i.kvadratApi = /*api*/
      o[0]), r[0] & /*contextMenuCoordinates*/
      64 && (i.initialPosition = /*contextMenuCoordinates*/
      o[6]), r[0] & /*contextMenuActions*/
      1024 && (i.contextMenuActions = /*contextMenuActions*/
      o[10]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_4(e) {
  let t, n, o, r = (
    /*$editorStore*/
    e[11].editorMode === EditorMode.EDITOR_MODE_3D && !/*$userInteractionStore*/
    e[4].materialPopupOpen && !/*$userInteractionStore*/
    e[4].materialPopupVisible && create_if_block_5(e)
  );
  return n = new Editor2d({
    props: { canvas3DSize: (
      /*canvas3DSize*/
      e[7]
    ) }
  }), {
    c() {
      r && r.c(), t = space$1(), create_component(n.$$.fragment);
    },
    m(i, s) {
      r && r.m(i, s), insert(i, t, s), mount_component(n, i, s), o = !0;
    },
    p(i, s) {
      /*$editorStore*/
      i[11].editorMode === EditorMode.EDITOR_MODE_3D && !/*$userInteractionStore*/
      i[4].materialPopupOpen && !/*$userInteractionStore*/
      i[4].materialPopupVisible ? r ? (r.p(i, s), s[0] & /*$editorStore, $userInteractionStore*/
      2064 && transition_in(r, 1)) : (r = create_if_block_5(i), r.c(), transition_in(r, 1), r.m(t.parentNode, t)) : r && (group_outros(), transition_out(r, 1, 1, () => {
        r = null;
      }), check_outros());
      const a = {};
      s[0] & /*canvas3DSize*/
      128 && (a.canvas3DSize = /*canvas3DSize*/
      i[7]), n.$set(a);
    },
    i(i) {
      o || (transition_in(r), transition_in(n.$$.fragment, i), o = !0);
    },
    o(i) {
      transition_out(r), transition_out(n.$$.fragment, i), o = !1;
    },
    d(i) {
      i && detach(t), r && r.d(i), destroy_component(n, i);
    }
  };
}
function create_if_block_5(e) {
  let t, n;
  return t = new Measurement3d({
    props: {
      canvas: (
        /*canvas*/
        e[2]
      ),
      viewer: (
        /*viewer*/
        e[1]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*canvas*/
      4 && (i.canvas = /*canvas*/
      o[2]), r[0] & /*viewer*/
      2 && (i.viewer = /*viewer*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_3(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: WrappedActionMenu,
      kvadrat: (
        /*api*/
        e[0]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*api*/
      1 && (i.kvadrat = /*api*/
      o[0]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_2(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: MaterialPopupHoc,
      kvadratApi: (
        /*api*/
        e[0]
      ),
      position: (
        /*$userInteractionStore*/
        e[4].materialPopupPosition
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*api*/
      1 && (i.kvadratApi = /*api*/
      o[0]), r[0] & /*$userInteractionStore*/
      16 && (i.position = /*$userInteractionStore*/
      o[4].materialPopupPosition), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_if_block_1(e) {
  let t, n;
  return t = new ReactAdapter({
    props: {
      element: WrappedOnboardingModal,
      kvadratApi: (
        /*api*/
        e[0]
      )
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*api*/
      1 && (i.kvadratApi = /*api*/
      o[0]), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_default_slot_1(e) {
  let t, n, o, r, i, s, a, l;
  t = new ReactAdapter({
    props: {
      element: WrappedDefineRoomHeader,
      kvadrat: (
        /*api*/
        e[0]
      )
    }
  });
  let d = (
    /*$userInteractionStore*/
    e[4].contextMenuOpen && /*selectedCollidable*/
    e[3] && /*$editorStore*/
    e[11].editorMode === EditorMode.EDITOR_MODE_3D && !/*isDragging*/
    e[5] && /*contextMenuActions*/
    e[10].length > 0 && create_if_block_6(e)
  ), c = (
    /*$featureFlagStore*/
    e[12].editor2D && create_if_block_4(e)
  ), m = (
    /*enableActionMenu*/
    e[13] && create_if_block_3(e)
  ), p = (
    /*$userInteractionStore*/
    e[4].allowMaterialPopup && create_if_block_2(e)
  ), g = (
    /*$userInteractionStore*/
    e[4].onboarding && create_if_block_1(e)
  );
  return {
    c() {
      create_component(t.$$.fragment), n = space$1(), d && d.c(), o = space$1(), c && c.c(), r = space$1(), m && m.c(), i = space$1(), p && p.c(), s = space$1(), g && g.c(), a = empty();
    },
    m(f, h) {
      mount_component(t, f, h), insert(f, n, h), d && d.m(f, h), insert(f, o, h), c && c.m(f, h), insert(f, r, h), m && m.m(f, h), insert(f, i, h), p && p.m(f, h), insert(f, s, h), g && g.m(f, h), insert(f, a, h), l = !0;
    },
    p(f, h) {
      const E = {};
      h[0] & /*api*/
      1 && (E.kvadrat = /*api*/
      f[0]), t.$set(E), /*$userInteractionStore*/
      f[4].contextMenuOpen && /*selectedCollidable*/
      f[3] && /*$editorStore*/
      f[11].editorMode === EditorMode.EDITOR_MODE_3D && !/*isDragging*/
      f[5] && /*contextMenuActions*/
      f[10].length > 0 ? d ? (d.p(f, h), h[0] & /*$userInteractionStore, selectedCollidable, $editorStore, isDragging, contextMenuActions*/
      3128 && transition_in(d, 1)) : (d = create_if_block_6(f), d.c(), transition_in(d, 1), d.m(o.parentNode, o)) : d && (group_outros(), transition_out(d, 1, 1, () => {
        d = null;
      }), check_outros()), /*$featureFlagStore*/
      f[12].editor2D ? c ? (c.p(f, h), h[0] & /*$featureFlagStore*/
      4096 && transition_in(c, 1)) : (c = create_if_block_4(f), c.c(), transition_in(c, 1), c.m(r.parentNode, r)) : c && (group_outros(), transition_out(c, 1, 1, () => {
        c = null;
      }), check_outros()), /*enableActionMenu*/
      f[13] && m.p(f, h), /*$userInteractionStore*/
      f[4].allowMaterialPopup ? p ? (p.p(f, h), h[0] & /*$userInteractionStore*/
      16 && transition_in(p, 1)) : (p = create_if_block_2(f), p.c(), transition_in(p, 1), p.m(s.parentNode, s)) : p && (group_outros(), transition_out(p, 1, 1, () => {
        p = null;
      }), check_outros()), /*$userInteractionStore*/
      f[4].onboarding ? g ? (g.p(f, h), h[0] & /*$userInteractionStore*/
      16 && transition_in(g, 1)) : (g = create_if_block_1(f), g.c(), transition_in(g, 1), g.m(a.parentNode, a)) : g && (group_outros(), transition_out(g, 1, 1, () => {
        g = null;
      }), check_outros());
    },
    i(f) {
      l || (transition_in(t.$$.fragment, f), transition_in(d), transition_in(c), transition_in(m), transition_in(p), transition_in(g), l = !0);
    },
    o(f) {
      transition_out(t.$$.fragment, f), transition_out(d), transition_out(c), transition_out(m), transition_out(p), transition_out(g), l = !1;
    },
    d(f) {
      f && (detach(n), detach(o), detach(r), detach(i), detach(s), detach(a)), destroy_component(t, f), d && d.d(f), c && c.d(f), m && m.d(f), p && p.d(f), g && g.d(f);
    }
  };
}
function create_default_slot(e) {
  let t, n;
  return t = new KeyboardEventListener({
    props: {
      $$slots: { default: [create_default_slot_1] },
      $$scope: { ctx: e }
    }
  }), {
    c() {
      create_component(t.$$.fragment);
    },
    m(o, r) {
      mount_component(t, o, r), n = !0;
    },
    p(o, r) {
      const i = {};
      r[0] & /*api, $userInteractionStore, canvas3DSize, canvas, viewer, $editorStore, $featureFlagStore, contextMenuCoordinates, contextMenuActions, selectedCollidable, isDragging*/
      7423 | r[1] & /*$$scope*/
      512 && (i.$$scope = { dirty: r, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (transition_in(t.$$.fragment, o), n = !0);
    },
    o(o) {
      transition_out(t.$$.fragment, o), n = !1;
    },
    d(o) {
      destroy_component(t, o);
    }
  };
}
function create_fragment(e) {
  let t, n, o = (
    /*$editorStore*/
    e[11].open && create_if_block(e)
  );
  return {
    c() {
      o && o.c(), t = empty();
    },
    m(r, i) {
      o && o.m(r, i), insert(r, t, i), n = !0;
    },
    p(r, i) {
      /*$editorStore*/
      r[11].open ? o ? (o.p(r, i), i[0] & /*$editorStore*/
      2048 && transition_in(o, 1)) : (o = create_if_block(r), o.c(), transition_in(o, 1), o.m(t.parentNode, t)) : o && (group_outros(), transition_out(o, 1, 1, () => {
        o = null;
      }), check_outros());
    },
    i(r) {
      n || (transition_in(o), n = !0);
    },
    o(r) {
      transition_out(o), n = !1;
    },
    d(r) {
      r && detach(t), o && o.d(r);
    }
  };
}
const activeRoomIndex = 0;
function instance(e, t, n) {
  let o, r, i, s, a, l, d, c, m, p, g;
  var f, h, E;
  let { api: I } = t, { storesContext: R } = t, { viewer: A } = t, { canvas: F } = t;
  const z = (f = R.configurationStore.get().uiOptions) === null || f === void 0 ? void 0 : f.enableActionMenu, { editorStore: ne, i18nStore: k, featureFlagStore: q, userInteractionStore: X, themeStore: ae } = R;
  component_subscribe(e, ne, (Y) => n(11, p = Y)), component_subscribe(e, k, (Y) => n(27, c = Y)), component_subscribe(e, q, (Y) => n(12, g = Y)), component_subscribe(e, X, (Y) => n(4, d = Y)), component_subscribe(e, ae, (Y) => n(33, m = Y)), FontLoader.loadFont(m), setStores(R), setApi(I);
  const { dragAndDropPolyfill: ve } = q.get();
  ve && polyfill({
    dragImageSetup: (Y) => {
      const Me = Y.cloneNode(!0);
      return Me.style.pointerEvents = "none", Me;
    },
    iterationInterval: 20
  }), X.setOnboarding(JSON.parse(window.localStorage.getItem(ONBOARDING_SESSION_KEY) || "true"));
  let De, Le, ue, le, we, ee;
  function W() {
    if (ee)
      n(6, we = ee);
    else if (ue && le) {
      const Y = U(ue, le), Me = A.project_world_position_to_canvas(Y.x, Y.y, Y.z);
      Me && n(6, we = ge.add(Me, { x: 5, y: 5 }));
    }
  }
  onMount(() => {
    const Y = A.get_camera_updated_observable(), Me = Y.add(() => {
      d.contextMenuOpen && W();
    });
    return () => {
      Y.remove(Me);
    };
  });
  function Z() {
    n(7, a = {
      width: F.width,
      height: F.height
    });
  }
  onMount(() => {
    const Y = mutationObserver(F, {
      callback: Z,
      options: {
        attributes: !0,
        attributeFilter: ["width", "height"]
      }
    });
    return () => Y.destroy();
  });
  function he(Y) {
    n(5, Le = !0), De = y(Y.clientX, Y.clientY);
  }
  function Ce(Y) {
    o || (ee = void 0), n(5, Le = !1);
    const Me = y(Y.clientX, Y.clientY);
    if (ge.length(ge.sub(De, Me)) < 5) {
      ee = void 0;
      const qe = A.raycast_object_using_canvas_coordinate(De.x, De.y);
      qe && (ue = A.get_position(qe.object), le = $(qe.world_position, ue)), o && X.setIsContextMenuOpen(!0);
    }
    W();
  }
  onMount(() => (F.addEventListener("pointerdown", he), F.addEventListener("pointerup", Ce), () => {
    F.addEventListener("pointerdown", he), F.removeEventListener("pointerup", Ce);
  }));
  function de() {
    X.setIsContextMenuOpen(!1), X.clearHoveredCollidableId();
  }
  function ye(Y) {
    ee = Y;
  }
  function Ae(Y) {
    if (o)
      return () => {
        var Me;
        (Me = Y.onHover) === null || Me === void 0 || Me.call(Y, u(0, 0, 0));
      };
  }
  function He(Y) {
    if (o)
      return () => {
        var Me;
        (Me = Y.onHoverOut) === null || Me === void 0 || Me.call(Y);
      };
  }
  function be(Y) {
    if (o)
      return () => {
        X.setIsContextMenuOpen(!1), Y.action(u(0, 0, 0)) && de();
      };
  }
  return e.$$set = (Y) => {
    "api" in Y && n(0, I = Y.api), "storesContext" in Y && n(23, R = Y.storesContext), "viewer" in Y && n(1, A = Y.viewer), "canvas" in Y && n(2, F = Y.canvas);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*$userInteractionStore*/
    16 && n(3, o = d.selectedCollidable), e.$$.dirty[0] & /*api, storesContext*/
    8388609 && n(26, r = createEditorActions(I, R)), e.$$.dirty[0] & /*selectedCollidable, actions*/
    67108872 && n(10, i = o ? r[o.type].getContextMenuActions(activeRoomIndex, o) : []), e.$$.dirty[0] & /*$i18nStore, _b, _c*/
    184549376 && n(9, s = (n(25, E = n(24, h = c == null ? void 0 : c.localizedInformation) === null || h === void 0 ? void 0 : h.localisation) === null || E === void 0 ? void 0 : E.writeDirection) || "ltr"), e.$$.dirty[0] & /*canvas*/
    4 && n(7, a = {
      width: F.width,
      height: F.height
    }), e.$$.dirty[0] & /*$userInteractionStore*/
    16 && n(8, l = d.panning || d.dragging || d.isPointerPressed);
  }, [
    I,
    A,
    F,
    o,
    d,
    Le,
    we,
    a,
    l,
    s,
    i,
    p,
    g,
    z,
    ne,
    k,
    q,
    X,
    ae,
    ye,
    Ae,
    He,
    be,
    R,
    h,
    E,
    r,
    c
  ];
}
class KvadratUI extends SvelteComponent {
  constructor(t) {
    super(), init(
      this,
      t,
      instance,
      create_fragment,
      safe_not_equal,
      {
        api: 0,
        storesContext: 23,
        viewer: 1,
        canvas: 2
      },
      null,
      [-1, -1]
    );
  }
}
function getRecommendedLights(e) {
  const t = getCeilingHeights(e), n = Math.min(...t), o = getWallsInConnectedOrder(e).map((a) => [a.p1.x, a.p1.z]), r = polylabel([o]), i = u(r[0], n, r[1]), s = e.walls.map(
    (a) => Pe(asVec2(e.corners[a.leftIndex]), asVec2(e.corners[a.rightIndex]), asVec2(i))
  );
  return [
    {
      position: i,
      distanceToNearestWall: Math.min(...s),
      distanceToFurthestWall: Math.max(...s),
      distanceToFloor: n
    }
  ];
}
const deferredQueue = createDeferredQueue();
function decorateAtomicWithEmitter(e, t) {
  return (...n) => {
    const o = deferredQueue.next().value;
    t.emit(o.promise);
    const r = e.call(null, ...n);
    return isErrorCode(r) ? o.reject() : o.resolve(), r;
  };
}
function decorateSplitFlowWithEmitter(e, t, n, o = !1) {
  let r;
  return [(...a) => ((!r || !r.pending) && (r = deferredQueue.next().value, n.emit(r.promise)), e.call(null, ...a)), (...a) => {
    if (o && !r && (r = deferredQueue.next().value, n.emit(r.promise)), !r)
      throw new Error("Attempt to close a snapshot flow that has not been opened.");
    const l = t.call(null, ...a);
    return isErrorCode(l) ? r == null || r.reject() : r == null || r.resolve(), l;
  }];
}
class Deferred {
  constructor() {
    C(this, "promise");
    C(this, "_resolve", () => ({}));
    C(this, "_reject", () => ({}));
    C(this, "_pending", !0);
    this.promise = new Promise((t, n) => {
      this._resolve = () => {
        t(), this._pending = !1;
      }, this._reject = () => {
        n(), this._pending = !1;
      };
    });
  }
  get resolve() {
    return this._resolve;
  }
  get reject() {
    return this._reject;
  }
  get pending() {
    return this._pending;
  }
}
function* createDeferredQueue() {
  let e = null;
  for (; ; )
    e != null && e.pending && e.reject("aborted"), yield e = new Deferred();
}
function injectBeforeEmitters(e, t) {
  return e.addWallFeatureToClosestWall = decorateAtomicWithEmitter(e.addWallFeatureToClosestWall, t), e.updateWallFeature = decorateAtomicWithEmitter(e.updateWallFeature, t), [e.updateSetCeilingHeight, e.endSetCeilingHeight] = decorateSplitFlowWithEmitter(
    e.updateSetCeilingHeight,
    e.endSetCeilingHeight,
    t
  ), [e.updateMoveWall, e.endMoveWall] = decorateSplitFlowWithEmitter(
    e.updateMoveWall,
    e.endMoveWall,
    t
  ), [e.updateMoveCorner, e.endMoveCorner] = decorateSplitFlowWithEmitter(
    e.updateMoveCorner,
    e.endMoveCorner,
    t
  ), [e.deleteWallFeatureDuring2dMove, e.addWallFeature] = decorateSplitFlowWithEmitter(
    e.deleteWallFeatureDuring2dMove,
    e.addWallFeature,
    t,
    !0
  ), e.setBlueprint = function() {
    const n = decorateAtomicWithEmitter(e.setBlueprint, t), o = e.setBlueprint;
    return function(i, s, a) {
      return s === !1 ? o(i, !1, a) : n(i, s, a);
    };
  }(), e.setCeilingHeight = function() {
    const n = decorateAtomicWithEmitter(e.setCeilingHeight, t), o = e.setCeilingHeight;
    return function(i, s) {
      return s === !1 ? o(i, !1) : n(i, s);
    };
  }(), e.resizeWall = function() {
    const n = decorateAtomicWithEmitter(e.resizeWall, t), o = e.resizeWall;
    return function(i, s, a, l) {
      return l === !0 ? o(i, s, a, !1) : n(i, s, a, l);
    };
  }(), e.moveWall = function() {
    const n = decorateAtomicWithEmitter(e.moveWall, t), o = e.moveWall;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.splitWall = function() {
    const n = decorateAtomicWithEmitter(e.splitWall, t), o = e.splitWall;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.moveCorner = function() {
    const n = decorateAtomicWithEmitter(e.moveCorner, t), o = e.moveCorner;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.deleteCorner = function() {
    const n = decorateAtomicWithEmitter(e.deleteCorner, t), o = e.deleteCorner;
    return function(i, s) {
      return s === !1 ? o(i, !1) : n(i, s);
    };
  }(), e.updateWallFeaturePosition = function() {
    const n = decorateAtomicWithEmitter(e.updateWallFeaturePosition, t), o = e.updateWallFeaturePosition;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.deleteWallFeature = function() {
    const n = decorateAtomicWithEmitter(e.deleteWallFeature, t), o = e.deleteWallFeature;
    return function(i, s) {
      return s === !1 ? o(i, !1) : n(i, s);
    };
  }(), e.setDoorHandleSide = function() {
    const n = decorateAtomicWithEmitter(e.setDoorHandleSide, t), o = e.setDoorHandleSide;
    return function(i, s, a = !0) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.setOpeningDirection = function() {
    const n = decorateAtomicWithEmitter(e.setOpeningDirection, t), o = e.setOpeningDirection;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.applyMaterialToWall = function() {
    const n = decorateAtomicWithEmitter(e.applyMaterialToWall, t), o = e.applyMaterialToWall;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.applyMaterialToFloor = function() {
    const n = decorateAtomicWithEmitter(e.applyMaterialToFloor, t), o = e.applyMaterialToFloor;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.applyMaterialToCeiling = function() {
    const n = decorateAtomicWithEmitter(e.applyMaterialToCeiling, t), o = e.applyMaterialToCeiling;
    return function(i, s, a) {
      return a === !1 ? o(i, s, !1) : n(i, s, a);
    };
  }(), e.applyMaterialToAllWalls = function() {
    const n = decorateAtomicWithEmitter(e.applyMaterialToAllWalls, t), o = e.applyMaterialToAllWalls;
    return function(i, s) {
      return s === !1 ? o(i, !1) : n(i, s);
    };
  }(), e.applyMaterialToAllFloors = function() {
    const n = decorateAtomicWithEmitter(e.applyMaterialToAllFloors, t), o = e.applyMaterialToAllFloors;
    return function(i, s) {
      return s === !1 ? o(i, !1) : n(i, s);
    };
  }(), e.applyMaterialToAllCeilings = function() {
    const n = decorateAtomicWithEmitter(e.applyMaterialToAllCeilings, t), o = e.applyMaterialToAllCeilings;
    return function(i, s) {
      return s === !1 ? o(i, !1) : n(i, s);
    };
  }(), e;
}
function createKvadrat(e, t) {
  return new Kvadrat(e, t);
}
class Kvadrat {
  constructor({ core: t, renderer: n, canvas: o, insightsApi: r, ...i }, s) {
    C(this, "dexf");
    C(this, "unsubscribeBlueprintChange");
    C(this, "unsubscribeBlueprintCompoundChange");
    C(this, "unsubscribeSelectedCollidableStore");
    C(this, "viewerAdapter");
    C(this, "generator");
    C(this, "editor3d");
    C(this, "saveCache");
    C(this, "customComponentDeserializer", new KvadratOnlyComponentDeserializer());
    C(this, "storesContext");
    C(this, "cameraActions");
    /*
      wrap the actual changing of editor mode in changeEditorMode,
      to allow setEditorMode to be spammed without pointless history snapshots.
    */
    C(this, "changeEditorMode");
    C(this, "rootComponent");
    C(this, "trackAppliedMaterials", {
      floors: 0,
      walls: 0,
      ceilings: 0
    });
    C(this, "rawBlueprintStore");
    C(this, "core");
    C(this, "onBeforeRoomChange", new EventEmitter());
    C(this, "onBeforeEditorModeChange", new EventEmitter());
    C(this, "onKvadratReady", new EventEmitter());
    C(this, "onNotification", new EventEmitter());
    var c, m;
    this.core = t, this.core.services.sceneManager.root.addComponent(new EditorModeComponent(EditorMode.EDITOR_MODE_2D, "top-down")), this.core.services.componentDeserializerRegistry.register(this.customComponentDeserializer), this.storesContext = this.createStores(i, t, n), this.syncUserInteractionStoreWithCoreState();
    const a = this.storesContext.configurationStore.get();
    this.dexf = new Dexf(a.dexfBaseUrl, a.dexfApiKey, a.dexfAppName), this.generator = new $e(), this.viewerAdapter = new ViewerAdapter({
      viewer: n,
      canvas: o,
      generator: this.generator,
      stores: this.storesContext,
      materialDefaults: a.materialDefaults
    }), this.viewerAdapter.onMeshCreated.subscribe((p) => {
      const g = this.viewerAdapter.getMetadata(p);
      if (!g)
        return;
      const f = findEntityByKvadratId(g.kvadID, t.services.entityManager);
      switch (g.type) {
        case tn.FLOOR: {
          f == null || f.addComponent(new CustomMeshComponent(p));
          return;
        }
        case tn.CEILING: {
          f == null || f.addComponent(new CustomMeshComponent(p, void 0, new Vector(180, 0, 0)));
          return;
        }
        case tn.WALL: {
          f == null || f.addComponent(new CustomMeshComponent(p, new Vector(-0.5, 0, 0.5), new Vector(-90, 0, 0)));
          return;
        }
        case tn.THICKNESS:
        case tn.WALL_HOLE_SIDE: {
          this.addThicknessComponents(g, p, t.services.entityManager);
          return;
        }
      }
    }), (isString(s) ? this.loadBlueprintFromDexf(s, !1) : Promise.resolve(this.createCuboidRoom(s, void 0, !1))).then(
      () => (
        // Reset the last saved state of the room with the current room
        this.storesContext.blueprintStore.setSavedState(this.storesContext.blueprintStore.get())
      )
    ).finally(() => {
      this.unsubscribeBlueprintChange = this.storesContext.blueprintStore.subscribe(
        this.onBlueprintChange.bind(this)
      ), this.onKvadratReady.emit();
    }), this.cameraActions = new CameraActions(n, this.viewerAdapter, this.storesContext), this.editor3d = new Editor3d(this.viewerAdapter, this.cameraActions, this.storesContext, o, this), this.storesContext.editorStore.setEditorMode(
      (c = a.enabledFeatures) != null && c.editor2D ? EditorMode.EDITOR_MODE_2D : EditorMode.EDITOR_MODE_3D
    );
    const d = new EditorModeCameraAdaptionSystem(
      this.cameraActions,
      this.storesContext.editorStore
    );
    (m = this.rawBlueprintStore) == null || m.registerSystem(d), this.changeEditorMode = decorateAtomicWithEmitter(
      (p, g, f) => {
        t.services.sceneManager.root.addComponent(new EditorModeComponent(p, g, f));
      },
      this.onBeforeEditorModeChange
    ), this.rootComponent = new KvadratUI({
      target: o.parentElement,
      props: {
        api: this,
        storesContext: this.storesContext,
        canvas: o,
        viewer: n
      }
    }), this.saveCache = {
      lastSavedRoom: "no save yet",
      roomConfigCode: "NOCODE"
    }, connectAnalytics(
      a.analytics,
      r,
      a.locale,
      !!a.useProxy,
      a.proxyUrl
    ), sendEvent(
      InsightsEventType.INITIALIZE_KVADRAT,
      {
        enabledFeatures: a.enabledFeatures
      },
      IpexMomentEnum.nonInteraction
    );
  }
  createStores(t, n, o) {
    const r = createConfigurationStore(t), i = _e(), { proxyUrl: s } = r.get();
    this.rawBlueprintStore = createCoreStore(n, o);
    const a = injectBeforeEmitters(this.rawBlueprintStore, this.onBeforeRoomChange), l = createBlueprintStore(i), d = createEditorStore(n), c = createThemeStore(s), m = createI18nStore(
      {
        locale: t.locale
      },
      s,
      t.dexfApiKey,
      t.dexfAppName,
      fetchLocalizations
    ), p = createFeatureFlagStore(r), g = createCollidablesStore(a, p), f = createUserInteractionStore(g), h = createDecoratedRoomStore(a), E = createCanvasStore(h, f), I = createShortcutStore(), R = createSelectedCollidableStore(f), A = new UpdateUserInteractionSystem(f);
    return this.rawBlueprintStore.registerSystem(A), {
      blueprintStore: a,
      blueprintStorePreview: l,
      canvasStore: E,
      collidablesStore: g,
      configurationStore: r,
      decoratedRoomStore: h,
      editorStore: d,
      featureFlagStore: p,
      i18nStore: m,
      selectedCollidableStore: R,
      shortcutStore: I,
      themeStore: c,
      userInteractionStore: f
      // Initialize more stores here
    };
  }
  syncUserInteractionStoreWithCoreState() {
    let t;
    this.unsubscribeSelectedCollidableStore = this.storesContext.selectedCollidableStore.subscribe(
      (n) => {
        if (t && t !== n) {
          const r = findEntityByKvadratId(t, this.core.services.entityManager);
          r && r.removeComponent(ComponentIds.SELECTED_COMPONENT_ID);
        }
        if (!n)
          return;
        t = n;
        const o = findEntityByKvadratId(n, this.core.services.entityManager);
        o && o.addComponent(new SelectedComponent());
      }
    );
  }
  addThicknessComponents(t, n, o) {
    var r;
    if ((r = t.mesh) != null && r.parent) {
      const i = findEntityByKvadratId(t.mesh.parent, o);
      if (!i)
        return;
      const s = createOrFindEntity(void 0, t.type + t.kvadID, o);
      s.addComponent(new WallThicknessComponent()), s.addComponent(new UnserializableEntityComponent()), TransformUtils.setWorldTransform(
        s,
        new Transform(
          new Vector(t.mesh.position.x, t.mesh.position.y, t.mesh.position.z).times(1e3),
          MathUtils.quaternionFromEulerRadians(
            t.mesh.rotation.x,
            t.mesh.rotation.y,
            t.mesh.rotation.z
          )
        )
      ), HierarchyUtils.setParentMaintainTransform(s, i), s.addComponent(new CustomMeshComponent(n));
    }
  }
  /**
   * Open the Kvadrat editor.
   */
  async open() {
    var t, n;
    await this.editor3d.open(), this.core.services.sceneManager.root.addComponent(new KvadratActiveComponent()), this.storesContext.editorStore.setOpen(!0), this.storesContext.shortcutStore.setEnabled(!0), sendEvent(
      InsightsEventType.OPEN_KVADRAT,
      {
        schema: this.storesContext.blueprintStore.get(),
        metricMeasurements: this.storesContext.configurationStore.get().measurementSystem === "metric"
      },
      IpexMomentEnum.nonInteraction
    ), (n = (t = this.storesContext.configurationStore.get()).onAfterKvadratOpen) == null || n.call(t);
  }
  /**
   * Close the Kvadrat editor.
   */
  async close() {
    var c, m;
    const { blueprintStore: t, configurationStore: n, editorStore: o, shortcutStore: r } = this.storesContext;
    o.setOpen(!1), r.setEnabled(!1), await this.editor3d.close();
    const i = this.cameraActions.popCamera();
    removeKvadratActiveComponent(this.core.services.sceneManager.root);
    const s = t.getDecoratedRooms(), a = wallsWithNonPerpendicularAngles(s), l = getWallFeatureCollidables(s[0].walls);
    let d = (p) => l.filter((g) => g.entity.type === p).length;
    sendEvent(InsightsEventType.CLOSE_KVADRAT, {
      schema: t.get(),
      nonPerpendicularWalls: a,
      nonPerpendicularWallCount: a.length,
      roomAreaSquareMeters: getSquareMeters(s[0]),
      wallCount: s[0].walls.length,
      windowCount: d(Lt.WINDOW),
      doorCount: d(Lt.DOOR),
      appliedWallMaterialCount: this.trackAppliedMaterials.walls,
      appliedFloorMaterialCount: this.trackAppliedMaterials.floors,
      appliedCeilingMaterialCount: this.trackAppliedMaterials.ceilings
    }), this.trackAppliedMaterials = {
      walls: 0,
      floors: 0,
      ceilings: 0
    }, (m = (c = n.get()).onAfterKvadratClose) == null || m.call(c), await i;
  }
  isOpen() {
    return this.storesContext.editorStore.get().open;
  }
  /**
   * Create a cuboid room from dimensions
   * @param dimensions - The dimensions in millimeters
   * @param position - The center coordinates of the room
   * @param commit - Passing true will trigger the onBeforeRoomChange (Default is true)
   */
  createCuboidRoom(t, n, o = !0) {
    const r = generateCuboidBlueprint(t, n, void 0);
    return this.setBlueprint(r, o), HierarchyUtils.findInHierarchy(this.core.services.sceneManager.root, hasRoomComponent) ?? null;
  }
  /**
   * Add a wall feature to a specific wall
   * @throws ValidationError
   * @param wallId
   * @param wallFeature
   * @param interactionType Specifies what triggered the action, if it was user initiated or not
   * @returns The wallfeature added
   */
  addWallFeature(t, n, o) {
    var i;
    const r = this.storesContext.blueprintStore.addWallFeature(t, n);
    return !isErrorCode(r) && this.getEditorMode() === EditorMode.EDITOR_MODE_2D && this.isOpen() && ((i = findEntityByKvadratId(r.id, this.core.services.entityManager)) == null || i.removeComponent(
      ComponentIds.RENDERED_COMPONENT_ID
    )), sendEvent(n.id ? InsightsEventType.MOVE_WALL_FEATURE : InsightsEventType.ADD_WALL_FEATURE, {
      wallFeature: n,
      wallFeatureType: n.type,
      schema: this.storesContext.blueprintStore.get(),
      editorMode: this.storesContext.editorStore.getEditorMode(),
      interaction: o && InsightsInteractionType[o]
    }), r;
  }
  addWallFeatureToClosestWall(t) {
    const n = this.storesContext.blueprintStore.addWallFeatureToClosestWall(t);
    if (!isErrorCode(n)) {
      const o = findEntityByKvadratId(n.id, this.core.services.entityManager);
      o && (o.addComponent(new SelectedComponent()), this.getEditorMode() === EditorMode.EDITOR_MODE_2D && this.isOpen() && o.removeComponent(ComponentIds.RENDERED_COMPONENT_ID)), sendEvent(InsightsEventType.ADD_WALL_FEATURE, {
        wallFeature: t,
        wallFeatureType: t.type,
        schema: this.storesContext.blueprintStore.get(),
        editorMode: this.storesContext.editorStore.getEditorMode(),
        interaction: InsightsInteractionType[InsightsInteractionType.CLICKED]
      });
    }
    return n;
  }
  updateWallFeature(t, n) {
    return this.storesContext.blueprintStore.updateWallFeature(t, n);
  }
  updateWallFeaturePosition(t, n) {
    return this.storesContext.blueprintStore.updateWallFeaturePosition(t, n);
  }
  resizeWallFeature(t, n, o) {
    return this.storesContext.blueprintStore.updateWallFeature(
      t,
      {
        size: n
      },
      o
    );
  }
  setDoorHandleSide(t, n) {
    const o = this.storesContext.blueprintStore.setDoorHandleSide(t, n);
    return isErrorCode(o) || sendEvent(InsightsEventType.UPDATE_DOOR_HANDLE_LOCATION, {
      handleLocation: n,
      editorMode: this.getEditorMode(),
      kvadratActive: this.isOpen()
    }), o;
  }
  setOpeningDirection(t, n) {
    const o = this.storesContext.blueprintStore.setOpeningDirection(t, n);
    return isErrorCode(o) || sendEvent(InsightsEventType.UPDATE_DOOR_OPENING_DIRECTION, {
      openingDirection: n,
      editorMode: this.getEditorMode(),
      kvadratActive: this.isOpen()
    }), o;
  }
  resizeWallAndAutoZoom(t, n, o) {
    const { blueprintStore: r, userInteractionStore: i, i18nStore: s } = this.storesContext, a = r.resizeWall(t, n, o);
    a && this.onNotification.emit({
      type: "error",
      title: s.translate("notificationTitleInvalidRoomShape"),
      message: s.translate(ERROR_CODE_TRANSLATION_KEYS[a])
    }), autoZoomCenterCanvas(i, r.getDecoratedRooms(), this.viewerAdapter.getCanvas());
  }
  /**
   * Sets the given Blueprint.
   * @param blueprint
   * @param commit
   * @param ipexMoment
   */
  setBlueprint(t, n = !0, o) {
    if (this.storesContext.blueprintStore.setBlueprint(migrate(t), n, o), hideAwayFacingSurfaces(getCameraEntityPosition(this.core.services.sceneManager), this.core.services.sceneManager), !this.isOpen()) {
      const { scene: r } = this.core.services.sceneManager;
      getDescendantsWithShouldBeInteractable(r).forEach((i) => {
        i.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID), i.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
      });
    }
  }
  /**
   * Returns the current Blueprint.
   * @returns
   */
  getBlueprint() {
    return this.storesContext.blueprintStore.get();
  }
  /**
   * Saves the current Blueprint to DEXF, returning a roomConfigCode.
   * @returns A roomConfigCode for the saved Blueprint.
   */
  async saveBlueprintToDexf() {
    const t = this.getBlueprint(), n = JSON.stringify(t);
    if (n === this.saveCache.lastSavedRoom)
      return this.saveCache.roomConfigCode;
    const o = await this.dexf.saveConfiguration(t), { versionMajor: r, versionMinor: i, rooms: s } = t, a = s.map((d) => ({
      corners: d.walls.length,
      squareMeters: getSquareMeters(d),
      wallHeights: d.walls.map((c) => c.height)
    })), l = {
      version: `${r}.${i}`,
      rooms: a
    };
    return this.saveCache.lastSavedRoom = n, this.saveCache.roomConfigCode = o, sendEvent(InsightsEventType.SAVE, l), o;
  }
  /**
   * Loads a blueprint from DEXF using a roomConfigCode.
   * @param roomConfigCode roomConfigCode for the space.
   * @param commit Whether to commit the loaded blueprint to the saved state
   */
  async loadBlueprintFromDexf(t, n = !0) {
    const o = await this.dexf.loadConfiguration(t);
    this.setBlueprint(o, n), this.saveCache.lastSavedRoom = JSON.stringify(o), this.saveCache.roomConfigCode = t, await this.cameraActions.reCenterView();
  }
  /**
   * Set the height of the room
   * @param height height in meters
   * @param commit Whether to commit the change to the saved state
   */
  setCeilingHeight(t, n = !0) {
    return this.storesContext.blueprintStore.setCeilingHeight(t, n);
  }
  /**
   * Returns the ceiling height of the room.
   * @returns The ceiling height.
   */
  getCeilingHeight() {
    return this.storesContext.blueprintStore.getCeilingHeight();
  }
  /**
   * Set the canvas to be centered
   * @deprecated This method is being deprecated in favour of reCenterView
   */
  setCanvasCenter() {
    this.reCenterView();
  }
  /**
   * Centers the room into view
   */
  reCenterView() {
    this.cameraActions.reCenterView();
  }
  frameSelectedTarget() {
    return this.cameraActions.frameSelectedTarget();
  }
  /**
   * Zoom in the camera
   */
  zoomIn() {
    this.storesContext.userInteractionStore.get().onboarding && (sendEvent(InsightsEventType.ONBOARDING_CLOSED, {
      closeType: InsightsInteractionType[InsightsInteractionType.ZOOM_BUTTON_IN]
    }), this.storesContext.userInteractionStore.setOnboarding(!1)), this.cameraActions.zoomIn();
  }
  /**
   * Zoom out the camera
   */
  zoomOut() {
    this.storesContext.userInteractionStore.get().onboarding && (sendEvent(InsightsEventType.ONBOARDING_CLOSED, {
      closeType: InsightsInteractionType.ZOOM_BUTTON_OUT
    }), this.storesContext.userInteractionStore.setOnboarding(!1)), this.cameraActions.zoomOut();
  }
  /**
   * Toggle between the 2D and 3D editor modes
   */
  toggleEditorMode() {
    this.setEditorMode(
      this.getEditorMode() === EditorMode.EDITOR_MODE_2D ? EditorMode.EDITOR_MODE_3D : EditorMode.EDITOR_MODE_2D
    );
  }
  /**
   * Toggle between the 2D and 3D editor modes
   */
  async setEditorMode(t, n, o = !1) {
    const r = t === EditorMode.EDITOR_MODE_2D ? "top-down" : "front-angled", { userInteractionStore: i } = this.storesContext;
    if (i.setIsContextMenuOpen(!1), i.setIsMaterialPopupOpen(!1), this.getEditorMode() === t) {
      this.core.services.sceneManager.root.addComponent(
        new EditorModeComponent(t, n ?? r, o)
      ), sendEvent(InsightsEventType.EDITOR_MODE, { editorMode: t });
      return;
    }
    this.changeEditorMode(t, n ?? r, o), sendEvent(InsightsEventType.EDITOR_MODE, { editorMode: t });
  }
  getEditorMode() {
    return this.storesContext.editorStore.getEditorMode();
  }
  /**
   * Update position of canvas based on panning offset
   * @param offset How far from original position - on canvas, onpanmove event.detail
   */
  pan(t) {
    this.storesContext.userInteractionStore.pan(t);
  }
  getWallById(t) {
    return this.storesContext.blueprintStore.getDecoratedWallById(t);
  }
  getWallByFeatureId(t) {
    return this.storesContext.blueprintStore.getDecoratedWallByFeatureId(t);
  }
  getWallFeatureById(t) {
    return this.storesContext.blueprintStore.getDecoratedWallFeatureById(t);
  }
  applyMaterialToWall(t, n, o = !0) {
    return o && this.trackAppliedMaterials.walls++, this.storesContext.blueprintStore.applyMaterialToWall(t, n, o);
  }
  applyMaterialToFloor(t, n, o = !0) {
    return o && this.trackAppliedMaterials.floors++, this.storesContext.blueprintStore.applyMaterialToFloor(t, n, o);
  }
  applyMaterialToCeiling(t, n, o = !0) {
    return o && this.trackAppliedMaterials.ceilings++, this.storesContext.blueprintStore.applyMaterialToCeiling(t, n, o);
  }
  applyMaterialToAllWalls(t, n = !0) {
    return n && this.trackAppliedMaterials.walls++, this.storesContext.blueprintStore.applyMaterialToAllWalls(t, n);
  }
  applyMaterialToAllFloors(t, n = !0) {
    return n && this.trackAppliedMaterials.floors++, this.storesContext.blueprintStore.applyMaterialToAllFloors(t, n);
  }
  applyMaterialToAllCeilings(t, n = !0) {
    return n && this.trackAppliedMaterials.ceilings++, this.storesContext.blueprintStore.applyMaterialToAllCeilings(t, n);
  }
  /**
   * Kills this Kvadrat instance by releasing assets
   */
  dispose() {
    var t, n, o;
    this.core.services.componentDeserializerRegistry.unregister(this.customComponentDeserializer), this.storesContext.blueprintStore.dispose(), this.storesContext.blueprintStorePreview.dispose(), this.storesContext.configurationStore.dispose(), this.storesContext.editorStore.dispose(), this.storesContext.i18nStore.dispose(), this.storesContext.userInteractionStore.dispose(), this.viewerAdapter.dispose(), this.cameraActions.dispose(), (t = this.unsubscribeBlueprintChange) == null || t.call(this), (n = this.unsubscribeBlueprintCompoundChange) == null || n.call(this), (o = this.unsubscribeSelectedCollidableStore) == null || o.call(this), this.onBeforeRoomChange.unsubscribeAll(), this.onBeforeEditorModeChange.unsubscribeAll(), this.onKvadratReady.unsubscribeAll(), this.onNotification.unsubscribeAll(), this.core.services.entityManager.entities.filter((r) => hasKvadratComponent(r)).forEach((r) => this.core.services.entityManager.disposeEntity(r));
  }
  /**
   * Get all viewer ids for objects created by Kvadrat.
   * @returns A list of all viewer ids created by Kvadrat.
   */
  getViewerIds() {
    return this.viewerAdapter.idIndex.getViewerIds();
  }
  /**
   * Get all viewer ids of a specific surface type.
   * @param type The type of surface.
   * @returns A list of all viewer ids where the surface type is `type`.
   */
  getViewerIdsByType(t) {
    return this.viewerAdapter.idIndex.getViewerIdsByType(t);
  }
  /**
   * Prepares Kvadrat for a drag and drop event by hiding the default drag
   * image and instead showing a representation of the wall feature about to be added
   * @example <caption>React example</caption>
   * {draggableItems.map(item  => (
   *    <a ondrag={e => kvadratApi.prepareDrop(e, item)}
   * )}
   * @param event
   * @param wallFeature
   */
  prepareDragAndDrop(t, n) {
    prepareDrop(t, n, this.storesContext.userInteractionStore.get().scale);
  }
  /**
   *
   * @param bp
   */
  onBlueprintChange(t) {
    this.generator.update(t, this.storesContext.featureFlagStore.get().thickWalls);
  }
  getRecommendedLights() {
    const n = this.getBlueprint().rooms[0];
    return n ? getRecommendedLights(n) : [];
  }
  getSelectedMeshScreenBounds() {
    return this.viewerAdapter.getSelectedMeshScreenBounds();
  }
  getVersion() {
    return KVADRAT_VERSION;
  }
  getViewerBackgroundColor() {
    return this.viewerAdapter.getBackgroundColor();
  }
  getICFRoom(t) {
    const n = this.storesContext.blueprintStore.get();
    return blueprintAsPartialIcf(n, t);
  }
  /** INTERNALS */
  getStores() {
    return this.storesContext;
  }
  setMaterialTags(t) {
    this.storesContext.configurationStore.setMaterialTags(t);
  }
  setDynamicVisibility(t) {
    const n = this.core.services.entityManager.getSystemsRegistered().find((o) => o.id === HideRoomSurfacesNotFacingCameraSystem.systemId);
    n && (t ? n.enable() : n.disable());
  }
  setMeasurementSystem(t) {
    this.storesContext.configurationStore.applyConfiguration({ measurementSystem: t });
  }
}
export {
  tt as AXIS,
  Qn as BLUEPRINT_SCHEMA_VERSION_MAJOR,
  eo as BLUEPRINT_SCHEMA_VERSION_MINOR,
  BlueprintComponent,
  CeilingComponent,
  ClosestEntitySide,
  CollidableType,
  CornerComponent,
  to as CornerRelationComponent,
  CustomComponentIds,
  CustomMeshComponent,
  Direction,
  DisabledRoomConnectorsConfigComponent,
  DoorComponent,
  Wn as DoorType,
  ERROR_CODE_TRANSLATION_KEYS,
  EdgeComponent,
  no as EdgeRelationComponent,
  EditingComponent,
  EditorMode,
  EditorModeComponent,
  EventEmitter,
  ExcludeWallFeatureFromBlueprintComponent,
  FloorComponent,
  GridComponent,
  it as HandleLocation,
  HighlightType,
  KVADRAT_CEILING_HEIGHT_MAX,
  KVADRAT_CEILING_HEIGHT_MIN,
  KvadratActiveComponent,
  KvadratButton,
  KvadratCategoryList,
  KvadratComponent,
  KvadratEditorModeToggle,
  ErrorCodes as KvadratErrorCodes,
  $e as KvadratGenerator,
  KvadratIdComponent,
  KvadratMenu,
  KvadratProviderWrapper,
  MINIMUM_DOOR_HEIGHT,
  MINIMUM_DOOR_WIDTH,
  MINIMUM_WINDOW_HEIGHT,
  MINIMUM_WINDOW_WIDTH,
  MaterialComponent,
  MaterialPreviewComponent,
  MaterialStorageComponent,
  MenuOptionType,
  MenuState,
  fe as MeshEventType,
  tn as MeshType,
  oo as OpeningArcComponent,
  Pn as OpeningDirection,
  OpeningDirectionComponent,
  ro as PI,
  io as PI_2,
  so as ParametricObjectComponent,
  ao as PredefinedRoomTypes,
  lo as Rectangle,
  co as RectangleAtlas,
  uo as RoomComponent,
  RoomSurfaceComponent,
  po as RoomSurfaceRelationsComponent,
  mo as RoomUnderConstructionComponent,
  go as ShouldBeInteractableComponent,
  fo as SlopedCeilingComponent,
  ho as SurfaceResizingComponent,
  UIResizeWidgetComponent,
  UpdateHostConnectionsComponent,
  ViewerUpdateObserverComponent,
  VisualGridPlaneComponent,
  WallComponent,
  Lt as WallFeatureType,
  WallThicknessComponent,
  Co as WindowComponent,
  Rn as WindowType,
  Eo as absv3,
  U as add,
  _o as addKvadratIdComponent,
  Io as almostEquals,
  vo as angularDistance,
  To as arrayGet,
  Oo as axisAngle,
  te as byPositionAlongWall,
  yo as cartesianToSpherical,
  So as checkIntersection,
  On as clamp,
  Fn as convertToMeters,
  Mo as convertToMillimeters,
  Ro as convertVectorToMeters,
  bo as createCircularHole,
  createKvadrat,
  wo as createRectangularHole,
  Ao as cross,
  pe as distance,
  Pe as distanceToLine,
  st as divs,
  B as dot,
  findRoomEntity,
  Do as floatEqual,
  Be as generate,
  xo as generateBlueprint,
  Lo as generateGeometry,
  No as getAllStructuralEntitiesInRoom,
  getBlueprintComponent,
  Wo as getCeilingComponent,
  getChildrenWithThickness,
  getCornerComponent,
  getCornerPosition,
  getCornerRelationComponent,
  Po as getCornerRelationEdges,
  getCornerRelationSurfaces,
  Fo as getCorners,
  getCustomMeshComponent,
  getDescendantWithEditing,
  getDescendantWithRoom,
  getDescendantsWithBlueprint,
  ko as getDescendantsWithCeiling,
  Vo as getDescendantsWithCorner,
  Uo as getDescendantsWithCornerRelation,
  getDescendantsWithCustomMesh,
  getDescendantsWithDoor,
  Bo as getDescendantsWithEdge,
  Ho as getDescendantsWithEdgeRelation,
  jo as getDescendantsWithFloor,
  getDescendantsWithKvadrat,
  getDescendantsWithMaterial,
  getDescendantsWithMaterialPreview,
  Ko as getDescendantsWithMaterialStorage,
  getDescendantsWithParametricObject,
  getDescendantsWithRoomSurface,
  zo as getDescendantsWithRoomSurfaceRelations,
  Go as getDescendantsWithRoomUnderConstruction,
  getDescendantsWithShouldBeInteractable,
  getDescendantsWithThickness,
  getDescendantsWithUIWidgets,
  getDescendantsWithWall,
  getDescendantsWithWindow,
  getDoorComponent,
  $o as getEdgeComponent,
  getEdgeCornerPoints,
  getEdgeRelationComponent,
  getEditingComponent,
  getEditorModeComponent,
  Zo as getFloor,
  Yo as getFloorComponent,
  getGridComponent,
  getKvadratEntities,
  getKvadratId,
  getKvadratIdComponent,
  Xo as getKvadratIds,
  getMaterialComponent,
  getMaterialPreviewComponent,
  qo as getMaterialStorageComponent,
  getOpeningArcComponent,
  getOpeningDirectionComponent,
  getParametricObjectComponent,
  Jo as getParametricObjects,
  Qo as getRoomChildren,
  er as getRoomComponent,
  tr as getRoomSurfaceComponent,
  getRoomSurfaceRelationsComponent,
  nr as getRoomUnderConstructionComponent,
  getShouldBeInteractableComponent,
  or as getSlopedCeilingComponent,
  rr as getSurfaceResizingComponent,
  ir as getTopLevelProductEntitiesInRoom,
  getUIWidgetComponent,
  sr as getWallComponent,
  ar as getWallConnectivity,
  lr as getWindowComponent,
  hasBlueprintComponent,
  hasCeilingComponent,
  dr as hasCornerComponent,
  cr as hasCornerRelationComponent,
  hasCustomMeshComponent,
  hasDoorComponent,
  hasEdgeComponent,
  ur as hasEdgeRelationComponent,
  hasEditingComponent,
  hasEditorModeComponent,
  pr as hasExcludeWallFeatureFromBlueprintComponent,
  hasFloorComponent,
  hasKvadratActiveComponent,
  hasKvadratComponent,
  mr as hasKvadratIdComponent,
  gr as hasMaterialComponent,
  fr as hasMaterialPreviewComponent,
  hr as hasMaterialStorageComponent,
  hasOpeningArcComponent,
  Cr as hasOpeningDirectionComponent,
  hasParametricObjectComponent,
  hasRoomComponent,
  hasRoomSurfaceComponent,
  Er as hasRoomSurfaceRelationsComponent,
  _r as hasRoomUnderConstructionComponent,
  Ir as hasShouldBeInteractableComponent,
  vr as hasSlopedCeilingComponent,
  Tr as hasSurfaceResizingComponent,
  hasUIWidgetComponent,
  hasWallComponent,
  hasWallThicknessComponent,
  hasWindowComponent,
  Or as innerAngle,
  yr as innerAngle3d,
  Sr as insertHoleVertices,
  isCeilingCollidable,
  isCollidableWithMaterialSupport,
  isCornerCollidable,
  bt as isDoorFeature,
  Mr as isDoorFeatureCollidable,
  isErrorCode,
  isFloorCollidable,
  Rr as isLinearSegments,
  me as isSame,
  isWallCollidable,
  isWallFeatureCollidable,
  Yt as isWindowFeature,
  br as isWindowFeatureCollidable,
  _ as length,
  wr as lerp,
  Ar as lerp3,
  Dr as lerpAngles,
  xr as lineIntersection2d,
  Lr as makeIdentity,
  Nr as makeMat4fromMat3,
  Wr as makeTransform,
  Pr as makeTranslation,
  Fr as mat3,
  kr as mat3FromAxis,
  Vr as maxComponent,
  Ur as maxv3,
  Br as minv3,
  Hr as mmmul4,
  jr as mod,
  P as muls,
  Kr as mulv,
  zr as mvdet,
  xt as mvmul,
  We as nearestPointOnLine,
  _e as newBlueprint,
  Gr as normaliseAngles,
  V as normalize,
  $r as perpendicular,
  Zr as placement,
  Yr as planarAngleXZ,
  Xr as polygonArea,
  prepareDrop,
  qr as removeCeilingComponent,
  Jr as removeCornerComponent,
  Qr as removeCornerRelationComponent,
  removeCustomMeshComponent,
  ei as removeDoorComponent,
  ti as removeEdgeComponent,
  ni as removeEdgeRelationComponent,
  removeEditingComponent,
  removeEditorModeComponent,
  removeExcludeWallFeatureFromBlueprintComponent,
  oi as removeFloorComponent,
  removeGridComponent,
  removeKvadratActiveComponent,
  ri as removeKvadratComponent,
  ii as removeKvadratIdComponent,
  si as removeMaterialComponent,
  removeMaterialPreviewComponent,
  ai as removeMaterialStorageComponent,
  removeOpeningArcComponent,
  li as removeOpeningDirectionComponent,
  removeParametricObjectComponent,
  di as removeRoomComponent,
  ci as removeRoomSurfaceComponent,
  ui as removeRoomSurfaceRelationsComponent,
  pi as removeRoomUnderConstructionComponent,
  mi as removeShouldBeInteractableComponent,
  gi as removeSlopedCeilingComponent,
  fi as removeSurfaceResizingComponent,
  removeUIWidgetComponent,
  removeUpdateHostConnectionsComponent,
  removeViewerUpdateObserverComponent,
  removeVisualGridPlaneComponent,
  hi as removeWallComponent,
  removeWallThicknessComponent,
  Ci as removeWindowComponent,
  requireEdgeRelationComponent,
  requireKvadratId,
  requireKvadratIds,
  Ei as requireRoomSurfaceRelationsComponent,
  _i as roomCenterTop,
  Ii as rotX,
  zn as rotY,
  vi as rotZ,
  Ti as safeSub,
  Oi as slerp,
  yi as sphericalToCartesian,
  $ as sub,
  Si as sum,
  Mi as tesselateNonplanarEarclipping,
  Ri as tesselatePolygonWithEarClipping,
  K as transform,
  bi as transpose,
  wi as transpose4,
  index as units,
  useBreakpoints,
  useMenuContext,
  useSubscribableStore,
  ge as v2,
  y as vec2,
  u as vec3,
  Ai as vec4,
  ht as wallHeightIsConstant,
  Di as xz
};
//# sourceMappingURL=index.js.map
